import "@mescius/wijmo.styles/wijmo-core.css";
import "primeicons/primeicons.css";
import "splitpanes/dist/splitpanes.css";
import { Aggregate, Aggregate as Aggregate$1, CollectionViewGroup, CollectionViewGroup as CollectionViewGroup$1, Control, DataType, DataType as DataType$1, Event as Event$1, Globalize, GroupDescription, NotifyCollectionChangedAction, NotifyCollectionChangedAction as NotifyCollectionChangedAction$1, NotifyCollectionChangedEventArgs, ObservableArray, ObservableArray as ObservableArray$1, PropertyGroupDescription, PropertyGroupDescription as PropertyGroupDescription$1, SortDescription, SortDescription as SortDescription$1, Tooltip, asNumber, clamp, culture, setLicenseKey } from "@mescius/wijmo";
import { CellRange, CellType, FlexGrid as DatagridInstance, GroupRow, MergeManager, Row } from "@mescius/wijmo.grid";
import { ZIndex, ZIndex as ZIndex$1, equals } from "@primeuix/utils";
import { Fragment, Suspense, Teleport, Transition, computed, createBlock, createCommentVNode, createElementBlock, createElementVNode, createSlots, createTextVNode, createVNode, defineComponent, getCurrentInstance, h, inject, isMemoSame, isRef, mergeDefaults, mergeModels, mergeProps, nextTick, normalizeClass, normalizeStyle, onBeforeUnmount, onMounted, onScopeDispose, onUnmounted, openBlock, provide, reactive, ref, render, renderList, renderSlot, resolveComponent, resolveDynamicComponent, shallowRef, toDisplayString, toRef, unref, useModel, useSlots, useTemplateRef, vModelCheckbox, vModelText, vShow, watch, watchEffect, withCtx, withDirectives, withKeys, withModifiers } from "vue";
import { CharacterCasing, ResourceManager, WhiteSpaceHandling, addDays, createGuid, getPropertyByPath, getSimplifiedDateFormat, parseSimplifiedDate, setPropertyByPath, setTimeOfDay, stringFormat, toCamelCase, toPascalCase, twoDigitYearMax } from "@neos/shared";
import { onClickOutside, reactiveComputed, useCurrentElement, useDebounceFn, useElementBounding, useElementSize, useEventBus, useEventListener, useFocus, useIntersectionObserver, useSpeechRecognition, useVModel, useWindowSize } from "@vueuse/core";
import PrimeBadge from "primevue/badge";
import PrimeButton from "primevue/button";
import { Markdown } from "@comark/vue";
import highlightPlugin from "@comark/vue/plugins/highlight";
import mermaidPlugin, { Mermaid } from "@comark/vue/plugins/mermaid";
import securityPlugin from "@comark/vue/plugins/security";
import { textContent } from "@comark/vue/utils";
import PrimePopover from "primevue/popover";
import PrimeDialog from "primevue/dialog";
import Carousel from "primevue/carousel";
import annotationPlugin from "chartjs-plugin-annotation";
import PrimeChip from "primevue/chip";
import PrimeContextMenu from "primevue/contextmenu";
import { WjFlexGrid, WjFlexGridCellTemplate, WjFlexGridCellTemplateDefinition, WjFlexGridColumn } from "@mescius/wijmo.vue2.grid";
import { WjFlexGridDetail } from "@mescius/wijmo.vue2.grid.detail";
import { DetailRow } from "@mescius/wijmo.grid.detail";
import { saveAs } from "file-saver";
import { WjInputColor, WjInputMask, WjInputNumber, WjInputTime, WjListBox } from "@mescius/wijmo.vue2.input";
import { WjGroupPanel } from "@mescius/wijmo.vue2.grid.grouppanel";
import Lottie from "lottie-web/build/player/lottie_light";
import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import PrimeDivider from "primevue/divider";
import PrimeMenu from "primevue/tieredmenu";
import PrimeSelectButton from "primevue/selectbutton";
import PrimePanel from "primevue/panel";
import DOMPurify from "dompurify";
import PrimeDatePicker, { default as PrimeDatePicker$1 } from "primevue/datepicker";
import PrimePassword from "primevue/password";
import PrimeProgressBar from "primevue/progressbar";
import { Pane, Splitpanes } from "splitpanes";
import PrimeTimeline from "primevue/timeline";
import PrimeToast from "primevue/toast";
import { VList } from "virtua/vue";
import { useToast as useToast$1 } from "primevue/usetoast";
import PrimeVue, { usePrimeVue } from "primevue/config";
import ToastService from "primevue/toastservice";
import Tooltip$1 from "primevue/tooltip";
//#region src/composables/useComponentAutomationProperties.ts
var automationMode = false;
function isAutomationMode() {
	return automationMode;
}
function setAutomationMode(value = true) {
	automationMode = value;
}
/**
* Set __neosComponent DOM variable if the application is started in automation mode (url parameters contains automation=true)
*/
function useComponentAutomationProperties(element, name) {
	if (!automationMode) return;
	name ??= getComponentName();
	if (!name) return;
	element ??= useCurrentElement();
	watch(element, (value) => {
		const el = value && getComponentElement(value);
		if (el) el.__neosComponent = name;
	});
}
function getComponentName() {
	const instance = getCurrentInstance();
	if (!instance) return;
	return instance.type.name ?? instance.type.__name;
}
function getComponentElement(element) {
	return element instanceof HTMLElement ? element : element.$el;
}
//#endregion
//#region src/composables/useImages.ts
function provideImages(images) {
	provide("images", images);
	return images;
}
function useImages() {
	return inject("images", {});
}
//#endregion
//#region src/composables/useThemeManager.ts
function provideThemeManager(themeManager) {
	provide("themeManager", themeManager);
	return themeManager;
}
function useThemeManager(throwError = true) {
	const themeManager = inject("themeManager", void 0);
	if (!themeManager && throwError) throw new Error("ThemeManager not provided");
	return themeManager;
}
//#endregion
//#region src/components/Image/standardImages.ts
var countryImages = {
	flagAD: {
		class: "i-twemoji-flag-andorra",
		colored: true
	},
	flagAE: {
		class: "i-twemoji-flag-united-arab-emirates",
		colored: true
	},
	flagAF: {
		class: "i-twemoji-flag-afghanistan",
		colored: true
	},
	flagAI: {
		class: "i-twemoji-flag-anguilla",
		colored: true
	},
	flagAL: {
		class: "i-twemoji-flag-albania",
		colored: true
	},
	flagAM: {
		class: "i-twemoji-flag-armenia",
		colored: true
	},
	flagAO: {
		class: "i-twemoji-flag-angola",
		colored: true
	},
	flagAR: {
		class: "i-twemoji-flag-argentina",
		colored: true
	},
	flagAS: {
		class: "i-twemoji-flag-american-samoa",
		colored: true
	},
	flagAT: {
		class: "i-twemoji-flag-austria",
		colored: true
	},
	flagAU: {
		class: "i-twemoji-flag-australia",
		colored: true
	},
	flagAW: {
		class: "i-twemoji-flag-aruba",
		colored: true
	},
	flagAZ: {
		class: "i-twemoji-flag-azerbaijan",
		colored: true
	},
	flagBB: {
		class: "i-twemoji-flag-barbados",
		colored: true
	},
	flagBD: {
		class: "i-twemoji-flag-bangladesh",
		colored: true
	},
	flagBE: {
		class: "i-twemoji-flag-belgium",
		colored: true
	},
	flagBF: {
		class: "i-twemoji-flag-burkina-faso",
		colored: true
	},
	flagBG: {
		class: "i-twemoji-flag-bulgaria",
		colored: true
	},
	flagBH: {
		class: "i-twemoji-flag-bahrain",
		colored: true
	},
	flagBI: {
		class: "i-twemoji-flag-burundi",
		colored: true
	},
	flagBJ: {
		class: "i-twemoji-flag-benin",
		colored: true
	},
	flagBM: {
		class: "i-twemoji-flag-bermuda",
		colored: true
	},
	flagBN: {
		class: "i-twemoji-flag-brunei",
		colored: true
	},
	flagBO: {
		class: "i-twemoji-flag-bolivia",
		colored: true
	},
	flagBR: {
		class: "i-twemoji-flag-brazil",
		colored: true
	},
	flagBS: {
		class: "i-twemoji-flag-bahamas",
		colored: true
	},
	flagBT: {
		class: "i-twemoji-flag-bhutan",
		colored: true
	},
	flagBW: {
		class: "i-twemoji-flag-botswana",
		colored: true
	},
	flagBY: {
		class: "i-twemoji-flag-belarus",
		colored: true
	},
	flagBZ: {
		class: "i-twemoji-flag-belize",
		colored: true
	},
	flagCA: {
		class: "i-twemoji-flag-canada",
		colored: true
	},
	flagCF: {
		class: "i-twemoji-flag-central-african-republic",
		colored: true
	},
	flagCH: {
		class: "i-twemoji-flag-switzerland",
		colored: true
	},
	flagCK: {
		class: "i-twemoji-flag-cook-islands",
		colored: true
	},
	flagCL: {
		class: "i-twemoji-flag-chile",
		colored: true
	},
	flagCM: {
		class: "i-twemoji-flag-cameroon",
		colored: true
	},
	flagCN: {
		class: "i-twemoji-flag-china",
		colored: true
	},
	flagCO: {
		class: "i-twemoji-flag-colombia",
		colored: true
	},
	flagCR: {
		class: "i-twemoji-flag-costa-rica",
		colored: true
	},
	flagCU: {
		class: "i-twemoji-flag-cuba",
		colored: true
	},
	flagCX: {
		class: "i-twemoji-flag-christmas-island",
		colored: true
	},
	flagCY: {
		class: "i-twemoji-flag-cyprus",
		colored: true
	},
	flagCZ: {
		class: "i-twemoji-flag-czechia",
		colored: true
	},
	flagDE: {
		class: "i-twemoji-flag-germany",
		colored: true
	},
	flagDJ: {
		class: "i-twemoji-flag-djibouti",
		colored: true
	},
	flagDK: {
		class: "i-twemoji-flag-denmark",
		colored: true
	},
	flagDM: {
		class: "i-twemoji-flag-dominica",
		colored: true
	},
	flagDO: {
		class: "i-twemoji-flag-dominican-republic",
		colored: true
	},
	flagDZ: {
		class: "i-twemoji-flag-algeria",
		colored: true
	},
	flagEC: {
		class: "i-twemoji-flag-ecuador",
		colored: true
	},
	flagEE: {
		class: "i-twemoji-flag-estonia",
		colored: true
	},
	flagEG: {
		class: "i-twemoji-flag-egypt",
		colored: true
	},
	flagER: {
		class: "i-twemoji-flag-eritrea",
		colored: true
	},
	flagES: {
		class: "i-twemoji-flag-spain",
		colored: true
	},
	flagET: {
		class: "i-twemoji-flag-ethiopia",
		colored: true
	},
	flagFI: {
		class: "i-twemoji-flag-finland",
		colored: true
	},
	flagFJ: {
		class: "i-twemoji-flag-fiji",
		colored: true
	},
	flagFK: {
		class: "i-twemoji-flag-falkland-islands",
		colored: true
	},
	flagFM: {
		class: "i-twemoji-flag-micronesia",
		colored: true
	},
	flagFO: {
		class: "i-twemoji-flag-faroe-islands",
		colored: true
	},
	flagFR: {
		class: "i-twemoji-flag-france",
		colored: true
	},
	flagGA: {
		class: "i-twemoji-flag-gabon",
		colored: true
	},
	flagGB: {
		class: "i-twemoji-flag-united-kingdom",
		colored: true
	},
	flagGD: {
		class: "i-twemoji-flag-grenada",
		colored: true
	},
	flagGE: {
		class: "i-twemoji-flag-georgia",
		colored: true
	},
	flagGF: {
		class: "i-twemoji-flag-french-guiana",
		colored: true
	},
	flagGG: {
		class: "i-twemoji-flag-guernsey",
		colored: true
	},
	flagGH: {
		class: "i-twemoji-flag-ghana",
		colored: true
	},
	flagGI: {
		class: "i-twemoji-flag-gibraltar",
		colored: true
	},
	flagGL: {
		class: "i-twemoji-flag-greenland",
		colored: true
	},
	flagGM: {
		class: "i-twemoji-flag-gambia",
		colored: true
	},
	flagGN: {
		class: "i-twemoji-flag-guinea",
		colored: true
	},
	flagGP: {
		class: "i-twemoji-flag-guadeloupe",
		colored: true
	},
	flagGQ: {
		class: "i-twemoji-flag-equatorial-guinea",
		colored: true
	},
	flagGR: {
		class: "i-twemoji-flag-greece",
		colored: true
	},
	flagGT: {
		class: "i-twemoji-flag-guatemala",
		colored: true
	},
	flagGU: {
		class: "i-twemoji-flag-guam",
		colored: true
	},
	flagGW: {
		class: "i-twemoji-flag-guinea-bissau",
		colored: true
	},
	flagGY: {
		class: "i-twemoji-flag-guyana",
		colored: true
	},
	flagHN: {
		class: "i-twemoji-flag-honduras",
		colored: true
	},
	flagHR: {
		class: "i-twemoji-flag-croatia",
		colored: true
	},
	flagHT: {
		class: "i-twemoji-flag-haiti",
		colored: true
	},
	flagHU: {
		class: "i-twemoji-flag-hungary",
		colored: true
	},
	flagID: {
		class: "i-twemoji-flag-indonesia",
		colored: true
	},
	flagIE: {
		class: "i-twemoji-flag-ireland",
		colored: true
	},
	flagIL: {
		class: "i-twemoji-flag-israel",
		colored: true
	},
	flagIM: {
		class: "i-twemoji-flag-isle-of-man",
		colored: true
	},
	flagIN: {
		class: "i-twemoji-flag-india",
		colored: true
	},
	flagIO: {
		class: "i-twemoji-flag-british-indian-ocean-territory",
		colored: true
	},
	flagIQ: {
		class: "i-twemoji-flag-iraq",
		colored: true
	},
	flagIR: {
		class: "i-twemoji-flag-iran",
		colored: true
	},
	flagIS: {
		class: "i-twemoji-flag-iceland",
		colored: true
	},
	flagIT: {
		class: "i-twemoji-flag-italy",
		colored: true
	},
	flagJE: {
		class: "i-twemoji-flag-jersey",
		colored: true
	},
	flagJM: {
		class: "i-twemoji-flag-jamaica",
		colored: true
	},
	flagJO: {
		class: "i-twemoji-flag-jordan",
		colored: true
	},
	flagJP: {
		class: "i-twemoji-flag-japan",
		colored: true
	},
	flagKE: {
		class: "i-twemoji-flag-kenya",
		colored: true
	},
	flagKG: {
		class: "i-twemoji-flag-kyrgyzstan",
		colored: true
	},
	flagKH: {
		class: "i-twemoji-flag-cambodia",
		colored: true
	},
	flagKI: {
		class: "i-twemoji-flag-kiribati",
		colored: true
	},
	flagKM: {
		class: "i-twemoji-flag-comoros",
		colored: true
	},
	flagKP: {
		class: "i-twemoji-flag-north-korea",
		colored: true
	},
	flagKW: {
		class: "i-twemoji-flag-kuwait",
		colored: true
	},
	flagKY: {
		class: "i-twemoji-flag-cayman-islands",
		colored: true
	},
	flagKZ: {
		class: "i-twemoji-flag-kazakhstan",
		colored: true
	},
	flagLA: {
		class: "i-twemoji-flag-laos",
		colored: true
	},
	flagLB: {
		class: "i-twemoji-flag-lebanon",
		colored: true
	},
	flagLI: {
		class: "i-twemoji-flag-liechtenstein",
		colored: true
	},
	flagLK: {
		class: "i-twemoji-flag-sri-lanka",
		colored: true
	},
	flagLR: {
		class: "i-twemoji-flag-liberia",
		colored: true
	},
	flagLS: {
		class: "i-twemoji-flag-lesotho",
		colored: true
	},
	flagLT: {
		class: "i-twemoji-flag-lithuania",
		colored: true
	},
	flagLU: {
		class: "i-twemoji-flag-luxembourg",
		colored: true
	},
	flagLV: {
		class: "i-twemoji-flag-latvia",
		colored: true
	},
	flagLY: {
		class: "i-twemoji-flag-libya",
		colored: true
	},
	flagMA: {
		class: "i-twemoji-flag-morocco",
		colored: true
	},
	flagMC: {
		class: "i-twemoji-flag-monaco",
		colored: true
	},
	flagMD: {
		class: "i-twemoji-flag-moldova",
		colored: true
	},
	flagME: {
		class: "i-twemoji-flag-montenegro",
		colored: true
	},
	flagMG: {
		class: "i-twemoji-flag-madagascar",
		colored: true
	},
	flagMH: {
		class: "i-twemoji-flag-marshall-islands",
		colored: true
	},
	flagMK: {
		class: "i-twemoji-flag-north-macedonia",
		colored: true
	},
	flagML: {
		class: "i-twemoji-flag-mali",
		colored: true
	},
	flagMN: {
		class: "i-twemoji-flag-mongolia",
		colored: true
	},
	flagMP: {
		class: "i-twemoji-flag-northern-mariana-islands",
		colored: true
	},
	flagMQ: {
		class: "i-twemoji-flag-martinique",
		colored: true
	},
	flagMR: {
		class: "i-twemoji-flag-mauritania",
		colored: true
	},
	flagMS: {
		class: "i-twemoji-flag-montserrat",
		colored: true
	},
	flagMT: {
		class: "i-twemoji-flag-malta",
		colored: true
	},
	flagMU: {
		class: "i-twemoji-flag-mauritius",
		colored: true
	},
	flagMV: {
		class: "i-twemoji-flag-maldives",
		colored: true
	},
	flagMW: {
		class: "i-twemoji-flag-malawi",
		colored: true
	},
	flagMX: {
		class: "i-twemoji-flag-mexico",
		colored: true
	},
	flagMY: {
		class: "i-twemoji-flag-malaysia",
		colored: true
	},
	flagMZ: {
		class: "i-twemoji-flag-mozambique",
		colored: true
	},
	flagNA: {
		class: "i-twemoji-flag-namibia",
		colored: true
	},
	flagNC: {
		class: "i-twemoji-flag-new-caledonia",
		colored: true
	},
	flagNE: {
		class: "i-twemoji-flag-niger",
		colored: true
	},
	flagNF: {
		class: "i-twemoji-flag-norfolk-island",
		colored: true
	},
	flagNG: {
		class: "i-twemoji-flag-nigeria",
		colored: true
	},
	flagNI: {
		class: "i-twemoji-flag-nicaragua",
		colored: true
	},
	flagNL: {
		class: "i-twemoji-flag-netherlands",
		colored: true
	},
	flagNO: {
		class: "i-twemoji-flag-norway",
		colored: true
	},
	flagNP: {
		class: "i-twemoji-flag-nepal",
		colored: true
	},
	flagNR: {
		class: "i-twemoji-flag-nauru",
		colored: true
	},
	flagNU: {
		class: "i-twemoji-flag-niue",
		colored: true
	},
	flagNZ: {
		class: "i-twemoji-flag-new-zealand",
		colored: true
	},
	flagOM: {
		class: "i-twemoji-flag-oman",
		colored: true
	},
	flagPA: {
		class: "i-twemoji-flag-panama",
		colored: true
	},
	flagPE: {
		class: "i-twemoji-flag-peru",
		colored: true
	},
	flagPF: {
		class: "i-twemoji-flag-french-polynesia",
		colored: true
	},
	flagPG: {
		class: "i-twemoji-flag-papua-new-guinea",
		colored: true
	},
	flagPH: {
		class: "i-twemoji-flag-philippines",
		colored: true
	},
	flagPK: {
		class: "i-twemoji-flag-pakistan",
		colored: true
	},
	flagPL: {
		class: "i-twemoji-flag-poland",
		colored: true
	},
	flagPN: {
		class: "i-twemoji-flag-pitcairn-islands",
		colored: true
	},
	flagPR: {
		class: "i-twemoji-flag-puerto-rico",
		colored: true
	},
	flagPT: {
		class: "i-twemoji-flag-portugal",
		colored: true
	},
	flagPW: {
		class: "i-twemoji-flag-palau",
		colored: true
	},
	flagPY: {
		class: "i-twemoji-flag-paraguay",
		colored: true
	},
	flagQA: {
		class: "i-twemoji-flag-qatar",
		colored: true
	},
	flagRO: {
		class: "i-twemoji-flag-romania",
		colored: true
	},
	flagRS: {
		class: "i-twemoji-flag-serbia",
		colored: true
	},
	flagRU: {
		class: "i-twemoji-flag-russia",
		colored: true
	},
	flagRW: {
		class: "i-twemoji-flag-rwanda",
		colored: true
	},
	flagSA: {
		class: "i-twemoji-flag-saudi-arabia",
		colored: true
	},
	flagSB: {
		class: "i-twemoji-flag-solomon-islands",
		colored: true
	},
	flagSC: {
		class: "i-twemoji-flag-seychelles",
		colored: true
	},
	flagSD: {
		class: "i-twemoji-flag-sudan",
		colored: true
	},
	flagSE: {
		class: "i-twemoji-flag-sweden",
		colored: true
	},
	flagSG: {
		class: "i-twemoji-flag-singapore",
		colored: true
	},
	flagSI: {
		class: "i-twemoji-flag-slovenia",
		colored: true
	},
	flagSK: {
		class: "i-twemoji-flag-slovakia",
		colored: true
	},
	flagSL: {
		class: "i-twemoji-flag-sierra-leone",
		colored: true
	},
	flagSM: {
		class: "i-twemoji-flag-san-marino",
		colored: true
	},
	flagSN: {
		class: "i-twemoji-flag-senegal",
		colored: true
	},
	flagSO: {
		class: "i-twemoji-flag-somalia",
		colored: true
	},
	flagSR: {
		class: "i-twemoji-flag-suriname",
		colored: true
	},
	flagSS: {
		class: "i-twemoji-flag-south-sudan",
		colored: true
	},
	flagSV: {
		class: "i-twemoji-flag-el-salvador",
		colored: true
	},
	flagSX: {
		class: "i-twemoji-flag-sint-maarten",
		colored: true
	},
	flagSY: {
		class: "i-twemoji-flag-syria",
		colored: true
	},
	flagSZ: {
		class: "i-twemoji-flag-eswatini",
		colored: true
	},
	flagTD: {
		class: "i-twemoji-flag-chad",
		colored: true
	},
	flagTG: {
		class: "i-twemoji-flag-togo",
		colored: true
	},
	flagTH: {
		class: "i-twemoji-flag-thailand",
		colored: true
	},
	flagTJ: {
		class: "i-twemoji-flag-tajikistan",
		colored: true
	},
	flagTK: {
		class: "i-twemoji-flag-tokelau",
		colored: true
	},
	flagTL: {
		class: "i-twemoji-flag-timor-leste",
		colored: true
	},
	flagTM: {
		class: "i-twemoji-flag-turkmenistan",
		colored: true
	},
	flagTN: {
		class: "i-twemoji-flag-tunisia",
		colored: true
	},
	flagTO: {
		class: "i-twemoji-flag-tonga",
		colored: true
	},
	flagTR: {
		class: "i-twemoji-flag-turkey",
		colored: true
	},
	flagTV: {
		class: "i-twemoji-flag-tuvalu",
		colored: true
	},
	flagTW: {
		class: "i-twemoji-flag-taiwan",
		colored: true
	},
	flagTZ: {
		class: "i-twemoji-flag-tanzania",
		colored: true
	},
	flagUA: {
		class: "i-twemoji-flag-ukraine",
		colored: true
	},
	flagUG: {
		class: "i-twemoji-flag-uganda",
		colored: true
	},
	flagUS: {
		class: "i-twemoji-flag-united-states",
		colored: true
	},
	flagUY: {
		class: "i-twemoji-flag-uruguay",
		colored: true
	},
	flagUZ: {
		class: "i-twemoji-flag-uzbekistan",
		colored: true
	},
	flagVA: {
		class: "i-twemoji-flag-vatican-city",
		colored: true
	},
	flagVE: {
		class: "i-twemoji-flag-venezuela",
		colored: true
	},
	flagVG: {
		class: "i-twemoji-flag-british-virgin-islands",
		colored: true
	},
	flagVN: {
		class: "i-twemoji-flag-vietnam",
		colored: true
	},
	flagVU: {
		class: "i-twemoji-flag-vanuatu",
		colored: true
	},
	flagWS: {
		class: "i-twemoji-flag-samoa",
		colored: true
	},
	flagXK: {
		class: "i-twemoji-flag-kosovo",
		colored: true
	},
	flagYE: {
		class: "i-twemoji-flag-yemen",
		colored: true
	},
	flagYT: {
		class: "i-twemoji-flag-mayotte",
		colored: true
	},
	flagZA: {
		class: "i-twemoji-flag-south-africa",
		colored: true
	},
	flagZM: {
		class: "i-twemoji-flag-zambia",
		colored: true
	},
	flagZW: {
		class: "i-twemoji-flag-zimbabwe",
		colored: true
	}
};
var dataTypeImages = {
	dataTypeAutoIncrementedInteger: {
		class: "i-mdi-counter",
		colored: false
	},
	dataTypeBoolean: {
		class: "i-mdi-checkbox-outline",
		colored: false
	},
	dataTypeColor: {
		class: "i-mdi-format-color-fill",
		colored: false
	},
	dataTypeDataType: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeDate: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	dataTypeDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeDecimal: {
		class: "i-mdi-decimal",
		colored: false
	},
	dataTypeEnum: {
		class: "i-mdi-format-list-bulleted",
		colored: false
	},
	dataTypeFile: {
		class: "i-mdi-file-outline",
		colored: false
	},
	dataTypeGuid: {
		class: "i-mdi-identifier",
		colored: false
	},
	dataTypeImage: {
		class: "i-mdi-image-outline",
		colored: false
	},
	dataTypeInteger: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeInvariantDateTime: {
		class: "i-mdi-calendar-clock-outline",
		colored: false
	},
	dataTypeLocalizableString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeLong: {
		class: "i-mdi-numeric-0-box-outline",
		colored: false
	},
	dataTypeString: {
		class: "i-mdi-format-text",
		colored: false
	},
	dataTypeStringArray: {
		class: "i-mdi-code-brackets",
		colored: false
	}
};
var standardImages = {
	add: {
		class: "i-mdi-plus-thick",
		colored: false
	},
	addCondition: {
		class: "i-mdi-playlist-plus",
		colored: false
	},
	addGroup: {
		class: "i-mdi-format-list-group-plus",
		colored: false
	},
	arrowDown: {
		class: "i-mdi-arrow-down-thin",
		colored: false
	},
	arrowLeft: {
		class: "i-mdi-arrow-left",
		colored: false
	},
	arrowRight: {
		class: "i-mdi-arrow-right",
		colored: false
	},
	arrowUp: {
		class: "i-mdi-arrow-up-thin",
		colored: false
	},
	asterisk: {
		class: "i-mdi-asterisk",
		colored: false
	},
	between: {
		class: "i-mdi-format-horizontal-align-center",
		colored: false
	},
	bookmarkOutline: {
		class: "i-mdi-bookmark-outline",
		colored: false
	},
	bulb: {
		class: "i-mdi-lightbulb-outline",
		colored: false
	},
	calendar: {
		class: "i-mdi-calendar-outline",
		colored: false
	},
	calendarStart: {
		class: "i-mdi-calendar-start",
		colored: false
	},
	chevronDoubleDown: {
		class: "i-mdi-chevron-double-down",
		colored: false
	},
	chevronDoubleLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	chevronDoubleRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	chevronDoubleUp: {
		class: "i-mdi-chevron-double-up",
		colored: false
	},
	chevronDown: {
		class: "i-mdi-chevron-down",
		colored: false
	},
	chevronLeft: {
		class: "i-mdi-chevron-left",
		colored: false
	},
	chevronRight: {
		class: "i-mdi-chevron-right",
		colored: false
	},
	chevronRightCircle: {
		class: "i-mdi-chevron-right-circle-outline",
		colored: false
	},
	chevronUp: {
		class: "i-mdi-chevron-up",
		colored: false
	},
	circle: {
		class: "i-mdi-checkbox-blank-circle",
		colored: false
	},
	clear: {
		class: "i-mdi-close-circle-outline",
		colored: false
	},
	clearFilter: {
		class: "i-mdi-filter-remove-outline",
		colored: false
	},
	clock: {
		class: "i-mdi-clock-outline",
		colored: false
	},
	clone: {
		class: "i-mdi-content-copy",
		colored: false
	},
	close: {
		class: "i-mdi-close",
		colored: false
	},
	closeTabs: {
		class: "i-mdi-tab-remove",
		colored: false
	},
	cog: {
		class: "i-mdi-cog",
		colored: false
	},
	collapse: {
		class: "i-mdi-arrow-collapse",
		colored: false
	},
	columnPicker: {
		class: "i-mdi-table-column-plus-before",
		colored: false
	},
	contains: {
		class: "i-mdi-format-letter-matches",
		colored: false
	},
	csharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	csv: {
		class: "i-mdi-file-table-outline",
		colored: false
	},
	danger: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	datagridLoadData: {
		class: "i-neos-datagrid-load-data",
		colored: true
	},
	datagridNoData: {
		class: "i-neos-datagrid-no-data",
		colored: true
	},
	dotsHorizontal: {
		class: "i-mdi-dots-horizontal",
		colored: false
	},
	doubleChevronLeft: {
		class: "i-mdi-chevron-double-left",
		colored: false
	},
	doubleChevronRight: {
		class: "i-mdi-chevron-double-right",
		colored: false
	},
	download: {
		class: "i-mdi-download",
		colored: false
	},
	dragHorizontal: {
		class: "i-mdi-drag-horizontal",
		colored: false
	},
	dragVertical: {
		class: "i-mdi-drag-vertical",
		colored: false
	},
	edit: {
		class: "i-mdi-pencil",
		colored: false
	},
	endsWith: {
		class: "i-mdi-format-letter-ends-with",
		colored: false
	},
	equal: {
		class: "i-mdi-equal",
		colored: false
	},
	erase: {
		class: "i-mdi-eraser",
		colored: false
	},
	error: {
		class: "i-mdi-alert-circle-outline",
		colored: false
	},
	excel: {
		class: "i-mdi-microsoft-excel",
		colored: false
	},
	expand: {
		class: "i-mdi-arrow-expand",
		colored: false
	},
	export: {
		class: "i-mdi-download",
		colored: false
	},
	expression: {
		class: "i-mdi-function-variant",
		colored: false
	},
	eye: {
		class: "i-mdi-eye",
		colored: false
	},
	eyeOff: {
		class: "i-mdi-eye-off",
		colored: false
	},
	filter: {
		class: "i-mdi-filter",
		colored: false
	},
	filterCheckOutline: {
		class: "i-mdi-filter-check-outline",
		colored: false
	},
	filterOutline: {
		class: "i-mdi-filter-outline",
		colored: false
	},
	folder: {
		class: "i-mdi-folder",
		colored: false
	},
	fullscreen: {
		class: "i-mdi-fullscreen",
		colored: false
	},
	fullscreenExit: {
		class: "i-mdi-fullscreen-exit",
		colored: false
	},
	generateduitemplate: {
		class: "i-mdi-identifier",
		colored: false
	},
	greater: {
		class: "i-mdi-greater-than",
		colored: false
	},
	greaterOrEqual: {
		class: "i-mdi-greater-than-or-equal",
		colored: false
	},
	groupPanel: {
		class: "i-mdi-format-list-group",
		colored: false
	},
	homeGroup: {
		class: "i-mdi-home-group",
		colored: false
	},
	in: {
		class: "i-mdi-plus-circle-outline",
		colored: false
	},
	info: {
		class: "i-mdi-information-outline",
		colored: false
	},
	isNotNull: {
		class: "i-mdi-alphabetical-variant",
		colored: false
	},
	isNull: {
		class: "i-mdi-alphabetical-variant-off",
		colored: false
	},
	less: {
		class: "i-mdi-less-than",
		colored: false
	},
	lessOrEqual: {
		class: "i-mdi-less-than-or-equal",
		colored: false
	},
	lock: {
		class: "i-mdi-lock-outline",
		colored: false
	},
	logout: {
		class: "i-mdi-logout",
		colored: false
	},
	menu: {
		class: "i-mdi-menu",
		colored: false
	},
	menuDown: {
		class: "i-mdi-menu-down",
		colored: false
	},
	microphone: {
		class: "i-mdi-microphone",
		colored: false
	},
	min: {
		class: "i-mdi-minus",
		colored: false
	},
	notEqual: {
		class: "i-mdi-not-equal-variant ",
		colored: false
	},
	notIn: {
		class: "i-mdi-minus-circle-outline",
		colored: false
	},
	open: {
		class: "i-mdi-open-in-new",
		colored: false
	},
	paperclip: {
		class: "i-mdi-paperclip",
		colored: false
	},
	pause: {
		class: "i-mdi-pause-circle-outline",
		colored: false
	},
	pdf: {
		class: "i-mdi-file-pdf-box",
		colored: false
	},
	pin: {
		class: "i-mdi-pin-outline",
		colored: false
	},
	pinned: {
		class: "i-mdi-pin-outline",
		colored: false
	},
	positive: {
		class: "i-mdi-check-circle-outline",
		colored: false
	},
	print: {
		class: "i-mdi-printer",
		colored: false
	},
	refresh: {
		class: "i-mdi-refresh",
		colored: false
	},
	remove: {
		class: "i-mdi-trash-can-outline",
		colored: false
	},
	removeColumn: {
		class: "i-mdi-table-column-remove",
		colored: false
	},
	reset: {
		class: "i-mdi-arrow-u-left-top",
		colored: false
	},
	restart: {
		class: "i-mdi-restart",
		colored: false
	},
	save: {
		class: "i-mdi-content-save-outline",
		colored: false
	},
	search: {
		class: "i-mdi-magnify",
		colored: false
	},
	send: {
		class: "i-mdi-send",
		colored: false
	},
	sparkles: {
		class: "i-neos-sparkles",
		colored: true
	},
	startsWith: {
		class: "i-mdi-format-letter-starts-with ",
		colored: false
	},
	swap: {
		class: "i-mdi-swap-vertical",
		colored: false
	},
	translate: {
		class: "i-mdi-translate",
		colored: false
	},
	typescript: {
		class: "i-mdi-language-typescript",
		colored: false
	},
	uicsharp: {
		class: "i-mdi-language-csharp",
		colored: false
	},
	uitemplate: {
		class: "i-mdi-xml",
		colored: false
	},
	unpin: {
		class: "i-mdi-pin-off-outline",
		colored: false
	},
	unsave: {
		class: "i-mdi-content-save-off-outline",
		colored: false
	},
	user: {
		class: "i-mdi-account",
		colored: false
	},
	validate: {
		class: "i-mdi-check",
		colored: false
	},
	warning: {
		class: "i-mdi-alert-outline",
		colored: false
	},
	...countryImages,
	...dataTypeImages
};
//#endregion
//#region src/components/Image/Image.ts?vue&type=script&src=true&lang.ts
var Image_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Image",
	props: {
		name: {
			type: String,
			default: void 0
		},
		size: {
			type: String,
			default: "medium"
		}
	},
	setup(props) {
		const images = useImages();
		const themeManager = useThemeManager(false);
		const image = computed(() => {
			if (!props.name) return;
			const camelCaseName = toCamelCase(props.name);
			const customImage = images[camelCaseName];
			return typeof customImage === "object" ? customImage : standardImages[customImage ?? camelCaseName] ?? standardImages[camelCaseName];
		});
		const classes = computed(() => {
			if (!image.value) return;
			if (image.value.path && image.value.colored) return ["image-bg", `image-${props.size}`];
			return [image.value.class ?? "image-mask", `image-${props.size}`];
		});
		const style = computed(() => {
			if (image.value?.darkVersionPath && themeManager?.currentTheme.colorScheme === "dark") return `--image-url: url('${image.value.darkVersionPath}')`;
			if (image.value?.path) return `--image-url: url('${image.value.path}')`;
		});
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
//#endregion
//#region \0plugin-vue:export-helper
var _plugin_vue_export_helper_default = (sfc, props) => {
	const target = sfc.__vccOpts || sfc;
	for (const [key, val] of props) target[key] = val;
	return target;
};
//#endregion
//#region src/components/Image/Image.vue
function _sfc_render$32(_ctx, _cache, $props, $setup, $data, $options) {
	return _ctx.classes ? (openBlock(), createElementBlock("div", {
		key: 0,
		class: normalizeClass(["image", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, null, 6)) : createCommentVNode("", true);
}
var Image_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Image_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$32], ["__scopeId", "data-v-e4db28c2"]]);
//#endregion
//#region src/components/Avatar/Avatar.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$36 = {
	key: 0,
	class: "avatar-label"
};
//#endregion
//#region src/components/Avatar/Avatar.vue
var Avatar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Avatar",
	props: {
		label: { default: void 0 },
		icon: { default: void 0 },
		size: { default: "medium" },
		shape: { default: "circle" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const array = [`avatar-${props.size}`];
			if (props.shape === "square") array.push("avatar-square");
			return array;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["avatar", classes.value]) }, [__props.label ? (openBlock(), createElementBlock("span", _hoisted_1$36, toDisplayString(__props.label), 1)) : __props.icon ? (openBlock(), createBlock(Image_default, {
				key: 1,
				name: __props.icon,
				class: "avatar-icon",
				size: __props.size
			}, null, 8, ["name", "size"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-c6f12af7"]]);
//#endregion
//#region src/components/Badge/Badge.vue
var Badge_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Badge",
	props: {
		value: { default: void 0 },
		severity: { default: "none" },
		size: { default: "medium" }
	},
	setup(__props) {
		const props = __props;
		const classes = computed(() => {
			const classes = [];
			if (props.size != "medium") classes.push(`badge-${props.size}`);
			if (props.value != null && String(props.value).length <= 2) classes.push("p-badge-circle");
			return classes;
		});
		const computedSeverity = computed(() => {
			switch (props.severity) {
				case "none": return null;
				case "positive": return "success";
				case "warning": return "warn";
				default: return props.severity;
			}
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeBadge), {
				value: __props.value,
				severity: computedSeverity.value,
				class: normalizeClass(["badge", classes.value])
			}, null, 8, [
				"value",
				"severity",
				"class"
			]);
		};
	}
}), [["__scopeId", "data-v-53d09dd7"]]);
//#endregion
//#region src/composables/useGlobalResourceManager.ts
function provideGlobalResourceManager(globalResourceManager) {
	provide("globalResourceManager", globalResourceManager);
	return globalResourceManager;
}
function useGlobalResourceManager() {
	const globalResourceManager = inject("globalResourceManager");
	if (!globalResourceManager) throw new Error("GlobalResourceManager not provided");
	return {
		globalResourceManager,
		translate: (key, ...args) => stringFormat(globalResourceManager.get(key), ...args)
	};
}
//#endregion
//#region src/composables/useFocusableElement.ts
var focusableElementProps = {
	autofocus: {
		type: Boolean,
		default: void 0
	},
	focused: {
		type: Boolean,
		default: void 0
	}
};
var focusableElementEmits = ["update:focused"];
function useFocusableElement(element, props, emit) {
	if (props.focused === void 0 && props.autofocus === void 0) return;
	const { focused } = useFocus(element);
	watch(element, (value) => {
		if (value) {
			const autofocus = props.focused || props.autofocus;
			if (autofocus) {
				const el = getComponentElement(value);
				el.setAttribute("autofocus", `${autofocus}`);
				el.focus();
			}
		}
	}, { immediate: true });
	watch(() => props.focused, (value) => {
		if (value !== void 0 && value !== focused.value) focused.value = value;
	});
	watch(focused, (value) => {
		if (value !== props.focused) emit("update:focused", value);
	});
}
//#endregion
//#region src/composables/useInput.ts
var inputProps = {
	label: {
		type: String,
		default: void 0
	},
	labelPosition: {
		type: String,
		default: void 0
	},
	required: {
		type: Boolean,
		default: false
	},
	readonly: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	},
	messageText: {
		type: String,
		default: void 0
	},
	messageSeverity: {
		type: String,
		default: void 0
	},
	messagePosition: {
		type: String,
		default: void 0
	},
	documentation: {
		type: String,
		default: void 0
	},
	placeholder: {
		type: String,
		default: void 0
	},
	tabStop: {
		type: Boolean,
		default: true
	},
	inputDisplayMode: {
		type: String,
		default: "form"
	},
	aiSuggestion: {
		type: Object,
		default: void 0
	},
	...focusableElementProps
};
var inputEmits = [
	"update:modelValue",
	"aiApply",
	"aiCancel",
	...focusableElementEmits
];
function useInput(props, emit) {
	const input = ref(null);
	const id = createGuid();
	const classes = computed(() => ({
		"neos-inline-input": props.labelPosition === "left" || props.labelPosition === "right",
		"neos-inline-right-input": props.labelPosition === "right",
		"neos-datagrid-input": props.inputDisplayMode === "datagrid",
		"neos-input-readonly": props.readonly,
		"neos-input-disabled": props.disabled,
		"neos-input-warning": props.messageSeverity === "warning" && props.messageText !== void 0,
		"neos-input-error": props.messageSeverity === "error" && props.messageText != void 0 || props.messageSeverity === void 0 && props.messageText != void 0
	}));
	const isLabelVisible = computed(() => props.label != null && props.labelPosition !== "hidden");
	const isMessageVisible = computed(() => props.messageText != null && props.messagePosition !== "hidden");
	const tabIndex = computed(() => props.tabStop ? void 0 : -1);
	useComponentAutomationProperties();
	useFocusableElement(input, props, emit);
	return {
		input,
		id,
		classes,
		isLabelVisible,
		isMessageVisible,
		tabIndex
	};
}
function triggerChangeOnActiveInput() {
	const el = document.activeElement;
	if ((el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) && !el.closest(".neos-input-readonly") && !el.closest(".neos-input-disabled")) el.dispatchEvent(new Event("change", { bubbles: true }));
}
//#endregion
//#region src/composables/useInputInvalidValue.ts
function useInputInvalidValue(props, emit) {
	const internalInvalidValue = ref(null);
	return computed({
		get() {
			if (props.invalidValue !== void 0) return props.invalidValue;
			return internalInvalidValue.value;
		},
		set(value) {
			if (props.invalidValue !== void 0) {
				if (props.invalidValue !== value) emit("update:invalidValue", value);
			} else internalInvalidValue.value = value;
		}
	});
}
//#endregion
//#region src/composables/useSelectProps.ts
function useSelectProps(props) {
	const disabledOrReadonly = computed(() => props.disabled || props.readonly);
	const keyProperty = computed(() => props.keyProperty ?? props.valueProperty);
	const displayProperty = computed(() => props.displayProperty ?? props.valueProperty);
	function getOptionValue(option) {
		if (props.valueProperty && option != null) return getPropertyByPath(option, props.valueProperty);
		return option;
	}
	return {
		disabledOrReadonly,
		keyProperty,
		displayProperty,
		getOptionValue
	};
}
//#endregion
//#region src/composables/useText.ts
var textPropsDefaults = {
	size: "medium",
	weight: "regular"
};
var smallTextPropsDefaults = {
	size: "small",
	weight: "regular"
};
function useText(props) {
	return {
		classes: computed(() => {
			const value = [];
			if (typeof props.size === "string") value.push(`text-${props.size}`);
			if (props.weight !== "regular") value.push(`text-${props.weight}`);
			return value;
		}),
		styles: computed(() => {
			const value = {};
			if (typeof props.size === "number") value["font-size"] = `${props.size}px`;
			return value;
		})
	};
}
//#endregion
//#region src/composables/useTextMaxLines.ts
function useTextMaxLines(props) {
	return {
		classes: computed(() => props.maxLines ? ["text-with-webkit-box-for-ellipsis"] : []),
		styles: computed(() => props.maxLines ? { "-webkit-line-clamp": props.maxLines } : void 0)
	};
}
//#endregion
//#region src/components/Text/Text.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$35 = ["title"];
//#endregion
//#region src/components/Text/Text.vue
var Text_default = /* @__PURE__ */ defineComponent({
	__name: "Text",
	props: /*@__PURE__*/ mergeDefaults({
		size: {},
		weight: {},
		orientation: {},
		tooltip: {},
		maxLines: {}
	}, {
		...textPropsDefaults,
		orientation: "horizontal",
		tooltip: void 0,
		maxLines: void 0
	}),
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes: baseClasses, styles: baseStyles } = useText(props);
		const { classes: maxLinesClasses, styles: maxLinesStyles } = useTextMaxLines(props);
		const classes = computed(() => {
			const value = [...baseClasses.value, ...maxLinesClasses.value];
			if (props.orientation !== "horizontal") value.push(`text-orientation-${props.orientation}`);
			return value;
		});
		const styles = computed(() => ({
			...baseStyles.value,
			...maxLinesStyles.value
		}));
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("span", {
				class: normalizeClass(["text", classes.value]),
				title: __props.tooltip,
				style: normalizeStyle(styles.value)
			}, [renderSlot(_ctx.$slots, "default")], 14, _hoisted_1$35);
		};
	}
});
//#endregion
//#region src/components/Button/Button.ts?vue&type=script&src=true&lang.ts
var commonBaseButtonElementProps = {
	tooltip: {
		type: String,
		default: void 0
	},
	contentAlign: {
		type: String,
		default: "start"
	}
};
var Button_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Button",
	components: {
		Text: Text_default,
		Image: Image_default,
		PrimeButton
	},
	props: {
		...focusableElementProps,
		...commonBaseButtonElementProps,
		type: {
			type: String,
			default: "button"
		},
		variant: {
			type: String,
			default: "default"
		},
		size: {
			type: String,
			default: "medium"
		},
		disabled: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: "horizontal"
		},
		loading: {
			type: Boolean,
			default: false
		},
		ariaLabel: {
			type: String,
			default: void 0
		},
		label: {
			type: [String, Number],
			default: void 0
		},
		icon: {
			type: String,
			default: void 0
		},
		badge: {
			type: [String, Number],
			default: void 0
		},
		badgeSeverity: {
			type: String,
			default: "none"
		},
		iconSize: {
			type: String,
			default: void 0
		},
		animated: {
			type: Boolean,
			default: false
		}
	},
	emits: [...focusableElementEmits],
	setup(props, { emit }) {
		const themeManager = useThemeManager(false);
		const root = ref(null);
		const rootStyle = computed(() => `justify-content: ${props.contentAlign}`);
		const labelStyle = computed(() => props.label !== void 0 ? void 0 : "display: none");
		const classes = computed(() => {
			const list = [
				`button-${props.variant}`,
				`button-${props.size}`,
				`neos-${props.direction}-content`
			];
			if (props.badge !== void 0 && !props.label) list.push("p-overlay-badge");
			if (props.animated && props.variant !== "link" && themeManager?.currentTheme.animatedButtons) list.push("button-animated");
			return list;
		});
		const computedBadgeSeverity = computed(() => {
			switch (props.badgeSeverity) {
				case "none": return null;
				case "positive": return "success";
				case "warning": return "warn";
				default: return props.badgeSeverity;
			}
		});
		const link = computed(() => props.variant === "link");
		useComponentAutomationProperties(root);
		useFocusableElement(root, props, emit);
		return {
			root,
			classes,
			rootStyle,
			labelStyle,
			computedBadgeSeverity,
			link
		};
	}
});
//#endregion
//#region src/components/Button/Button.vue
function _sfc_render$31(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_PrimeButton = resolveComponent("PrimeButton");
	return openBlock(), createBlock(_component_PrimeButton, {
		ref: "root",
		class: normalizeClass(["button", _ctx.classes]),
		type: _ctx.type,
		label: _ctx.label?.toString(),
		"aria-label": _ctx.ariaLabel ?? _ctx.label,
		disabled: _ctx.disabled,
		title: _ctx.tooltip,
		loading: _ctx.loading,
		text: "",
		badge: _ctx.badge?.toString(),
		"badge-severity": _ctx.computedBadgeSeverity,
		link: _ctx.link,
		pt: {
			root: { style: _ctx.rootStyle },
			label: { style: _ctx.labelStyle }
		},
		onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["stop"]))
	}, createSlots({
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 2
	}, [_ctx.icon ? {
		name: "icon",
		fn: withCtx(() => [createVNode(_component_Image, {
			name: _ctx.icon,
			size: _ctx.iconSize ?? _ctx.size
		}, null, 8, ["name", "size"])]),
		key: "0"
	} : void 0]), 1032, [
		"type",
		"class",
		"label",
		"aria-label",
		"disabled",
		"title",
		"loading",
		"badge",
		"badge-severity",
		"link",
		"pt"
	]);
}
var Button_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Button_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$31]]);
//#endregion
//#region src/composables/useButtonContainerSpace.ts
function useButtonContainerSpace(themeManager, props) {
	return computed(() => {
		return (props?.animated ?? themeManager?.currentTheme.animatedButtons) === true ? "none" : void 0;
	});
}
//#endregion
//#region src/utils/tokens.ts
var SpaceValues = {
	none: "0px",
	extrasmall: "0.25rem",
	small: "0.5rem",
	medium: "0.875rem",
	large: "1.125rem",
	extralarge: "1.5rem"
};
var CornerRadiusValues = {
	...SpaceValues,
	full: "50%"
};
var multiSpaceValueValidatorExpression = /^(none|extrasmall|small|medium|large|extralarge)(( (none|extrasmall|small|medium|large|extralarge)){3})?$/;
var AlignValues = {
	start: "flex-start",
	left: "flex-start",
	center: "center",
	end: "flex-end",
	right: "flex-end",
	stretch: "stretch",
	"space-between": "space-between"
};
var VerticalAlignValues = {
	top: "flex-start",
	center: "center",
	bottom: "flex-end",
	stretch: "stretch"
};
var BreakpointValues = {
	small: 640,
	medium: 768,
	large: 1024,
	extralarge: 1280
};
var WeightValues = {
	regular: "var(--text-weight-regular)",
	strong: "var(--text-weight-strong)",
	stronger: "var(--text-weight-stronger)"
};
var LayoutDirectiveProperty = /* @__PURE__ */ function(LayoutDirectiveProperty) {
	LayoutDirectiveProperty["alignSelfHorizontal"] = "align-self-horizontal";
	LayoutDirectiveProperty["alignSelfVertical"] = "align-self-vertical";
	LayoutDirectiveProperty["height"] = "height";
	LayoutDirectiveProperty["margin"] = "margin";
	LayoutDirectiveProperty["maxHeight"] = "max-height";
	LayoutDirectiveProperty["maxWidth"] = "max-width";
	LayoutDirectiveProperty["minHeight"] = "min-height";
	LayoutDirectiveProperty["minWidth"] = "min-width";
	LayoutDirectiveProperty["padding"] = "padding";
	LayoutDirectiveProperty["visibility"] = "visibility";
	LayoutDirectiveProperty["width"] = "width";
	return LayoutDirectiveProperty;
}({});
var AutomationDirectivePropertyValues = {
	id: "neosAutomationId",
	"repeat-index": "neosAutomationRepeatIndex"
};
var StyleDirectivePropertyValues = {
	"border-color": void 0,
	"corner-radius": void 0,
	"font-style": "font-style",
	"font-weight": "font-weight",
	"hover-background": "--neos-hover-background",
	"hover-border-color": "--neos-hover-border-color",
	"hover-color": "--neos-hover-color",
	"hover-font-style": "--neos-hover-font-style",
	"hover-font-weight": "--neos-hover-font-weight",
	"hover-text-decoration": "--neos-hover-text-decoration",
	"overflow-wrap": "overflow-wrap",
	"shadow-color": "box-shadow",
	"text-align": "text-align",
	"text-decoration": "text-decoration",
	background: "background",
	color: "color"
};
var validationMessageSeverities = [
	"error",
	"warning",
	"information"
];
//#endregion
//#region src/components/HorizontalLayout/HorizontalLayout.ts?vue&type=script&src=true&lang.ts
var HorizontalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HorizontalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "left"
		},
		verticalAlign: {
			type: String,
			default: "stretch"
		},
		wrap: {
			type: Boolean,
			default: true
		},
		reverse: {
			type: Boolean,
			default: false
		},
		fullHeight: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const classes = computed(() => {
			const array = [];
			if (!props.wrap) array.push("horizontal-layout-nowrap");
			if (props.fullHeight) array.push("horizontal-layout-full-height");
			if (props.reverse) array.push("horizontal-layout-reverse");
			return array;
		});
		const style = computed(() => ({
			[`--horizontal-space`]: SpaceValues[props.space],
			[`--horizontal-align`]: AlignValues[props.align],
			[`--horizontal-vertical-align`]: VerticalAlignValues[props.verticalAlign]
		}));
		useComponentAutomationProperties();
		return {
			classes,
			style
		};
	}
});
//#endregion
//#region src/components/HorizontalLayout/HorizontalLayout.vue
function _sfc_render$30(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["horizontal-layout", _ctx.classes]),
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 6);
}
var HorizontalLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HorizontalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$30]]);
//#endregion
//#region src/components/ButtonsLayout/ButtonsLayout.vue
var ButtonsLayout_default = /* @__PURE__ */ defineComponent({
	__name: "ButtonsLayout",
	setup(__props) {
		const themeManager = useThemeManager(false);
		const reverse = computed(() => themeManager?.currentTheme.buttonsLayoutReverseOrder === true);
		const align = computed(() => reverse.value ? "start" : "end");
		const buttonContainerSpace = useButtonContainerSpace(themeManager);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: unref(buttonContainerSpace),
				reverse: reverse.value,
				align: align.value
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"space",
				"reverse",
				"align"
			]);
		};
	}
});
var csharp_default = [Object.freeze(JSON.parse("{\"displayName\":\"C#\",\"name\":\"csharp\",\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#directives\"},{\"include\":\"#declarations\"},{\"include\":\"#script-top-level\"}],\"repository\":{\"accessor-getter\":{\"patterns\":[{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"contentName\":\"meta.accessor.getter.cs\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#statement\"}]},{\"include\":\"#accessor-getter-expression\"},{\"include\":\"#punctuation-semicolon\"}]},\"accessor-getter-expression\":{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.arrow.cs\"}},\"contentName\":\"meta.accessor.getter.cs\",\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},\"accessor-setter\":{\"patterns\":[{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"contentName\":\"meta.accessor.setter.cs\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#statement\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.arrow.cs\"}},\"contentName\":\"meta.accessor.setter.cs\",\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-semicolon\"}]},\"anonymous-method-expression\":{\"patterns\":[{\"begin\":\"((?:\\\\b(?:async|static)\\\\b\\\\s*)*)(?:(@?[_[:alpha:]][_[:alnum:]]*)\\\\b|(\\\\()(?<tuple>(?:[^()]|\\\\(\\\\g<tuple>\\\\))*)(\\\\)))\\\\s*(=>)\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"match\":\"async|static\",\"name\":\"storage.modifier.$0.cs\"}]},\"2\":{\"name\":\"entity.name.variable.parameter.cs\"},\"3\":{\"name\":\"punctuation.parenthesis.open.cs\"},\"4\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#explicit-anonymous-function-parameter\"},{\"include\":\"#implicit-anonymous-function-parameter\"},{\"include\":\"#default-argument\"},{\"include\":\"#punctuation-comma\"}]},\"5\":{\"name\":\"punctuation.parenthesis.close.cs\"},\"6\":{\"name\":\"keyword.operator.arrow.cs\"}},\"end\":\"(?=[),;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"(?=\\\\{)\",\"end\":\"(?=[),;}])\",\"patterns\":[{\"include\":\"#block\"},{\"include\":\"#intrusive\"}]},{\"begin\":\"\\\\b(ref)\\\\b|(?=\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ref.cs\"}},\"end\":\"(?=[),;}])\",\"patterns\":[{\"include\":\"#expression\"}]}]},{\"begin\":\"((?:\\\\b(?:async|static)\\\\b\\\\s*)*)\\\\b(delegate)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"match\":\"async|static\",\"name\":\"storage.modifier.$0.cs\"}]},\"2\":{\"name\":\"storage.type.delegate.cs\"}},\"end\":\"(?<=})|(?=[),;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#explicit-anonymous-function-parameter\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#block\"}]}]},\"anonymous-object-creation-expression\":{\"begin\":\"\\\\b(new)\\\\b\\\\s*(?=\\\\{|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.new.cs\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#initializer-expression\"}]},\"argument\":{\"patterns\":[{\"match\":\"\\\\b(ref|in)\\\\b\",\"name\":\"storage.modifier.$1.cs\"},{\"begin\":\"\\\\b(out)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.out.cs\"}},\"end\":\"(?=[]),])\",\"patterns\":[{\"include\":\"#declaration-expression-local\"},{\"include\":\"#expression\"}]},{\"include\":\"#expression\"}]},\"argument-list\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#named-argument\"},{\"include\":\"#argument\"},{\"include\":\"#punctuation-comma\"}]},\"array-creation-expression\":{\"begin\":\"\\\\b(new|stackalloc)\\\\b\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\*\\\\s*)*(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)?\\\\s*(?=\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.$1.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]}},\"end\":\"(?<=])\",\"patterns\":[{\"include\":\"#bracketed-argument-list\"}]},\"as-expression\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.as.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]}},\"match\":\"(?<!\\\\.)\\\\b(as)\\\\b\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?(?!\\\\?))?(?:\\\\s*\\\\[\\\\s*(?:,\\\\s*)*](?:\\\\s*\\\\?(?!\\\\?))?)*)?\"},\"assignment-expression\":{\"begin\":\"(?:[-%*+/]|\\\\?\\\\?|[\\\\&^]|<<|>>>?|\\\\|)?=(?![=>])\",\"beginCaptures\":{\"0\":{\"patterns\":[{\"include\":\"#assignment-operators\"}]}},\"end\":\"(?=[]),;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},\"assignment-operators\":{\"patterns\":[{\"match\":\"(?:[-%*+/]|\\\\?\\\\?)=\",\"name\":\"keyword.operator.assignment.compound.cs\"},{\"match\":\"(?:[\\\\&^]|<<|>>>?|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.cs\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.cs\"}]},\"attribute\":{\"patterns\":[{\"include\":\"#type-name\"},{\"include\":\"#type-arguments\"},{\"include\":\"#attribute-arguments\"}]},\"attribute-arguments\":{\"begin\":\"(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#attribute-named-argument\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"attribute-named-argument\":{\"begin\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(?==)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.variable.property.cs\"}},\"end\":\"(?=([),]))\",\"patterns\":[{\"include\":\"#operator-assignment\"},{\"include\":\"#expression\"}]},\"attribute-section\":{\"begin\":\"(\\\\[)(assembly|module|field|event|method|param|property|return|typevar|type)?(:)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.squarebracket.open.cs\"},\"2\":{\"name\":\"keyword.other.attribute-specifier.cs\"},\"3\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.squarebracket.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#attribute\"},{\"include\":\"#punctuation-comma\"}]},\"await-expression\":{\"match\":\"(?<!\\\\.\\\\s*)\\\\b(await)\\\\b\",\"name\":\"keyword.operator.expression.await.cs\"},\"await-statement\":{\"begin\":\"(?<!\\\\.\\\\s*)\\\\b(await)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.await.cs\"}},\"end\":\"(?<=})|(?=[;}])\",\"patterns\":[{\"include\":\"#foreach-statement\"},{\"include\":\"#using-statement\"},{\"include\":\"#expression\"}]},\"base-class-constructor-call\":{\"begin\":\"(?:(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(\\\\.))*(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(<(?<type_args>[^()<>]|\\\\((?:[^()<>]|<[^()<>]*>|\\\\([^()<>]*\\\\))*\\\\)|<\\\\g<type_args>*>)*>\\\\s*)?(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"},\"3\":{\"name\":\"entity.name.type.cs\"},\"4\":{\"patterns\":[{\"include\":\"#type-arguments\"}]}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#argument-list\"}]},\"base-types\":{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=\\\\{|where|;)\",\"patterns\":[{\"include\":\"#base-class-constructor-call\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#preprocessor\"}]},\"block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#statement\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<!\\\\.)\\\\btrue\\\\b\",\"name\":\"constant.language.boolean.true.cs\"},{\"match\":\"(?<!\\\\.)\\\\bfalse\\\\b\",\"name\":\"constant.language.boolean.false.cs\"}]},\"bracketed-argument-list\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.open.cs\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.close.cs\"}},\"patterns\":[{\"include\":\"#named-argument\"},{\"include\":\"#argument\"},{\"include\":\"#punctuation-comma\"}]},\"bracketed-parameter-list\":{\"begin\":\"(?=(\\\\[))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.squarebracket.open.cs\"}},\"end\":\"(?=(]))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.squarebracket.close.cs\"}},\"patterns\":[{\"begin\":\"(?<=\\\\[)\",\"end\":\"(?=])\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#attribute-section\"},{\"include\":\"#parameter\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#variable-initializer\"}]}]},\"break-or-continue-statement\":{\"match\":\"(?<!\\\\.)\\\\b(break|continue)\\\\b\",\"name\":\"keyword.control.flow.$1.cs\"},\"case-guard\":{\"patterns\":[{\"include\":\"#parenthesized-expression\"},{\"include\":\"#expression\"}]},\"cast-expression\":{\"captures\":{\"1\":{\"name\":\"punctuation.parenthesis.open.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"match\":\"(\\\\()\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*(\\\\))(?=\\\\s*-*!*@?[(_[:alnum:]])\"},\"casted-constant-pattern\":{\"begin\":\"(\\\\()([.:@_\\\\s[:alnum:]]+)(\\\\))(?=[-!+~\\\\s]*@?[\\\"'(_[:alnum:]]+)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.parenthesis.open.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type-builtin\"},{\"include\":\"#type-name\"}]},\"3\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#casted-constant-pattern\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#constant-pattern\"}]},{\"include\":\"#constant-pattern\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.alias.cs\"},\"2\":{\"name\":\"punctuation.separator.coloncolon.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(::)\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(\\\\.)\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"variable.other.constant.cs\"}]},\"catch-clause\":{\"begin\":\"(?<!\\\\.)\\\\b(catch)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.exception.catch.cs\"}},\"end\":\"(?<=})\",\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"captures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"6\":{\"name\":\"entity.name.variable.local.cs\"}},\"match\":\"(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*(?:(\\\\g<identifier>)\\\\b)?\"}]},{\"include\":\"#when-clause\"},{\"include\":\"#comment\"},{\"include\":\"#block\"}]},\"char-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{1,4}|u\\\\h{4}|.)\",\"name\":\"constant.character.escape.cs\"},\"char-literal\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.char.begin.cs\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.char.end.cs\"},\"2\":{\"name\":\"invalid.illegal.newline.cs\"}},\"name\":\"string.quoted.single.cs\",\"patterns\":[{\"include\":\"#char-character-escape\"}]},\"class-declaration\":{\"begin\":\"(?=(\\\\brecord\\\\b\\\\s+)?\\\\bclass\\\\b)\",\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(\\\\b(record)\\\\b\\\\s+)?\\\\b(class)\\\\b\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"2\":{\"name\":\"storage.type.record.cs\"},\"3\":{\"name\":\"storage.type.class.cs\"},\"4\":{\"name\":\"entity.name.type.class.cs\"}},\"end\":\"(?=\\\\{)|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameter-list\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#base-types\"},{\"include\":\"#generic-constraints\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#class-or-struct-members\"}]},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"class-or-struct-members\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#storage-modifier\"},{\"include\":\"#type-declarations\"},{\"include\":\"#constructor-declaration\"},{\"include\":\"#property-declaration\"},{\"include\":\"#fixed-size-buffer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#event-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#destructor-declaration\"},{\"include\":\"#operator-declaration\"},{\"include\":\"#conversion-operator-declaration\"},{\"include\":\"#method-declaration\"},{\"include\":\"#attribute-section\"},{\"include\":\"#punctuation-semicolon\"}]},\"combinator-pattern\":{\"match\":\"\\\\b(and|or|not)\\\\b\",\"name\":\"keyword.operator.expression.pattern.combinator.$1.cs\"},\"comment\":{\"patterns\":[{\"begin\":\"(^\\\\s+)?(///)(?!/)\",\"captures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.cs\"},\"2\":{\"name\":\"punctuation.definition.comment.cs\"}},\"name\":\"comment.block.documentation.cs\",\"patterns\":[{\"include\":\"#xml-doc-comment\"}],\"while\":\"^(\\\\s*)(///)(?!/)\"},{\"begin\":\"(^\\\\s+)?(/\\\\*\\\\*)(?!/)\",\"captures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.cs\"},\"2\":{\"name\":\"punctuation.definition.comment.cs\"}},\"end\":\"(^\\\\s+)?(\\\\*/)\",\"name\":\"comment.block.documentation.cs\",\"patterns\":[{\"begin\":\"\\\\G(?=(?~\\\\*/)$)\",\"patterns\":[{\"include\":\"#xml-doc-comment\"}],\"while\":\"^(\\\\s*+)(\\\\*(?!/))?(?=(?~\\\\*/)$)\",\"whileCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.cs\"},\"2\":{\"name\":\"punctuation.definition.comment.cs\"}}},{\"include\":\"#xml-doc-comment\"}]},{\"begin\":\"(^\\\\s+)?(//).*$\",\"captures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.cs\"},\"2\":{\"name\":\"punctuation.definition.comment.cs\"}},\"name\":\"comment.line.double-slash.cs\",\"while\":\"^(\\\\s*)(//).*$\"},{\"begin\":\"/\\\\*\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.cs\"}},\"end\":\"\\\\*/\",\"name\":\"comment.block.cs\"}]},\"conditional-operator\":{\"patterns\":[{\"match\":\"\\\\?(?!\\\\?|\\\\s*[.\\\\[])\",\"name\":\"keyword.operator.conditional.question-mark.cs\"},{\"match\":\":\",\"name\":\"keyword.operator.conditional.colon.cs\"}]},\"constant-pattern\":{\"patterns\":[{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#char-literal\"},{\"include\":\"#string-literal\"},{\"include\":\"#raw-string-literal\"},{\"include\":\"#verbatim-string-literal\"},{\"include\":\"#type-operator-expression\"},{\"include\":\"#expression-operator-expression\"},{\"include\":\"#expression-operators\"},{\"include\":\"#casted-constant-pattern\"}]},\"constructor-declaration\":{\"begin\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(?=\\\\(|$)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=\\\\{|=>)\",\"patterns\":[{\"include\":\"#constructor-initializer\"}]},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"constructor-initializer\":{\"begin\":\"\\\\b(base|this)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"variable.language.$1.cs\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#argument-list\"}]},\"context-control-paren-statement\":{\"patterns\":[{\"include\":\"#fixed-statement\"},{\"include\":\"#lock-statement\"},{\"include\":\"#using-statement\"}]},\"context-control-statement\":{\"match\":\"\\\\b(checked|unchecked|unsafe)\\\\b(?!\\\\s*[(@_[:alpha:]])\",\"name\":\"keyword.control.context.$1.cs\"},\"conversion-operator-declaration\":{\"begin\":\"\\\\b(?<explicit_or_implicit_keyword>(?:ex|im)plicit)\\\\s*\\\\b(?<operator_keyword>operator)\\\\s*(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.explicit.cs\"}},\"match\":\"\\\\b(explicit)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.implicit.cs\"}},\"match\":\"\\\\b(implicit)\\\\b\"}]},\"2\":{\"name\":\"storage.type.operator.cs\"},\"3\":{\"patterns\":[{\"include\":\"#type\"}]}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"declaration-expression-local\":{\"captures\":{\"1\":{\"name\":\"storage.type.var.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.local.cs\"}},\"match\":\"(?:\\\\b(var)\\\\b|(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*))\\\\s+(\\\\g<identifier>)\\\\b\\\\s*(?=[]),])\"},\"declaration-expression-tuple\":{\"captures\":{\"1\":{\"name\":\"storage.type.var.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.tuple-element.cs\"}},\"match\":\"(?:\\\\b(var)\\\\b|(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*))\\\\s+(\\\\g<identifier>)\\\\b\\\\s*(?=[),])\"},\"declarations\":{\"patterns\":[{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-declarations\"},{\"include\":\"#punctuation-semicolon\"}]},\"default-argument\":{\"begin\":\"=\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.assignment.cs\"}},\"end\":\"(?=[),])\",\"patterns\":[{\"include\":\"#expression\"}]},\"default-literal-expression\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.default.cs\"}},\"match\":\"\\\\b(default)\\\\b\"},\"delegate-declaration\":{\"begin\":\"\\\\b(delegate)\\\\b\\\\s+(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+(\\\\g<identifier>)\\\\s*(<([^<>]+)>)?\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.delegate.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.type.delegate.cs\"},\"8\":{\"patterns\":[{\"include\":\"#type-parameter-list\"}]}},\"end\":\"(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#generic-constraints\"}]},\"designation-pattern\":{\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#designation-pattern\"}]},{\"include\":\"#simple-designation-pattern\"}]},\"destructor-declaration\":{\"begin\":\"(~)(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.tilde.cs\"},\"2\":{\"name\":\"entity.name.function.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"directives\":{\"patterns\":[{\"include\":\"#extern-alias-directive\"},{\"include\":\"#using-directive\"},{\"include\":\"#attribute-section\"},{\"include\":\"#punctuation-semicolon\"}]},\"discard-pattern\":{\"match\":\"_(?![_[:alnum:]])\",\"name\":\"variable.language.discard.cs\"},\"do-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(do)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.loop.do.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#statement\"}]},\"double-raw-interpolation\":{\"begin\":\"(?<=[^{][^{]|^)(\\\\{*)(\\\\{\\\\{)(?=[^{])\",\"beginCaptures\":{\"1\":{\"name\":\"string.quoted.double.cs\"},\"2\":{\"name\":\"punctuation.definition.interpolation.begin.cs\"}},\"end\":\"}}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.interpolation.end.cs\"}},\"name\":\"meta.embedded.interpolation.cs\",\"patterns\":[{\"include\":\"#expression\"}]},\"element-access-expression\":{\"begin\":\"(?:(?:(\\\\?)\\\\s*)?(\\\\.)\\\\s*|(->)\\\\s*)?(?:(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*)?(?:(\\\\?)\\\\s*)?(?=\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.null-conditional.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"},\"3\":{\"name\":\"punctuation.accessor.pointer.cs\"},\"4\":{\"name\":\"variable.other.object.property.cs\"},\"5\":{\"name\":\"keyword.operator.null-conditional.cs\"}},\"end\":\"(?<=])(?!\\\\s*\\\\[)\",\"patterns\":[{\"include\":\"#bracketed-argument-list\"}]},\"else-part\":{\"begin\":\"(?<!\\\\.)\\\\b(else)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.else.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#statement\"}]},\"enum-declaration\":{\"begin\":\"(?=\\\\benum\\\\b)\",\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(?=enum)\",\"end\":\"(?=\\\\{)|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"storage.type.enum.cs\"},\"2\":{\"name\":\"entity.name.type.enum.cs\"}},\"match\":\"(enum)\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\"},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#type\"}]}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#attribute-section\"},{\"include\":\"#punctuation-comma\"},{\"begin\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.variable.enum-member.cs\"}},\"end\":\"(?=([,}]))\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]}]},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"event-accessors\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#attribute-section\"},{\"begin\":\"\\\\b(add|remove)\\\\b\\\\s*(?=[;{]|=>|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.accessor.$1.cs\"}},\"end\":\"(?<=[;}])|(?=})\",\"patterns\":[{\"include\":\"#accessor-setter\"}]}]},\"event-declaration\":{\"begin\":\"\\\\b(event)\\\\b\\\\s*(?<return_type>(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+)(?<interface_name>\\\\g<type_name>\\\\s*\\\\.\\\\s*)?(\\\\g<identifier>)\\\\s*(?=[,;={]|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.event.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"8\":{\"patterns\":[{\"include\":\"#type\"},{\"include\":\"#punctuation-accessor\"}]},\"9\":{\"name\":\"entity.name.variable.event.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#event-accessors\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.event.cs\"},{\"include\":\"#punctuation-comma\"},{\"begin\":\"=\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.assignment.cs\"}},\"end\":\"(?<=,)|(?=;)\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]}]},\"explicit-anonymous-function-parameter\":{\"captures\":{\"1\":{\"name\":\"storage.modifier.$1.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.parameter.cs\"}},\"match\":\"(?:\\\\b(ref|params|out|in)\\\\b\\\\s*)?(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args><(?:[^<>]|\\\\g<type_args>)*>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)*\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*\\\\b(\\\\g<identifier>)\\\\b\"},\"expression\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#expression-operator-expression\"},{\"include\":\"#type-operator-expression\"},{\"include\":\"#default-literal-expression\"},{\"include\":\"#throw-expression\"},{\"include\":\"#raw-interpolated-string\"},{\"include\":\"#interpolated-string\"},{\"include\":\"#verbatim-interpolated-string\"},{\"include\":\"#type-builtin\"},{\"include\":\"#language-variable\"},{\"include\":\"#switch-statement-or-expression\"},{\"include\":\"#with-expression\"},{\"include\":\"#conditional-operator\"},{\"include\":\"#assignment-expression\"},{\"include\":\"#expression-operators\"},{\"include\":\"#await-expression\"},{\"include\":\"#query-expression\"},{\"include\":\"#as-expression\"},{\"include\":\"#is-expression\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#anonymous-method-expression\"},{\"include\":\"#object-creation-expression\"},{\"include\":\"#array-creation-expression\"},{\"include\":\"#anonymous-object-creation-expression\"},{\"include\":\"#invocation-expression\"},{\"include\":\"#member-access-expression\"},{\"include\":\"#element-access-expression\"},{\"include\":\"#cast-expression\"},{\"include\":\"#literal\"},{\"include\":\"#parenthesized-expression\"},{\"include\":\"#tuple-deconstruction-assignment\"},{\"include\":\"#initializer-expression\"},{\"include\":\"#identifier\"}]},\"expression-body\":{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.arrow.cs\"}},\"end\":\"(?=[),;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},\"expression-operator-expression\":{\"begin\":\"\\\\b(checked|unchecked|nameof)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.$1.cs\"},\"2\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.cs\"},{\"match\":\"[!=]=\",\"name\":\"keyword.operator.comparison.cs\"},{\"match\":\"<=|>=|[<>]\",\"name\":\"keyword.operator.relational.cs\"},{\"match\":\"!|&&|\\\\|\\\\|\",\"name\":\"keyword.operator.logical.cs\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.cs\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.cs\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.cs\"},{\"match\":\"\\\\+|-(?!>)|[%*/]\",\"name\":\"keyword.operator.arithmetic.cs\"},{\"match\":\"\\\\?\\\\?\",\"name\":\"keyword.operator.null-coalescing.cs\"},{\"match\":\"\\\\.\\\\.\",\"name\":\"keyword.operator.range.cs\"}]},\"extern-alias-directive\":{\"begin\":\"\\\\b(extern)\\\\s+(alias)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.other.directive.extern.cs\"},\"2\":{\"name\":\"keyword.other.directive.alias.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"variable.other.alias.cs\"}]},\"field-declaration\":{\"begin\":\"(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+(\\\\g<identifier>)\\\\s*(?!=[=>])(?=[,;=]|$)\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"6\":{\"name\":\"entity.name.variable.field.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.field.cs\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#class-or-struct-members\"}]},\"finally-clause\":{\"begin\":\"(?<!\\\\.)\\\\b(finally)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.exception.finally.cs\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#block\"}]},\"fixed-size-buffer-declaration\":{\"begin\":\"\\\\b(fixed)\\\\b\\\\s+(?<type_name>(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*)\\\\s+(\\\\g<identifier>)\\\\s*(?=\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.fixed.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"6\":{\"name\":\"entity.name.variable.field.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"include\":\"#bracketed-argument-list\"},{\"include\":\"#comment\"}]},\"fixed-statement\":{\"begin\":\"\\\\b(fixed)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.context.fixed.cs\"}},\"end\":\"(?<=\\\\))|(?=[;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#local-variable-declaration\"}]}]},\"for-statement\":{\"begin\":\"\\\\b(for)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.loop.for.cs\"}},\"end\":\"(?<=\\\\))|(?=[;}])\",\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"begin\":\"(?=[^);])\",\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#local-variable-declaration\"},{\"include\":\"#local-tuple-var-deconstruction\"},{\"include\":\"#tuple-deconstruction-assignment\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?=;)\",\"end\":\"(?=\\\\))\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]}]}]},\"foreach-statement\":{\"begin\":\"\\\\b(foreach)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.loop.foreach.cs\"}},\"end\":\"(?<=\\\\))|(?=[;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ref.cs\"},\"2\":{\"name\":\"storage.type.var.cs\"},\"3\":{\"patterns\":[{\"include\":\"#type\"}]},\"8\":{\"name\":\"entity.name.variable.local.cs\"},\"9\":{\"name\":\"keyword.control.loop.in.cs\"}},\"match\":\"(?:(?:\\\\b(ref)\\\\s+)?\\\\b(var)\\\\b|(?<type_name>(?:ref\\\\s+)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*))\\\\s+(\\\\g<identifier>)\\\\s+\\\\b(in)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.var.cs\"},\"2\":{\"patterns\":[{\"include\":\"#tuple-declaration-deconstruction-element-list\"}]},\"3\":{\"name\":\"keyword.control.loop.in.cs\"}},\"match\":\"(?:\\\\b(var)\\\\b\\\\s*)?(?<tuple>\\\\((?:[^()]|\\\\g<tuple>)+\\\\))\\\\s+\\\\b(in)\\\\b\"},{\"include\":\"#expression\"}]}]},\"generic-constraints\":{\"begin\":\"(where)\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.where.cs\"},\"2\":{\"name\":\"entity.name.type.type-parameter.cs\"},\"3\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=\\\\{|where|;|=>)\",\"patterns\":[{\"match\":\"\\\\bclass\\\\b\",\"name\":\"storage.type.class.cs\"},{\"match\":\"\\\\bstruct\\\\b\",\"name\":\"storage.type.struct.cs\"},{\"match\":\"\\\\bdefault\\\\b\",\"name\":\"keyword.other.constraint.default.cs\"},{\"match\":\"\\\\bnotnull\\\\b\",\"name\":\"keyword.other.constraint.notnull.cs\"},{\"match\":\"\\\\bunmanaged\\\\b\",\"name\":\"keyword.other.constraint.unmanaged.cs\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.new.cs\"},\"2\":{\"name\":\"punctuation.parenthesis.open.cs\"},\"3\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"match\":\"(new)\\\\s*(\\\\()\\\\s*(\\\\))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#generic-constraints\"}]},\"goto-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(goto)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.goto.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"begin\":\"\\\\b(case)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.case.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.conditional.default.cs\"}},\"match\":\"\\\\b(default)\\\\b\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.label.cs\"}]},\"group-by\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.by.cs\"}},\"match\":\"\\\\b(by)\\\\b\\\\s*\"},\"group-clause\":{\"begin\":\"\\\\b(group)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.group.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#group-by\"},{\"include\":\"#group-into\"},{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"group-into\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.into.cs\"},\"2\":{\"name\":\"entity.name.variable.range-variable.cs\"}},\"match\":\"\\\\b(into)\\\\b\\\\s*(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\\\\s*\"},\"identifier\":{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"variable.other.readwrite.cs\"},\"if-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(if)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.if.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#statement\"}]},\"implicit-anonymous-function-parameter\":{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\\\\b\",\"name\":\"entity.name.variable.parameter.cs\"},\"indexer-declaration\":{\"begin\":\"(?<return_type>(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+)(?<interface_name>\\\\g<type_name>\\\\s*\\\\.\\\\s*)?(?<indexer_name>this)\\\\s*(?=\\\\[)\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"patterns\":[{\"include\":\"#type\"},{\"include\":\"#punctuation-accessor\"}]},\"8\":{\"name\":\"variable.language.this.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#bracketed-parameter-list\"},{\"include\":\"#property-accessors\"},{\"include\":\"#accessor-getter-expression\"},{\"include\":\"#variable-initializer\"}]},\"initializer-expression\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"interface-declaration\":{\"begin\":\"(?=\\\\binterface\\\\b)\",\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(interface)\\\\b\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.interface.cs\"},\"2\":{\"name\":\"entity.name.type.interface.cs\"}},\"end\":\"(?=\\\\{)|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameter-list\"},{\"include\":\"#base-types\"},{\"include\":\"#generic-constraints\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#interface-members\"}]},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"interface-members\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#storage-modifier\"},{\"include\":\"#property-declaration\"},{\"include\":\"#event-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#method-declaration\"},{\"include\":\"#operator-declaration\"},{\"include\":\"#attribute-section\"},{\"include\":\"#punctuation-semicolon\"}]},\"interpolated-string\":{\"begin\":\"\\\\$\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.cs\"},\"2\":{\"name\":\"invalid.illegal.newline.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#string-character-escape\"},{\"include\":\"#interpolation\"}]},\"interpolation\":{\"begin\":\"(?<=[^{]|^)((?:\\\\{\\\\{)*)(\\\\{)(?=[^{])\",\"beginCaptures\":{\"1\":{\"name\":\"string.quoted.double.cs\"},\"2\":{\"name\":\"punctuation.definition.interpolation.begin.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.interpolation.end.cs\"}},\"name\":\"meta.embedded.interpolation.cs\",\"patterns\":[{\"include\":\"#expression\"}]},\"intrusive\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"invocation-expression\":{\"begin\":\"(?:(?:(\\\\?)\\\\s*)?(\\\\.)\\\\s*|(->)\\\\s*)?(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(<(?<type_args>[^()<>]|\\\\((?:[^()<>]|<[^()<>]*>|\\\\([^()<>]*\\\\))*\\\\)|<\\\\g<type_args>*>)*>\\\\s*)?(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.null-conditional.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"},\"3\":{\"name\":\"punctuation.accessor.pointer.cs\"},\"4\":{\"name\":\"entity.name.function.cs\"},\"5\":{\"patterns\":[{\"include\":\"#type-arguments\"}]}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#argument-list\"}]},\"is-expression\":{\"begin\":\"(?<!\\\\.)\\\\b(is)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.pattern.is.cs\"}},\"end\":\"(?=[]\\\\&),:;=?^|}]|!=)\",\"patterns\":[{\"include\":\"#pattern\"}]},\"join-clause\":{\"begin\":\"\\\\b(join)\\\\b\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)?\\\\s+(\\\\g<identifier>)\\\\b\\\\s*\\\\b(in)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.join.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.range-variable.cs\"},\"8\":{\"name\":\"keyword.operator.expression.query.in.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#join-on\"},{\"include\":\"#join-equals\"},{\"include\":\"#join-into\"},{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"join-equals\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.equals.cs\"}},\"match\":\"\\\\b(equals)\\\\b\\\\s*\"},\"join-into\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.into.cs\"},\"2\":{\"name\":\"entity.name.variable.range-variable.cs\"}},\"match\":\"\\\\b(into)\\\\b\\\\s*(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\\\\s*\"},\"join-on\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.on.cs\"}},\"match\":\"\\\\b(on)\\\\b\\\\s*\"},\"labeled-statement\":{\"captures\":{\"1\":{\"name\":\"entity.name.label.cs\"},\"2\":{\"name\":\"punctuation.separator.colon.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(:)\"},\"language-variable\":{\"patterns\":[{\"match\":\"\\\\b(base|this)\\\\b\",\"name\":\"variable.language.$1.cs\"},{\"match\":\"\\\\b(value)\\\\b\",\"name\":\"variable.other.$1.cs\"}]},\"let-clause\":{\"begin\":\"\\\\b(let)\\\\b\\\\s*(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\\\\s*(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.let.cs\"},\"2\":{\"name\":\"entity.name.variable.range-variable.cs\"},\"3\":{\"name\":\"keyword.operator.assignment.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"list-pattern\":{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.open.cs\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.close.cs\"}},\"patterns\":[{\"include\":\"#pattern\"},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?<=])\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#simple-designation-pattern\"}]}]},\"literal\":{\"patterns\":[{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#char-literal\"},{\"include\":\"#raw-string-literal\"},{\"include\":\"#string-literal\"},{\"include\":\"#verbatim-string-literal\"},{\"include\":\"#tuple-literal\"}]},\"local-constant-declaration\":{\"begin\":\"\\\\b(?<const_keyword>const)\\\\b\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+(\\\\g<identifier>)\\\\s*(?=[,;=])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.const.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.local.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.local.cs\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},\"local-declaration\":{\"patterns\":[{\"include\":\"#local-constant-declaration\"},{\"include\":\"#local-variable-declaration\"},{\"include\":\"#local-function-declaration\"},{\"include\":\"#local-tuple-var-deconstruction\"},{\"include\":\"#local-tuple-declaration-deconstruction\"}]},\"local-function-declaration\":{\"begin\":\"\\\\b((?:(?:async|unsafe|static|extern)\\\\s+)*)(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?)?(?:\\\\s*\\\\[\\\\s*(?:,\\\\s*)*](?:\\\\s*\\\\?)?)*)\\\\s+(\\\\g<identifier>)\\\\s*(<[^<>]+>)?\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#storage-modifier\"}]},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.function.cs\"},\"8\":{\"patterns\":[{\"include\":\"#type-parameter-list\"}]}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#generic-constraints\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"local-tuple-declaration-deconstruction\":{\"captures\":{\"1\":{\"patterns\":[{\"include\":\"#tuple-declaration-deconstruction-element-list\"}]}},\"match\":\"(?<tuple>\\\\((?:[^()]|\\\\g<tuple>)+\\\\))\\\\s*(?!=[=>])(?==)\"},\"local-tuple-var-deconstruction\":{\"begin\":\"\\\\b(var)\\\\b\\\\s*(?<tuple>\\\\((?:[^()]|\\\\g<tuple>)+\\\\))\\\\s*(?=[);=])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.var.cs\"},\"2\":{\"patterns\":[{\"include\":\"#tuple-declaration-deconstruction-element-list\"}]}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},\"local-variable-declaration\":{\"begin\":\"(?:(?:\\\\b(ref)\\\\s+(?:\\\\b(readonly)\\\\s+)?)?\\\\b(var)\\\\b|(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\*\\\\s*)*(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*))\\\\s+(\\\\g<identifier>)\\\\s*(?!=>)(?=[),;=])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ref.cs\"},\"2\":{\"name\":\"storage.modifier.readonly.cs\"},\"3\":{\"name\":\"storage.type.var.cs\"},\"4\":{\"patterns\":[{\"include\":\"#type\"}]},\"9\":{\"name\":\"entity.name.variable.local.cs\"}},\"end\":\"(?=[);}])\",\"patterns\":[{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.local.cs\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},\"lock-statement\":{\"begin\":\"\\\\b(lock)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.context.lock.cs\"}},\"end\":\"(?<=\\\\))|(?=[;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#expression\"}]}]},\"member-access-expression\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.null-conditional.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"},\"3\":{\"name\":\"punctuation.accessor.pointer.cs\"},\"4\":{\"name\":\"variable.other.object.property.cs\"}},\"match\":\"(?:(?:(\\\\?)\\\\s*)?(\\\\.)\\\\s*|(->)\\\\s*)(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(?![(_[:alnum:]]|(\\\\?)?\\\\[|<)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.cs\"},\"2\":{\"name\":\"variable.other.object.cs\"},\"3\":{\"patterns\":[{\"include\":\"#type-arguments\"}]}},\"match\":\"(\\\\.)?\\\\s*(@?[_[:alpha:]][_[:alnum:]]*)(?<type_params>\\\\s*<([^<>]|\\\\g<type_params>)+>\\\\s*)(?=(\\\\s*\\\\?)?\\\\s*\\\\.\\\\s*@?[_[:alpha:]][_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.object.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)(?=\\\\s*(?:(?:\\\\?\\\\s*)?\\\\.|->)\\\\s*@?[_[:alpha:]][_[:alnum:]]*)\"}]},\"method-declaration\":{\"begin\":\"(?<return_type>(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+)(?<interface_name>\\\\g<type_name>\\\\s*\\\\.\\\\s*)?(\\\\g<identifier>)\\\\s*(<([^<>]+)>)?\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"patterns\":[{\"include\":\"#type\"},{\"include\":\"#punctuation-accessor\"}]},\"8\":{\"name\":\"entity.name.function.cs\"},\"9\":{\"patterns\":[{\"include\":\"#type-parameter-list\"}]}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#generic-constraints\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"named-argument\":{\"begin\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.variable.parameter.cs\"},\"2\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=([]),]))\",\"patterns\":[{\"include\":\"#argument\"}]},\"namespace-declaration\":{\"begin\":\"\\\\b(namespace)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.namespace.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.namespace.cs\"},{\"include\":\"#punctuation-accessor\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#declarations\"},{\"include\":\"#using-directive\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"null-literal\":{\"match\":\"(?<!\\\\.)\\\\bnull\\\\b\",\"name\":\"constant.language.null.cs\"},\"numeric-literal\":{\"captures\":{\"0\":{\"patterns\":[{\"begin\":\"(?=.)\",\"end\":\"$\",\"patterns\":[{\"captures\":{\"2\":{\"name\":\"constant.numeric.decimal.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"3\":{\"name\":\"constant.numeric.other.separator.thousands.cs\"},\"4\":{\"name\":\"constant.numeric.other.separator.decimals.cs\"},\"5\":{\"name\":\"constant.numeric.decimal.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"6\":{\"name\":\"constant.numeric.other.separator.thousands.cs\"},\"8\":{\"name\":\"constant.numeric.other.exponent.cs\"},\"9\":{\"name\":\"keyword.operator.arithmetic.cs\"},\"10\":{\"name\":\"keyword.operator.arithmetic.cs\"},\"11\":{\"name\":\"constant.numeric.decimal.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"12\":{\"name\":\"constant.numeric.other.suffix.cs\"}},\"match\":\"\\\\G((?=[.0-9])(?!0[BXbx]))([0-9](?:[0-9]|((?<=\\\\h)_(?=\\\\h)))*)?((?<=[0-9])|\\\\.(?=[0-9]))([0-9](?:[0-9]|((?<=\\\\h)_(?=\\\\h)))*)?((?<!_)([Ee])(\\\\+?)(-?)([0-9](?:[0-9]|(?<=\\\\h)_(?=\\\\h))*))?([DFMdfm](?!\\\\w))?$\"},{\"captures\":{\"1\":{\"name\":\"constant.numeric.other.preffix.binary.cs\"},\"2\":{\"name\":\"constant.numeric.binary.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"3\":{\"name\":\"constant.numeric.other.separator.thousands.cs\"},\"4\":{\"name\":\"constant.numeric.other.suffix.cs\"}},\"match\":\"\\\\G(0[Bb])([01_](?:[01_]|((?<=\\\\h)_(?=\\\\h)))*)((?:(?:(?:(?:(?:[Uu]|[Uu]l)|[Uu]L)|l[Uu]?)|L[Uu]?)|[DFMdfm])(?!\\\\w))?$\"},{\"captures\":{\"1\":{\"name\":\"constant.numeric.other.preffix.hex.cs\"},\"2\":{\"name\":\"constant.numeric.hex.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"3\":{\"name\":\"constant.numeric.other.separator.thousands.cs\"},\"4\":{\"name\":\"constant.numeric.other.suffix.cs\"}},\"match\":\"\\\\G(0[Xx])(\\\\h(?:\\\\h|((?<=\\\\h)_(?=\\\\h)))*)((?:(?:(?:(?:(?:[Uu]|[Uu]l)|[Uu]L)|l[Uu]?)|L[Uu]?)|[DFMdfm])(?!\\\\w))?$\"},{\"captures\":{\"2\":{\"name\":\"constant.numeric.decimal.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"3\":{\"name\":\"constant.numeric.other.separator.thousands.cs\"},\"5\":{\"name\":\"constant.numeric.other.exponent.cs\"},\"6\":{\"name\":\"keyword.operator.arithmetic.cs\"},\"7\":{\"name\":\"keyword.operator.arithmetic.cs\"},\"8\":{\"name\":\"constant.numeric.decimal.cs\",\"patterns\":[{\"match\":\"(?<=\\\\h)_(?=\\\\h)\",\"name\":\"constant.numeric.other.separator.thousands.cs\"}]},\"9\":{\"name\":\"constant.numeric.other.suffix.cs\"}},\"match\":\"\\\\G((?=[.0-9])(?!0[BXbx]))([0-9](?:[0-9]|((?<=\\\\h)_(?=\\\\h)))*)((?<!_)([Ee])(\\\\+?)(-?)([0-9](?:[0-9]|(?<=\\\\h)_(?=\\\\h))*))?((?:(?:(?:(?:(?:[Uu]|[Uu]l)|[Uu]L)|l[Uu]?)|L[Uu]?)|[DFMdfm])(?!\\\\w))?$\"},{\"match\":\"(?:[0-9A-Z_a-z]|(?<=[Ee])[-+]|\\\\.\\\\d)+\",\"name\":\"invalid.illegal.constant.numeric.cs\"}]}]}},\"match\":\"(?<!\\\\w)\\\\.?\\\\d(?:[0-9A-Z_a-z]|(?<=[Ee])[-+]|\\\\.\\\\d)*\"},\"object-creation-expression\":{\"patterns\":[{\"include\":\"#object-creation-expression-with-parameters\"},{\"include\":\"#object-creation-expression-with-no-parameters\"}]},\"object-creation-expression-with-no-parameters\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.new.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]}},\"match\":\"(new)\\\\s+(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*(?=\\\\{|//|/\\\\*|$)\"},\"object-creation-expression-with-parameters\":{\"begin\":\"(new)(?:\\\\s+(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*))?\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.new.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#argument-list\"}]},\"operator-assignment\":{\"match\":\"(?<![!=])(=)(?!=)\",\"name\":\"keyword.operator.assignment.cs\"},\"operator-declaration\":{\"begin\":\"(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s*\\\\b(?<operator_keyword>operator)\\\\b\\\\s*(?<operator>[-!%\\\\&*+/<=>^|~]+|true|false)\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"6\":{\"name\":\"storage.type.operator.cs\"},\"7\":{\"name\":\"entity.name.function.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#expression-body\"},{\"include\":\"#block\"}]},\"orderby-clause\":{\"begin\":\"\\\\b(orderby)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.orderby.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#ordering-direction\"},{\"include\":\"#query-body\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"ordering-direction\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.query.$1.cs\"}},\"match\":\"\\\\b((?:a|de)scending)\\\\b\"},\"parameter\":{\"captures\":{\"1\":{\"name\":\"storage.modifier.$1.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.parameter.cs\"}},\"match\":\"(?:\\\\b(ref|params|out|in|this)\\\\b\\\\s+)?(?<type_name>(?:ref\\\\s+)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+(\\\\g<identifier>)\"},\"parenthesized-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"parenthesized-parameter-list\":{\"begin\":\"(\\\\()\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#attribute-section\"},{\"include\":\"#parameter\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#variable-initializer\"}]},\"pattern\":{\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#combinator-pattern\"},{\"include\":\"#discard-pattern\"},{\"include\":\"#constant-pattern\"},{\"include\":\"#relational-pattern\"},{\"include\":\"#var-pattern\"},{\"include\":\"#type-pattern\"},{\"include\":\"#positional-pattern\"},{\"include\":\"#property-pattern\"},{\"include\":\"#list-pattern\"},{\"include\":\"#slice-pattern\"}]},\"positional-pattern\":{\"begin\":\"(?=\\\\()\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#subpattern\"},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?<=\\\\))\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#property-pattern\"},{\"include\":\"#simple-designation-pattern\"}]}]},\"preprocessor\":{\"begin\":\"^\\\\s*(#)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.hash.cs\"}},\"end\":\"(?<=$)\",\"name\":\"meta.preprocessor.cs\",\"patterns\":[{\"include\":\"#preprocessor-comment\"},{\"include\":\"#preprocessor-define-or-undef\"},{\"include\":\"#preprocessor-if-or-elif\"},{\"include\":\"#preprocessor-else-or-endif\"},{\"include\":\"#preprocessor-warning-or-error\"},{\"include\":\"#preprocessor-region\"},{\"include\":\"#preprocessor-endregion\"},{\"include\":\"#preprocessor-load\"},{\"include\":\"#preprocessor-r\"},{\"include\":\"#preprocessor-line\"},{\"include\":\"#preprocessor-pragma-warning\"},{\"include\":\"#preprocessor-pragma-checksum\"},{\"include\":\"#preprocessor-app-directive\"}]},\"preprocessor-app-directive\":{\"begin\":\"\\\\s*(:)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.colon.cs\"}},\"end\":\"(?=$)\",\"patterns\":[{\"include\":\"#preprocessor-app-directive-package\"},{\"include\":\"#preprocessor-app-directive-property\"},{\"include\":\"#preprocessor-app-directive-exclude\"},{\"include\":\"#preprocessor-app-directive-include\"},{\"include\":\"#preprocessor-app-directive-project\"},{\"include\":\"#preprocessor-app-directive-sdk\"},{\"include\":\"#preprocessor-app-directive-generic\"}]},\"preprocessor-app-directive-exclude\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.exclude.cs\"},\"2\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(exclude)\\\\b\\\\s*(.*)?\\\\s*\"},\"preprocessor-app-directive-generic\":{\"captures\":{\"1\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(.*)?\\\\s*\"},\"preprocessor-app-directive-include\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.include.cs\"},\"2\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(include)\\\\b\\\\s*(.*)?\\\\s*\"},\"preprocessor-app-directive-package\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.package.cs\"},\"2\":{\"patterns\":[{\"include\":\"#preprocessor-app-directive-package-name\"}]},\"3\":{\"name\":\"punctuation.separator.at.cs\"},\"4\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(package)\\\\b\\\\s*([_[:alpha:]][._[:alnum:]]*)?(@)?(.*)?\\\\s*\"},\"preprocessor-app-directive-package-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.dot.cs\"},\"2\":{\"name\":\"entity.name.variable.preprocessor.symbol.cs\"}},\"match\":\"(\\\\.)([_[:alpha:]][_[:alnum:]]*)\"},{\"match\":\"[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.preprocessor.symbol.cs\"}]},\"preprocessor-app-directive-project\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.project.cs\"},\"2\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(project)\\\\b\\\\s*(.*)?\\\\s*\"},\"preprocessor-app-directive-property\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.property.cs\"},\"2\":{\"name\":\"entity.name.variable.preprocessor.symbol.cs\"},\"3\":{\"name\":\"punctuation.separator.equals.cs\"},\"4\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(property)\\\\b\\\\s*([_[:alpha:]][_[:alnum:]]*)?(=)?(.*)?\\\\s*\"},\"preprocessor-app-directive-sdk\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.sdk.cs\"},\"2\":{\"patterns\":[{\"include\":\"#preprocessor-app-directive-package-name\"}]},\"3\":{\"name\":\"punctuation.separator.at.cs\"},\"4\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(sdk)\\\\b\\\\s*([_[:alpha:]][._[:alnum:]]*)?(@)?(.*)?\\\\s*\"},\"preprocessor-comment\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.cs\"}},\"match\":\"(//).*(?=$)\",\"name\":\"comment.line.double-slash.cs\"},{\"begin\":\"/\\\\*\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.cs\"}},\"end\":\"\\\\*/\",\"name\":\"comment.block.cs\"}]},\"preprocessor-define-or-undef\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.define.cs\"},\"2\":{\"name\":\"keyword.preprocessor.undef.cs\"},\"3\":{\"name\":\"entity.name.variable.preprocessor.symbol.cs\"}},\"match\":\"\\\\b(?:(define)|(undef))\\\\b\\\\s*\\\\b([_[:alpha:]][_[:alnum:]]*)\\\\b\"},\"preprocessor-else-or-endif\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.else.cs\"},\"2\":{\"name\":\"keyword.preprocessor.endif.cs\"}},\"match\":\"\\\\b(?:(else)|(endif))\\\\b\"},\"preprocessor-endregion\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.endregion.cs\"}},\"match\":\"\\\\b(endregion)\\\\b\"},\"preprocessor-expression\":{\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#preprocessor-expression\"}]},{\"captures\":{\"1\":{\"name\":\"constant.language.boolean.true.cs\"},\"2\":{\"name\":\"constant.language.boolean.false.cs\"},\"3\":{\"name\":\"entity.name.variable.preprocessor.symbol.cs\"}},\"match\":\"\\\\b(?:(true)|(false)|([_[:alpha:]][_[:alnum:]]*))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.comparison.cs\"},\"2\":{\"name\":\"keyword.operator.logical.cs\"}},\"match\":\"([!=]=)|(!|&&|\\\\|\\\\|)\"}]},\"preprocessor-if-or-elif\":{\"begin\":\"\\\\b(?:(if)|(elif))\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.preprocessor.if.cs\"},\"2\":{\"name\":\"keyword.preprocessor.elif.cs\"}},\"end\":\"(?=$)\",\"patterns\":[{\"include\":\"#preprocessor-comment\"},{\"include\":\"#preprocessor-expression\"}]},\"preprocessor-line\":{\"begin\":\"\\\\b(line)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.preprocessor.line.cs\"}},\"end\":\"(?=$)\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.default.cs\"},\"2\":{\"name\":\"keyword.preprocessor.hidden.cs\"}},\"match\":\"\\\\b(default|hidden)\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.cs\"}},\"match\":\"[0-9]+\"},{\"captures\":{\"0\":{\"name\":\"string.quoted.double.cs\"}},\"match\":\"\\\"[^\\\"]*\\\"\"}]},\"preprocessor-load\":{\"begin\":\"\\\\b(load)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.preprocessor.load.cs\"}},\"end\":\"(?=$)\",\"patterns\":[{\"captures\":{\"0\":{\"name\":\"string.quoted.double.cs\"}},\"match\":\"\\\"[^\\\"]*\\\"\"}]},\"preprocessor-pragma-checksum\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.pragma.cs\"},\"2\":{\"name\":\"keyword.preprocessor.checksum.cs\"},\"3\":{\"name\":\"string.quoted.double.cs\"},\"4\":{\"name\":\"string.quoted.double.cs\"},\"5\":{\"name\":\"string.quoted.double.cs\"}},\"match\":\"\\\\b(pragma)\\\\b\\\\s*\\\\b(checksum)\\\\b\\\\s*(\\\"[^\\\"]*\\\")\\\\s*(\\\"[^\\\"]*\\\")\\\\s*(\\\"[^\\\"]*\\\")\"},\"preprocessor-pragma-warning\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.pragma.cs\"},\"2\":{\"name\":\"keyword.preprocessor.warning.cs\"},\"3\":{\"name\":\"keyword.preprocessor.disable.cs\"},\"4\":{\"name\":\"keyword.preprocessor.restore.cs\"},\"5\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.cs\"}},\"match\":\"[0-9]+\"},{\"include\":\"#punctuation-comma\"}]}},\"match\":\"\\\\b(pragma)\\\\b\\\\s*\\\\b(warning)\\\\b\\\\s*\\\\b(?:(disable)|(restore))\\\\b(\\\\s*[0-9]+(?:\\\\s*,\\\\s*[0-9]+)?)?\"},\"preprocessor-r\":{\"begin\":\"\\\\b(r)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.preprocessor.r.cs\"}},\"end\":\"(?=$)\",\"patterns\":[{\"captures\":{\"0\":{\"name\":\"string.quoted.double.cs\"}},\"match\":\"\\\"[^\\\"]*\\\"\"}]},\"preprocessor-region\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.region.cs\"},\"2\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(region)\\\\b\\\\s*(.*)(?=$)\"},\"preprocessor-warning-or-error\":{\"captures\":{\"1\":{\"name\":\"keyword.preprocessor.warning.cs\"},\"2\":{\"name\":\"keyword.preprocessor.error.cs\"},\"3\":{\"name\":\"string.unquoted.preprocessor.message.cs\"}},\"match\":\"\\\\b(?:(warning)|(error))\\\\b\\\\s*(.*)(?=$)\"},\"property-accessors\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#attribute-section\"},{\"match\":\"\\\\b(private|protected|internal)\\\\b\",\"name\":\"storage.modifier.$1.cs\"},{\"begin\":\"(?:\\\\b(readonly)\\\\s+)?\\\\b(get)\\\\b\\\\s*(?=[;{]|=>|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.readonly.cs\"},\"2\":{\"name\":\"storage.type.accessor.get.cs\"}},\"end\":\"(?<=[;}])|(?=})\",\"patterns\":[{\"include\":\"#accessor-getter\"}]},{\"begin\":\"\\\\b(set|init)\\\\b\\\\s*(?=[;{]|=>|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.accessor.$1.cs\"}},\"end\":\"(?<=[;}])|(?=})\",\"patterns\":[{\"include\":\"#accessor-setter\"}]}]},\"property-declaration\":{\"begin\":\"(?![[:word:]\\\\s]*\\\\b(?:class|interface|struct|enum|event)\\\\b)(?<return_type>(?<type_name>(?:ref\\\\s+(?:readonly\\\\s+)?)?(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)\\\\s+)(?<interface_name>\\\\g<type_name>\\\\s*\\\\.\\\\s*)?(?<property_name>\\\\g<identifier>)\\\\s*(?=\\\\{|=>|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"patterns\":[{\"include\":\"#type\"},{\"include\":\"#punctuation-accessor\"}]},\"8\":{\"name\":\"entity.name.variable.property.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#property-accessors\"},{\"include\":\"#accessor-getter-expression\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#class-or-struct-members\"}]},\"property-pattern\":{\"begin\":\"(?=\\\\{)\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#subpattern\"},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?<=})\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#simple-designation-pattern\"}]}]},\"punctuation-accessor\":{\"match\":\"\\\\.\",\"name\":\"punctuation.accessor.cs\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.cs\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.cs\"},\"query-body\":{\"patterns\":[{\"include\":\"#let-clause\"},{\"include\":\"#where-clause\"},{\"include\":\"#join-clause\"},{\"include\":\"#orderby-clause\"},{\"include\":\"#select-clause\"},{\"include\":\"#group-clause\"}]},\"query-expression\":{\"begin\":\"\\\\b(from)\\\\b\\\\s*(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)?\\\\s+(\\\\g<identifier>)\\\\b\\\\s*\\\\b(in)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.from.cs\"},\"2\":{\"patterns\":[{\"include\":\"#type\"}]},\"7\":{\"name\":\"entity.name.variable.range-variable.cs\"},\"8\":{\"name\":\"keyword.operator.expression.query.in.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"raw-interpolated-string\":{\"patterns\":[{\"include\":\"#raw-interpolated-string-five-or-more-quote-one-or-more-interpolation\"},{\"include\":\"#raw-interpolated-string-three-or-more-quote-three-or-more-interpolation\"},{\"include\":\"#raw-interpolated-string-quadruple-quote-double-interpolation\"},{\"include\":\"#raw-interpolated-string-quadruple-quote-single-interpolation\"},{\"include\":\"#raw-interpolated-string-triple-quote-double-interpolation\"},{\"include\":\"#raw-interpolated-string-triple-quote-single-interpolation\"}]},\"raw-interpolated-string-five-or-more-quote-one-or-more-interpolation\":{\"begin\":\"\\\\$+\\\"\\\"\\\"\\\"\\\"+\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\\\"\\\"+\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\"},\"raw-interpolated-string-quadruple-quote-double-interpolation\":{\"begin\":\"\\\\$\\\\$\\\"\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#double-raw-interpolation\"}]},\"raw-interpolated-string-quadruple-quote-single-interpolation\":{\"begin\":\"\\\\$\\\"\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#raw-interpolation\"}]},\"raw-interpolated-string-three-or-more-quote-three-or-more-interpolation\":{\"begin\":\"\\\\$\\\\$\\\\$+\\\"\\\"\\\"+\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"+\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\"},\"raw-interpolated-string-triple-quote-double-interpolation\":{\"begin\":\"\\\\$\\\\$\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#double-raw-interpolation\"}]},\"raw-interpolated-string-triple-quote-single-interpolation\":{\"begin\":\"\\\\$\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#raw-interpolation\"}]},\"raw-interpolation\":{\"begin\":\"(?<=[^{]|^)(\\\\{*)(\\\\{)(?=[^{])\",\"beginCaptures\":{\"1\":{\"name\":\"string.quoted.double.cs\"},\"2\":{\"name\":\"punctuation.definition.interpolation.begin.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.interpolation.end.cs\"}},\"name\":\"meta.embedded.interpolation.cs\",\"patterns\":[{\"include\":\"#expression\"}]},\"raw-string-literal\":{\"patterns\":[{\"include\":\"#raw-string-literal-more\"},{\"include\":\"#raw-string-literal-quadruple\"},{\"include\":\"#raw-string-literal-triple\"}]},\"raw-string-literal-more\":{\"begin\":\"\\\"\\\"\\\"\\\"\\\"+\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\\\"\\\"+\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\"},\"raw-string-literal-quadruple\":{\"begin\":\"\\\"\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\"},\"raw-string-literal-triple\":{\"begin\":\"\\\"\\\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\\\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\"},\"readonly-modifier\":{\"match\":\"\\\\breadonly\\\\b\",\"name\":\"storage.modifier.readonly.cs\"},\"record-declaration\":{\"begin\":\"(?=\\\\brecord\\\\b)\",\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(record)\\\\b\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.record.cs\"},\"2\":{\"name\":\"entity.name.type.class.cs\"}},\"end\":\"(?=\\\\{)|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameter-list\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#base-types\"},{\"include\":\"#generic-constraints\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#class-or-struct-members\"}]},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"ref-modifier\":{\"match\":\"\\\\bref\\\\b\",\"name\":\"storage.modifier.ref.cs\"},\"relational-pattern\":{\"begin\":\"<=?|>=?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.relational.cs\"}},\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},\"return-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(return)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.return.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},\"script-top-level\":{\"patterns\":[{\"include\":\"#statement\"},{\"include\":\"#method-declaration\"},{\"include\":\"#punctuation-semicolon\"}]},\"select-clause\":{\"begin\":\"\\\\b(select)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.select.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"simple-designation-pattern\":{\"patterns\":[{\"include\":\"#discard-pattern\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.variable.local.cs\"}]},\"slice-pattern\":{\"match\":\"\\\\.\\\\.\",\"name\":\"keyword.operator.range.cs\"},\"statement\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#while-statement\"},{\"include\":\"#do-statement\"},{\"include\":\"#for-statement\"},{\"include\":\"#foreach-statement\"},{\"include\":\"#if-statement\"},{\"include\":\"#else-part\"},{\"include\":\"#goto-statement\"},{\"include\":\"#return-statement\"},{\"include\":\"#break-or-continue-statement\"},{\"include\":\"#throw-statement\"},{\"include\":\"#yield-statement\"},{\"include\":\"#await-statement\"},{\"include\":\"#try-statement\"},{\"include\":\"#expression-operator-expression\"},{\"include\":\"#context-control-statement\"},{\"include\":\"#context-control-paren-statement\"},{\"include\":\"#labeled-statement\"},{\"include\":\"#object-creation-expression\"},{\"include\":\"#array-creation-expression\"},{\"include\":\"#anonymous-object-creation-expression\"},{\"include\":\"#local-declaration\"},{\"include\":\"#block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]},\"storage-modifier\":{\"match\":\"(?<!\\\\.)\\\\b(new|public|protected|internal|private|abstract|virtual|override|sealed|static|partial|readonly|volatile|const|extern|async|unsafe|ref|required|file)\\\\b\",\"name\":\"storage.modifier.$1.cs\"},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{1,4}|U\\\\h{8}|u\\\\h{4}|.)\",\"name\":\"constant.character.escape.cs\"},\"string-literal\":{\"begin\":\"(?<!@)\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.cs\"},\"2\":{\"name\":\"invalid.illegal.newline.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"struct-declaration\":{\"begin\":\"(?=(\\\\brecord\\\\b\\\\s+)?\\\\bstruct\\\\b)\",\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"(\\\\b(record)\\\\b\\\\s+)?(struct)\\\\b\\\\s+(@?[_[:alpha:]][_[:alnum:]]*)\",\"beginCaptures\":{\"2\":{\"name\":\"storage.type.record.cs\"},\"3\":{\"name\":\"storage.type.struct.cs\"},\"4\":{\"name\":\"entity.name.type.struct.cs\"}},\"end\":\"(?=\\\\{)|(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameter-list\"},{\"include\":\"#parenthesized-parameter-list\"},{\"include\":\"#base-types\"},{\"include\":\"#generic-constraints\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#class-or-struct-members\"}]},{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"}]},\"subpattern\":{\"patterns\":[{\"captures\":{\"1\":{\"patterns\":[{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"variable.other.object.property.cs\"},{\"include\":\"#punctuation-accessor\"}]},\"2\":{\"name\":\"punctuation.separator.colon.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*(?:\\\\s*\\\\.\\\\s*@?[_[:alpha:]][_[:alnum:]]*)*)\\\\s*(:)\"},{\"include\":\"#pattern\"}]},\"switch-expression\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.arrow.cs\"}},\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\b(when)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.when.cs\"}},\"end\":\"(?==>|[,}])\",\"patterns\":[{\"include\":\"#case-guard\"}]},{\"begin\":\"(?!\\\\s)\",\"end\":\"(?=\\\\bwhen\\\\b|=>|[,}])\",\"patterns\":[{\"include\":\"#pattern\"}]}]},\"switch-label\":{\"begin\":\"\\\\b(case|default)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.$1.cs\"}},\"end\":\"(:)|(?=})\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.separator.colon.cs\"}},\"patterns\":[{\"begin\":\"\\\\b(when)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.when.cs\"}},\"end\":\"(?=[:}])\",\"patterns\":[{\"include\":\"#case-guard\"}]},{\"begin\":\"(?!\\\\s)\",\"end\":\"(?=\\\\bwhen\\\\b|[:}])\",\"patterns\":[{\"include\":\"#pattern\"}]}]},\"switch-statement\":{\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.open.cs\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.curlybrace.close.cs\"}},\"patterns\":[{\"include\":\"#switch-label\"},{\"include\":\"#statement\"}]}]},\"switch-statement-or-expression\":{\"begin\":\"(?<!\\\\.)\\\\b(switch)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.switch.cs\"}},\"end\":\"(?<=})|(?=})\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"(?=\\\\()\",\"end\":\"(?<=})|(?=})\",\"patterns\":[{\"include\":\"#switch-statement\"}]},{\"begin\":\"(?=\\\\{)\",\"end\":\"(?<=})|(?=})\",\"patterns\":[{\"include\":\"#switch-expression\"}]}]},\"throw-expression\":{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.throw.cs\"}},\"match\":\"\\\\b(throw)\\\\b\"},\"throw-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(throw)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.throw.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#expression\"}]},\"try-block\":{\"begin\":\"(?<!\\\\.)\\\\b(try)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.exception.try.cs\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#block\"}]},\"try-statement\":{\"patterns\":[{\"include\":\"#try-block\"},{\"include\":\"#catch-clause\"},{\"include\":\"#finally-clause\"}]},\"tuple-declaration-deconstruction-element-list\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#tuple-declaration-deconstruction-element-list\"},{\"include\":\"#declaration-expression-tuple\"},{\"include\":\"#punctuation-comma\"},{\"captures\":{\"1\":{\"name\":\"entity.name.variable.tuple-element.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\\\\s*(?=[),])\"}]},\"tuple-deconstruction-assignment\":{\"captures\":{\"1\":{\"patterns\":[{\"include\":\"#tuple-deconstruction-element-list\"}]}},\"match\":\"(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\))\\\\s*(?!=[=>])(?==)\"},\"tuple-deconstruction-element-list\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#tuple-deconstruction-element-list\"},{\"include\":\"#declaration-expression-tuple\"},{\"include\":\"#punctuation-comma\"},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\\\\s*(?=[),])\"}]},\"tuple-element\":{\"captures\":{\"1\":{\"patterns\":[{\"include\":\"#type\"}]},\"6\":{\"name\":\"entity.name.variable.tuple-element.cs\"}},\"match\":\"(?<type_name>(?:(?:(?<identifier>@?[_[:alpha:]][_[:alnum:]]*)\\\\s*::\\\\s*)?(?<name_and_type_args>\\\\g<identifier>\\\\s*(?<type_args>\\\\s*<(?:[^<>]|\\\\g<type_args>)+>\\\\s*)?)(?:\\\\s*\\\\.\\\\s*\\\\g<name_and_type_args>)*|(?<tuple>\\\\s*\\\\((?:[^()]|\\\\g<tuple>)+\\\\)))(?:\\\\s*\\\\?\\\\s*)?(?:\\\\s*\\\\[(?:\\\\s*,\\\\s*)*]\\\\s*\\\\??\\\\s*)*)(?:(?<tuple_name>\\\\g<identifier>)\\\\b)?\"},\"tuple-literal\":{\"begin\":\"(\\\\()(?=.*[,:])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#tuple-literal-element\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"tuple-literal-element\":{\"begin\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.variable.tuple-element.cs\"}},\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.separator.colon.cs\"}}},\"tuple-type\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#tuple-element\"},{\"include\":\"#punctuation-comma\"}]},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#ref-modifier\"},{\"include\":\"#readonly-modifier\"},{\"include\":\"#tuple-type\"},{\"include\":\"#type-builtin\"},{\"include\":\"#type-name\"},{\"include\":\"#type-arguments\"},{\"include\":\"#type-array-suffix\"},{\"include\":\"#type-nullable-suffix\"},{\"include\":\"#type-pointer-suffix\"}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.cs\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.cs\"}},\"patterns\":[{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-array-suffix\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.open.cs\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.squarebracket.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin\":{\"captures\":{\"1\":{\"name\":\"keyword.type.$1.cs\"}},\"match\":\"\\\\b(bool|s?byte|u?short|n?u?int|u?long|float|double|decimal|char|string|object|void|dynamic)\\\\b\"},\"type-declarations\":{\"patterns\":[{\"include\":\"#preprocessor\"},{\"include\":\"#comment\"},{\"include\":\"#storage-modifier\"},{\"include\":\"#class-declaration\"},{\"include\":\"#delegate-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#struct-declaration\"},{\"include\":\"#record-declaration\"},{\"include\":\"#attribute-section\"},{\"include\":\"#punctuation-semicolon\"}]},\"type-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"entity.name.type.alias.cs\"},\"2\":{\"name\":\"punctuation.separator.coloncolon.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(::)\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.cs\"},\"2\":{\"name\":\"punctuation.accessor.cs\"}},\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(\\\\.)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.cs\"},\"2\":{\"name\":\"entity.name.type.cs\"}},\"match\":\"(\\\\.)\\\\s*(@?[_[:alpha:]][_[:alnum:]]*)\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.cs\"}]},\"type-nullable-suffix\":{\"match\":\"\\\\?\",\"name\":\"punctuation.separator.question-mark.cs\"},\"type-operator-expression\":{\"begin\":\"\\\\b(default|sizeof|typeof)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.$1.cs\"},\"2\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#type\"}]},\"type-parameter-list\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.cs\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.cs\"}},\"patterns\":[{\"match\":\"\\\\b(in|out)\\\\b\",\"name\":\"storage.modifier.$1.cs\"},{\"match\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\b\",\"name\":\"entity.name.type.type-parameter.cs\"},{\"include\":\"#comment\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#attribute-section\"}]},\"type-pattern\":{\"begin\":\"(?=@?[_[:alpha:]][_[:alnum:]]*)\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?!\\\\G[@_[:alpha:]])(?=[]\\\\&(),:;=@^_{|}[:alpha:]]|(?:\\\\s|^)\\\\?|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#type-subpattern\"}]},{\"begin\":\"(?=[(@_{[:alpha:]])\",\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#positional-pattern\"},{\"include\":\"#property-pattern\"},{\"include\":\"#simple-designation-pattern\"}]}]},\"type-pointer-suffix\":{\"match\":\"\\\\*\",\"name\":\"punctuation.separator.asterisk.cs\"},\"type-subpattern\":{\"patterns\":[{\"include\":\"#type-builtin\"},{\"begin\":\"(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(::)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.alias.cs\"},\"2\":{\"name\":\"punctuation.separator.coloncolon.cs\"}},\"end\":\"(?<=[_[:alnum:]])|(?=[]\\\\&(),.:-=?\\\\[^{|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.cs\"}]},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.cs\"},{\"begin\":\"\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.accessor.cs\"}},\"end\":\"(?<=[_[:alnum:]])|(?=[]\\\\&(),:-=?\\\\[^{|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#intrusive\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.cs\"}]},{\"include\":\"#type-arguments\"},{\"include\":\"#type-array-suffix\"},{\"match\":\"(?<!\\\\s)\\\\?\",\"name\":\"punctuation.separator.question-mark.cs\"}]},\"using-directive\":{\"patterns\":[{\"begin\":\"\\\\b(?:(global)\\\\s+)?(using)\\\\s+(static)\\\\b\\\\s*(?:(unsafe)\\\\b\\\\s*)?\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.other.directive.global.cs\"},\"2\":{\"name\":\"keyword.other.directive.using.cs\"},\"3\":{\"name\":\"keyword.other.directive.static.cs\"},\"4\":{\"name\":\"storage.modifier.unsafe.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"\\\\b(?:(global)\\\\s+)?(using)\\\\b\\\\s*(?:(unsafe)\\\\b\\\\s*)?(@?[_[:alpha:]][_[:alnum:]]*)\\\\s*(=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.other.directive.global.cs\"},\"2\":{\"name\":\"keyword.other.directive.using.cs\"},\"3\":{\"name\":\"storage.modifier.unsafe.cs\"},\"4\":{\"name\":\"entity.name.type.alias.cs\"},\"5\":{\"name\":\"keyword.operator.assignment.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type\"}]},{\"begin\":\"\\\\b(?:(global)\\\\s+)?(using)\\\\b\\\\s*+(?!\\\\(|var\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.other.directive.global.cs\"},\"2\":{\"name\":\"keyword.other.directive.using.cs\"}},\"end\":\"(?=;)\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"@?[_[:alpha:]][_[:alnum:]]*\",\"name\":\"entity.name.type.namespace.cs\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#operator-assignment\"}]}]},\"using-statement\":{\"begin\":\"\\\\b(using)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.context.using.cs\"}},\"end\":\"(?<=\\\\))|(?=[;}])\",\"patterns\":[{\"include\":\"#intrusive\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#intrusive\"},{\"include\":\"#await-expression\"},{\"include\":\"#local-variable-declaration\"},{\"include\":\"#expression\"}]},{\"include\":\"#local-variable-declaration\"}]},\"var-pattern\":{\"begin\":\"\\\\b(var)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.var.cs\"}},\"end\":\"(?=[]\\\\&),:;=?^|}]|!=|\\\\b(and|or|when)\\\\b)\",\"patterns\":[{\"include\":\"#designation-pattern\"}]},\"variable-initializer\":{\"begin\":\"(?<![!=])(=)(?![=>])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.cs\"}},\"end\":\"(?=[]),;}])\",\"patterns\":[{\"include\":\"#ref-modifier\"},{\"include\":\"#expression\"}]},\"verbatim-interpolated-string\":{\"begin\":\"(?:\\\\$@|@\\\\$)\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"(?=[^\\\"])\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#verbatim-string-character-escape\"},{\"include\":\"#interpolation\"}]},\"verbatim-string-character-escape\":{\"match\":\"\\\"\\\"\",\"name\":\"constant.character.escape.cs\"},\"verbatim-string-literal\":{\"begin\":\"@\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"(?=[^\\\"])\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#verbatim-string-character-escape\"}]},\"when-clause\":{\"begin\":\"(?<!\\\\.)\\\\b(when)\\\\b\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.exception.when.cs\"},\"2\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#comment\"}]},\"where-clause\":{\"begin\":\"\\\\b(where)\\\\b\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.query.where.cs\"}},\"end\":\"(?=[);])\",\"patterns\":[{\"include\":\"#query-body\"},{\"include\":\"#expression\"}]},\"while-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(while)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.loop.while.cs\"}},\"end\":\"(?<=})|(?=;)\",\"patterns\":[{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.open.cs\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.parenthesis.close.cs\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#statement\"}]},\"with-expression\":{\"begin\":\"(?<!\\\\.)\\\\b(with)\\\\b\\\\s*(?=\\\\{|//|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.with.cs\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#initializer-expression\"}]},\"xml-attribute\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.cs\"},\"2\":{\"name\":\"entity.other.attribute-name.namespace.cs\"},\"3\":{\"name\":\"punctuation.separator.colon.cs\"},\"4\":{\"name\":\"entity.other.attribute-name.localname.cs\"},\"5\":{\"name\":\"punctuation.separator.equals.cs\"}},\"match\":\"(?:^|\\\\s+)((?:([-_[:alnum:]]+)(:))?([-_[:alnum:]]+))(=)\"},{\"include\":\"#xml-string\"}]},\"xml-cdata\":{\"begin\":\"<!\\\\[CDATA\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"]]>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.unquoted.cdata.cs\"},\"xml-character-entity\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.constant.cs\"},\"3\":{\"name\":\"punctuation.definition.constant.cs\"}},\"match\":\"(&)([:_[:alpha:]][-.:_[:alnum:]]*|#\\\\d+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.cs\"},{\"match\":\"&\",\"name\":\"invalid.illegal.bad-ampersand.cs\"}]},\"xml-comment\":{\"begin\":\"<!--\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.cs\"}},\"end\":\"-->\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.cs\"}},\"name\":\"comment.block.cs\"},\"xml-doc-comment\":{\"patterns\":[{\"include\":\"#xml-comment\"},{\"include\":\"#xml-character-entity\"},{\"include\":\"#xml-cdata\"},{\"include\":\"#xml-tag\"}]},\"xml-string\":{\"patterns\":[{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.single.cs\",\"patterns\":[{\"include\":\"#xml-character-entity\"}]},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.cs\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.cs\"}},\"name\":\"string.quoted.double.cs\",\"patterns\":[{\"include\":\"#xml-character-entity\"}]}]},\"xml-tag\":{\"begin\":\"(</?)((?:([-_[:alnum:]]+)(:))?([-_[:alnum:]]+))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.cs\"},\"2\":{\"name\":\"entity.name.tag.cs\"},\"3\":{\"name\":\"entity.name.tag.namespace.cs\"},\"4\":{\"name\":\"punctuation.separator.colon.cs\"},\"5\":{\"name\":\"entity.name.tag.localname.cs\"}},\"end\":\"(/?>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.cs\"}},\"name\":\"meta.tag.cs\",\"patterns\":[{\"include\":\"#xml-attribute\"}]},\"yield-break-statement\":{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.yield.cs\"},\"2\":{\"name\":\"keyword.control.flow.break.cs\"}},\"match\":\"(?<!\\\\.)\\\\b(yield)\\\\b\\\\s*\\\\b(break)\\\\b\"},\"yield-return-statement\":{\"begin\":\"(?<!\\\\.)\\\\b(yield)\\\\b\\\\s*\\\\b(return)\\\\b\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.yield.cs\"},\"2\":{\"name\":\"keyword.control.flow.return.cs\"}},\"end\":\"(?=[;}])\",\"patterns\":[{\"include\":\"#expression\"}]},\"yield-statement\":{\"patterns\":[{\"include\":\"#yield-return-statement\"},{\"include\":\"#yield-break-statement\"}]}},\"scopeName\":\"source.cs\",\"aliases\":[\"c#\",\"cs\"]}"))];
var sql_default = [Object.freeze(JSON.parse("{\"displayName\":\"SQL\",\"name\":\"sql\",\"patterns\":[{\"match\":\"((?<!@)@)\\\\b(\\\\w+)\\\\b\",\"name\":\"text.variable\"},{\"match\":\"(\\\\[)[^]]*(])\",\"name\":\"text.bracketed\"},{\"include\":\"#comments\"},{\"captures\":{\"1\":{\"name\":\"keyword.other.create.sql\"},\"2\":{\"name\":\"keyword.other.sql\"},\"5\":{\"name\":\"entity.name.function.sql\"}},\"match\":\"(?i:^\\\\s*(create(?:\\\\s+or\\\\s+replace)?)\\\\s+(aggregate|conversion|database|domain|function|group|(unique\\\\s+)?index|language|operator class|operator|rule|schema|sequence|table|tablespace|trigger|type|user|view)\\\\s+)([\\\"'`]?)(\\\\w+)\\\\4\",\"name\":\"meta.create.sql\"},{\"captures\":{\"1\":{\"name\":\"keyword.other.create.sql\"},\"2\":{\"name\":\"keyword.other.sql\"}},\"match\":\"(?i:^\\\\s*(drop)\\\\s+(aggregate|conversion|database|domain|function|group|index|language|operator class|operator|rule|schema|sequence|table|tablespace|trigger|type|user|view))\",\"name\":\"meta.drop.sql\"},{\"captures\":{\"1\":{\"name\":\"keyword.other.create.sql\"},\"2\":{\"name\":\"keyword.other.table.sql\"},\"3\":{\"name\":\"entity.name.function.sql\"},\"4\":{\"name\":\"keyword.other.cascade.sql\"}},\"match\":\"(?i:\\\\s*(drop)\\\\s+(table)\\\\s+(\\\\w+)(\\\\s+cascade)?\\\\b)\",\"name\":\"meta.drop.sql\"},{\"captures\":{\"1\":{\"name\":\"keyword.other.create.sql\"},\"2\":{\"name\":\"keyword.other.table.sql\"}},\"match\":\"(?i:^\\\\s*(alter)\\\\s+(aggregate|conversion|database|domain|function|group|index|language|operator class|operator|proc(edure)?|rule|schema|sequence|table|tablespace|trigger|type|user|view)\\\\s+)\",\"name\":\"meta.alter.sql\"},{\"captures\":{\"1\":{\"name\":\"storage.type.sql\"},\"2\":{\"name\":\"storage.type.sql\"},\"3\":{\"name\":\"constant.numeric.sql\"},\"4\":{\"name\":\"storage.type.sql\"},\"5\":{\"name\":\"constant.numeric.sql\"},\"6\":{\"name\":\"storage.type.sql\"},\"7\":{\"name\":\"constant.numeric.sql\"},\"8\":{\"name\":\"constant.numeric.sql\"},\"9\":{\"name\":\"storage.type.sql\"},\"10\":{\"name\":\"constant.numeric.sql\"},\"11\":{\"name\":\"storage.type.sql\"},\"12\":{\"name\":\"storage.type.sql\"},\"13\":{\"name\":\"storage.type.sql\"},\"14\":{\"name\":\"constant.numeric.sql\"},\"15\":{\"name\":\"storage.type.sql\"}},\"match\":\"(?i)\\\\b(bigint|bigserial|bit|boolean|box|bytea|cidr|circle|date|double\\\\sprecision|inet|int|integer|line|lseg|macaddr|money|oid|path|point|polygon|real|serial|smallint|sysdate|text)\\\\b|\\\\b(bit\\\\svarying|character\\\\s(?:varying)?|tinyint|var\\\\schar|float|interval)\\\\((\\\\d+)\\\\)|\\\\b(char|number|varchar\\\\d?)\\\\b(?:\\\\((\\\\d+)\\\\))?|\\\\b(numeric|decimal)\\\\b(?:\\\\((\\\\d+),(\\\\d+)\\\\))?|\\\\b(times?)\\\\b(?:\\\\((\\\\d+)\\\\))?(\\\\swith(?:out)?\\\\stime\\\\szone\\\\b)?|\\\\b(timestamp)(s|tz)?\\\\b(?:\\\\((\\\\d+)\\\\))?(\\\\s(with(?:|out))\\\\stime\\\\szone\\\\b)?\"},{\"match\":\"(?i:\\\\b((?:primary|foreign)\\\\s+key|references|on\\\\s+(delete|update)(\\\\s+cascade)?|nocheck|check|constraint|collate|default)\\\\b)\",\"name\":\"storage.modifier.sql\"},{\"match\":\"\\\\b\\\\d+\\\\b\",\"name\":\"constant.numeric.sql\"},{\"match\":\"(?i:\\\\b(select(\\\\s+(all|distinct))?|insert\\\\s+(ignore\\\\s+)?into|update|delete|from|set|where|group\\\\s+by|or|like|and|union(\\\\s+all)?|having|order\\\\s+by|limit|cross\\\\s+join|join|straight_join|(inner|(left|right|full)(\\\\s+outer)?)\\\\s+join|natural(\\\\s+(inner|(left|right|full)(\\\\s+outer)?))?\\\\s+join)\\\\b)\",\"name\":\"keyword.other.DML.sql\"},{\"match\":\"(?i:\\\\b(on|off|((is\\\\s+)?not\\\\s+)?null)\\\\b)\",\"name\":\"keyword.other.DDL.create.II.sql\"},{\"match\":\"(?i:\\\\bvalues\\\\b)\",\"name\":\"keyword.other.DML.II.sql\"},{\"match\":\"(?i:\\\\b(begin(\\\\s+work)?|start\\\\s+transaction|commit(\\\\s+work)?|rollback(\\\\s+work)?)\\\\b)\",\"name\":\"keyword.other.LUW.sql\"},{\"match\":\"(?i:\\\\b(grant(\\\\swith\\\\sgrant\\\\soption)?|revoke)\\\\b)\",\"name\":\"keyword.other.authorization.sql\"},{\"match\":\"(?i:\\\\bin\\\\b)\",\"name\":\"keyword.other.data-integrity.sql\"},{\"match\":\"(?i:^\\\\s*(comment\\\\s+on\\\\s+(table|column|aggregate|constraint|database|domain|function|index|operator|rule|schema|sequence|trigger|type|view))\\\\s+)\",\"name\":\"keyword.other.object-comments.sql\"},{\"match\":\"(?i)\\\\bAS\\\\b\",\"name\":\"keyword.other.alias.sql\"},{\"match\":\"(?i)\\\\b(DESC|ASC)\\\\b\",\"name\":\"keyword.other.order.sql\"},{\"match\":\"\\\\*\",\"name\":\"keyword.operator.star.sql\"},{\"match\":\"[!<>]?=|<>|[<>]\",\"name\":\"keyword.operator.comparison.sql\"},{\"match\":\"[-+/]\",\"name\":\"keyword.operator.math.sql\"},{\"match\":\"\\\\|\\\\|\",\"name\":\"keyword.operator.concatenator.sql\"},{\"captures\":{\"1\":{\"name\":\"support.function.aggregate.sql\"}},\"match\":\"(?i)\\\\b(approx_count_distinct|approx_percentile_cont|approx_percentile_disc|avg|checksum_agg|count|count_big|group|grouping|grouping_id|max|min|sum|stdevp??|varp??)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.analytic.sql\"}},\"match\":\"(?i)\\\\b(cume_dist|first_value|lag|last_value|lead|percent_rank|percentile_cont|percentile_disc)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.bitmanipulation.sql\"}},\"match\":\"(?i)\\\\b((?:bit_coun|get_bi|left_shif|right_shif|set_bi)t)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.conversion.sql\"}},\"match\":\"(?i)\\\\b(cast|convert|parse|try_cast|try_convert|try_parse)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.collation.sql\"}},\"match\":\"(?i)\\\\b(collationproperty|tertiary_weights)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.cryptographic.sql\"}},\"match\":\"(?i)\\\\b(asymkey_id|asymkeyproperty|certproperty|cert_id|crypt_gen_random|decryptbyasymkey|decryptbycert|decryptbykey|decryptbykeyautoasymkey|decryptbykeyautocert|decryptbypassphrase|encryptbyasymkey|encryptbycert|encryptbykey|encryptbypassphrase|hashbytes|is_objectsigned|key_guid|key_id|key_name|signbyasymkey|signbycert|symkeyproperty|verifysignedbycert|verifysignedbyasymkey)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.cursor.sql\"}},\"match\":\"(?i)\\\\b(cursor_status)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.datetime.sql\"}},\"match\":\"(?i)\\\\b(sysdatetime|sysdatetimeoffset|sysutcdatetime|current_time(stamp)?|getdate|getutcdate|datename|datepart|day|month|year|datefromparts|datetime2fromparts|datetimefromparts|datetimeoffsetfromparts|smalldatetimefromparts|timefromparts|datediff|dateadd|datetrunc|eomonth|switchoffset|todatetimeoffset|isdate|date_bucket)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.datatype.sql\"}},\"match\":\"(?i)\\\\b(datalength|ident_current|ident_incr|ident_seed|identity|sql_variant_property)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.expression.sql\"}},\"match\":\"(?i)\\\\b(coalesce|nullif)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.globalvar.sql\"}},\"match\":\"(?<!@)@@(?i)\\\\b(cursor_rows|connections|cpu_busy|datefirst|dbts|error|fetch_status|identity|idle|io_busy|langid|language|lock_timeout|max_connections|max_precision|nestlevel|options|packet_errors|pack_received|pack_sent|procid|remserver|rowcount|servername|servicename|spid|textsize|timeticks|total_errors|total_read|total_write|trancount|version)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.json.sql\"}},\"match\":\"(?i)\\\\b(json|isjson|json_object|json_array|json_value|json_query|json_modify|json_path_exists)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.logical.sql\"}},\"match\":\"(?i)\\\\b(choose|iif|greatest|least)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.mathematical.sql\"}},\"match\":\"(?i)\\\\b(abs|acos|asin|atan|atn2|ceiling|cos|cot|degrees|exp|floor|log|log10|pi|power|radians|rand|round|sign|sin|sqrt|square|tan)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.metadata.sql\"}},\"match\":\"(?i)\\\\b(app_name|applock_mode|applock_test|assemblyproperty|col_length|col_name|columnproperty|database_principal_id|databasepropertyex|db_id|db_name|file_id|file_idex|file_name|filegroup_id|filegroup_name|filegroupproperty|fileproperty|fulltextcatalogproperty|fulltextserviceproperty|index_col|indexkey_property|indexproperty|object_definition|object_id|object_name|object_schema_name|objectproperty|objectpropertyex|original_db_name|parsename|schema_id|schema_name|scope_identity|serverproperty|stats_date|type_id|type_name|typeproperty)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.ranking.sql\"}},\"match\":\"(?i)\\\\b(rank|dense_rank|ntile|row_number)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.rowset.sql\"}},\"match\":\"(?i)\\\\b(generate_series|opendatasource|openjson|openrowset|openquery|openxml|predict|string_split)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.security.sql\"}},\"match\":\"(?i)\\\\b(certencoded|certprivatekey|current_user|database_principal_id|has_perms_by_name|is_member|is_rolemember|is_srvrolemember|original_login|permissions|pwdcompare|pwdencrypt|schema_id|schema_name|session_user|suser_id|suser_sid|suser_sname|system_user|suser_name|user_id|user_name)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.string.sql\"}},\"match\":\"(?i)\\\\b(ascii|char|charindex|concat|difference|format|left|len|lower|ltrim|nchar|nodes|patindex|quotename|replace|replicate|reverse|right|rtrim|soundex|space|str|string_agg|string_escape|string_split|stuff|substring|translate|trim|unicode|upper)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.system.sql\"}},\"match\":\"(?i)\\\\b(binary_checksum|checksum|compress|connectionproperty|context_info|current_request_id|current_transaction_id|decompress|error_line|error_message|error_number|error_procedure|error_severity|error_state|formatmessage|get_filestream_transaction_context|getansinull|host_id|host_name|isnull|isnumeric|min_active_rowversion|newid|newsequentialid|rowcount_big|session_context|session_id|xact_state)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.textimage.sql\"}},\"match\":\"(?i)\\\\b(patindex|textptr|textvalid)\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"support.function.vector.sql\"}},\"match\":\"(?i)\\\\b(vector_(?:distance|norm|normalize))\\\\b\\\\s*\\\\(\"},{\"captures\":{\"1\":{\"name\":\"constant.other.database-name.sql\"},\"2\":{\"name\":\"constant.other.table-name.sql\"}},\"match\":\"(\\\\w+?)\\\\.(\\\\w+)\"},{\"include\":\"#strings\"},{\"include\":\"#regexps\"},{\"match\":\"\\\\b(?i)(abort|abort_after_wait|absent|absolute|accent_sensitivity|acceptable_cursopt|acp|action|activation|add|address|admin|aes_128|aes_192|aes_256|affinity|after|aggregate|algorithm|all_constraints|all_errormsgs|all_indexes|all_levels|all_results|allow_connections|allow_dup_row|allow_encrypted_value_modifications|allow_page_locks|allow_row_locks|allow_snapshot_isolation|alter|altercolumn|always|anonymous|ansi_defaults|ansi_null_default|ansi_null_dflt_off|ansi_null_dflt_on|ansi_nulls|ansi_padding|ansi_warnings|appdomain|append|application|apply|arithabort|arithignore|array|assembly|asymmetric|asynchronous_commit|at|atan2|atomic|attach|attach_force_rebuild_log|attach_rebuild_log|audit|auth_realm|authentication|auto|auto_cleanup|auto_close|auto_create_statistics|auto_drop|auto_shrink|auto_update_statistics|auto_update_statistics_async|automated_backup_preference|automatic|autopilot|availability|availability_mode|backup|backup_priority|base64|basic|batches|batchsize|before|between|bigint|binary|binding|bit|block|blockers|blocksize|bmk|both|break|broker|broker_instance|bucket_count|buffer|buffercount|bulk_logged|by|call|caller|card|case|catalog|catch|cert|certificate|change_retention|change_tracking|change_tracking_context|changes|char|character|character_set|check_expiration|check_policy|checkconstraints|checkindex|checkpoint|checksum|cleanup_policy|clear|clear_port|close|clustered|codepage|collection|column_encryption_key|column_master_key|columnstore|columnstore_archive|colv_80_to_100|colv_100_to_80|commit_differential_base|committed|compatibility_level|compress_all_row_groups|compression|compression_delay|concat_null_yields_null|concatenate|configuration|connect|connection|containment|continue|continue_after_error|contract|contract_name|control|conversation|conversation_group_id|conversation_handle|copy|copy_only|count_rows|counter|create(\\\\\\\\s+or\\\\\\\\s+alter)?|credential|cross|cryptographic|cryptographic_provider|cube|cursor|cursor_close_on_commit|cursor_default|data|data_compression|data_flush_interval_seconds|data_mirroring|data_purity|data_source|database|database_name|database_snapshot|datafiletype|date_correlation_optimization|date|datefirst|dateformat|date_format|datetime2??|datetimeoffset|day(s)?|db_chaining|dbid|dbidexec|dbo_only|deadlock_priority|deallocate|dec|decimal|declare|decrypt|decrypt_a|decryption|default_database|default_fulltext_language|default_language|default_logon_domain|default_schema|definition|delay|delayed_durability|delimitedtext|density_vector|dependent|des|description|desired_state|desx|differential|digest|disable|disable_broker|disable_def_cnst_chk|disabled|disk|distinct|distributed|distribution|drop|drop_existing|dts_buffers|dump|durability|dynamic|edition|elements|else|emergency|empty|enable|enable_broker|enabled|encoding|encrypted|encrypted_value|encryption|encryption_type|end|endpoint|endpoint_url|enhancedintegrity|entry|error_broker_conversations|errorfile|estimateonly|event|except|exec|executable|execute|exists|expand|expiredate|expiry_date|explicit|external|external_access|failover|failover_mode|failure_condition_level|fast|fast_forward|fastfirstrow|federated_service_account|fetch|field_terminator|fieldterminator|file|filelistonly|filegroup|filegrowth|filename|filestream|filestream_log|filestream_on|filetable|file_format|filter|first_row|fips_flagger|fire_triggers|first|firstrow|float|flush_interval_seconds|fmtonly|following|for|force|force_failover_allow_data_loss|force_service_allow_data_loss|forced|forceplan|formatfile|format_options|format_type|formsof|forward_only|free_cursors|free_exec_context|fullscan|fulltext|fulltextall|fulltextkey|function|generated|get|geography|geometry|global|go|goto|governor|guid|hadoop|hardening|hash|hashed|header_limit|headeronly|health_check_timeout|hidden|hierarchyid|histogram|histogram_steps|hits_cursors|hits_exec_context|hour(s)?|http|identity|identity_value|if|ifnull|ignore|ignore_constraints|ignore_dup_key|ignore_dup_row|ignore_triggers|image|immediate|implicit_transactions|include|include_null_values|incremental|index|inflectional|init|initiator|insensitive|insert|instead|int|integer|integrated|intersect|intermediate|interval_length_minutes|into|inuse_cursors|inuse_exec_context|io|is|isabout|iso_week|isolation|job_tracker_location|json|keep|keep_nulls|keep_replication|keepdefaults|keepfixed|keepidentity|keepnulls|kerberos|key|key_path|key_source|key_store_provider_name|keyset|kill|kilobytes_per_batch|labelonly|langid|language|last|lastrow|leading|legacy_cardinality_estimation|length|level|lifetime|lineage_80_to_100|lineage_100_to_80|listener_ip|listener_port|load|loadhistory|lob_compaction|local|local_service_name|locate|location|lock_escalation|lock_timeout|lockres|log|login|login_type|loop|manual|mark_in_use_for_removal|masked|master|match|matched|max_queue_readers|max_duration|max_outstanding_io_per_volume|maxdop|maxerrors|maxlength|maxtransfersize|max_plans_per_query|max_storage_size_mb|mediadescription|medianame|mediapassword|memogroup|memory_optimized|merge|message|message_forward_size|message_forwarding|microsecond|millisecond|minute(s)?|mirror_address|misses_cursors|misses_exec_context|mixed|modify|money|month|move|multi_user|must_change|name|namespace|nanosecond|native|native_compilation|nchar|ncharacter|nested_triggers|never|new_account|new_broker|newname|next|no|no_browsetable|no_checksum|no_compression|no_infomsgs|no_triggers|no_truncate|nocount|noexec|noexpand|noformat|noinit|nolock|nonatomic|nonclustered|nondurable|none|norecompute|norecovery|noreset|norewind|noskip|not|notification|nounload|now|nowait|ntext|ntlm|nulls|numeric|numeric_roundabort|nvarchar|object|objid|oem|offline|old_account|online|operation_mode|open|openjson|optimistic|option|orc|out|outer|output|over|override|owner|ownership|pad_index|page|page_checksum|page_verify|pagecount|paglock|param|parameter_sniffing|parameter_type_expansion|parameterization|parquet|parseonly|partial|partition|partner|password|path|pause|percentage|permission_set|persisted|period|physical_only|plan_forcing_mode|policy|pool|population|ports|preceding|precision|predicate|presume_abort|primary|primary_role|print|prior|priority |priority_level|private|proc(edure)?|procedure_name|profile|provider|quarter|query_capture_mode|query_governor_cost_limit|query_optimizer_hotfixes|query_store|queue|quoted_identifier|raiserror|range|raw|rcfile|rc2|rc4|rc4_128|rdbms|read_committed_snapshot|read|read_only|read_write|readcommitted|readcommittedlock|readonly|readpast|readuncommitted|readwrite|real|rebuild|receive|recmodel_70backcomp|recompile|reconfigure|recovery|recursive|recursive_triggers|redo_queue|reject_sample_value|reject_type|reject_value|relative|remote|remote_data_archive|remote_proc_transactions|remote_service_name|remove|removed_cursors|removed_exec_context|reorganize|repeat|repeatable|repeatableread|replace|replica|replicated|replnick_100_to_80|replnickarray_80_to_100|replnickarray_100_to_80|required|required_cursopt|resample|reset|resource|resource_manager_location|respect|restart|restore|restricted_user|resume|retaindays|retention|return|revert|rewind|rewindonly|returns|robust|role|rollup|root|round_robin|route|row|rowdump|rowguidcol|rowlock|row_terminator|rows|rows_per_batch|rowsets_only|rowterminator|rowversion|rsa_1024|rsa_2048|rsa_3072|rsa_4096|rsa_512|safe|safety|sample|save|scalar|schema|schemabinding|scoped|scroll|scroll_locks|sddl|second|secexpr|seconds|secondary|secondary_only|secondary_role|secret|security|securityaudit|selective|self|send|sent|sequence|serde_method|serializable|server|service|service_broker|service_name|service_objective|session_timeout|sessions??|seterror|setopts|sets|shard_map_manager|shard_map_name|sharded|shared_memory|shortest_path|show_statistics|showplan_all|showplan_text|showplan_xml|showplan_xml_with_recompile|shrinkdb|shutdown|sid|signature|simple|single_blob|single_clob|single_nclob|single_user|singleton|site|size|size_based_cleanup_mode|skip|smalldatetime|smallint|smallmoney|snapshot|snapshot_import|snapshotrestorephase|soap|softnuma|sort_in_tempdb|sorted_data|sorted_data_reorg|spatial|sql|sql_bigint|sql_binary|sql_bit|sql_char|sql_date|sql_decimal|sql_double|sql_float|sql_guid|sql_handle|sql_longvarbinary|sql_longvarchar|sql_numeric|sql_real|sql_smallint|sql_time|sql_timestamp|sql_tinyint|sql_tsi_day|sql_tsi_frac_second|sql_tsi_hour|sql_tsi_minute|sql_tsi_month|sql_tsi_quarter|sql_tsi_second|sql_tsi_week|sql_tsi_year|sql_type_date|sql_type_time|sql_type_timestamp|sql_varbinary|sql_varchar|sql_variant|sql_wchar|sql_wlongvarchar|ssl|ssl_port|standard|standby|start|start_date|started|stat_header|state|statement|static|statistics|statistics_incremental|statistics_norecompute|statistics_only|statman|stats|stats_stream|status|stop|stop_on_error|stopat|stopatmark|stopbeforemark|stoplist|stopped|string_delimiter|subject|supplemental_logging|supported|suspend|symmetric|synchronous_commit|synonym|sysname|system|system_time|system_versioning|table|tableresults|tablockx??|take|tape|target|target_index|target_partition|target_recovery_time|tcp|temporal_history_retention|text|textimage_on|then|thesaurus|throw|time|timeout|timestamp|tinyint|top??|torn_page_detection|track_columns_updated|trailing|tran|transaction|transfer|transform_noise_words|triple_des|triple_des_3key|truncate|trustworthy|try|tsql|two_digit_year_cutoff|type|type_desc|type_warning|tzoffset|uid|unbounded|uncommitted|unique|uniqueidentifier|unlimited|unload|unlock|unsafe|updlock|url|use|useplan|useroptions|use_type_default|using|utcdatetime|valid_xml|validation|values??|varbinary|varchar|vector|verbose|verifyonly|version|view_metadata|virtual_device|visiblity|wait_at_low_priority|waitfor|webmethod|week|weekday|weight|well_formed_xml|when|while|widechar|widechar_ansi|widenative|windows??|with|within|within group|witness|without|without_array_wrapper|workload|wsdl|xact_abort|xlock|xml|xmlschema|xquery|xsinil|year|zone)\\\\b\",\"name\":\"keyword.other.sql\"},{\"captures\":{\"1\":{\"name\":\"punctuation.section.scope.begin.sql\"},\"2\":{\"name\":\"punctuation.section.scope.end.sql\"}},\"match\":\"(\\\\()(\\\\))\",\"name\":\"meta.block.sql\"}],\"repository\":{\"comment-block\":{\"begin\":\"/\\\\*\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.sql\"}},\"end\":\"\\\\*/\",\"name\":\"comment.block\",\"patterns\":[{\"include\":\"#comment-block\"}]},\"comments\":{\"patterns\":[{\"begin\":\"(^[\\\\t ]+)?(?=--)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.sql\"}},\"end\":\"(?!\\\\G)\",\"patterns\":[{\"begin\":\"--\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.sql\"}},\"end\":\"\\\\n\",\"name\":\"comment.line.double-dash.sql\"}]},{\"begin\":\"(^[\\\\t ]+)?(?=#)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.sql\"}},\"end\":\"(?!\\\\G)\",\"patterns\":[]},{\"include\":\"#comment-block\"}]},\"regexps\":{\"patterns\":[{\"begin\":\"/(?=\\\\S.*/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.regexp.sql\",\"patterns\":[{\"include\":\"#string_interpolation\"},{\"match\":\"\\\\\\\\/\",\"name\":\"constant.character.escape.slash.sql\"}]},{\"begin\":\"%r\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.regexp.modr.sql\",\"patterns\":[{\"include\":\"#string_interpolation\"}]}]},\"string_escape\":{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.sql\"},\"string_interpolation\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.sql\"},\"3\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"match\":\"(#\\\\{)([^}]*)(})\",\"name\":\"string.interpolated.sql\"},\"strings\":{\"patterns\":[{\"captures\":{\"2\":{\"name\":\"punctuation.definition.string.begin.sql\"},\"3\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"match\":\"(?:(?<![0-9A-Z_a-z])(N))?(')[^']*(')\",\"name\":\"string.quoted.single.sql\"},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.quoted.single.sql\",\"patterns\":[{\"include\":\"#string_escape\"}]},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.sql\"},\"2\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"match\":\"(`)[^\\\\\\\\`]*(`)\",\"name\":\"string.quoted.other.backtick.sql\"},{\"begin\":\"`\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.quoted.other.backtick.sql\",\"patterns\":[{\"include\":\"#string_escape\"}]},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.sql\"},\"2\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"match\":\"(\\\")[^\\\"#]*(\\\")\",\"name\":\"string.quoted.double.sql\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.quoted.double.sql\",\"patterns\":[{\"include\":\"#string_interpolation\"}]},{\"begin\":\"%\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.sql\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.sql\"}},\"name\":\"string.other.quoted.brackets.sql\",\"patterns\":[{\"include\":\"#string_interpolation\"}]}]}},\"scopeName\":\"source.sql\"}"))];
var typescript_default = [Object.freeze(JSON.parse("{\"displayName\":\"TypeScript\",\"name\":\"typescript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.array.literal.ts\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.ts\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.ts\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.ts\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.ts\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.angle.ts\"}},\"match\":\"\\\\s*(<)\\\\s*(const)\\\\s*(>)\",\"name\":\"cast.expr.ts\"},{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=^return|[^$._[:alnum:]]return|^throw|[^$._[:alnum:]]throw|^yield|[^$._[:alnum:]]yield|^await|[^$._[:alnum:]]await|^default|[^$._[:alnum:]]default|[\\\\&(*,:=>?^|]|[^$_[:alnum:]](?:\\\\+\\\\+|--)|[^+]\\\\+|[^-]-)\\\\s*(<)(?!<?=)(?!\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?<=^)\\\\s*(<)(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.angle.ts\"}},\"name\":\"cast.expr.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.type.class.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.ts\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.documentation.ts\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"},\"2\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.ts\"}},\"name\":\"comment.block.ts\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.ts\"},\"2\":{\"name\":\"entity.name.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.ts\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.ts\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.ts\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"name\":\"meta.parameter.object-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"name\":\"meta.paramter.array-binding-pattern.ts\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.ts\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.ts\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.ts\"},\"2\":{\"name\":\"entity.name.tag.directive.ts\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.ts\"}},\"name\":\"meta.tag.ts\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.ts\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.ts\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.enum.ts\"},\"5\":{\"name\":\"entity.name.type.enum.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.ts\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.as.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"},\"4\":{\"name\":\"entity.name.type.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"},\"3\":{\"name\":\"keyword.operator.assignment.ts\"},\"4\":{\"name\":\"keyword.control.default.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.ts\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.ts\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.ts\"},\"2\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.ts\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.ts\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.ts\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.ts\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.ts\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.ts\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.ts\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"3\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.ts\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.ts\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.ts\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.ts\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.ts\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.ts\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.ts\"},\"2\":{\"name\":\"keyword.operator.arithmetic.ts\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.ts\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.ts variable.object.property.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.ts\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.ts\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.ts\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.ts\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.ts punctuation.accessor.optional.ts\"},{\"match\":\"!\",\"name\":\"meta.function-call.ts keyword.operator.definiteassignment.ts\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.ts\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.async.ts\"},\"4\":{\"name\":\"storage.type.function.ts\"},\"5\":{\"name\":\"keyword.generator.asterisk.ts\"},\"6\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.function.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"},\"4\":{\"name\":\"meta.definition.function.ts entity.name.function.ts\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.ts\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.ts entity.name.function.ts\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.ts\"}},\"name\":\"meta.parameters.ts\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.ts\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.ts\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.ts\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"},\"7\":{\"name\":\"keyword.control.require.ts\"},\"8\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.import-equals.external.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"keyword.control.import.ts\"},\"4\":{\"name\":\"keyword.control.type.ts\"},\"5\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"6\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.ts\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.ts\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.ts\"},\"2\":{\"name\":\"keyword.control.assert.ts\"},\"3\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.ts\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.ts\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.block.ts\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"keyword.control.default.ts\"},\"3\":{\"name\":\"constant.language.import-export-all.ts\"},\"4\":{\"name\":\"variable.other.readwrite.ts\"},\"5\":{\"name\":\"string.quoted.alias.ts\"},\"12\":{\"name\":\"keyword.control.as.ts\"},\"13\":{\"name\":\"keyword.control.default.ts\"},\"14\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"15\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.ts\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.ts\"},\"2\":{\"name\":\"variable.other.readwrite.alias.ts\"},\"3\":{\"name\":\"string.quoted.alias.ts\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.ts\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"meta.brace.square.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.declaration.ts\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"meta.brace.square.ts\"},\"4\":{\"name\":\"entity.name.type.ts\"},\"5\":{\"name\":\"keyword.operator.expression.in.ts\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.ts\"},\"2\":{\"name\":\"keyword.operator.type.modifier.ts\"},\"3\":{\"name\":\"keyword.operator.optional.ts\"}},\"name\":\"meta.indexer.mappedtype.declaration.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.type.interface.ts\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"keyword.operator.new.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.modifier.ts\"},\"4\":{\"name\":\"storage.modifier.async.ts\"},\"5\":{\"name\":\"storage.type.property.ts\"},\"6\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.ts entity.name.function.ts\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.ts\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.namespace.ts\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.ts\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.ts\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.ts\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.ts\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.ts\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"2\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"4\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"6\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"7\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"9\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"11\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.ts\"},\"13\":{\"name\":\"storage.type.numeric.bigint.ts\"},\"14\":{\"name\":\"storage.type.numeric.bigint.ts\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.ts\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.ts\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.ts\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.ts\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"variable.other.constant.object.property.ts\"},\"4\":{\"name\":\"variable.other.object.property.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.ts\"},\"2\":{\"name\":\"variable.other.object.ts\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.objectliteral.ts\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"storage.type.property.ts\"},\"3\":{\"name\":\"keyword.generator.asterisk.ts\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.ts meta.object-literal.key.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.ts\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"constant.numeric.decimal.ts\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"},\"1\":{\"name\":\"entity.name.function.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.ts\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.ts\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.ts\"},\"2\":{\"name\":\"keyword.control.satisfies.ts\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.ts punctuation.separator.key-value.ts\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.ts\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.ts\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.ts\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.ts\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.ts\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.ts meta.return.type.arrow.ts keyword.operator.type.annotation.ts\"}},\"contentName\":\"meta.arrow.ts meta.return.type.arrow.ts\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.ts\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.ts\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.ts\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.double.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"invalid.illegal.newline.ts\"}},\"name\":\"string.quoted.single.ts\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.ts\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.ts\"},\"2\":{\"name\":\"keyword.other.ts\"}},\"name\":\"string.regexp.ts\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.ts\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.ts\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.ts\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.ts\"},\"2\":{\"name\":\"comment.line.double-slash.ts\"},\"3\":{\"name\":\"punctuation.definition.comment.ts\"},\"4\":{\"name\":\"storage.type.internaldeclaration.ts\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.ts\"}},\"contentName\":\"comment.line.double-slash.ts\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.ts\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.ts\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.ts\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.importmeta.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"support.variable.property.target.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.ts\"},\"2\":{\"name\":\"punctuation.accessor.optional.ts\"},\"3\":{\"name\":\"support.variable.property.ts\"},\"4\":{\"name\":\"support.constant.ts\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.ts\"},\"2\":{\"name\":\"support.type.object.module.ts\"},\"3\":{\"name\":\"punctuation.accessor.ts\"},\"4\":{\"name\":\"punctuation.accessor.optional.ts\"},\"5\":{\"name\":\"support.type.object.module.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"switch-statement.expr.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"},\"2\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"switch-expression.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.ts\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.ts\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"},\"2\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"contentName\":\"meta.block.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.ts punctuation.definition.block.ts\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.ts punctuation.definition.section.case-statement.ts\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.ts\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.ts\"},\"2\":{\"name\":\"string.template.ts punctuation.definition.string.template.begin.ts\"}},\"contentName\":\"string.template.ts\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.ts punctuation.definition.string.template.end.ts\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.ts\"}},\"contentName\":\"meta.embedded.line.ts\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.ts\"}},\"name\":\"meta.template.expression.ts\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.ts\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.type.ts\"},\"4\":{\"name\":\"entity.name.type.alias.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"},\"2\":{\"name\":\"keyword.control.intrinsic.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.ts\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.ts\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.ts\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.ts\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.ts storage.modifier.ts\"},\"2\":{\"name\":\"meta.type.constructor.ts keyword.control.new.ts\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.control.new.ts\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.ts\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.ts\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.ts\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.ts\"},\"2\":{\"name\":\"entity.name.type.ts\"},\"3\":{\"name\":\"keyword.operator.expression.extends.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.ts\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"},\"4\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.ts\"},\"2\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.begin.ts\"}},\"contentName\":\"meta.type.parameters.ts\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.ts punctuation.definition.typeparameters.end.ts\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.ts\"},\"2\":{\"name\":\"punctuation.accessor.ts\"},\"3\":{\"name\":\"punctuation.accessor.optional.ts\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.ts\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.ts\"}},\"name\":\"meta.object.type.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.ts\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.ts\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.ts\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.ts\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.ts\"}},\"name\":\"meta.type.parameters.ts\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.ts\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.ts\"}},\"name\":\"meta.type.paren.cover.ts\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"entity.name.function.ts variable.language.this.ts\"},\"4\":{\"name\":\"entity.name.function.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ts\"},\"2\":{\"name\":\"keyword.operator.rest.ts\"},\"3\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"4\":{\"name\":\"variable.parameter.ts\"},\"5\":{\"name\":\"keyword.operator.optional.ts\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.ts\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"},\"4\":{\"name\":\"keyword.operator.expression.is.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.ts\"},\"2\":{\"name\":\"variable.parameter.ts variable.language.this.ts\"},\"3\":{\"name\":\"variable.parameter.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.ts\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.ts\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.ts\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.ts\"}},\"name\":\"meta.type.tuple.ts\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.ts\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.ts\"},\"2\":{\"name\":\"keyword.operator.optional.ts\"},\"3\":{\"name\":\"punctuation.separator.label.ts\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.ts\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.ts\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.ts\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.ts\"},\"2\":{\"name\":\"storage.modifier.ts\"},\"3\":{\"name\":\"storage.type.ts\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.ts\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts entity.name.function.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts entity.name.function.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.constant.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.ts variable.other.readwrite.ts\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.ts\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.ts\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.ts\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.ts\",\"aliases\":[\"ts\",\"cts\",\"mts\"]}"))];
var css_default = [Object.freeze(JSON.parse("{\"displayName\":\"CSS\",\"name\":\"css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#combinators\"},{\"include\":\"#selector\"},{\"include\":\"#at-rules\"},{\"include\":\"#rule-list\"}],\"repository\":{\"at-rules\":{\"patterns\":[{\"begin\":\"\\\\A\\\\uFEFF?(?i:(?=\\\\s*@charset\\\\b))\",\"end\":\";|(?=$)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.terminator.rule.css\"}},\"name\":\"meta.at-rule.charset.css\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"invalid.illegal.not-lowercase.charset.css\"},\"2\":{\"name\":\"invalid.illegal.leading-whitespace.charset.css\"},\"3\":{\"name\":\"invalid.illegal.no-whitespace.charset.css\"},\"4\":{\"name\":\"invalid.illegal.whitespace.charset.css\"},\"5\":{\"name\":\"invalid.illegal.not-double-quoted.charset.css\"},\"6\":{\"name\":\"invalid.illegal.unclosed-string.charset.css\"},\"7\":{\"name\":\"invalid.illegal.unexpected-characters.charset.css\"}},\"match\":\"\\\\G((?!@charset)@\\\\w+)|\\\\G(\\\\s+)|(@charset\\\\S[^;]*)|(?<=@charset)( {2,}|\\\\t+)|(?<=@charset )([^\\\";]+)|(\\\"[^\\\"]+)$|(?<=\\\")([^;]+)\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.at-rule.charset.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"match\":\"((@)charset)(?=\\\\s)\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.css\"}},\"end\":\"\\\"|$\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.css\"}},\"name\":\"string.quoted.double.css\",\"patterns\":[{\"begin\":\"(?:\\\\G|^)(?=[^\\\"]+$)\",\"end\":\"$\",\"name\":\"invalid.illegal.unclosed.string.css\"}]}]},{\"begin\":\"(?i)((@)import)(?:\\\\s+|$|(?=[\\\"']|/\\\\*))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.import.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\";\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.terminator.rule.css\"}},\"name\":\"meta.at-rule.import.css\",\"patterns\":[{\"begin\":\"\\\\G\\\\s*(?=/\\\\*)\",\"end\":\"(?<=\\\\*/)\\\\s*\",\"patterns\":[{\"include\":\"#comment-block\"}]},{\"include\":\"#string\"},{\"include\":\"#url\"},{\"include\":\"#media-query-list\"}]},{\"begin\":\"(?i)((@)font-face)(?=\\\\s*|\\\\{|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.font-face.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?!\\\\G)\",\"name\":\"meta.at-rule.font-face.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#rule-list\"}]},{\"begin\":\"(?i)(@)page(?=[:{\\\\s]|/\\\\*|$)\",\"captures\":{\"0\":{\"name\":\"keyword.control.at-rule.page.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*($|[:;{]))\",\"name\":\"meta.at-rule.page.css\",\"patterns\":[{\"include\":\"#rule-list\"}]},{\"begin\":\"(?i)(?=@media([(\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)media\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.media.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*[;{])\",\"name\":\"meta.at-rule.media.header.css\",\"patterns\":[{\"include\":\"#media-query-list\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.media.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.media.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.media.body.css\",\"patterns\":[{\"include\":\"$self\"}]}]},{\"begin\":\"(?i)(?=@counter-style([\\\"';{\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)counter-style\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.counter-style.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*\\\\{)\",\"name\":\"meta.at-rule.counter-style.header.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"captures\":{\"0\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.parameter.style-name.css\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.counter-style.body.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#rule-list-innards\"}]}]},{\"begin\":\"(?i)(?=@document([\\\"';{\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)document\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.document.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*[;{])\",\"name\":\"meta.at-rule.document.header.css\",\"patterns\":[{\"begin\":\"(?i)(?<![-\\\\w])(url-prefix|domain|regexp)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.document-rule.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.document-rule.css\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"match\":\"[^\\\"')\\\\s]+\",\"name\":\"variable.parameter.document-rule.css\"}]},{\"include\":\"#url\"},{\"include\":\"#commas\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.document.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.document.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.document.body.css\",\"patterns\":[{\"include\":\"$self\"}]}]},{\"begin\":\"(?i)(?=@(?:-(?:webkit|moz|o|ms)-)?keyframes([\\\"';{\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)(?:-(?:webkit|moz|o|ms)-)?keyframes\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.keyframes.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*\\\\{)\",\"name\":\"meta.at-rule.keyframes.header.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"captures\":{\"0\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.parameter.keyframe-list.css\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.keyframes.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.keyframes.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.keyframes.body.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"captures\":{\"1\":{\"name\":\"entity.other.keyframe-offset.css\"},\"2\":{\"name\":\"entity.other.keyframe-offset.percentage.css\"}},\"match\":\"(?i)(?<![-\\\\w])(from|to)(?![-\\\\w])|([-+]?(?:\\\\d+(?:\\\\.\\\\d+)?|\\\\.\\\\d+)%)\"},{\"include\":\"#rule-list\"}]}]},{\"begin\":\"(?i)(?=@supports([(\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)|(?=;)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)supports\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.supports.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*[;{])\",\"name\":\"meta.at-rule.supports.header.css\",\"patterns\":[{\"include\":\"#feature-query-operators\"},{\"include\":\"#feature-query\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.supports.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.supports.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.supports.body.css\",\"patterns\":[{\"include\":\"$self\"}]}]},{\"begin\":\"(?i)((@)(-(ms|o)-)?viewport)(?=[\\\"';{\\\\s]|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.viewport.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*[;@{])\",\"name\":\"meta.at-rule.viewport.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"}]},{\"begin\":\"(?i)((@)font-feature-values)(?=[\\\"';{\\\\s]|/\\\\*|$)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.font-feature-values.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"contentName\":\"variable.parameter.font-name.css\",\"end\":\"(?=\\\\s*[;@{])\",\"name\":\"meta.at-rule.font-features.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"}]},{\"include\":\"#font-features\"},{\"begin\":\"(?i)((@)namespace)(?=[\\\"';\\\\s]|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.namespace.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\";|(?=[@{])\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.terminator.rule.css\"}},\"name\":\"meta.at-rule.namespace.css\",\"patterns\":[{\"include\":\"#url\"},{\"captures\":{\"1\":{\"patterns\":[{\"include\":\"#comment-block\"}]},\"2\":{\"name\":\"entity.name.function.namespace-prefix.css\",\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(?i)(?:\\\\G|^|(?<=\\\\s))(?=(?<=\\\\s|^)[-A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\s*/\\\\*(?:[^*]|\\\\*[^/])*\\\\*/)(.*?)([-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*)\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#string\"}]},{\"begin\":\"(?i)(?=@[-\\\\w]+[^;]+;s*$)\",\"end\":\"(?<=;)(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)[-\\\\w]+\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\";\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.terminator.rule.css\"}},\"name\":\"meta.at-rule.header.css\"}]},{\"begin\":\"(?i)(?=@[-\\\\w]+([({\\\\s]|/\\\\*|$))\",\"end\":\"(?<=})(?!\\\\G)\",\"patterns\":[{\"begin\":\"(?i)\\\\G(@)[-\\\\w]+\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.at-rule.css\"},\"1\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?=\\\\s*[;{])\",\"name\":\"meta.at-rule.header.css\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.end.bracket.curly.css\"}},\"name\":\"meta.at-rule.body.css\",\"patterns\":[{\"include\":\"$self\"}]}]}]},\"color-keywords\":{\"patterns\":[{\"match\":\"(?i)(?<![-\\\\w])(aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow)(?![-\\\\w])\",\"name\":\"support.constant.color.w3c-standard-color-name.css\"},{\"match\":\"(?i)(?<![-\\\\w])(aliceblue|antiquewhite|aquamarine|azure|beige|bisque|blanchedalmond|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|gainsboro|ghostwhite|gold|goldenrod|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|limegreen|linen|magenta|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|oldlace|olivedrab|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|rebeccapurple|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|thistle|tomato|transparent|turquoise|violet|wheat|whitesmoke|yellowgreen)(?![-\\\\w])\",\"name\":\"support.constant.color.w3c-extended-color-name.css\"},{\"match\":\"(?i)(?<![-\\\\w])currentColor(?![-\\\\w])\",\"name\":\"support.constant.color.current.css\"},{\"match\":\"(?i)(?<![-\\\\w])(ActiveBorder|ActiveCaption|AppWorkspace|Background|ButtonFace|ButtonHighlight|ButtonShadow|ButtonText|CaptionText|GrayText|Highlight|HighlightText|InactiveBorder|InactiveCaption|InactiveCaptionText|InfoBackground|InfoText|Menu|MenuText|Scrollbar|ThreeDDarkShadow|ThreeDFace|ThreeDHighlight|ThreeDLightShadow|ThreeDShadow|Window|WindowFrame|WindowText)(?![-\\\\w])\",\"name\":\"invalid.deprecated.color.system.css\"}]},\"combinators\":{\"patterns\":[{\"match\":\"/deep/|>>>\",\"name\":\"invalid.deprecated.combinator.css\"},{\"match\":\">>|[+>~]\",\"name\":\"keyword.operator.combinator.css\"}]},\"commas\":{\"match\":\",\",\"name\":\"punctuation.separator.list.comma.css\"},\"comment-block\":{\"begin\":\"/\\\\*\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.begin.css\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.end.css\"}},\"name\":\"comment.block.css\"},\"escapes\":{\"patterns\":[{\"match\":\"\\\\\\\\\\\\h{1,6}\",\"name\":\"constant.character.escape.codepoint.css\"},{\"begin\":\"\\\\\\\\$\\\\s*\",\"end\":\"^(?<!\\\\G)\",\"name\":\"constant.character.escape.newline.css\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.css\"}]},\"feature-query\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.condition.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.condition.end.bracket.round.css\"}},\"name\":\"meta.feature-query.css\",\"patterns\":[{\"include\":\"#feature-query-operators\"},{\"include\":\"#feature-query\"}]},\"feature-query-operators\":{\"patterns\":[{\"match\":\"(?i)(?<=[()\\\\s]|^|\\\\*/)(and|not|or)(?=[()\\\\s]|/\\\\*|$)\",\"name\":\"keyword.operator.logical.feature.$1.css\"},{\"include\":\"#rule-list-innards\"}]},\"font-features\":{\"begin\":\"(?i)((@)(annotation|character-variant|ornaments|styleset|stylistic|swash))(?=[\\\"';@{\\\\s]|/\\\\*|$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.at-rule.${3:/downcase}.css\"},\"2\":{\"name\":\"punctuation.definition.keyword.css\"}},\"end\":\"(?<=})\",\"name\":\"meta.at-rule.${3:/downcase}.css\",\"patterns\":[{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.end.bracket.curly.css\"}},\"name\":\"meta.property-list.font-feature.css\",\"patterns\":[{\"captures\":{\"0\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.font-feature.css\"},{\"include\":\"#rule-list-innards\"}]}]},\"functional-pseudo-classes\":{\"patterns\":[{\"begin\":\"(?i)((:)dir)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.pseudo-class.css\"},\"2\":{\"name\":\"punctuation.definition.entity.css\"},\"3\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"match\":\"(?i)(?<![-\\\\w])(ltr|rtl)(?![-\\\\w])\",\"name\":\"support.constant.text-direction.css\"},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)((:)lang)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.pseudo-class.css\"},\"2\":{\"name\":\"punctuation.definition.entity.css\"},\"3\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"match\":\"(?<=[(,\\\\s])[A-Za-z]+(-[0-9A-Za-z]*|\\\\\\\\(?:\\\\h{1,6}|.))*(?=[),\\\\s])\",\"name\":\"support.constant.language-range.css\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.css\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.css\"}},\"name\":\"string.quoted.double.css\",\"patterns\":[{\"include\":\"#escapes\"},{\"match\":\"(?<=[\\\"\\\\s])[*A-Za-z]+(-[*0-9A-Za-z]*)*(?=[\\\"\\\\s])\",\"name\":\"support.constant.language-range.css\"}]},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.css\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.css\"}},\"name\":\"string.quoted.single.css\",\"patterns\":[{\"include\":\"#escapes\"},{\"match\":\"(?<=['\\\\s])[*A-Za-z]+(-[*0-9A-Za-z]*)*(?=['\\\\s])\",\"name\":\"support.constant.language-range.css\"}]},{\"include\":\"#commas\"}]},{\"begin\":\"(?i)((:)(?:not|has|matches|where|is))(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.pseudo-class.css\"},\"2\":{\"name\":\"punctuation.definition.entity.css\"},\"3\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"include\":\"#selector-innards\"}]},{\"begin\":\"(?i)((:)nth-(?:last-)?(?:child|of-type))(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.pseudo-class.css\"},\"2\":{\"name\":\"punctuation.definition.entity.css\"},\"3\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"match\":\"(?i)[-+]?(\\\\d+n?|n)(\\\\s*[-+]\\\\s*\\\\d+)?\",\"name\":\"constant.numeric.css\"},{\"match\":\"(?i)even|odd\",\"name\":\"support.constant.parity.css\"}]}]},\"functions\":{\"patterns\":[{\"begin\":\"(?i)(?<![-\\\\w])(calc)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.calc.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.calc.css\",\"patterns\":[{\"match\":\"[*/]|(?<=\\\\s|^)[-+](?=\\\\s|$)\",\"name\":\"keyword.operator.arithmetic.css\"},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])(rgba?|hsla?|hwb|lab|oklab|lch|oklch|color)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.misc.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.color.css\",\"patterns\":[{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])((?:-(?:webkit-|moz-|o-))?(?:repeating-)?(?:linear|radial|conic)-gradient)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.gradient.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.gradient.css\",\"patterns\":[{\"match\":\"(?i)(?<![-\\\\w])(from|to|at|in|hue)(?![-\\\\w])\",\"name\":\"keyword.operator.gradient.css\"},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])(-webkit-gradient)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"invalid.deprecated.gradient.function.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.gradient.invalid.deprecated.gradient.css\",\"patterns\":[{\"begin\":\"(?i)(?<![-\\\\w])(from|to|color-stop)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"invalid.deprecated.function.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"include\":\"#property-values\"}]},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])(annotation|attr|blur|brightness|character-variant|clamp|contrast|counters?|cross-fade|drop-shadow|element|fit-content|format|grayscale|hue-rotate|color-mix|image-set|invert|local|max|min|minmax|opacity|ornaments|repeat|saturate|sepia|styleset|stylistic|swash|symbols|cos|sin|tan|acos|asin|atan2??|hypot|sqrt|pow|log|exp|abs|sign)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.misc.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.misc.css\",\"patterns\":[{\"match\":\"(?i)(?<=[\\\",\\\\s]|\\\\*/|^)\\\\d+x(?=[\\\"'),\\\\s]|/\\\\*|$)\",\"name\":\"constant.numeric.other.density.css\"},{\"include\":\"#property-values\"},{\"match\":\"[^\\\"'),\\\\s]+\",\"name\":\"variable.parameter.misc.css\"}]},{\"begin\":\"(?i)(?<![-\\\\w])(circle|ellipse|inset|polygon|rect)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.shape.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.shape.css\",\"patterns\":[{\"match\":\"(?i)(?<=\\\\s|^|\\\\*/)(at|round)(?=\\\\s|/\\\\*|$)\",\"name\":\"keyword.operator.shape.css\"},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])(cubic-bezier|steps)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.timing-function.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.timing-function.css\",\"patterns\":[{\"match\":\"(?i)(?<![-\\\\w])(start|end)(?=\\\\s*\\\\)|$)\",\"name\":\"support.constant.step-direction.css\"},{\"include\":\"#property-values\"}]},{\"begin\":\"(?i)(?<![-\\\\w])((?:translate|scale|rotate)(?:[XYZ]|3D)?|matrix(?:3D)?|skew[XY]?|perspective)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.transform.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"patterns\":[{\"include\":\"#property-values\"}]},{\"include\":\"#url\"},{\"begin\":\"(?i)(?<![-\\\\w])(var)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.misc.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.variable.css\",\"patterns\":[{\"match\":\"--[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.argument.css\"},{\"include\":\"#property-values\"}]}]},\"media-feature-keywords\":{\"match\":\"(?i)(?<=^|[:\\\\s]|\\\\*/)(?:portrait|landscape|progressive|interlace|fullscreen|standalone|minimal-ui|browser|hover)(?=[)\\\\s]|$)\",\"name\":\"support.constant.property-value.css\"},\"media-features\":{\"captures\":{\"1\":{\"name\":\"support.type.property-name.media.css\"},\"2\":{\"name\":\"support.type.property-name.media.css\"},\"3\":{\"name\":\"support.type.vendored.property-name.media.css\"}},\"match\":\"(?i)(?<=^|[(\\\\s]|\\\\*/)(?:((?:m(?:in-|ax-))?(?:height|width|aspect-ratio|color|color-index|monochrome|resolution)|grid|scan|orientation|display-mode|hover)|((?:m(?:in-|ax-))?device-(?:height|width|aspect-ratio))|((?:[-_](?:webkit|apple|khtml|epub|moz|ms|o|xv|ah|rim|atsc|hp|tc|wap|ro)|(?:mso|prince))-[-\\\\w]+(?=\\\\s*(?:/\\\\*(?:[^*]|\\\\*[^/])*\\\\*/)?\\\\s*[):])))(?=\\\\s|$|[):<=>]|/\\\\*)\"},\"media-query\":{\"begin\":\"\\\\G\",\"end\":\"(?=\\\\s*[;{])\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#media-types\"},{\"match\":\"(?i)(?<=\\\\s|^|,|\\\\*/)(only|not)(?=[{\\\\s]|/\\\\*|$)\",\"name\":\"keyword.operator.logical.$1.media.css\"},{\"match\":\"(?i)(?<=\\\\s|^|\\\\*/|\\\\))and(?=\\\\s|/\\\\*|$)\",\"name\":\"keyword.operator.logical.and.media.css\"},{\"match\":\",(?:(?:\\\\s*,)+|(?=\\\\s*[);{]))\",\"name\":\"invalid.illegal.comma.css\"},{\"include\":\"#commas\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.bracket.round.css\"}},\"patterns\":[{\"include\":\"#media-features\"},{\"include\":\"#media-feature-keywords\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.css\"},{\"match\":\">=|<=|[<=>]\",\"name\":\"keyword.operator.comparison.css\"},{\"captures\":{\"1\":{\"name\":\"constant.numeric.css\"},\"2\":{\"name\":\"keyword.operator.arithmetic.css\"},\"3\":{\"name\":\"constant.numeric.css\"}},\"match\":\"(\\\\d+)\\\\s*(/)\\\\s*(\\\\d+)\",\"name\":\"meta.ratio.css\"},{\"include\":\"#numeric-values\"},{\"include\":\"#comment-block\"}]}]},\"media-query-list\":{\"begin\":\"(?=\\\\s*[^;{])\",\"end\":\"(?=\\\\s*[;{])\",\"patterns\":[{\"include\":\"#media-query\"}]},\"media-types\":{\"captures\":{\"1\":{\"name\":\"support.constant.media.css\"},\"2\":{\"name\":\"invalid.deprecated.constant.media.css\"}},\"match\":\"(?i)(?<=^|[,\\\\s]|\\\\*/)(?:(all|print|screen|speech)|(aural|braille|embossed|handheld|projection|tty|tv))(?=$|[,;{\\\\s]|/\\\\*)\"},\"numeric-values\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.constant.css\"}},\"match\":\"(#)(?:\\\\h{3,4}|\\\\h{6}|\\\\h{8})\\\\b\",\"name\":\"constant.other.color.rgb-value.hex.css\"},{\"captures\":{\"1\":{\"name\":\"keyword.other.unit.percentage.css\"},\"2\":{\"name\":\"keyword.other.unit.${2:/downcase}.css\"}},\"match\":\"(?i)(?<![-\\\\w])[-+]?(?:[0-9]+(?:\\\\.[0-9]+)?|\\\\.[0-9]+)(?:(?<=[0-9])E[-+]?[0-9]+)?(?:(%)|(deg|grad|rad|turn|Hz|kHz|ch|cm|em|ex|fr|in|mm|mozmm|pc|pt|px|q|rem|rch|rex|rlh|ic|ric|rcap|vh|vw|vb|vi|svh|svw|svb|svi|dvh|dvw|dvb|dvi|lvh|lvw|lvb|lvi|vmax|vmin|cqw|cqi|cqh|cqb|cqmin|cqmax|dpi|dpcm|dppx|s|ms)\\\\b)?\",\"name\":\"constant.numeric.css\"}]},\"property-keywords\":{\"patterns\":[{\"match\":\"(?i)(?<![-\\\\w])(above|absolute|active|add|additive|after-edge|alias|all|all-petite-caps|all-scroll|all-small-caps|alpha|alphabetic|alternate|alternate-reverse|always|antialiased|auto|auto-fill|auto-fit|auto-pos|available|avoid|avoid-column|avoid-page|avoid-region|backwards|balance|baseline|before-edge|below|bevel|bidi-override|blink|block|block-axis|block-start|block-end|bold|bolder|border|border-box|both|bottom|bottom-outside|break-all|break-word|bullets|butt|capitalize|caption|cell|center|central|char|circle|clip|clone|close-quote|closest-corner|closest-side|col-resize|collapse|color|color-burn|color-dodge|column|column-reverse|common-ligatures|compact|condensed|contain|content|content-box|contents|context-menu|contextual|copy|cover|crisp-edges|crispEdges|crosshair|cyclic|dark|darken|dashed|decimal|default|dense|diagonal-fractions|difference|digits|disabled|disc|discretionary-ligatures|distribute|distribute-all-lines|distribute-letter|distribute-space|dot|dotted|double|double-circle|downleft|downright|e-resize|each-line|ease|ease-in|ease-in-out|ease-out|economy|ellipse|ellipsis|embed|end|evenodd|ew-resize|exact|exclude|exclusion|expanded|extends|extra-condensed|extra-expanded|fallback|farthest-corner|farthest-side|fill|fill-available|fill-box|filled|fit-content|fixed|flat|flex|flex-end|flex-start|flip|flow|flow-root|forwards|freeze|from-image|full-width|geometricPrecision|georgian|grab|grabbing|grayscale|grid|groove|hand|hanging|hard-light|help|hidden|hide|historical-forms|historical-ligatures|horizontal|horizontal-tb|hue|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|infinite|inherit|initial|inline|inline-axis|inline-block|inline-end|inline-flex|inline-grid|inline-list-item|inline-start|inline-table|inset|inside|inter-character|inter-ideograph|inter-word|intersect|invert|isolate|isolate-override|italic|jis04|jis78|jis83|jis90|justify|justify-all|kannada|keep-all|landscape|larger??|left|light|lighten|lighter|line|line-edge|line-through|linear|linearRGB|lining-nums|list-item|local|loose|lowercase|lr|lr-tb|ltr|luminance|luminosity|main-size|mandatory|manipulation|manual|margin-box|match-parent|match-source|mathematical|max-content|medium|menu|message-box|middle|min-content|miter|mixed|move|multiply|n-resize|narrower|ne-resize|nearest-neighbor|nesw-resize|newspaper|no-change|no-clip|no-close-quote|no-common-ligatures|no-contextual|no-discretionary-ligatures|no-drop|no-historical-ligatures|no-open-quote|no-repeat|none|nonzero|normal|not-allowed|nowrap|ns-resize|numbers|numeric|nw-resize|nwse-resize|oblique|oldstyle-nums|open|open-quote|optimizeLegibility|optimizeQuality|optimizeSpeed|optional|ordinal|outset|outside|over|overlay|overline|padding|padding-box|page|painted|pan-down|pan-left|pan-right|pan-up|pan-x|pan-y|paused|petite-caps|pixelated|plaintext|pointer|portrait|pre|pre-line|pre-wrap|preserve-3d|progress|progressive|proportional-nums|proportional-width|proximity|radial|recto|region|relative|remove|repeat|repeat-[xy]|reset-size|reverse|revert|revert-layer|ridge|right|rl|rl-tb|round|row|row-resize|row-reverse|row-severse|rtl|ruby|ruby-base|ruby-base-container|ruby-text|ruby-text-container|run-in|running|s-resize|saturation|scale-down|screen|scroll|scroll-position|se-resize|semi-condensed|semi-expanded|separate|sesame|show|sideways|sideways-left|sideways-lr|sideways-right|sideways-rl|simplified|slashed-zero|slice|small|small-caps|small-caption|smaller|smooth|soft-light|solid|space|space-around|space-between|space-evenly|spell-out|square|sRGB|stacked-fractions|start|static|status-bar|swap|step-end|step-start|sticky|stretch|strict|stroke|stroke-box|style|sub|subgrid|subpixel-antialiased|subtract|super|sw-resize|symbolic|table|table-caption|table-cell|table-column|table-column-group|table-footer-group|table-header-group|table-row|table-row-group|tabular-nums|tb|tb-rl|text|text-after-edge|text-before-edge|text-bottom|text-top|thick|thin|titling-caps|top|top-outside|touch|traditional|transparent|triangle|ultra-condensed|ultra-expanded|under|underline|unicase|unset|upleft|uppercase|upright|use-glyph-orientation|use-script|verso|vertical|vertical-ideographic|vertical-lr|vertical-rl|vertical-text|view-box|visible|visibleFill|visiblePainted|visibleStroke|w-resize|wait|wavy|weight|whitespace|wider|words|wrap|wrap-reverse|x|x-large|x-small|xx-large|xx-small|y|zero|zoom-in|zoom-out)(?![-\\\\w])\",\"name\":\"support.constant.property-value.css\"},{\"match\":\"(?i)(?<![-\\\\w])(arabic-indic|armenian|bengali|cambodian|circle|cjk-decimal|cjk-earthly-branch|cjk-heavenly-stem|cjk-ideographic|decimal|decimal-leading-zero|devanagari|disc|disclosure-closed|disclosure-open|ethiopic-halehame-am|ethiopic-halehame-ti-e[rt]|ethiopic-numeric|georgian|gujarati|gurmukhi|hangul|hangul-consonant|hebrew|hiragana|hiragana-iroha|japanese-formal|japanese-informal|kannada|katakana|katakana-iroha|khmer|korean-hangul-formal|korean-hanja-formal|korean-hanja-informal|lao|lower-alpha|lower-armenian|lower-greek|lower-latin|lower-roman|malayalam|mongolian|myanmar|oriya|persian|simp-chinese-formal|simp-chinese-informal|square|tamil|telugu|thai|tibetan|trad-chinese-formal|trad-chinese-informal|upper-alpha|upper-armenian|upper-latin|upper-roman|urdu)(?![-\\\\w])\",\"name\":\"support.constant.property-value.list-style-type.css\"},{\"match\":\"(?<![-\\\\w])(?i:-(?:ah|apple|atsc|epub|hp|khtml|moz|ms|o|rim|ro|tc|wap|webkit|xv)|(?:mso|prince))-[-A-Za-z]+\",\"name\":\"support.constant.vendored.property-value.css\"},{\"match\":\"(?<![-\\\\w])(?i:arial|century|comic|courier|garamond|georgia|helvetica|impact|lucida|symbol|system-ui|system|tahoma|times|trebuchet|ui-monospace|ui-rounded|ui-sans-serif|ui-serif|utopia|verdana|webdings|sans-serif|serif|monospace)(?![-\\\\w])\",\"name\":\"support.constant.font-name.css\"}]},\"property-names\":{\"patterns\":[{\"match\":\"(?i)(?<![-\\\\w])(?:accent-color|additive-symbols|align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|aspect-ratio|backdrop-filter|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-position-[xy]|background-repeat|background-size|bleed|block-size|border|border-block-end|border-block-end-color|border-block-end-style|border-block-end-width|border-block-start|border-block-start-color|border-block-start-style|border-block-start-width|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-end-end-radius|border-end-start-radius|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-inline-end|border-inline-end-color|border-inline-end-style|border-inline-end-width|border-inline-start|border-inline-start-color|border-inline-start-style|border-inline-start-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-start-end-radius|border-start-start-radius|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-decoration-break|box-shadow|box-sizing|break-after|break-before|break-inside|caption-side|caret-color|clear|clip|clip-path|clip-rule|color|color-adjust|color-interpolation-filters|color-scheme|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|contain|container|container-name|container-type|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|enable-background|fallback|fill|fill-opacity|fill-rule|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|flood-color|flood-opacity|font|font-display|font-family|font-feature-settings|font-kerning|font-language-override|font-optical-sizing|font-size|font-size-adjust|font-stretch|font-style|font-synthesis|font-variant|font-variant-alternates|font-variant-caps|font-variant-east-asian|font-variant-ligatures|font-variant-numeric|font-variant-position|font-variation-settings|font-weight|gap|glyph-orientation-horizontal|glyph-orientation-vertical|grid|grid-area|grid-auto-columns|grid-auto-flow|grid-auto-rows|grid-column|grid-column-end|grid-column-gap|grid-column-start|grid-gap|grid-row|grid-row-end|grid-row-gap|grid-row-start|grid-template|grid-template-areas|grid-template-columns|grid-template-rows|hanging-punctuation|height|hyphens|image-orientation|image-rendering|image-resolution|ime-mode|initial-letter|initial-letter-align|inline-size|inset|inset-block|inset-block-end|inset-block-start|inset-inline|inset-inline-end|inset-inline-start|isolation|justify-content|justify-items|justify-self|kerning|left|letter-spacing|lighting-color|line-break|line-clamp|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-block|margin-block-end|margin-block-start|margin-bottom|margin-inline|margin-inline-end|margin-inline-start|margin-left|margin-right|margin-top|marker-end|marker-mid|marker-start|marks|mask|mask-border|mask-border-mode|mask-border-outset|mask-border-repeat|mask-border-slice|mask-border-source|mask-border-width|mask-clip|mask-composite|mask-image|mask-mode|mask-origin|mask-position|mask-repeat|mask-size|mask-type|max-block-size|max-height|max-inline-size|max-lines|max-width|max-zoom|min-block-size|min-height|min-inline-size|min-width|min-zoom|mix-blend-mode|negative|object-fit|object-position|offset|offset-anchor|offset-distance|offset-path|offset-position|offset-rotation|opacity|order|orientation|orphans|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-anchor|overflow-block|overflow-inline|overflow-wrap|overflow-[xy]|overscroll-behavior|overscroll-behavior-block|overscroll-behavior-inline|overscroll-behavior-[xy]|pad|padding|padding-block|padding-block-end|padding-block-start|padding-bottom|padding-inline|padding-inline-end|padding-inline-start|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|paint-order|perspective|perspective-origin|place-content|place-items|place-self|pointer-events|position|prefix|quotes|range|resize|right|rotate|row-gap|ruby-align|ruby-merge|ruby-position|scale|scroll-behavior|scroll-margin|scroll-margin-block|scroll-margin-block-end|scroll-margin-block-start|scroll-margin-bottom|scroll-margin-inline|scroll-margin-inline-end|scroll-margin-inline-start|scroll-margin-left|scroll-margin-right|scroll-margin-top|scroll-padding|scroll-padding-block|scroll-padding-block-end|scroll-padding-block-start|scroll-padding-bottom|scroll-padding-inline|scroll-padding-inline-end|scroll-padding-inline-start|scroll-padding-left|scroll-padding-right|scroll-padding-top|scroll-snap-align|scroll-snap-coordinate|scroll-snap-destination|scroll-snap-stop|scroll-snap-type|scrollbar-color|scrollbar-gutter|scrollbar-width|shape-image-threshold|shape-margin|shape-outside|shape-rendering|size|speak-as|src|stop-color|stop-opacity|stroke|stroke-dasharray|stroke-dashoffset|stroke-linecap|stroke-linejoin|stroke-miterlimit|stroke-opacity|stroke-width|suffix|symbols|system|tab-size|table-layout|text-align|text-align-last|text-anchor|text-combine-upright|text-decoration|text-decoration-color|text-decoration-line|text-decoration-skip|text-decoration-skip-ink|text-decoration-style|text-decoration-thickness|text-emphasis|text-emphasis-color|text-emphasis-position|text-emphasis-style|text-indent|text-justify|text-orientation|text-overflow|text-rendering|text-shadow|text-size-adjust|text-transform|text-underline-offset|text-underline-position|top|touch-action|transform|transform-box|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|translate|unicode-bidi|unicode-range|user-select|user-zoom|vertical-align|visibility|white-space|widows|width|will-change|word-break|word-spacing|word-wrap|writing-mode|z-index|zoom|alignment-baseline|baseline-shift|clip-rule|color-interpolation|color-interpolation-filters|color-profile|color-rendering|cx|cy|dominant-baseline|enable-background|fill|fill-opacity|fill-rule|flood-color|flood-opacity|glyph-orientation-horizontal|glyph-orientation-vertical|height|kerning|lighting-color|marker-end|marker-mid|marker-start|rx??|ry|shape-rendering|stop-color|stop-opacity|stroke|stroke-dasharray|stroke-dashoffset|stroke-linecap|stroke-linejoin|stroke-miterlimit|stroke-opacity|stroke-width|text-anchor|width|[xy]|adjust|after|align|align-last|alignment|alignment-adjust|appearance|attachment|azimuth|background-break|balance|baseline|before|bidi|binding|bookmark|bookmark-label|bookmark-level|bookmark-target|border-length|bottom-color|bottom-left-radius|bottom-right-radius|bottom-style|bottom-width|box|box-align|box-direction|box-flex|box-flex-group|box-lines|box-ordinal-group|box-orient|box-pack|break|character|collapse|column|column-break-after|column-break-before|count|counter|crop|cue|cue-after|cue-before|decoration|decoration-break|delay|display-model|display-role|down|drop|drop-initial-after-adjust|drop-initial-after-align|drop-initial-before-adjust|drop-initial-before-align|drop-initial-size|drop-initial-value|duration|elevation|emphasis|family|fit|fit-position|flex-group|float-offset|gap|grid-columns|grid-rows|hanging-punctuation|header|hyphenate|hyphenate-after|hyphenate-before|hyphenate-character|hyphenate-lines|hyphenate-resource|icon|image|increment|indent|index|initial-after-adjust|initial-after-align|initial-before-adjust|initial-before-align|initial-size|initial-value|inline-box-align|iteration-count|justify|label|left-color|left-style|left-width|length|level|line|line-stacking|line-stacking-ruby|line-stacking-shift|line-stacking-strategy|lines|list|mark|mark-after|mark-before|marks|marquee|marquee-direction|marquee-play-count|marquee-speed|marquee-style|max|min|model|move-to|name|nav|nav-down|nav-index|nav-left|nav-right|nav-up|new|numeral|offset|ordinal-group|orient|origin|overflow-style|overhang|pack|page|page-policy|pause|pause-after|pause-before|phonemes|pitch|pitch-range|play-count|play-during|play-state|point|presentation|presentation-level|profile|property|punctuation|punctuation-trim|radius|rate|rendering-intent|repeat|replace|reset|resolution|resource|respond-to|rest|rest-after|rest-before|richness|right-color|right-style|right-width|role|rotation|rotation-point|rows|ruby|ruby-overhang|ruby-span|rule|rule-color|rule-style|rule-width|shadow|size|size-adjust|sizing|space|space-collapse|spacing|span|speak|speak-header|speak-numeral|speak-punctuation|speech|speech-rate|speed|stacking|stacking-ruby|stacking-shift|stacking-strategy|stress|stretch|string-set|style|style-image|style-position|style-type|target|target-name|target-new|target-position|text|text-height|text-justify|text-outline|text-replace|text-wrap|timing-function|top-color|top-left-radius|top-right-radius|top-style|top-width|trim|unicode|up|user-select|variant|voice|voice-balance|voice-duration|voice-family|voice-pitch|voice-pitch-range|voice-rate|voice-stress|voice-volume|volume|weight|white|white-space-collapse|word|wrap)(?![-\\\\w])\",\"name\":\"support.type.property-name.css\"},{\"match\":\"(?<![-\\\\w])(?i:-(?:ah|apple|atsc|epub|hp|khtml|moz|ms|o|rim|ro|tc|wap|webkit|xv)|(?:mso|prince))-[-A-Za-z]+\",\"name\":\"support.type.vendored.property-name.css\"}]},\"property-values\":{\"patterns\":[{\"include\":\"#commas\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#functions\"},{\"include\":\"#property-keywords\"},{\"include\":\"#unicode-range\"},{\"include\":\"#numeric-values\"},{\"include\":\"#color-keywords\"},{\"include\":\"#string\"},{\"match\":\"!\\\\s*important(?![-\\\\w])\",\"name\":\"keyword.other.important.css\"}]},\"pseudo-classes\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.css\"},\"2\":{\"name\":\"invalid.illegal.colon.css\"}},\"match\":\"(?i)(:)(:*)(?:active|any-link|checked|default|disabled|empty|enabled|first|(?:first|last|only)-(?:child|of-type)|focus|focus-visible|focus-within|fullscreen|host|hover|in-range|indeterminate|invalid|left|link|optional|out-of-range|read-only|read-write|required|right|root|scope|target|unresolved|valid|visited)(?![-\\\\w]|\\\\s*[;}])\",\"name\":\"entity.other.attribute-name.pseudo-class.css\"},\"pseudo-elements\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.css\"},\"2\":{\"name\":\"punctuation.definition.entity.css\"}},\"match\":\"(?i)(?:(::?)(?:after|before|first-letter|first-line|(?:-(?:ah|apple|atsc|epub|hp|khtml|moz|ms|o|rim|ro|tc|wap|webkit|xv)|(?:mso|prince))-[-a-z]+)|(::)(?:backdrop|content|grammar-error|marker|placeholder|selection|shadow|spelling-error))(?![-\\\\w]|\\\\s*[;}])\",\"name\":\"entity.other.attribute-name.pseudo-element.css\"},\"rule-list\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.begin.bracket.curly.css\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.property-list.end.bracket.curly.css\"}},\"name\":\"meta.property-list.css\",\"patterns\":[{\"include\":\"#rule-list-innards\"}]},\"rule-list-innards\":{\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"},{\"include\":\"#font-features\"},{\"match\":\"(?<![-\\\\w])--[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.css\"},{\"begin\":\"(?<![-A-Za-z])(?=[-A-Za-z])\",\"end\":\"$|(?![-A-Za-z])\",\"name\":\"meta.property-name.css\",\"patterns\":[{\"include\":\"#property-names\"}]},{\"begin\":\"(:)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.key-value.css\"}},\"contentName\":\"meta.property-value.css\",\"end\":\"\\\\s*(;)|\\\\s*(?=[)}])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.terminator.rule.css\"}},\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#property-values\"}]},{\"match\":\";\",\"name\":\"punctuation.terminator.rule.css\"}]},\"selector\":{\"begin\":\"(?=\\\\|?(?:[-#*.:A-\\\\[_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.)))\",\"end\":\"(?=\\\\s*[)/@{])\",\"name\":\"meta.selector.css\",\"patterns\":[{\"include\":\"#selector-innards\"}]},\"selector-innards\":{\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#commas\"},{\"include\":\"#escapes\"},{\"include\":\"#combinators\"},{\"captures\":{\"1\":{\"name\":\"entity.other.namespace-prefix.css\"},\"2\":{\"name\":\"punctuation.separator.css\"}},\"match\":\"(?:^|(?<=[(,;}\\\\s]))(?![-*\\\\w]+\\\\|(?![-#*.:A-\\\\[_a-z[^\\\\x00-\\\\x7F]]))([-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*|\\\\*)?(\\\\|)\"},{\"include\":\"#tag-names\"},{\"match\":\"\\\\*\",\"name\":\"entity.name.tag.wildcard.css\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.css\"},\"2\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(?<![-@\\\\w])([#.])((?:-?[0-9]|-(?=$|[#)+,.:>\\\\[{|~\\\\s]|/\\\\*)|(?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*(?:[]!\\\"%-(*;<?@^`|}]|/(?!\\\\*))+)(?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*)\",\"name\":\"invalid.illegal.bad-identifier.css\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.css\"},\"2\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(\\\\.)((?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))+)(?=$|[#)+,.:>\\\\[{|~\\\\s]|/\\\\*)\",\"name\":\"entity.other.attribute-name.class.css\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.css\"},\"2\":{\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(#)(-?(?![0-9])(?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))+)(?=$|[#)+,.:>\\\\[{|~\\\\s]|/\\\\*)\",\"name\":\"entity.other.attribute-name.id.css\"},{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.entity.begin.bracket.square.css\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.entity.end.bracket.square.css\"}},\"name\":\"meta.attribute-selector.css\",\"patterns\":[{\"include\":\"#comment-block\"},{\"include\":\"#string\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.ignore-case.css\"}},\"match\":\"(?<=[\\\"'\\\\s]|^|\\\\*/)\\\\s*([Ii])\\\\s*(?=[]\\\\s]|/\\\\*|$)\"},{\"captures\":{\"1\":{\"name\":\"string.unquoted.attribute-value.css\",\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(?<==)\\\\s*((?!/\\\\*)(?:[^]\\\"'\\\\\\\\\\\\s]|\\\\\\\\.)+)\"},{\"include\":\"#escapes\"},{\"match\":\"[$*^|~]?=\",\"name\":\"keyword.operator.pattern.css\"},{\"match\":\"\\\\|\",\"name\":\"punctuation.separator.css\"},{\"captures\":{\"1\":{\"name\":\"entity.other.namespace-prefix.css\",\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(-?(?!\\\\d)(?:[-\\\\w[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))+|\\\\*)(?=\\\\|(?![=\\\\s]|$|])(?:-?(?!\\\\d)|[-\\\\\\\\\\\\w[^\\\\x00-\\\\x7F]]))\"},{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.css\",\"patterns\":[{\"include\":\"#escapes\"}]}},\"match\":\"(-?(?!\\\\d)(?>[-\\\\w[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))+)\\\\s*(?=[]$*=^|~]|/\\\\*)\"}]},{\"include\":\"#pseudo-classes\"},{\"include\":\"#pseudo-elements\"},{\"include\":\"#functional-pseudo-classes\"},{\"match\":\"(?<![-@\\\\w])(?=[a-z]\\\\w*-)(?:(?![A-Z])[-\\\\w])+(?![-(\\\\w])\",\"name\":\"entity.name.tag.custom.css\"}]},\"string\":{\"patterns\":[{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.css\"}},\"end\":\"\\\"|(?<!\\\\\\\\)(?=$|\\\\n)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.css\"}},\"name\":\"string.quoted.double.css\",\"patterns\":[{\"begin\":\"(?:\\\\G|^)(?=(?:[^\\\"\\\\\\\\]|\\\\\\\\.)+$)\",\"end\":\"$\",\"name\":\"invalid.illegal.unclosed.string.css\",\"patterns\":[{\"include\":\"#escapes\"}]},{\"include\":\"#escapes\"}]},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.css\"}},\"end\":\"'|(?<!\\\\\\\\)(?=$|\\\\n)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.css\"}},\"name\":\"string.quoted.single.css\",\"patterns\":[{\"begin\":\"(?:\\\\G|^)(?=(?:[^'\\\\\\\\]|\\\\\\\\.)+$)\",\"end\":\"$\",\"name\":\"invalid.illegal.unclosed.string.css\",\"patterns\":[{\"include\":\"#escapes\"}]},{\"include\":\"#escapes\"}]}]},\"tag-names\":{\"match\":\"(?i)(?<![-:\\\\w])(?:a|abbr|acronym|address|applet|area|article|aside|audio|b|base|basefont|bdi|bdo|bgsound|big|blink|blockquote|body|br|button|canvas|caption|center|cite|code|col|colgroup|command|content|data|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|element|em|embed|fieldset|figcaption|figure|font|footer|form|frame|frameset|h[1-6]|head|header|hgroup|hr|html|i|iframe|image|img|input|ins|isindex|kbd|keygen|label|legend|li|link|listing|main|map|mark|marquee|math|menu|menuitem|meta|meter|multicol|nav|nextid|nobr|noembed|noframes|noscript|object|ol|optgroup|option|output|p|param|picture|plaintext|pre|progress|q|rb|rp|rtc??|ruby|s|samp|script|section|select|shadow|slot|small|source|spacer|span|strike|strong|style|sub|summary|sup|table|tbody|td|template|textarea|tfoot|th|thead|time|title|tr|track|tt|ul??|var|video|wbr|xmp|altGlyph|altGlyphDef|altGlyphItem|animate|animateColor|animateMotion|animateTransform|circle|clipPath|color-profile|cursor|defs|desc|discard|ellipse|feBlend|feColorMatrix|feComponentTransfer|feComposite|feConvolveMatrix|feDiffuseLighting|feDisplacementMap|feDistantLight|feDropShadow|feFlood|feFuncA|feFuncB|feFuncG|feFuncR|feGaussianBlur|feImage|feMerge|feMergeNode|feMorphology|feOffset|fePointLight|feSpecularLighting|feSpotLight|feTile|feTurbulence|filter|font-face|font-face-format|font-face-name|font-face-src|font-face-uri|foreignObject|g|glyph|glyphRef|hatch|hatchpath|hkern|line|linearGradient|marker|mask|mesh|meshgradient|meshpatch|meshrow|metadata|missing-glyph|mpath|path|pattern|polygon|polyline|radialGradient|rect|set|solidcolor|stop|svg|switch|symbol|text|textPath|tref|tspan|use|view|vkern|annotation|annotation-xml|maction|maligngroup|malignmark|math|menclose|merror|mfenced|mfrac|mglyph|mi|mlabeledtr|mlongdiv|mmultiscripts|mn|mo|mover|mpadded|mphantom|mroot|mrow|ms|mscarries|mscarry|msgroup|msline|mspace|msqrt|msrow|mstack|mstyle|msub|msubsup|msup|mtable|mtd|mtext|mtr|munder|munderover|semantics)(?=[#)+,.:>\\\\[{|~\\\\s]|/\\\\*|$)\",\"name\":\"entity.name.tag.css\"},\"unicode-range\":{\"captures\":{\"0\":{\"name\":\"constant.other.unicode-range.css\"},\"1\":{\"name\":\"punctuation.separator.dash.unicode-range.css\"}},\"match\":\"(?<![-\\\\w])[Uu]\\\\+[?\\\\h]{1,6}(?:(-)\\\\h{1,6})?(?![-\\\\w])\"},\"url\":{\"begin\":\"(?i)(?<![-@\\\\w])(url)(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"support.function.url.css\"},\"2\":{\"name\":\"punctuation.section.function.begin.bracket.round.css\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.function.end.bracket.round.css\"}},\"name\":\"meta.function.url.css\",\"patterns\":[{\"match\":\"[^\\\"')\\\\s]+\",\"name\":\"variable.parameter.url.css\"},{\"include\":\"#string\"},{\"include\":\"#comment-block\"},{\"include\":\"#escapes\"}]}},\"scopeName\":\"source.css\"}"))];
var javascript_default = [Object.freeze(JSON.parse("{\"displayName\":\"JavaScript\",\"name\":\"javascript\",\"patterns\":[{\"include\":\"#directives\"},{\"include\":\"#statements\"},{\"include\":\"#shebang\"}],\"repository\":{\"access-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},\"after-operator-block-as-object-literal\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[!(+,:=>?\\\\[]|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^yield|[^$._[:alnum:]]yield|^throw|[^$._[:alnum:]]throw|^in|[^$._[:alnum:]]in|^of|[^$._[:alnum:]]of|^typeof|[^$._[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"array-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#binding-element-const\"},{\"include\":\"#punctuation-comma\"}]},\"array-literal\":{\"begin\":\"\\\\s*(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.array.literal.js\",\"patterns\":[{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"}]},\"arrow-function\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async)\\\\s+)?([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?==>)\",\"name\":\"meta.arrow.js\"},{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(async))?((?<![]!)}])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#arrow-return-type\"},{\"include\":\"#possibly-arrow-return-type\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"((?<=[}\\\\S])(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!/[*/])\",\"name\":\"meta.arrow.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"}]}]},\"arrow-return-type\":{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"name\":\"meta.return.type.arrow.js\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"arrow-return-type-body\":{\"patterns\":[{\"begin\":\"(?<=:)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"async-modifier\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.async.js\"},\"binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#array-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"}]},\"binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"}]},\"boolean-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.true.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.boolean.false.js\"}]},\"brackets\":{\"patterns\":[{\"begin\":\"\\\\{\",\"end\":\"}|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]},{\"begin\":\"\\\\[\",\"end\":\"]|(?=\\\\*/)\",\"patterns\":[{\"include\":\"#brackets\"}]}]},\"cast\":{\"patterns\":[{\"include\":\"#jsx\"}]},\"class-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-declaration-or-expression-patterns\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.class.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"class-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.type.class.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.class.js\",\"patterns\":[{\"include\":\"#class-declaration-or-expression-patterns\"}]},\"class-or-interface-body\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#decorator\"},{\"begin\":\"(?<=:)\\\\s*\",\"end\":\"(?=[-\\\\])+,:;}\\\\s]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#string\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#access-modifier\"},{\"include\":\"#property-accessor\"},{\"include\":\"#async-modifier\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"}]},\"class-or-interface-heritage\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\b(extends|implements)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=\\\\{)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"include\":\"#type-parameters\"},{\"include\":\"#expressionWithoutIdentifiers\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[$_[:alpha:]][$_[:alnum:]]*)*\\\\s*)\"},{\"captures\":{\"1\":{\"name\":\"entity.other.inherited-class.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\"},{\"include\":\"#expressionPunctuations\"}]},\"comment\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.documentation.js\",\"patterns\":[{\"include\":\"#docblock\"}]},{\"begin\":\"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"},\"2\":{\"name\":\"storage.type.internaldeclaration.js\"},\"3\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"end\":\"\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"name\":\"comment.block.js\"},{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=$)\"}]},\"control-statement\":{\"patterns\":[{\"include\":\"#switch-statement\"},{\"include\":\"#for-loop\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.trycatch.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.loop.js\"},\"2\":{\"name\":\"entity.name.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"(?=[;}]|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#expression\"}]},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.switch.js\"},{\"include\":\"#if-statement\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.conditional.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.with.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.other.debugger.js\"}]},\"decl-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#statements\"}]},\"declaration\":{\"patterns\":[{\"include\":\"#decorator\"},{\"include\":\"#var-expr\"},{\"include\":\"#function-declaration\"},{\"include\":\"#class-declaration\"},{\"include\":\"#interface-declaration\"},{\"include\":\"#enum-declaration\"},{\"include\":\"#namespace-declaration\"},{\"include\":\"#type-alias-declaration\"},{\"include\":\"#import-equals-declaration\"},{\"include\":\"#import-declaration\"},{\"include\":\"#export-declaration\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"}]},\"decorator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))@\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.decorator.js\"}},\"end\":\"(?=\\\\s)\",\"name\":\"meta.decorator.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"destructuring-const\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern-const\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-parameter\":{\"patterns\":[{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"name\":\"meta.parameter.object-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},{\"begin\":\"(?<![:=])\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"name\":\"meta.paramter.array-binding-pattern.js\",\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]}]},\"destructuring-parameter-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable\":{\"patterns\":[{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\{)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.object-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#object-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]},{\"begin\":\"(?<![:=]|^of|[^$._[:alnum:]]of|^in|[^$._[:alnum:]]in)\\\\s*(?=\\\\[)\",\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"name\":\"meta.array-binding-pattern-variable.js\",\"patterns\":[{\"include\":\"#array-binding-pattern\"},{\"include\":\"#type-annotation\"},{\"include\":\"#comment\"}]}]},\"destructuring-variable-rest\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"destructuring-variable-rest-const\":{\"captures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"match\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)\"},\"directives\":{\"begin\":\"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))+\\\\s*/>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=$)\",\"name\":\"comment.line.triple-slash.directive.js\",\"patterns\":[{\"begin\":\"(<)(reference|amd-dependency|amd-module)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.directive.js\"},\"2\":{\"name\":\"entity.name.tag.directive.js\"}},\"end\":\"/>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.directive.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"match\":\"path|types|no-default-lib|lib|name|resolution-mode\",\"name\":\"entity.other.attribute-name.directive.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"include\":\"#string\"}]}]},\"docblock\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.access-type.jsdoc\"}},\"match\":\"((@)a(?:ccess|pi))\\\\s+(p(?:rivate|rotected|ublic))\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"5\":{\"name\":\"constant.other.email.link.underline.jsdoc\"},\"6\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"match\":\"((@)author)\\\\s+([^*/<>@\\\\s](?:[^*/<>@]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"4\":{\"name\":\"keyword.operator.control.jsdoc\"},\"5\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)borrows)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^*/@\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)example)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=@|\\\\*/)\",\"name\":\"meta.example.jsdoc\",\"patterns\":[{\"match\":\"^\\\\s\\\\*\\\\s+\"},{\"begin\":\"\\\\G(<)caption(>)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}},\"contentName\":\"constant.other.description.jsdoc\",\"end\":\"(</)caption(>)|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"entity.name.tag.inline.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.angle.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.angle.end.jsdoc\"}}},{\"captures\":{\"0\":{\"name\":\"source.embedded.js\"}},\"match\":\"[^*@\\\\s](?:[^*]|\\\\*[^/])*\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"constant.language.symbol-type.jsdoc\"}},\"match\":\"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"4\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)see)\\\\s+(?:((?=https?://)(?:[^*\\\\s]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^]\\\\[]*])?\\\\{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^*/@\\\\s]|\\\\*[^/])+))\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)template)\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*(?:\\\\s*,\\\\s*[$A-Z_a-z][]$.\\\\[\\\\w]*)*)\"},{\"begin\":\"((@)template)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([$A-Z_a-z][]$.\\\\[\\\\w]*)\"},{\"begin\":\"((@)typedef)\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"(?:[^*/@\\\\s]|\\\\*[^/])+\",\"name\":\"entity.name.type.instance.jsdoc\"}]},{\"begin\":\"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"},{\"match\":\"([$A-Z_a-z][]$.\\\\[\\\\w]*)\",\"name\":\"variable.other.jsdoc\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.optional-value.begin.bracket.square.jsdoc\"},\"2\":{\"name\":\"keyword.operator.assignment.jsdoc\"},\"3\":{\"name\":\"source.embedded.js\"},\"4\":{\"name\":\"punctuation.definition.optional-value.end.bracket.square.jsdoc\"},\"5\":{\"name\":\"invalid.illegal.syntax.jsdoc\"}},\"match\":\"(\\\\[)\\\\s*[$\\\\w]+(?:(?:\\\\[])?\\\\.[$\\\\w]+)*(?:\\\\s*(=)\\\\s*((?>\\\"(?:\\\\*(?!/)|\\\\\\\\(?!\\\")|[^*\\\\\\\\])*?\\\"|'(?:\\\\*(?!/)|\\\\\\\\(?!')|[^*\\\\\\\\])*?'|\\\\[(?:\\\\*(?!/)|[^*])*?]|(?:\\\\*(?!/)|\\\\s(?!\\\\s*])|\\\\[.*?(?:]|(?=\\\\*/))|[^]*\\\\[\\\\s])*)*))?\\\\s*(?:(])((?:[^*\\\\s]|\\\\*[^/\\\\s])+)?|(?=\\\\*/))\",\"name\":\"variable.other.jsdoc\"}]},{\"begin\":\"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?=\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"end\":\"(?=\\\\s|\\\\*/|[^]$A-\\\\[_a-{}])\",\"patterns\":[{\"include\":\"#jsdoctype\"}]},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"entity.name.type.instance.jsdoc\"}},\"match\":\"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^*@{}\\\\s]|\\\\*[^/])+)\"},{\"begin\":\"((@)(?:default(?:value)?|license|version))\\\\s+(([\\\"']))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"},\"4\":{\"name\":\"punctuation.definition.string.begin.jsdoc\"}},\"contentName\":\"variable.other.jsdoc\",\"end\":\"(\\\\3)|(?=$|\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"variable.other.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.string.end.jsdoc\"}}},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"},\"3\":{\"name\":\"variable.other.jsdoc\"}},\"match\":\"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^*\\\\s]+)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b\",\"name\":\"storage.type.class.jsdoc\"},{\"include\":\"#inline-tags\"},{\"captures\":{\"1\":{\"name\":\"storage.type.class.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.block.tag.jsdoc\"}},\"match\":\"((@)[$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s+)\"}]},\"enum-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.enum.js\"},\"5\":{\"name\":\"entity.name.type.enum.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.enum.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"0\":{\"name\":\"variable.other.enummember.js\"}},\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"begin\":\"(?=(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+])))\",\"end\":\"(?=[,}]|$)\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#comment\"},{\"include\":\"#variable-initializer\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"export-declaration\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.as.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"},\"4\":{\"name\":\"entity.name.type.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:\\\\s*(=)|\\\\s+(default)(?=\\\\s+))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"},\"3\":{\"name\":\"keyword.operator.assignment.js\"},\"4\":{\"name\":\"keyword.control.default.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.default.js\",\"patterns\":[{\"include\":\"#interface-declaration\"},{\"include\":\"#expression\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[*{])|((?=\\\\s*[$_[:alpha:]][$_[:alnum:]]*([,\\\\s]))(?!\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?=$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.export.js\",\"patterns\":[{\"include\":\"#import-export-declaration\"}]}]},\"expression\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-inside-possibly-arrow-parens\":{\"patterns\":[{\"include\":\"#expressionWithoutIdentifiers\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[,:]|$)\"},{\"include\":\"#type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#identifiers\"},{\"include\":\"#expressionPunctuations\"}]},\"expression-operators\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.control.flow.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*\\\\*)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.flow.js\"}},\"end\":\"\\\\*\",\"endCaptures\":{\"0\":{\"name\":\"keyword.generator.asterisk.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.control.flow.js\"},\"2\":{\"name\":\"keyword.generator.asterisk.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.delete.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.in.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()\",\"name\":\"keyword.operator.expression.of.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.instanceof.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.new.js\"},{\"include\":\"#typeof-operator\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.void.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[]),:;}]))\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=^|[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+<))\",\"patterns\":[{\"include\":\"#type\"}]},{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.spread.js\"},{\"match\":\"(?:\\\\*|(?<!\\\\()/|[-%+])=\",\"name\":\"keyword.operator.assignment.compound.js\"},{\"match\":\"(?:[\\\\&^]|<<|>>>??|\\\\|)=\",\"name\":\"keyword.operator.assignment.compound.bitwise.js\"},{\"match\":\"<<|>>>?\",\"name\":\"keyword.operator.bitwise.shift.js\"},{\"match\":\"[!=]==?\",\"name\":\"keyword.operator.comparison.js\"},{\"match\":\"<=|>=|<>|[<>]\",\"name\":\"keyword.operator.relational.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.logical.js\"},\"2\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"3\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[$_[:alnum:]])(!)\\\\s*(?:(/=)|(/)(?![*/]))\"},{\"match\":\"!|&&|\\\\|\\\\||\\\\?\\\\?\",\"name\":\"keyword.operator.logical.js\"},{\"match\":\"[\\\\&^|~]\",\"name\":\"keyword.operator.bitwise.js\"},{\"match\":\"=\",\"name\":\"keyword.operator.assignment.js\"},{\"match\":\"--\",\"name\":\"keyword.operator.decrement.js\"},{\"match\":\"\\\\+\\\\+\",\"name\":\"keyword.operator.increment.js\"},{\"match\":\"[-%*+/]\",\"name\":\"keyword.operator.arithmetic.js\"},{\"begin\":\"(?<=[]$)_[:alnum:]])\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)+(?:(/=)|(/)(?![*/])))\",\"end\":\"(/=)|(/)(?!\\\\*([^*]|(\\\\*[^/]))*\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"patterns\":[{\"include\":\"#comment\"}]},{\"captures\":{\"1\":{\"name\":\"keyword.operator.assignment.compound.js\"},\"2\":{\"name\":\"keyword.operator.arithmetic.js\"}},\"match\":\"(?<=[]$)_[:alnum:]])\\\\s*(?:(/=)|(/)(?![*/]))\"}]},\"expressionPunctuations\":{\"patterns\":[{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-accessor\"}]},\"expressionWithoutIdentifiers\":{\"patterns\":[{\"include\":\"#jsx\"},{\"include\":\"#string\"},{\"include\":\"#regex\"},{\"include\":\"#comment\"},{\"include\":\"#function-expression\"},{\"include\":\"#class-expression\"},{\"include\":\"#arrow-function\"},{\"include\":\"#paren-expression-possibly-arrow\"},{\"include\":\"#cast\"},{\"include\":\"#ternary-expression\"},{\"include\":\"#new-expr\"},{\"include\":\"#instanceof-expr\"},{\"include\":\"#object-literal\"},{\"include\":\"#expression-operators\"},{\"include\":\"#function-call\"},{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#paren-expression\"}]},\"field-declaration\":{\"begin\":\"(?<!\\\\()(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=}]|$))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?=[,;}]|$|^((?!\\\\s*(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|(#?[$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(?:(?:(\\\\?)|(!))\\\\s*)?([,:;=]|$))))|(?<=})\",\"name\":\"meta.field.declaration.js\",\"patterns\":[{\"include\":\"#variable-initializer\"},{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"meta.definition.property.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)(?:(\\\\?)|(!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"match\":\"#?[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.property.js variable.object.property.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"},{\"match\":\"!\",\"name\":\"keyword.operator.definiteassignment.js\"}]},\"for-loop\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*))await)?\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)?(\\\\())\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.control.loop.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"await\",\"name\":\"keyword.control.loop.js\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#var-expr\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"}]}]},\"function-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"include\":\"#function-parameters\"},{\"include\":\"#return-type\"},{\"include\":\"#type-function-return-type\"},{\"include\":\"#decl-block\"},{\"match\":\"\\\\*\",\"name\":\"keyword.generator.asterisk.js\"}]},\"function-call\":{\"patterns\":[{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"end\":\"(?<=\\\\))(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?\\\\())\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"},{\"include\":\"#paren-expression\"}]},{\"begin\":\"(?=(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"end\":\"(?<=>)(?!(((([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))|(?<=\\\\)))(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*[(\\\\[{]\\\\s*)$)\",\"name\":\"meta.function-call.js\",\"patterns\":[{\"include\":\"#function-call-target\"}]},{\"include\":\"#comment\"},{\"include\":\"#function-call-optionals\"},{\"include\":\"#type-arguments\"}]}]},\"function-call-optionals\":{\"patterns\":[{\"match\":\"\\\\?\\\\.\",\"name\":\"meta.function-call.js punctuation.accessor.optional.js\"},{\"match\":\"!\",\"name\":\"meta.function-call.js keyword.operator.definiteassignment.js\"}]},\"function-call-target\":{\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"(#?[$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.js\"}]},\"function-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.async.js\"},\"4\":{\"name\":\"storage.type.function.js\"},\"5\":{\"name\":\"keyword.generator.asterisk.js\"},\"6\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|(?<=})\",\"name\":\"meta.function.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#function-body\"}]},\"function-expression\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function)\\\\b(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([$_[:alpha:]][$_[:alnum:]]*))?\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.function.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"},\"4\":{\"name\":\"meta.definition.function.js entity.name.function.js\"}},\"end\":\"(?=;)|(?<=})\",\"name\":\"meta.function.expression.js\",\"patterns\":[{\"include\":\"#function-name\"},{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#function-body\"}]},\"function-name\":{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.function.js entity.name.function.js\"},\"function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.begin.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.parameters.end.js\"}},\"name\":\"meta.parameters.js\",\"patterns\":[{\"include\":\"#function-parameters-body\"}]},\"function-parameters-body\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#decorator\"},{\"include\":\"#destructuring-parameter\"},{\"include\":\"#parameter-name\"},{\"include\":\"#parameter-type-annotation\"},{\"include\":\"#variable-initializer\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"}]},\"identifiers\":{\"patterns\":[{\"include\":\"#object-identifiers\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"entity.name.function.js\"}},\"match\":\"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*)?([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"match\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])\",\"name\":\"variable.other.constant.js\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"variable.other.readwrite.js\"}]},\"if-statement\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))\",\"end\":\"(?=;|$|})\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.conditional.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<=\\\\))\\\\s*/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"include\":\"#statements\"}]}]},\"import-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[(:])(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"}},\"end\":\"(?<!(?:^|[^$._[:alnum:]])import)(?=;|$|^)\",\"name\":\"meta.import.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"begin\":\"(?<=(?:^|[^$._[:alnum:]])import)(?!\\\\s*[\\\"'])\",\"end\":\"\\\\bfrom\\\\b\",\"endCaptures\":{\"0\":{\"name\":\"keyword.control.from.js\"}},\"patterns\":[{\"include\":\"#import-export-declaration\"}]},{\"include\":\"#import-export-declaration\"}]},\"import-equals-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"},\"7\":{\"name\":\"keyword.control.require.js\"},\"8\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.import-equals.external.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"keyword.control.import.js\"},\"4\":{\"name\":\"keyword.control.type.js\"},\"5\":{\"name\":\"variable.other.readwrite.alias.js\"},\"6\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=;|$|^)\",\"name\":\"meta.import-equals.internal.js\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.other.readwrite.js\"}]}]},\"import-export-assert-clause\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.with.js\"},\"2\":{\"name\":\"keyword.control.assert.js\"},\"3\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object-literal.key.js\"},{\"match\":\":\",\"name\":\"punctuation.separator.key-value.js\"}]},\"import-export-block\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.block.js\",\"patterns\":[{\"include\":\"#import-export-clause\"}]},\"import-export-clause\":{\"patterns\":[{\"include\":\"#comment\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"keyword.control.default.js\"},\"3\":{\"name\":\"constant.language.import-export-all.js\"},\"4\":{\"name\":\"variable.other.readwrite.js\"},\"5\":{\"name\":\"string.quoted.alias.js\"},\"12\":{\"name\":\"keyword.control.as.js\"},\"13\":{\"name\":\"keyword.control.default.js\"},\"14\":{\"name\":\"variable.other.readwrite.alias.js\"},\"15\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(type)\\\\s+)?(?:\\\\b(default)|(\\\\*)|\\\\b([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\\\\s+(as)\\\\s+(?:(default(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"\\\\*\",\"name\":\"constant.language.import-export-all.js\"},{\"match\":\"\\\\b(default)\\\\b\",\"name\":\"keyword.control.default.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.type.js\"},\"2\":{\"name\":\"variable.other.readwrite.alias.js\"},\"3\":{\"name\":\"string.quoted.alias.js\"}},\"match\":\"(?:\\\\b(type)\\\\s+)?(?:([$_[:alpha:]][$_[:alnum:]]*)|(('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)))\"}]},\"import-export-declaration\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#import-export-block\"},{\"match\":\"\\\\bfrom\\\\b\",\"name\":\"keyword.control.from.js\"},{\"include\":\"#import-export-assert-clause\"},{\"include\":\"#import-export-clause\"}]},\"indexer-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=:)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"meta.brace.square.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"end\":\"(])\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.declaration.js\",\"patterns\":[{\"include\":\"#type-annotation\"}]},\"indexer-mapped-type-declaration\":{\"begin\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([-+])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([$_[:alpha:]][$_[:alnum:]]*)\\\\s+(in)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"meta.brace.square.js\"},\"4\":{\"name\":\"entity.name.type.js\"},\"5\":{\"name\":\"keyword.operator.expression.in.js\"}},\"end\":\"(])([-+])?\\\\s*(\\\\?\\\\s*)?|$\",\"endCaptures\":{\"1\":{\"name\":\"meta.brace.square.js\"},\"2\":{\"name\":\"keyword.operator.type.modifier.js\"},\"3\":{\"name\":\"keyword.operator.optional.js\"}},\"name\":\"meta.indexer.mappedtype.declaration.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+\"},{\"include\":\"#type\"}]},\"inline-tags\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.bracket.square.begin.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.square.end.jsdoc\"}},\"match\":\"(\\\\[)[^]]+(])(?=\\\\{@(?:link|linkcode|linkplain|tutorial))\",\"name\":\"constant.other.description.jsdoc\"},{\"begin\":\"(\\\\{)((@)(?:link(?:code|plain)?|tutorial))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"},\"2\":{\"name\":\"storage.type.class.jsdoc\"},\"3\":{\"name\":\"punctuation.definition.inline.tag.jsdoc\"}},\"end\":\"}|(?=\\\\*/)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"name\":\"entity.name.type.instance.jsdoc\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"variable.other.link.underline.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?=https?://)(?:[^*|}\\\\s]|\\\\*/)+)(\\\\|)?\"},{\"captures\":{\"1\":{\"name\":\"variable.other.description.jsdoc\"},\"2\":{\"name\":\"punctuation.separator.pipe.jsdoc\"}},\"match\":\"\\\\G((?:[^*@{|}\\\\s]|\\\\*[^/])+)(\\\\|)?\"}]}]},\"instanceof-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.expression.instanceof.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|([!=]==?)|(([\\\\&^|~]\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s+instanceof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"patterns\":[{\"include\":\"#type\"}]},\"interface-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[*/])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.type.interface.js\"}},\"end\":\"(?<=})\",\"name\":\"meta.interface.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#class-or-interface-heritage\"},{\"captures\":{\"0\":{\"name\":\"entity.name.type.interface.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\"},{\"include\":\"#type-parameters\"},{\"include\":\"#class-or-interface-body\"}]},\"jsdoctype\":{\"patterns\":[{\"begin\":\"\\\\G(\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"1\":{\"name\":\"punctuation.definition.bracket.curly.begin.jsdoc\"}},\"contentName\":\"entity.name.type.instance.jsdoc\",\"end\":\"((}))\\\\s*|(?=\\\\*/)\",\"endCaptures\":{\"1\":{\"name\":\"entity.name.type.instance.jsdoc\"},\"2\":{\"name\":\"punctuation.definition.bracket.curly.end.jsdoc\"}},\"patterns\":[{\"include\":\"#brackets\"}]}]},\"jsx\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes-in-expression\"},{\"include\":\"#jsx-tag-in-expression\"}]},\"jsx-children\":{\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"},{\"include\":\"#jsx-tag\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-entities\"}]},\"jsx-entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.js\"},\"3\":{\"name\":\"punctuation.definition.entity.js\"}},\"match\":\"(&)([0-9A-Za-z]+|#[0-9]+|#x\\\\h+)(;)\",\"name\":\"constant.character.entity.js\"}]},\"jsx-evaluated-code\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.begin.js\"}},\"contentName\":\"meta.embedded.expression.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.section.embedded.end.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"jsx-string-double-quoted\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-string-single-quoted\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#jsx-entities\"}]},\"jsx-tag\":{\"begin\":\"(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(/>)|(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"},\"2\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"3\":{\"name\":\"entity.name.tag.namespace.js\"},\"4\":{\"name\":\"punctuation.separator.namespace.js\"},\"5\":{\"name\":\"entity.name.tag.js\"},\"6\":{\"name\":\"support.class.component.js\"},\"7\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.js\",\"patterns\":[{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"}},\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-arguments\"},{\"include\":\"#jsx-tag-attributes\"}]},{\"begin\":\"(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(?=</)\",\"patterns\":[{\"include\":\"#jsx-children\"}]}]},\"jsx-tag-attribute-assignment\":{\"match\":\"=(?=\\\\s*(?:[\\\"'{]|/\\\\*|//|\\\\n))\",\"name\":\"keyword.operator.assignment.js\"},\"jsx-tag-attribute-name\":{\"captures\":{\"1\":{\"name\":\"entity.other.attribute-name.namespace.js\"},\"2\":{\"name\":\"punctuation.separator.namespace.js\"},\"3\":{\"name\":\"entity.other.attribute-name.js\"}},\"match\":\"\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(:))?([$_[:alpha:]][-$_[:alnum:]]*)(?=[=\\\\s]|/?>|/\\\\*|//)\"},\"jsx-tag-attributes\":{\"begin\":\"\\\\s+\",\"end\":\"(?=/?>)\",\"name\":\"meta.tag.attributes.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#jsx-tag-attribute-name\"},{\"include\":\"#jsx-tag-attribute-assignment\"},{\"include\":\"#jsx-string-double-quoted\"},{\"include\":\"#jsx-string-single-quoted\"},{\"include\":\"#jsx-evaluated-code\"},{\"include\":\"#jsx-tag-attributes-illegal\"}]},\"jsx-tag-attributes-illegal\":{\"match\":\"\\\\S+\",\"name\":\"invalid.illegal.attribute.js\"},\"jsx-tag-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[$_[:alpha:]][$_[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|/?>))\",\"patterns\":[{\"include\":\"#jsx-tag\"}]},\"jsx-tag-without-attributes\":{\"begin\":\"(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"contentName\":\"meta.jsx.children.js\",\"end\":\"(</)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.js\"},\"2\":{\"name\":\"entity.name.tag.namespace.js\"},\"3\":{\"name\":\"punctuation.separator.namespace.js\"},\"4\":{\"name\":\"entity.name.tag.js\"},\"5\":{\"name\":\"support.class.component.js\"},\"6\":{\"name\":\"punctuation.definition.tag.end.js\"}},\"name\":\"meta.tag.without-attributes.js\",\"patterns\":[{\"include\":\"#jsx-children\"}]},\"jsx-tag-without-attributes-in-expression\":{\"begin\":\"(?<!\\\\+\\\\+|--)(?<=[(*,:=>?\\\\[{]|&&|\\\\|\\\\||\\\\?|\\\\*/|^await|[^$._[:alnum:]]await|^return|[^$._[:alnum:]]return|^default|[^$._[:alnum:]]default|^yield|[^$._[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"end\":\"(?!(<)\\\\s*(?:([$_[:alpha:]][-$._[:alnum:]]*)(?<![-.])(:))?((?:[a-z][0-9a-z]*|([$_[:alpha:]][-$._[:alnum:]]*))(?<![-.]))?\\\\s*(>))\",\"patterns\":[{\"include\":\"#jsx-tag-without-attributes\"}]},\"label\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#decl-block\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(:)\"}]},\"literal\":{\"patterns\":[{\"include\":\"#numeric-literal\"},{\"include\":\"#boolean-literal\"},{\"include\":\"#null-literal\"},{\"include\":\"#undefined-literal\"},{\"include\":\"#numericConstant-literal\"},{\"include\":\"#array-literal\"},{\"include\":\"#this-literal\"},{\"include\":\"#super-literal\"}]},\"method-declaration\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"keyword.operator.new.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(p(?:ublic|rivate|rotected))\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.modifier.js\"},\"4\":{\"name\":\"storage.modifier.async.js\"},\"5\":{\"name\":\"storage.type.property.js\"},\"6\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"}]}]},\"method-declaration-name\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??)\\\\s*[(<])\",\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"meta.definition.method.js entity.name.function.js\"},{\"match\":\"\\\\?\",\"name\":\"keyword.operator.optional.js\"}]},\"namespace-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[\\\"$'_`[:alpha:]])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.namespace.js\"}},\"end\":\"(?<=})|(?=;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.namespace.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.type.module.js\"},{\"include\":\"#punctuation-accessor\"},{\"include\":\"#decl-block\"}]},\"new-expr\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.new.js\"}},\"end\":\"(?<=\\\\))|(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[$_[:alpha:]][$_[:alnum:]]*)|(\\\\s*\\\\())))\",\"name\":\"new.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"null-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.null.js\"},\"numeric-literal\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.hex.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.binary.js\"},{\"captures\":{\"1\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"\\\\b(?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)\",\"name\":\"constant.numeric.octal.js\"},{\"captures\":{\"0\":{\"name\":\"constant.numeric.decimal.js\"},\"1\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"2\":{\"name\":\"storage.type.numeric.bigint.js\"},\"3\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"4\":{\"name\":\"storage.type.numeric.bigint.js\"},\"5\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"6\":{\"name\":\"storage.type.numeric.bigint.js\"},\"7\":{\"name\":\"storage.type.numeric.bigint.js\"},\"8\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"9\":{\"name\":\"storage.type.numeric.bigint.js\"},\"10\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"11\":{\"name\":\"storage.type.numeric.bigint.js\"},\"12\":{\"name\":\"meta.delimiter.decimal.period.js\"},\"13\":{\"name\":\"storage.type.numeric.bigint.js\"},\"14\":{\"name\":\"storage.type.numeric.bigint.js\"}},\"match\":\"(?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)\"}]},\"numericConstant-literal\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.nan.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.infinity.js\"}]},\"object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element\"}]},{\"include\":\"#object-binding-pattern\"},{\"include\":\"#destructuring-variable-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-const\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#binding-element-const\"}]},{\"include\":\"#object-binding-pattern-const\"},{\"include\":\"#destructuring-variable-rest-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"object-binding-element-propertyName\":{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(:)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.destructuring.js\"}},\"patterns\":[{\"include\":\"#string\"},{\"include\":\"#array-literal\"},{\"include\":\"#numeric-literal\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"variable.object.property.js\"}]},\"object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element\"}]},\"object-binding-pattern-const\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#object-binding-element-const\"}]},\"object-identifiers\":{\"patterns\":[{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))\",\"name\":\"support.class.js\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"variable.other.constant.object.property.js\"},\"4\":{\"name\":\"variable.other.object.property.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(#?\\\\p{upper}[$_\\\\d[:upper:]]*)|(#?[$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"},{\"captures\":{\"1\":{\"name\":\"variable.other.constant.object.js\"},\"2\":{\"name\":\"variable.other.object.js\"}},\"match\":\"(?:(\\\\p{upper}[$_\\\\d[:upper:]]*)|([$_[:alpha:]][$_[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*#?[$_[:alpha:]][$_[:alnum:]]*)\"}]},\"object-literal\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.objectliteral.js\",\"patterns\":[{\"include\":\"#object-member\"}]},\"object-literal-method-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#method-declaration-name\"},{\"include\":\"#function-body\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b([gs]et)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*((\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"storage.type.property.js\"},\"3\":{\"name\":\"keyword.generator.asterisk.js\"}},\"end\":\"(?=[(<])\",\"patterns\":[{\"include\":\"#method-declaration-name\"}]}]},\"object-member\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#object-literal-method-declaration\"},{\"begin\":\"(?=\\\\[)\",\"end\":\"(?=:)|((?<=])(?=\\\\s*[(<]))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#array-literal\"}]},{\"begin\":\"(?=[\\\"'`])\",\"end\":\"(?=:)|((?<=[\\\"'`])(?=((\\\\s*[(,<}])|(\\\\s+(as|satisifies)\\\\s+))))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"}]},{\"begin\":\"(?=\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$)))\",\"end\":\"(?=:)|(?=\\\\s*([(,<}])|(\\\\s+as|satisifies\\\\s+))\",\"name\":\"meta.object.member.js meta.object-literal.key.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#numeric-literal\"}]},{\"begin\":\"(?<=[]\\\"'`])(?=\\\\s*[(<])\",\"end\":\"(?=[,;}])|(?<=})\",\"name\":\"meta.method.declaration.js\",\"patterns\":[{\"include\":\"#function-body\"}]},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"constant.numeric.decimal.js\"}},\"match\":\"(?![$_[:alpha:]])(\\\\d+)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"},\"1\":{\"name\":\"entity.name.function.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:(\\\\s*/\\\\*([^*]|(\\\\*[^/]))*\\\\*/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"0\":{\"name\":\"meta.object-literal.key.js\"}},\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\\\\s*(?=(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*:)\",\"name\":\"meta.object.member.js\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"captures\":{\"1\":{\"name\":\"variable.other.readwrite.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))\",\"name\":\"meta.object.member.js\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.as.js\"},\"2\":{\"name\":\"keyword.control.satisfies.js\"}},\"end\":\"(?=[-\\\\])+,:;>?}]|\\\\|\\\\||&&|!==|$|^|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(?=[$_[:alpha:]][$_[:alnum:]]*\\\\s*=)\",\"end\":\"(?=[,}]|$|//|/\\\\*)\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"meta.object-literal.key.js punctuation.separator.key-value.js\"}},\"end\":\"(?=[,}])\",\"name\":\"meta.object.member.js\",\"patterns\":[{\"begin\":\"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"begin\":\"(?<=:)\\\\s*(async)?\\\\s*(?=<\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<=>)\\\\s*(\\\\()(?=\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]},{\"include\":\"#possibly-arrow-return-type\"},{\"include\":\"#expression\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#decl-block\"}]},\"parameter-array-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.array.js\"}},\"patterns\":[{\"include\":\"#parameter-binding-element\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#regex\"},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#parameter-array-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"}]},\"parameter-name\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)\"}]},\"parameter-object-binding-element\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?=(\\\\b((?<!\\\\$)0[Xx]\\\\h[_\\\\h]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Bb][01][01_]*(n)?\\\\b(?!\\\\$))|\\\\b((?<!\\\\$)0[Oo]?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\B(\\\\.)[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*[Ee][-+]?[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B|\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b|\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.))(?!\\\\$))|([$_[:alpha:]][$_[:alnum:]]*)|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`)|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])+]))\\\\s*(:))\",\"end\":\"(?=[,}])\",\"patterns\":[{\"include\":\"#object-binding-element-propertyName\"},{\"include\":\"#parameter-binding-element\"},{\"include\":\"#paren-expression\"}]},{\"include\":\"#parameter-object-binding-pattern\"},{\"include\":\"#destructuring-parameter-rest\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#punctuation-comma\"}]},\"parameter-object-binding-pattern\":{\"begin\":\"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.rest.js\"},\"2\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.binding-pattern.object.js\"}},\"patterns\":[{\"include\":\"#parameter-object-binding-element\"}]},\"parameter-type-annotation\":{\"patterns\":[{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?=[),])|(?==[^>])\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"paren-expression\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"paren-expression-possibly-arrow\":{\"patterns\":[{\"begin\":\"(?<=[(,=])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"begin\":\"(?<=[(,=]|=>|^return|[^$._[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)))\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.async.js\"}},\"end\":\"(?<=\\\\))\",\"patterns\":[{\"include\":\"#paren-expression-possibly-arrow-with-typeparameters\"}]},{\"include\":\"#possibly-arrow-return-type\"}]},\"paren-expression-possibly-arrow-with-typeparameters\":{\"patterns\":[{\"include\":\"#type-parameters\"},{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"patterns\":[{\"include\":\"#expression-inside-possibly-arrow-parens\"}]}]},\"possibly-arrow-return-type\":{\"begin\":\"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*=>)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.arrow.js meta.return.type.arrow.js keyword.operator.type.annotation.js\"}},\"contentName\":\"meta.arrow.js meta.return.type.arrow.js\",\"end\":\"(?==>|\\\\{|^(\\\\s*(export|function|class|interface|let|var|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))\",\"patterns\":[{\"include\":\"#arrow-return-type-body\"}]},\"property-accessor\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.type.property.js\"},\"punctuation-accessor\":{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d))\"},\"punctuation-comma\":{\"match\":\",\",\"name\":\"punctuation.separator.comma.js\"},\"punctuation-semicolon\":{\"match\":\";\",\"name\":\"punctuation.terminator.statement.js\"},\"qstring-double\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(\\\")|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.double.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"qstring-single\":{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(')|([^\\\\n\\\\\\\\])$\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"invalid.illegal.newline.js\"}},\"name\":\"string.quoted.single.js\",\"patterns\":[{\"include\":\"#string-character-escape\"}]},\"regex\":{\"patterns\":[{\"begin\":\"(?<!\\\\+\\\\+|--|})(?<=[!(+,:=?\\\\[]|^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*/)\\\\s*(/)(?![*/])(?=(?:[^()/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)+]|\\\\(([^)\\\\\\\\]|\\\\\\\\.)+\\\\))+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"((?<![]$)_[:alnum:]]|\\\\+\\\\+|--|}|\\\\*/)|((?<=^return|[^$._[:alnum:]]return|^case|[^$._[:alnum:]]case))\\\\s*)/(?![*/])(?=(?:[^/\\\\[\\\\\\\\]|\\\\\\\\.|\\\\[([^]\\\\\\\\]|\\\\\\\\.)*])+/([dgimsuvy]+|(?![*/])|(?=/\\\\*))(?!\\\\s*[$0-9A-Z_a-z]))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.js\"}},\"end\":\"(/)([dgimsuvy]*)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.js\"},\"2\":{\"name\":\"keyword.other.js\"}},\"name\":\"string.regexp.js\",\"patterns\":[{\"include\":\"#regexp\"}]}]},\"regex-character-class\":{\"patterns\":[{\"match\":\"\\\\\\\\[DSWdfnrstvw]|\\\\.\",\"name\":\"constant.other.character-class.regexp\"},{\"match\":\"\\\\\\\\([0-7]{3}|x\\\\h{2}|u\\\\h{4})\",\"name\":\"constant.character.numeric.regexp\"},{\"match\":\"\\\\\\\\c[A-Z]\",\"name\":\"constant.character.control.regexp\"},{\"match\":\"\\\\\\\\.\",\"name\":\"constant.character.escape.backslash.regexp\"}]},\"regexp\":{\"patterns\":[{\"match\":\"\\\\\\\\[Bb]|[$^]\",\"name\":\"keyword.control.anchor.regexp\"},{\"captures\":{\"0\":{\"name\":\"keyword.other.back-reference.regexp\"},\"1\":{\"name\":\"variable.other.regexp\"}},\"match\":\"\\\\\\\\(?:[1-9]\\\\d*|k<([$A-Z_a-z][$\\\\w]*)>)\"},{\"match\":\"[*+?]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)}\\\\??\",\"name\":\"keyword.operator.quantifier.regexp\"},{\"match\":\"\\\\|\",\"name\":\"keyword.operator.or.regexp\"},{\"begin\":\"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"},\"2\":{\"name\":\"punctuation.definition.group.assertion.regexp\"},\"3\":{\"name\":\"meta.assertion.look-ahead.regexp\"},\"4\":{\"name\":\"meta.assertion.negative-look-ahead.regexp\"},\"5\":{\"name\":\"meta.assertion.look-behind.regexp\"},\"6\":{\"name\":\"meta.assertion.negative-look-behind.regexp\"}},\"end\":\"(\\\\))\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.assertion.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"\\\\((?:(\\\\?:)|\\\\?<([$A-Z_a-z][$\\\\w]*)>)?\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"},\"1\":{\"name\":\"punctuation.definition.group.no-capture.regexp\"},\"2\":{\"name\":\"variable.other.regexp\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.group.regexp\"}},\"name\":\"meta.group.regexp\",\"patterns\":[{\"include\":\"#regexp\"}]},{\"begin\":\"(\\\\[)(\\\\^)?\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"},\"2\":{\"name\":\"keyword.operator.negation.regexp\"}},\"end\":\"(])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.character-class.regexp\"}},\"name\":\"constant.other.character-class.set.regexp\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"constant.character.numeric.regexp\"},\"2\":{\"name\":\"constant.character.control.regexp\"},\"3\":{\"name\":\"constant.character.escape.backslash.regexp\"},\"4\":{\"name\":\"constant.character.numeric.regexp\"},\"5\":{\"name\":\"constant.character.control.regexp\"},\"6\":{\"name\":\"constant.character.escape.backslash.regexp\"}},\"match\":\"(?:.|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))-(?:[^]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x\\\\h{2}|u\\\\h{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\",\"name\":\"constant.other.character-class.range.regexp\"},{\"include\":\"#regex-character-class\"}]},{\"include\":\"#regex-character-class\"}]},\"return-type\":{\"patterns\":[{\"begin\":\"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?=$|^|[,;{}]|//)\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]},{\"begin\":\"(?<=\\\\))\\\\s*(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[,;{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.return.type.js\",\"patterns\":[{\"include\":\"#return-type-core\"}]}]},\"return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<=[\\\\&:|])(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"shebang\":{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.js\"}},\"match\":\"\\\\A(#!).*(?=$)\",\"name\":\"comment.line.shebang.js\"},\"single-line-comment-consuming-line-ending\":{\"begin\":\"(^[\\\\t ]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"},\"2\":{\"name\":\"comment.line.double-slash.js\"},\"3\":{\"name\":\"punctuation.definition.comment.js\"},\"4\":{\"name\":\"storage.type.internaldeclaration.js\"},\"5\":{\"name\":\"punctuation.decorator.internaldeclaration.js\"}},\"contentName\":\"comment.line.double-slash.js\",\"end\":\"(?=^)\"},\"statements\":{\"patterns\":[{\"include\":\"#declaration\"},{\"include\":\"#control-statement\"},{\"include\":\"#after-operator-block-as-object-literal\"},{\"include\":\"#decl-block\"},{\"include\":\"#label\"},{\"include\":\"#expression\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template\"}]},\"string-character-escape\":{\"match\":\"\\\\\\\\(x\\\\h{2}|u\\\\h{4}|u\\\\{\\\\h+}|[012][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)\",\"name\":\"constant.character.escape.js\"},\"super-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)\",\"name\":\"variable.language.super.js\"},\"support-function-call-identifiers\":{\"patterns\":[{\"include\":\"#literal\"},{\"include\":\"#support-objects\"},{\"include\":\"#object-identifiers\"},{\"include\":\"#punctuation-accessor\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\(\\\\s*[\\\"'`])\",\"name\":\"keyword.operator.expression.import.js\"}]},\"support-objects\":{\"patterns\":[{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)\",\"name\":\"variable.language.arguments.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)\",\"name\":\"support.class.promise.js\"},{\"captures\":{\"1\":{\"name\":\"keyword.control.import.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.importmeta.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(meta)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.new.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"support.variable.property.target.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(target)\\\\b(?!\\\\$)\"},{\"captures\":{\"1\":{\"name\":\"punctuation.accessor.js\"},\"2\":{\"name\":\"punctuation.accessor.optional.js\"},\"3\":{\"name\":\"support.variable.property.js\"},\"4\":{\"name\":\"support.constant.js\"}},\"match\":\"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\()|(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$))\"},{\"captures\":{\"1\":{\"name\":\"support.type.object.module.js\"},\"2\":{\"name\":\"support.type.object.module.js\"},\"3\":{\"name\":\"punctuation.accessor.js\"},\"4\":{\"name\":\"punctuation.accessor.optional.js\"},\"5\":{\"name\":\"support.type.object.module.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)\"}]},\"switch-statement\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"switch-statement.expr.js\",\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"},\"2\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"switch-expression.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"(?=})\",\"name\":\"switch-block.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.switch.js\"}},\"end\":\"(?=:)\",\"name\":\"case-clause.expr.js\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(:)\\\\s*(\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"},\"2\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"contentName\":\"meta.block.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"meta.block.js punctuation.definition.block.js\"}},\"patterns\":[{\"include\":\"#statements\"}]},{\"captures\":{\"0\":{\"name\":\"case-clause.expr.js punctuation.definition.section.case-statement.js\"}},\"match\":\"(:)\"},{\"include\":\"#statements\"}]}]},\"template\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-call\":{\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"end\":\"(?=`)\",\"patterns\":[{\"begin\":\"(?=(([$_[:alpha:]][$_[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([$_[:alpha:]][$_[:alnum:]]*))\",\"end\":\"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)?`)\",\"patterns\":[{\"include\":\"#support-function-call-identifiers\"},{\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"name\":\"entity.name.function.tagged-template.js\"}]},{\"include\":\"#type-arguments\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>|<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([$_[:alpha:]][$_[:alnum:]]*|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))(?=\\\\s*([,.<>\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^(<>]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(?<==)>)*(?<!=)>))*(?<!=)>)*(?<!=)>\\\\s*)`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"}},\"end\":\"(?=`)\",\"patterns\":[{\"include\":\"#type-arguments\"}]}]},\"template-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#expression\"}]},\"template-type\":{\"patterns\":[{\"include\":\"#template-call\"},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)?(`)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function.tagged-template.js\"},\"2\":{\"name\":\"string.template.js punctuation.definition.string.template.begin.js\"}},\"contentName\":\"string.template.js\",\"end\":\"`\",\"endCaptures\":{\"0\":{\"name\":\"string.template.js punctuation.definition.string.template.end.js\"}},\"patterns\":[{\"include\":\"#template-type-substitution-element\"},{\"include\":\"#string-character-escape\"}]}]},\"template-type-substitution-element\":{\"begin\":\"\\\\$\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.begin.js\"}},\"contentName\":\"meta.embedded.line.js\",\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.template-expression.end.js\"}},\"name\":\"meta.template.expression.js\",\"patterns\":[{\"include\":\"#type\"}]},\"ternary-expression\":{\"begin\":\"(?!\\\\?\\\\.\\\\s*\\\\D)(\\\\?)(?!\\\\?)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\"\\\\s*(:)\",\"endCaptures\":{\"1\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#expression\"}]},\"this-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)\",\"name\":\"variable.language.this.js\"},\"type\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-string\"},{\"include\":\"#numeric-literal\"},{\"include\":\"#type-primitive\"},{\"include\":\"#type-builtin-literals\"},{\"include\":\"#type-parameters\"},{\"include\":\"#type-tuple\"},{\"include\":\"#type-object\"},{\"include\":\"#type-operators\"},{\"include\":\"#type-conditional\"},{\"include\":\"#type-fn-type-parameters\"},{\"include\":\"#type-paren-or-function-parameters\"},{\"include\":\"#type-function-return-type\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\"},{\"include\":\"#type-name\"}]},\"type-alias-declaration\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([$_[:alpha:]][$_[:alnum:]]*)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.type.js\"},\"4\":{\"name\":\"entity.name.type.alias.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"name\":\"meta.type.declaration.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"},{\"begin\":\"(=)\\\\s*(intrinsic)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"},\"2\":{\"name\":\"keyword.control.intrinsic.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(=)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[;}]|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-annotation\":{\"patterns\":[{\"begin\":\"(:)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])(?!\\\\s*[\\\\&|]\\\\s+)((?=^|[]),;}]|//)|(?==[^>])|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]},{\"begin\":\"(:)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.type.annotation.js\"}},\"end\":\"(?<![\\\\&:|])((?=[]),;}]|//)|(?==[^>])|(?=^\\\\s*$)|((?<=[]$)>_}[:alpha:]])\\\\s*(?=\\\\{)))\",\"name\":\"meta.type.annotation.js\",\"patterns\":[{\"include\":\"#type\"}]}]},\"type-arguments\":{\"begin\":\"<\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#type-arguments-body\"}]},\"type-arguments-body\":{\"patterns\":[{\"captures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"type-builtin-literals\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.builtin.js\"},\"type-conditional\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"}},\"end\":\"(?<=:)\",\"patterns\":[{\"begin\":\"\\\\?\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"end\":\":\",\"endCaptures\":{\"0\":{\"name\":\"keyword.operator.ternary.js\"}},\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#type\"}]}]},\"type-fn-type-parameters\":{\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*<)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.type.constructor.js storage.modifier.js\"},\"2\":{\"name\":\"meta.type.constructor.js keyword.control.new.js\"}},\"end\":\"(?<=>)\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#type-parameters\"}]},{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()\",\"beginCaptures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.control.new.js\"}},\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.constructor.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]},{\"begin\":\"((?=\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>))))))\",\"end\":\"(?<=\\\\))\",\"name\":\"meta.type.function.js\",\"patterns\":[{\"include\":\"#function-parameters\"}]}]},\"type-function-return-type\":{\"patterns\":[{\"begin\":\"(=>)(?=\\\\s*\\\\S)\",\"beginCaptures\":{\"1\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])(?=[]),:;=>?{}]|//|$)\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]},{\"begin\":\"=>\",\"beginCaptures\":{\"0\":{\"name\":\"storage.type.function.arrow.js\"}},\"end\":\"(?<!=>)(?<![\\\\&|])((?=[]),:;=>?{}]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))\",\"name\":\"meta.type.function.return.js\",\"patterns\":[{\"include\":\"#type-function-return-type-core\"}]}]},\"type-function-return-type-core\":{\"patterns\":[{\"include\":\"#comment\"},{\"begin\":\"(?<==>)(?=\\\\s*\\\\{)\",\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"include\":\"#type-predicate-operator\"},{\"include\":\"#type\"}]},\"type-infer\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.expression.infer.js\"},\"2\":{\"name\":\"entity.name.type.js\"},\"3\":{\"name\":\"keyword.operator.expression.extends.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([$_[:alpha:]][$_[:alnum:]]*)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?\",\"name\":\"meta.type.infer.js\"}]},\"type-name\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\\\\s*(<)\",\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"},\"4\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(<)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.type.js\"},\"2\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.begin.js\"}},\"contentName\":\"meta.type.parameters.js\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"meta.type.parameters.js punctuation.definition.typeparameters.end.js\"}},\"patterns\":[{\"include\":\"#type-arguments-body\"}]},{\"captures\":{\"1\":{\"name\":\"entity.name.type.module.js\"},\"2\":{\"name\":\"punctuation.accessor.js\"},\"3\":{\"name\":\"punctuation.accessor.optional.js\"}},\"match\":\"([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*\\\\d)))\"},{\"match\":\"[$_[:alpha:]][$_[:alnum:]]*\",\"name\":\"entity.name.type.js\"}]},\"type-object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.block.js\"}},\"name\":\"meta.object.type.js\",\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#method-declaration\"},{\"include\":\"#indexer-declaration\"},{\"include\":\"#indexer-mapped-type-declaration\"},{\"include\":\"#field-declaration\"},{\"include\":\"#type-annotation\"},{\"begin\":\"\\\\.\\\\.\\\\.\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.spread.js\"}},\"end\":\"(?=[,;}]|$)|(?<=})\",\"patterns\":[{\"include\":\"#type\"}]},{\"include\":\"#punctuation-comma\"},{\"include\":\"#punctuation-semicolon\"},{\"include\":\"#type\"}]},\"type-operators\":{\"patterns\":[{\"include\":\"#typeof-operator\"},{\"include\":\"#type-infer\"},{\"begin\":\"([\\\\&|])(?=\\\\s*\\\\{)\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?<=})\",\"patterns\":[{\"include\":\"#type-object\"}]},{\"begin\":\"[\\\\&|]\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.keyof.js\"},{\"match\":\"([:?])\",\"name\":\"keyword.operator.ternary.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()\",\"name\":\"keyword.operator.expression.import.js\"}]},\"type-parameters\":{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.begin.js\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.typeparameters.end.js\"}},\"name\":\"meta.type.parameters.js\",\"patterns\":[{\"include\":\"#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.js\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.js\"}]},\"type-paren-or-function-parameters\":{\"begin\":\"\\\\(\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"end\":\"\\\\)\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.round.js\"}},\"name\":\"meta.type.paren.cover.js\",\"patterns\":[{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"entity.name.function.js variable.language.this.js\"},\"4\":{\"name\":\"entity.name.function.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))))\"},{\"captures\":{\"1\":{\"name\":\"storage.modifier.js\"},\"2\":{\"name\":\"keyword.operator.rest.js\"},\"3\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"4\":{\"name\":\"variable.parameter.js\"},\"5\":{\"name\":\"keyword.operator.optional.js\"}},\"match\":\"(?:(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<![:=])(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s*(\\\\??)(?=:)\"},{\"include\":\"#type-annotation\"},{\"match\":\",\",\"name\":\"punctuation.separator.parameter.js\"},{\"include\":\"#type\"}]},\"type-predicate-operator\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"},\"4\":{\"name\":\"keyword.operator.expression.is.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))\\\\s(is)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"captures\":{\"1\":{\"name\":\"keyword.operator.type.asserts.js\"},\"2\":{\"name\":\"variable.parameter.js variable.language.this.js\"},\"3\":{\"name\":\"variable.parameter.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([$_[:alpha:]][$_[:alnum:]]*))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.type.asserts.js\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"keyword.operator.expression.is.js\"}]},\"type-primitive\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"support.type.primitive.js\"},\"type-string\":{\"patterns\":[{\"include\":\"#qstring-single\"},{\"include\":\"#qstring-double\"},{\"include\":\"#template-type\"}]},\"type-tuple\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"meta.brace.square.js\"}},\"name\":\"meta.type.tuple.js\",\"patterns\":[{\"match\":\"\\\\.\\\\.\\\\.\",\"name\":\"keyword.operator.rest.js\"},{\"captures\":{\"1\":{\"name\":\"entity.name.label.js\"},\"2\":{\"name\":\"keyword.operator.optional.js\"},\"3\":{\"name\":\"punctuation.separator.label.js\"}},\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([$_[:alpha:]][$_[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)\"},{\"include\":\"#type\"},{\"include\":\"#punctuation-comma\"}]},\"typeof-operator\":{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"beginCaptures\":{\"0\":{\"name\":\"keyword.operator.expression.typeof.js\"}},\"end\":\"(?=[]\\\\&),:;=>?{|}]|(extends\\\\s+)|$|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)\",\"patterns\":[{\"include\":\"#type-arguments\"},{\"include\":\"#expression\"}]},\"undefined-literal\":{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"constant.language.undefined.js\"},\"var-expr\":{\"patterns\":[{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!^let|[^$._[:alnum:]]let|^var|[^$._[:alnum:]]var)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(var|let)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-variable\"},{\"include\":\"#var-single-variable\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]])const)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*(?=$|//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#destructuring-const\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]},{\"begin\":\"(?=(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?!(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=[;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b)|((?<!(?:^|[^$._[:alnum:]]|^await\\\\s+|[^$._[:alnum:]]await\\\\s+)using)(?=\\\\s*$)))\",\"name\":\"meta.var.expr.js\",\"patterns\":[{\"begin\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(export)\\\\s+)?(?:\\\\b(declare)\\\\s+)?\\\\b\\\\b(using(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])|await\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b)\\\\b(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.export.js\"},\"2\":{\"name\":\"storage.modifier.js\"},\"3\":{\"name\":\"storage.type.js\"}},\"end\":\"(?=\\\\S)\"},{\"include\":\"#var-single-const\"},{\"include\":\"#variable-initializer\"},{\"include\":\"#comment\"},{\"begin\":\"(,)\\\\s*((?!\\\\S)|(?=//))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.comma.js\"}},\"end\":\"(?<!,)(((?=[;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))\",\"patterns\":[{\"include\":\"#single-line-comment-consuming-line-ending\"},{\"include\":\"#comment\"},{\"include\":\"#var-single-const\"},{\"include\":\"#punctuation-comma\"}]},{\"include\":\"#punctuation-comma\"}]}]},\"var-single-const\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js entity.name.function.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable\":{\"patterns\":[{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>)))))|(:\\\\s*((<)|(\\\\(\\\\s*((\\\\))|(\\\\.\\\\.\\\\.)|([$_[:alnum:]]+\\\\s*(([,:=?])|(\\\\)\\\\s*=>)))))))|(:\\\\s*(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^(),<=>])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(*<])|(function\\\\s+)|([$_[:alpha:]][$_[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*)$|(\\\\(\\\\s*((([\\\\[{]\\\\s*)?)$|((\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})\\\\s*((:\\\\s*\\\\{?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*)))|((\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])\\\\s*((:\\\\s*\\\\[?)$|((\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*((\\\\)\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[$_[:alpha:]][$_[:alnum:]]*\\\\s*:)))|(<\\\\s*[$_[:alpha:]][$_[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<]|<\\\\s*(((const\\\\s+)?[$_[:alpha:]])|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*]))([^<=>]|=[^<])*>)*>)*>\\\\s*)?\\\\(\\\\s*(/\\\\*([^*]|(\\\\*[^/]))*\\\\*/\\\\s*)*(([$_[:alpha:]]|(\\\\{([^{}]|(\\\\{([^{}]|\\\\{[^{}]*})*}))*})|(\\\\[([^]\\\\[]|(\\\\[([^]\\\\[]|\\\\[[^]\\\\[]*])*]))*])|(\\\\.\\\\.\\\\.\\\\s*[$_[:alpha:]]))([^\\\"'()`]|(\\\\(([^()]|(\\\\(([^()]|\\\\([^()]*\\\\))*\\\\)))*\\\\))|('([^'\\\\\\\\]|\\\\\\\\.)*')|(\\\"([^\\\"\\\\\\\\]|\\\\\\\\.)*\\\")|(`([^\\\\\\\\`]|\\\\\\\\.)*`))*)?\\\\)(\\\\s*:\\\\s*([^()<>{}]|<([^<>]|<([^<>]|<[^<>]+>)+>)+>|\\\\([^()]+\\\\)|\\\\{[^{}]+})+)?\\\\s*=>))))))\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js entity.name.function.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"(\\\\p{upper}[$_\\\\d[:upper:]]*)(?![$_[:alnum:]])(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.constant.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]},{\"begin\":\"([$_[:alpha:]][$_[:alnum:]]*)(!)?\",\"beginCaptures\":{\"1\":{\"name\":\"meta.definition.variable.js variable.other.readwrite.js\"},\"2\":{\"name\":\"keyword.operator.definiteassignment.js\"}},\"end\":\"(?=$|^|[,;=}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|^\\\\s*(?:abstract|async|\\\\bawait\\\\s+\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b\\\\b|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[$_[:alpha:]])\\\\b|var|while)\\\\b))\",\"name\":\"meta.var-single-variable.expr.js\",\"patterns\":[{\"include\":\"#var-single-variable-type-annotation\"}]}]},\"var-single-variable-type-annotation\":{\"patterns\":[{\"include\":\"#type-annotation\"},{\"include\":\"#string\"},{\"include\":\"#comment\"}]},\"variable-initializer\":{\"patterns\":[{\"begin\":\"(?<![!=])(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=$|^|[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))\",\"patterns\":[{\"include\":\"#expression\"}]},{\"begin\":\"(?<![!=])(=)(?!=)\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.operator.assignment.js\"}},\"end\":\"(?=[]),;}]|((?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![-\\\\&*+/|])(?<=\\\\S)(?<!=)(?=\\\\s*$)\",\"patterns\":[{\"include\":\"#expression\"}]}]}},\"scopeName\":\"source.js\",\"aliases\":[\"js\",\"cjs\",\"mjs\"]}"))];
var json_default = [Object.freeze(JSON.parse("{\"displayName\":\"JSON\",\"name\":\"json\",\"patterns\":[{\"include\":\"#value\"}],\"repository\":{\"array\":{\"begin\":\"\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.array.begin.json\"}},\"end\":\"]\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.array.end.json\"}},\"name\":\"meta.structure.array.json\",\"patterns\":[{\"include\":\"#value\"},{\"match\":\",\",\"name\":\"punctuation.separator.array.json\"},{\"match\":\"[^]\\\\s]\",\"name\":\"invalid.illegal.expected-array-separator.json\"}]},\"comments\":{\"patterns\":[{\"begin\":\"/\\\\*\\\\*(?!/)\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.json\"}},\"end\":\"\\\\*/\",\"name\":\"comment.block.documentation.json\"},{\"begin\":\"/\\\\*\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.json\"}},\"end\":\"\\\\*/\",\"name\":\"comment.block.json\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.comment.json\"}},\"match\":\"(//).*$\\\\n?\",\"name\":\"comment.line.double-slash.js\"}]},\"constant\":{\"match\":\"\\\\b(?:true|false|null)\\\\b\",\"name\":\"constant.language.json\"},\"number\":{\"match\":\"-?(?:0|[1-9]\\\\d*)(?:(?:\\\\.\\\\d+)?(?:[Ee][-+]?\\\\d+)?)?\",\"name\":\"constant.numeric.json\"},\"object\":{\"begin\":\"\\\\{\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.dictionary.begin.json\"}},\"end\":\"}\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.dictionary.end.json\"}},\"name\":\"meta.structure.dictionary.json\",\"patterns\":[{\"include\":\"#objectkey\"},{\"include\":\"#comments\"},{\"begin\":\":\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.dictionary.key-value.json\"}},\"end\":\"(,)|(?=})\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.separator.dictionary.pair.json\"}},\"name\":\"meta.structure.dictionary.value.json\",\"patterns\":[{\"include\":\"#value\"},{\"match\":\"[^,\\\\s]\",\"name\":\"invalid.illegal.expected-dictionary-separator.json\"}]},{\"match\":\"[^}\\\\s]\",\"name\":\"invalid.illegal.expected-dictionary-separator.json\"}]},\"objectkey\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.support.type.property-name.begin.json\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.support.type.property-name.end.json\"}},\"name\":\"string.json support.type.property-name.json\",\"patterns\":[{\"include\":\"#stringcontent\"}]},\"string\":{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.json\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.json\"}},\"name\":\"string.quoted.double.json\",\"patterns\":[{\"include\":\"#stringcontent\"}]},\"stringcontent\":{\"patterns\":[{\"match\":\"\\\\\\\\(?:[\\\"/\\\\\\\\bfnrt]|u\\\\h{4})\",\"name\":\"constant.character.escape.json\"},{\"match\":\"\\\\\\\\.\",\"name\":\"invalid.illegal.unrecognized-string-escape.json\"}]},\"value\":{\"patterns\":[{\"include\":\"#constant\"},{\"include\":\"#number\"},{\"include\":\"#string\"},{\"include\":\"#array\"},{\"include\":\"#object\"},{\"include\":\"#comments\"}]}},\"scopeName\":\"source.json\"}"))];
//#endregion
//#region ../../node_modules/@shikijs/langs/dist/html.mjs
var lang$6 = Object.freeze(JSON.parse("{\"displayName\":\"HTML\",\"injections\":{\"R:text.html - (comment.block, text.html meta.embedded, meta.tag.*.*.html, meta.tag.*.*.*.html, meta.tag.*.*.*.*.html)\":{\"patterns\":[{\"match\":\"<\",\"name\":\"invalid.illegal.bad-angle-bracket.html\"}]}},\"name\":\"html\",\"patterns\":[{\"include\":\"#xml-processing\"},{\"include\":\"#comment\"},{\"include\":\"#doctype\"},{\"include\":\"#cdata\"},{\"include\":\"#tags-valid\"},{\"include\":\"#tags-invalid\"},{\"include\":\"#entities\"}],\"repository\":{\"attribute\":{\"patterns\":[{\"begin\":\"(s(hape|cope|t(ep|art)|ize(s)?|p(ellcheck|an)|elected|lot|andbox|rc(set|doc|lang)?)|h(ttp-equiv|i(dden|gh)|e(ight|aders)|ref(lang)?)|n(o(nce|validate|module)|ame)|c(h(ecked|arset)|ite|o(nt(ent(editable)?|rols)|ords|l(s(pan)?|or))|lass|rossorigin)|t(ype(mustmatch)?|itle|a(rget|bindex)|ranslate)|i(s(map)?|n(tegrity|putmode)|tem(scope|type|id|prop|ref)|d)|op(timum|en)|d(i(sabled|r(name)?)|ownload|e(coding|f(er|ault))|at(etime|a)|raggable)|usemap|p(ing|oster|la(ysinline|ceholder)|attern|reload)|enctype|value|kind|for(m(novalidate|target|enctype|action|method)?)?|w(idth|rap)|l(ist|o(op|w)|a(ng|bel))|a(s(ync)?|c(ce(sskey|pt(-charset)?)|tion)|uto(c(omplete|apitalize)|play|focus)|l(t|low(usermedia|paymentrequest|fullscreen))|bbr)|r(ows(pan)?|e(versed|quired|ferrerpolicy|l|adonly))|m(in(length)?|u(ted|ltiple)|e(thod|dia)|a(nifest|x(length)?)))(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"begin\":\"style(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.style.html\",\"patterns\":[{\"begin\":\"=\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.key-value.html\"}},\"end\":\"(?<=[^=\\\\s])(?!\\\\s*=)|(?=/?>)\",\"patterns\":[{\"begin\":\"(?=[^/<=>`\\\\s]|/(?!>))\",\"end\":\"(?!\\\\G)\",\"name\":\"meta.embedded.line.css\",\"patterns\":[{\"captures\":{\"0\":{\"name\":\"source.css\"}},\"match\":\"([^\\\"'/<=>`\\\\s]|/(?!>))+\",\"name\":\"string.unquoted.html\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"contentName\":\"source.css\",\"end\":\"(\\\")\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"},\"1\":{\"name\":\"source.css\"}},\"name\":\"string.quoted.double.html\",\"patterns\":[{\"include\":\"#entities\"}]},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"contentName\":\"source.css\",\"end\":\"(')\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"},\"1\":{\"name\":\"source.css\"}},\"name\":\"string.quoted.single.html\",\"patterns\":[{\"include\":\"#entities\"}]}]},{\"match\":\"=\",\"name\":\"invalid.illegal.unexpected-equals-sign.html\"}]}]},{\"begin\":\"on(s(croll|t(orage|alled)|u(spend|bmit)|e(curitypolicyviolation|ek(ing|ed)|lect))|hashchange|c(hange|o(ntextmenu|py)|u(t|echange)|l(ick|ose)|an(cel|play(through)?))|t(imeupdate|oggle)|in(put|valid)|o((?:n|ff)line)|d(urationchange|r(op|ag(start|over|e(n(ter|d)|xit)|leave)?)|blclick)|un(handledrejection|load)|p(opstate|lay(ing)?|a(ste|use|ge(show|hide))|rogress)|e(nded|rror|mptied)|volumechange|key(down|up|press)|focus|w(heel|aiting)|l(oad(start|e(nd|d((?:|meta)data)))?|anguagechange)|a(uxclick|fterprint|bort)|r(e(s(ize|et)|jectionhandled)|atechange)|m(ouse(o(ut|ver)|down|up|enter|leave|move)|essage(error)?)|b(efore(unload|print)|lur))(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.event-handler.$1.html\",\"patterns\":[{\"begin\":\"=\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.key-value.html\"}},\"end\":\"(?<=[^=\\\\s])(?!\\\\s*=)|(?=/?>)\",\"patterns\":[{\"begin\":\"(?=[^/<=>`\\\\s]|/(?!>))\",\"end\":\"(?!\\\\G)\",\"name\":\"meta.embedded.line.js\",\"patterns\":[{\"captures\":{\"0\":{\"name\":\"source.js\"},\"1\":{\"patterns\":[{\"include\":\"source.js\"}]}},\"match\":\"(([^\\\"'/<=>`\\\\s]|/(?!>))+)\",\"name\":\"string.unquoted.html\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"contentName\":\"source.js\",\"end\":\"(\\\")\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"},\"1\":{\"name\":\"source.js\"}},\"name\":\"string.quoted.double.html\",\"patterns\":[{\"captures\":{\"0\":{\"patterns\":[{\"include\":\"source.js\"}]}},\"match\":\"([^\\\\n\\\"/]|/(?![*/]))+\"},{\"begin\":\"//\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=\\\")|\\\\n\",\"name\":\"comment.line.double-slash.js\"},{\"begin\":\"/\\\\*\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.begin.js\"}},\"end\":\"(?=\\\")|\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.end.js\"}},\"name\":\"comment.block.js\"}]},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"contentName\":\"source.js\",\"end\":\"(')\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"},\"1\":{\"name\":\"source.js\"}},\"name\":\"string.quoted.single.html\",\"patterns\":[{\"captures\":{\"0\":{\"patterns\":[{\"include\":\"source.js\"}]}},\"match\":\"([^\\\\n'/]|/(?![*/]))+\"},{\"begin\":\"//\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=')|\\\\n\",\"name\":\"comment.line.double-slash.js\"},{\"begin\":\"/\\\\*\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.begin.js\"}},\"end\":\"(?=')|\\\\*/\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.end.js\"}},\"name\":\"comment.block.js\"}]}]},{\"match\":\"=\",\"name\":\"invalid.illegal.unexpected-equals-sign.html\"}]}]},{\"begin\":\"(data-[-a-z]+)(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.data-x.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"begin\":\"(align|bgcolor|border)(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"invalid.deprecated.entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"begin\":\"([^\\\\x00- \\\"'/<=>\\\\x7F-\\\\x{9F}﷐-﷯￾￿🿾🿿𯿾𯿿𿿾𿿿\\\\x{4FFFE}\\\\x{4FFFF}\\\\x{5FFFE}\\\\x{5FFFF}\\\\x{6FFFE}\\\\x{6FFFF}\\\\x{7FFFE}\\\\x{7FFFF}\\\\x{8FFFE}\\\\x{8FFFF}\\\\x{9FFFE}\\\\x{9FFFF}\\\\x{AFFFE}\\\\x{AFFFF}\\\\x{BFFFE}\\\\x{BFFFF}\\\\x{CFFFE}\\\\x{CFFFF}\\\\x{DFFFE}\\\\x{DFFFF}\\\\x{EFFFE}\\\\x{EFFFF}\\\\x{FFFFE}\\\\x{FFFFF}\\\\x{10FFFE}\\\\x{10FFFF}]+)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.unrecognized.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"match\":\"[^>\\\\s]+\",\"name\":\"invalid.illegal.character-not-allowed-here.html\"}]},\"attribute-interior\":{\"patterns\":[{\"begin\":\"=\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.separator.key-value.html\"}},\"end\":\"(?<=[^=\\\\s])(?!\\\\s*=)|(?=/?>)\",\"patterns\":[{\"match\":\"([^\\\"'/<=>`\\\\s]|/(?!>))+\",\"name\":\"string.unquoted.html\"},{\"begin\":\"\\\"\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"end\":\"\\\"\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"}},\"name\":\"string.quoted.double.html\",\"patterns\":[{\"include\":\"#entities\"}]},{\"begin\":\"'\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.begin.html\"}},\"end\":\"'\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.string.end.html\"}},\"name\":\"string.quoted.single.html\",\"patterns\":[{\"include\":\"#entities\"}]},{\"match\":\"=\",\"name\":\"invalid.illegal.unexpected-equals-sign.html\"}]}]},\"cdata\":{\"begin\":\"<!\\\\[CDATA\\\\[\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.begin.html\"}},\"contentName\":\"string.other.inline-data.html\",\"end\":\"]]>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.cdata.html\"},\"comment\":{\"begin\":\"<!--\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.html\"}},\"end\":\"-->\",\"name\":\"comment.block.html\",\"patterns\":[{\"match\":\"\\\\G-?>\",\"name\":\"invalid.illegal.characters-not-allowed-here.html\"},{\"match\":\"<!-(?:-(?!>)|(?=-->))\",\"name\":\"invalid.illegal.characters-not-allowed-here.html\"},{\"match\":\"--!>\",\"name\":\"invalid.illegal.characters-not-allowed-here.html\"}]},\"core-minus-invalid\":{\"patterns\":[{\"include\":\"#xml-processing\"},{\"include\":\"#comment\"},{\"include\":\"#doctype\"},{\"include\":\"#cdata\"},{\"include\":\"#tags-valid\"},{\"include\":\"#entities\"}]},\"doctype\":{\"begin\":\"<!(?=(?i:DOCTYPE\\\\s))\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.begin.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.doctype.html\",\"patterns\":[{\"match\":\"\\\\G(?i:DOCTYPE)\",\"name\":\"entity.name.tag.html\"},{\"begin\":\"\\\"\",\"end\":\"\\\"\",\"name\":\"string.quoted.double.html\"},{\"match\":\"[^>\\\\s]+\",\"name\":\"entity.other.attribute-name.html\"}]},\"entities\":{\"patterns\":[{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.html\"},\"912\":{\"name\":\"punctuation.definition.entity.html\"}},\"match\":\"(&)(?=[A-Za-z])((a(s(ymp(eq)?|cr|t)|n(d(slope|[dv]|and)?|g(s(t|ph)|zarr|e|le|rt(vb(d)?)?|msd(a([a-h]))?)?)|c(y|irc|d|ute|E)?|tilde|o(pf|gon)|uml|p(id|os|prox(eq)?|[Ee]|acir)?|elig|f(r)?|w((?:con|)int)|l(pha|e(ph|fsym))|acute|ring|grave|m(p|a(cr|lg))|breve)|A(s(sign|cr)|nd|MP|c(y|irc)|tilde|o(pf|gon)|uml|pplyFunction|fr|Elig|lpha|acute|ring|grave|macr|breve))|(B(scr|cy|opf|umpeq|e(cause|ta|rnoullis)|fr|a(ckslash|r(v|wed))|reve)|b(s(cr|im(e)?|ol(hsub|b)?|emi)|n(ot|e(quiv)?)|c(y|ong)|ig(s(tar|qcup)|c(irc|up|ap)|triangle(down|up)|o(times|dot|plus)|uplus|vee|wedge)|o(t(tom)?|pf|wtie|x(h([DUdu])?|times|H([DUdu])?|d([LRlr])|u([LRlr])|plus|D([LRlr])|v([HLRhlr])?|U([LRlr])|V([HLRhlr])?|minus|box))|Not|dquo|u(ll(et)?|mp(e(q)?|E)?)|prime|e(caus(e)?|t(h|ween|a)|psi|rnou|mptyv)|karow|fr|l(ock|k(1([24])|34)|a(nk|ck(square|triangle(down|left|right)?|lozenge)))|a(ck(sim(eq)?|cong|prime|epsilon)|r(vee|wed(ge)?))|r(eve|vbar)|brk(tbrk)?))|(c(s(cr|u(p(e)?|b(e)?))|h(cy|i|eck(mark)?)|ylcty|c(irc|ups(sm)?|edil|a(ps|ron))|tdot|ir(scir|c(eq|le(d(R|circ|S|dash|ast)|arrow(left|right)))?|e|fnint|E|mid)?|o(n(int|g(dot)?)|p(y(sr)?|f|rod)|lon(e(q)?)?|m(p(fn|le(xes|ment))?|ma(t)?))|dot|u(darr([lr])|p(s|c([au]p)|or|dot|brcap)?|e(sc|pr)|vee|wed|larr(p)?|r(vearrow(left|right)|ly(eq(succ|prec)|vee|wedge)|arr(m)?|ren))|e(nt(erdot)?|dil|mptyv)|fr|w((?:con|)int)|lubs(uit)?|a(cute|p(s|c([au]p)|dot|and|brcup)?|r(on|et))|r(oss|arr))|C(scr|hi|c(irc|onint|edil|aron)|ircle(Minus|Times|Dot|Plus)|Hcy|o(n(tourIntegral|int|gruent)|unterClockwiseContourIntegral|p(f|roduct)|lon(e)?)|dot|up(Cap)?|OPY|e(nterDot|dilla)|fr|lo(seCurly((?:Double|)Quote)|ckwiseContourIntegral)|a(yleys|cute|p(italDifferentialD)?)|ross))|(d(s(c([ry])|trok|ol)|har([lr])|c(y|aron)|t(dot|ri(f)?)|i(sin|e|v(ide(ontimes)?|onx)?|am(s|ond(suit)?)?|gamma)|Har|z(cy|igrarr)|o(t(square|plus|eq(dot)?|minus)?|ublebarwedge|pf|wn(harpoon(left|right)|downarrows|arrow)|llar)|d(otseq|a(rr|gger))?|u(har|arr)|jcy|e(lta|g|mptyv)|f(isht|r)|wangle|lc(orn|rop)|a(sh(v)?|leth|rr|gger)|r(c(orn|rop)|bkarow)|b(karow|lac)|Arr)|D(s(cr|trok)|c(y|aron)|Scy|i(fferentialD|a(critical(Grave|Tilde|Do(t|ubleAcute)|Acute)|mond))|o(t(Dot|Equal)?|uble(Right(Tee|Arrow)|ContourIntegral|Do(t|wnArrow)|Up((?:Down|)Arrow)|VerticalBar|L(ong(RightArrow|Left((?:Right|)Arrow))|eft(RightArrow|Tee|Arrow)))|pf|wn(Right(TeeVector|Vector(Bar)?)|Breve|Tee(Arrow)?|arrow|Left(RightVector|TeeVector|Vector(Bar)?)|Arrow(Bar|UpArrow)?))|Zcy|el(ta)?|D(otrahd)?|Jcy|fr|a(shv|rr|gger)))|(e(s(cr|im|dot)|n(sp|g)|c(y|ir(c)?|olon|aron)|t([ah])|o(pf|gon)|dot|u(ro|ml)|p(si(v|lon)?|lus|ar(sl)?)|e|D(D??ot)|q(s(im|lant(less|gtr))|c(irc|olon)|u(iv(DD)?|est|als)|vparsl)|f(Dot|r)|l(s(dot)?|inters|l)?|a(ster|cute)|r(Dot|arr)|g(s(dot)?|rave)?|x(cl|ist|p(onentiale|ectation))|m(sp(1([34]))?|pty(set|v)?|acr))|E(s(cr|im)|c(y|irc|aron)|ta|o(pf|gon)|NG|dot|uml|TH|psilon|qu(ilibrium|al(Tilde)?)|fr|lement|acute|grave|x(ists|ponentialE)|m(pty((?:|Very)SmallSquare)|acr)))|(f(scr|nof|cy|ilig|o(pf|r(k(v)?|all))|jlig|partint|emale|f(ilig|l(l??ig)|r)|l(tns|lig|at)|allingdotseq|r(own|a(sl|c(1([2-68])|78|2([35])|3([458])|45|5([68])))))|F(scr|cy|illed((?:|Very)SmallSquare)|o(uriertrf|pf|rAll)|fr))|(G(scr|c(y|irc|edil)|t|opf|dot|T|Jcy|fr|amma(d)?|reater(Greater|SlantEqual|Tilde|Equal(Less)?|FullEqual|Less)|g|breve)|g(s(cr|im([el])?)|n(sim|e(q(q)?)?|E|ap(prox)?)|c(y|irc)|t(c(c|ir)|dot|quest|lPar|r(sim|dot|eq(q?less)|less|a(pprox|rr)))?|imel|opf|dot|jcy|e(s(cc|dot(o(l)?)?|l(es)?)?|q(slant|q)?|l)?|v(nE|ertneqq)|fr|E(l)?|l([Eaj])?|a(cute|p|mma(d)?)|rave|g(g)?|breve))|(h(s(cr|trok|lash)|y(phen|bull)|circ|o(ok((?:lef|righ)tarrow)|pf|arr|rbar|mtht)|e(llip|arts(uit)?|rcon)|ks([ew]arow)|fr|a(irsp|lf|r(dcy|r(cir|w)?)|milt)|bar|Arr)|H(s(cr|trok)|circ|ilbertSpace|o(pf|rizontalLine)|ump(DownHump|Equal)|fr|a(cek|t)|ARDcy))|(i(s(cr|in(s(v)?|dot|[Ev])?)|n(care|t(cal|prod|e(rcal|gers)|larhk)?|odot|fin(tie)?)?|c(y|irc)?|t(ilde)?|i(nfin|i(i??nt)|ota)?|o(cy|ta|pf|gon)|u(kcy|ml)|jlig|prod|e(cy|xcl)|quest|f([fr])|acute|grave|m(of|ped|a(cr|th|g(part|e|line))))|I(scr|n(t(e(rsection|gral))?|visible(Comma|Times))|c(y|irc)|tilde|o(ta|pf|gon)|dot|u(kcy|ml)|Ocy|Jlig|fr|Ecy|acute|grave|m(plies|a(cr|ginaryI))?))|(j(s(cr|ercy)|c(y|irc)|opf|ukcy|fr|math)|J(s(cr|ercy)|c(y|irc)|opf|ukcy|fr))|(k(scr|hcy|c(y|edil)|opf|jcy|fr|appa(v)?|green)|K(scr|c(y|edil)|Hcy|opf|Jcy|fr|appa))|(l(s(h|cr|trok|im([eg])?|q(uo(r)?|b)|aquo)|h(ar(d|u(l)?)|blk)|n(sim|e(q(q)?)?|E|ap(prox)?)|c(y|ub|e(d??il)|aron)|Barr|t(hree|c(c|ir)|imes|dot|quest|larr|r(i([ef])?|Par))?|Har|o(ng(left((?:|right)arrow)|rightarrow|mapsto)|times|z(enge|f)?|oparrow(left|right)|p(f|lus|ar)|w(ast|bar)|a(ng|rr)|brk)|d(sh|ca|quo(r)?|r((?:d|us)har))|ur((?:ds|u)har)|jcy|par(lt)?|e(s(s(sim|dot|eq(q?gtr)|approx|gtr)|cc|dot(o(r)?)?|g(es)?)?|q(slant|q)?|ft(harpoon(down|up)|threetimes|leftarrows|arrow(tail)?|right(squigarrow|harpoons|arrow(s)?))|g)?|v(nE|ertneqq)|f(isht|loor|r)|E(g)?|l(hard|corner|tri|arr)?|a(ng(d|le)?|cute|t(e(s)?|ail)?|p|emptyv|quo|rr(sim|hk|tl|pl|fs|lp|b(fs)?)?|gran|mbda)|r(har(d)?|corner|tri|arr|m)|g(E)?|m(idot|oust(ache)?)|b(arr|r(k(sl([du])|e)|ac([ek]))|brk)|A(tail|arr|rr))|L(s(h|cr|trok)|c(y|edil|aron)|t|o(ng(RightArrow|left((?:|right)arrow)|rightarrow|Left((?:Right|)Arrow))|pf|wer((?:Righ|Lef)tArrow))|T|e(ss(Greater|SlantEqual|Tilde|EqualGreater|FullEqual|Less)|ft(Right(Vector|Arrow)|Ceiling|T(ee(Vector|Arrow)?|riangle(Bar|Equal)?)|Do(ubleBracket|wn(TeeVector|Vector(Bar)?))|Up(TeeVector|DownVector|Vector(Bar)?)|Vector(Bar)?|arrow|rightarrow|Floor|A(ngleBracket|rrow(RightArrow|Bar)?)))|Jcy|fr|l(eftarrow)?|a(ng|cute|placetrf|rr|mbda)|midot))|(M(scr|cy|inusPlus|opf|u|e(diumSpace|llintrf)|fr|ap)|m(s(cr|tpos)|ho|nplus|c(y|omma)|i(nus(d(u)?|b)?|cro|d(cir|dot|ast)?)|o(dels|pf)|dash|u((?:lti|)map)?|p|easuredangle|DDot|fr|l(cp|dr)|a(cr|p(sto(down|up|left)?)?|l(t(ese)?|e)|rker)))|(n(s(hort(parallel|mid)|c(cue|[er])?|im(e(q)?)?|u(cc(eq)?|p(set(eq(q)?)?|[Ee])?|b(set(eq(q)?)?|[Ee])?)|par|qsu([bp]e)|mid)|Rightarrow|h(par|arr|Arr)|G(t(v)?|g)|c(y|ong(dot)?|up|edil|a(p|ron))|t(ilde|lg|riangle(left(eq)?|right(eq)?)|gl)|i(s(d)?|v)?|o(t(ni(v([abc]))?|in(dot|v([abc])|E)?)?|pf)|dash|u(m(sp|ero)?)?|jcy|p(olint|ar(sl|t|allel)?|r(cue|e(c(eq)?)?)?)|e(s(im|ear)|dot|quiv|ar(hk|r(ow)?)|xist(s)?|Arr)?|v(sim|infin|Harr|dash|Dash|l(t(rie)?|e|Arr)|ap|r(trie|Arr)|g([et]))|fr|w(near|ar(hk|r(ow)?)|Arr)|V([Dd]ash)|l(sim|t(ri(e)?)?|dr|e(s(s)?|q(slant|q)?|ft((?:|right)arrow))?|E|arr|Arr)|a(ng|cute|tur(al(s)?)?|p(id|os|prox|E)?|bla)|r(tri(e)?|ightarrow|arr([cw])?|Arr)|g(sim|t(r)?|e(s|q(slant|q)?)?|E)|mid|L(t(v)?|eft((?:|right)arrow)|l)|b(sp|ump(e)?))|N(scr|c(y|edil|aron)|tilde|o(nBreakingSpace|Break|t(R(ightTriangle(Bar|Equal)?|everseElement)|Greater(Greater|SlantEqual|Tilde|Equal|FullEqual|Less)?|S(u(cceeds(SlantEqual|Tilde|Equal)?|perset(Equal)?|bset(Equal)?)|quareSu(perset(Equal)?|bset(Equal)?))|Hump(DownHump|Equal)|Nested(GreaterGreater|LessLess)|C(ongruent|upCap)|Tilde(Tilde|Equal|FullEqual)?|DoubleVerticalBar|Precedes((?:Slant|)Equal)?|E(qual(Tilde)?|lement|xists)|VerticalBar|Le(ss(Greater|SlantEqual|Tilde|Equal|Less)?|ftTriangle(Bar|Equal)?))?|pf)|u|e(sted(GreaterGreater|LessLess)|wLine|gative(MediumSpace|Thi((?:n|ck)Space)|VeryThinSpace))|Jcy|fr|acute))|(o(s(cr|ol|lash)|h(m|bar)|c(y|ir(c)?)|ti(lde|mes(as)?)|S|int|opf|d(sold|iv|ot|ash|blac)|uml|p(erp|lus|ar)|elig|vbar|f(cir|r)|l(c(ir|ross)|t|ine|arr)|a(st|cute)|r(slope|igof|or|d(er(of)?|[fm])?|v|arr)?|g(t|on|rave)|m(i(nus|cron|d)|ega|acr))|O(s(cr|lash)|c(y|irc)|ti(lde|mes)|opf|dblac|uml|penCurly((?:Double|)Quote)|ver(B(ar|rac(e|ket))|Parenthesis)|fr|Elig|acute|r|grave|m(icron|ega|acr)))|(p(s(cr|i)|h(i(v)?|one|mmat)|cy|i(tchfork|v)?|o(intint|und|pf)|uncsp|er(cnt|tenk|iod|p|mil)|fr|l(us(sim|cir|two|d([ou])|e|acir|mn|b)?|an(ck(h)?|kv))|ar(s(im|l)|t|a(llel)?)?|r(sim|n(sim|E|ap)|cue|ime(s)?|o(d|p(to)?|f(surf|line|alar))|urel|e(c(sim|n(sim|eqq|approx)|curlyeq|eq|approx)?)?|E|ap)?|m)|P(s(cr|i)|hi|cy|i|o(incareplane|pf)|fr|lusMinus|artialD|r(ime|o(duct|portion(al)?)|ecedes(SlantEqual|Tilde|Equal)?)?))|(q(scr|int|opf|u(ot|est(eq)?|at(int|ernions))|prime|fr)|Q(scr|opf|UOT|fr))|(R(s(h|cr)|ho|c(y|edil|aron)|Barr|ight(Ceiling|T(ee(Vector|Arrow)?|riangle(Bar|Equal)?)|Do(ubleBracket|wn(TeeVector|Vector(Bar)?))|Up(TeeVector|DownVector|Vector(Bar)?)|Vector(Bar)?|arrow|Floor|A(ngleBracket|rrow(Bar|LeftArrow)?))|o(undImplies|pf)|uleDelayed|e(verse(UpEquilibrium|E(quilibrium|lement)))?|fr|EG|a(ng|cute|rr(tl)?)|rightarrow)|r(s(h|cr|q(uo(r)?|b)|aquo)|h(o(v)?|ar(d|u(l)?))|nmid|c(y|ub|e(d??il)|aron)|Barr|t(hree|imes|ri([ef]|ltri)?)|i(singdotseq|ng|ght(squigarrow|harpoon(down|up)|threetimes|left(harpoons|arrows)|arrow(tail)?|rightarrows))|Har|o(times|p(f|lus|ar)|a(ng|rr)|brk)|d(sh|ca|quo(r)?|ldhar)|uluhar|p(polint|ar(gt)?)|e(ct|al(s|ine|part)?|g)|f(isht|loor|r)|l(har|arr|m)|a(ng([de]|le)?|c(ute|e)|t(io(nals)?|ail)|dic|emptyv|quo|rr(sim|hk|c|tl|pl|fs|w|lp|ap|b(fs)?)?)|rarr|x|moust(ache)?|b(arr|r(k(sl([du])|e)|ac([ek]))|brk)|A(tail|arr|rr)))|(s(s(cr|tarf|etmn|mile)|h(y|c(hcy|y)|ort(parallel|mid)|arp)|c(sim|y|n(sim|E|ap)|cue|irc|polint|e(dil)?|E|a(p|ron))?|t(ar(f)?|r(ns|aight(phi|epsilon)))|i(gma([fv])?|m(ne|dot|plus|e(q)?|l(E)?|rarr|g(E)?)?)|zlig|o(pf|ftcy|l(b(ar)?)?)|dot([be])?|u(ng|cc(sim|n(sim|eqq|approx)|curlyeq|eq|approx)?|p(s(im|u([bp])|et(neq(q)?|eq(q)?)?)|hs(ol|ub)|1|n([Ee])|2|d(sub|ot)|3|plus|e(dot)?|E|larr|mult)?|m|b(s(im|u([bp])|et(neq(q)?|eq(q)?)?)|n([Ee])|dot|plus|e(dot)?|E|rarr|mult)?)|pa(des(uit)?|r)|e(swar|ct|tm(n|inus)|ar(hk|r(ow)?)|xt|mi|Arr)|q(su(p(set(eq)?|e)?|b(set(eq)?|e)?)|c(up(s)?|ap(s)?)|u(f|ar([ef]))?)|fr(own)?|w(nwar|ar(hk|r(ow)?)|Arr)|larr|acute|rarr|m(t(e(s)?)?|i(d|le)|eparsl|a(shp|llsetminus))|bquo)|S(scr|hort((?:Right|Down|Up|Left)Arrow)|c(y|irc|edil|aron)?|tar|igma|H(cy|CHcy)|opf|u(c(hThat|ceeds(SlantEqual|Tilde|Equal)?)|p(set|erset(Equal)?)?|m|b(set(Equal)?)?)|OFTcy|q(uare(Su(perset(Equal)?|bset(Equal)?)|Intersection|Union)?|rt)|fr|acute|mallCircle))|(t(s(hcy|c([ry])|trok)|h(i(nsp|ck(sim|approx))|orn|e(ta(sym|v)?|re(4|fore))|k(sim|ap))|c(y|edil|aron)|i(nt|lde|mes(d|b(ar)?)?)|o(sa|p(cir|f(ork)?|bot)?|ea)|dot|prime|elrec|fr|w(ixt|ohead((?:lef|righ)tarrow))|a(u|rget)|r(i(sb|time|dot|plus|e|angle(down|q|left(eq)?|right(eq)?)?|minus)|pezium|ade)|brk)|T(s(cr|trok)|RADE|h(i((?:n|ck)Space)|e(ta|refore))|c(y|edil|aron)|S(H??cy)|ilde(Tilde|Equal|FullEqual)?|HORN|opf|fr|a([bu])|ripleDot))|(u(scr|h(ar([lr])|blk)|c(y|irc)|t(ilde|dot|ri(f)?)|Har|o(pf|gon)|d(har|arr|blac)|u(arr|ml)|p(si(h|lon)?|harpoon(left|right)|downarrow|uparrows|lus|arrow)|f(isht|r)|wangle|l(c(orn(er)?|rop)|tri)|a(cute|rr)|r(c(orn(er)?|rop)|tri|ing)|grave|m(l|acr)|br(cy|eve)|Arr)|U(scr|n(ion(Plus)?|der(B(ar|rac(e|ket))|Parenthesis))|c(y|irc)|tilde|o(pf|gon)|dblac|uml|p(si(lon)?|downarrow|Tee(Arrow)?|per((?:Righ|Lef)tArrow)|DownArrow|Equilibrium|arrow|Arrow(Bar|DownArrow)?)|fr|a(cute|rr(ocir)?)|ring|grave|macr|br(cy|eve)))|(v(s(cr|u(pn([Ee])|bn([Ee])))|nsu([bp])|cy|Bar(v)?|zigzag|opf|dash|prop|e(e(eq|bar)?|llip|r(t|bar))|Dash|fr|ltri|a(ngrt|r(s(igma|u(psetneq(q)?|bsetneq(q)?))|nothing|t(heta|riangle(left|right))|p(hi|i|ropto)|epsilon|kappa|r(ho)?))|rtri|Arr)|V(scr|cy|opf|dash(l)?|e(e|r(yThinSpace|t(ical(Bar|Separator|Tilde|Line))?|bar))|Dash|vdash|fr|bar))|(w(scr|circ|opf|p|e(ierp|d(ge(q)?|bar))|fr|r(eath)?)|W(scr|circ|opf|edge|fr))|(X(scr|i|opf|fr)|x(s(cr|qcup)|h([Aa]rr)|nis|c(irc|up|ap)|i|o(time|dot|p(f|lus))|dtri|u(tri|plus)|vee|fr|wedge|l([Aa]rr)|r([Aa]rr)|map))|(y(scr|c(y|irc)|icy|opf|u(cy|ml)|en|fr|ac(y|ute))|Y(scr|c(y|irc)|opf|uml|Icy|Ucy|fr|acute|Acy))|(z(scr|hcy|c(y|aron)|igrarr|opf|dot|e(ta|etrf)|fr|w(n?j)|acute)|Z(scr|c(y|aron)|Hcy|opf|dot|e(ta|roWidthSpace)|fr|acute)))(;)\",\"name\":\"constant.character.entity.named.$2.html\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.html\"},\"3\":{\"name\":\"punctuation.definition.entity.html\"}},\"match\":\"(&)#[0-9]+(;)\",\"name\":\"constant.character.entity.numeric.decimal.html\"},{\"captures\":{\"1\":{\"name\":\"punctuation.definition.entity.html\"},\"3\":{\"name\":\"punctuation.definition.entity.html\"}},\"match\":\"(&)#[Xx]\\\\h+(;)\",\"name\":\"constant.character.entity.numeric.hexadecimal.html\"},{\"match\":\"&(?=[0-9A-Za-z]+;)\",\"name\":\"invalid.illegal.ambiguous-ampersand.html\"}]},\"math\":{\"patterns\":[{\"begin\":\"(?i)(<)(math)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.structure.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.structure.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.structure.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]}],\"repository\":{\"attribute\":{\"patterns\":[{\"begin\":\"(s(hift|ymmetric|cript(sizemultiplier|level|minsize)|t(ackalign|retchy)|ide|u([bp]scriptshift)|e(parator(s)?|lection)|rc)|h(eight|ref)|n(otation|umalign)|c(haralign|olumn(spa(n|cing)|width|lines|align)|lose|rossout)|i(n(dent(shift(first|last)?|target|align(first|last)?)|fixlinebreakstyle)|d)|o(pen|verflow)|d(i(splay(style)?|r)|e(nomalign|cimalpoint|pth))|position|e(dge|qual(columns|rows))|voffset|f(orm|ence|rame(spacing)?)|width|l(space|ine(thickness|leading|break(style|multchar)?)|o(ngdivstyle|cation)|ength|quote|argeop)|a(c(cent(under)?|tiontype)|l(t(text|img(-(height|valign|width))?)|ign(mentscope)?))|r(space|ow(spa(n|cing)|lines|align)|quote)|groupalign|x(link:href|mlns)|m(in(size|labelspacing)|ovablelimits|a(th(size|color|variant|background)|xsize))|bevelled)(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"begin\":\"([^\\\\x00- \\\"'/<=>\\\\x7F-\\\\x{9F}﷐-﷯￾￿🿾🿿𯿾𯿿𿿾𿿿\\\\x{4FFFE}\\\\x{4FFFF}\\\\x{5FFFE}\\\\x{5FFFF}\\\\x{6FFFE}\\\\x{6FFFF}\\\\x{7FFFE}\\\\x{7FFFF}\\\\x{8FFFE}\\\\x{8FFFF}\\\\x{9FFFE}\\\\x{9FFFF}\\\\x{AFFFE}\\\\x{AFFFF}\\\\x{BFFFE}\\\\x{BFFFF}\\\\x{CFFFE}\\\\x{CFFFF}\\\\x{DFFFE}\\\\x{DFFFF}\\\\x{EFFFE}\\\\x{EFFFF}\\\\x{FFFFE}\\\\x{FFFFF}\\\\x{10FFFE}\\\\x{10FFFF}]+)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.unrecognized.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"match\":\"[^>\\\\s]+\",\"name\":\"invalid.illegal.character-not-allowed-here.html\"}]},\"tags\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#cdata\"},{\"captures\":{\"0\":{\"name\":\"meta.tag.structure.math.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(annotation|annotation-xml|semantics|menclose|merror|mfenced|mfrac|mpadded|mphantom|mroot|mrow|msqrt|mstyle|mmultiscripts|mover|mprescripts|msub|msubsup|msup|munder|munderover|none|mlabeledtr|mtable|mtd|mtr|mlongdiv|mscarries|mscarry|msgroup|msline|msrow|mstack|maction)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.structure.math.$2.html\"},{\"begin\":\"(?i)(<)(annotation|annotation-xml|semantics|menclose|merror|mfenced|mfrac|mpadded|mphantom|mroot|mrow|msqrt|mstyle|mmultiscripts|mover|mprescripts|msub|msubsup|msup|munder|munderover|none|mlabeledtr|mtable|mtd|mtr|mlongdiv|mscarries|mscarry|msgroup|msline|msrow|mstack|maction)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.structure.math.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.structure.math.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.structure.math.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.inline.math.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(m(?:[inos]|space|text|aligngroup|alignmark))(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.inline.math.$2.html\"},{\"begin\":\"(?i)(<)(m(?:[inos]|space|text|aligngroup|alignmark))(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.inline.math.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.inline.math.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.inline.math.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.object.math.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(mglyph)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.object.math.$2.html\"},{\"begin\":\"(?i)(<)(mglyph)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.object.math.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.object.math.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.object.math.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.other.invalid.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(([:\\\\w]+))(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.other.invalid.html\"},{\"begin\":\"(?i)(<)((\\\\w[^>\\\\s]*))(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.other.invalid.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)((\\\\2))\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.other.invalid.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.other.invalid.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.invalid.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"include\":\"#tags-invalid\"}]}}},\"svg\":{\"patterns\":[{\"begin\":\"(?i)(<)(svg)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.structure.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.structure.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.structure.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]}],\"repository\":{\"attribute\":{\"patterns\":[{\"begin\":\"(s(hape-rendering|ystemLanguage|cale|t(yle|itchTiles|op-(color|opacity)|dDeviation|em([hv])|artOffset|r(i(ng|kethrough-(thickness|position))|oke(-(opacity|dash(offset|array)|width|line(cap|join)|miterlimit))?))|urfaceScale|p(e(cular(Constant|Exponent)|ed)|acing|readMethod)|eed|lope)|h(oriz-(origin-x|adv-x)|eight|anging|ref(lang)?)|y([12]|ChannelSelector)?|n(umOctaves|ame)|c(y|o(ntentS((?:cript|tyle)Type)|lor(-(interpolation(-filters)?|profile|rendering))?)|ursor|l(ip(-(path|rule)|PathUnits)?|ass)|a(p-height|lcMode)|x)|t(ype|o|ext(-(decoration|anchor|rendering)|Length)|a(rget([XY])?|b(index|leValues))|ransform)|i(n(tercept|2)?|d(eographic)?|mage-rendering)|z(oomAndPan)?|o(p(erator|acity)|ver(flow|line-(thickness|position))|ffset|r(i(ent(ation)?|gin)|der))|d(y|i(splay|visor|ffuseConstant|rection)|ominant-baseline|ur|e(scent|celerate)|x)?|u(1|n(i(code(-(range|bidi))?|ts-per-em)|derline-(thickness|position))|2)|p(ing|oint(s(At([XYZ]))?|er-events)|a(nose-1|t(h(Length)?|tern(ContentUnits|Transform|Units))|int-order)|r(imitiveUnits|eserveA(spectRatio|lpha)))|e(n(d|able-background)|dgeMode|levation|x(ternalResourcesRequired|ponent))|v(i(sibility|ew(Box|Target))|-(hanging|ideographic|alphabetic|mathematical)|e(ctor-effect|r(sion|t-(origin-([xy])|adv-y)))|alues)|k([123]|e(y(Splines|Times|Points)|rn(ing|el(Matrix|UnitLength)))|4)?|f(y|il(ter(Res|Units)?|l(-(opacity|rule))?)|o(nt-(s(t(yle|retch)|ize(-adjust)?)|variant|family|weight)|rmat)|lood-(color|opacity)|r(om)?|x)|w(idth(s)?|ord-spacing|riting-mode)|l(i(ghting-color|mitingConeAngle)|ocal|e(ngthAdjust|tter-spacing)|ang)|a(scent|cc(umulate|ent-height)|ttribute(Name|Type)|zimuth|dditive|utoReverse|l(ignment-baseline|phabetic|lowReorder)|rabic-form|mplitude)|r(y|otate|e(s(tart|ult)|ndering-intent|peat(Count|Dur)|quired(Extensions|Features)|f([XY]|errerPolicy)|l)|adius|x)?|g([12]|lyph(Ref|-(name|orientation-(horizontal|vertical)))|radient(Transform|Units))|x([12]|ChannelSelector|-height|link:(show|href|t(ype|itle)|a(ctuate|rcrole)|role)|ml:(space|lang|base))?|m(in|ode|e(thod|dia)|a(sk((?:Content|)Units)?|thematical|rker(Height|-(start|end|mid)|Units|Width)|x))|b(y|ias|egin|ase(Profile|line-shift|Frequency)|box))(?![-:\\\\w])\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"begin\":\"([^\\\\x00- \\\"'/<=>\\\\x7F-\\\\x{9F}﷐-﷯￾￿🿾🿿𯿾𯿿𿿾𿿿\\\\x{4FFFE}\\\\x{4FFFF}\\\\x{5FFFE}\\\\x{5FFFF}\\\\x{6FFFE}\\\\x{6FFFF}\\\\x{7FFFE}\\\\x{7FFFF}\\\\x{8FFFE}\\\\x{8FFFF}\\\\x{9FFFE}\\\\x{9FFFF}\\\\x{AFFFE}\\\\x{AFFFF}\\\\x{BFFFE}\\\\x{BFFFF}\\\\x{CFFFE}\\\\x{CFFFF}\\\\x{DFFFE}\\\\x{DFFFF}\\\\x{EFFFE}\\\\x{EFFFF}\\\\x{FFFFE}\\\\x{FFFFF}\\\\x{10FFFE}\\\\x{10FFFF}]+)\",\"beginCaptures\":{\"0\":{\"name\":\"entity.other.attribute-name.html\"}},\"end\":\"(?=\\\\s*+[^=\\\\s])\",\"name\":\"meta.attribute.unrecognized.$1.html\",\"patterns\":[{\"include\":\"#attribute-interior\"}]},{\"match\":\"[^>\\\\s]+\",\"name\":\"invalid.illegal.character-not-allowed-here.html\"}]},\"tags\":{\"patterns\":[{\"include\":\"#comment\"},{\"include\":\"#cdata\"},{\"captures\":{\"0\":{\"name\":\"meta.tag.metadata.svg.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(color-profile|desc|metadata|script|style|title)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.metadata.svg.$2.html\"},{\"begin\":\"(?i)(<)(color-profile|desc|metadata|script|style|title)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.svg.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.svg.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.metadata.svg.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.structure.svg.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(animateMotion|clipPath|defs|feComponentTransfer|feDiffuseLighting|feMerge|feSpecularLighting|filter|g|hatch|linearGradient|marker|mask|mesh|meshgradient|meshpatch|meshrow|pattern|radialGradient|switch|text|textPath)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.structure.svg.$2.html\"},{\"begin\":\"(?i)(<)(animateMotion|clipPath|defs|feComponentTransfer|feDiffuseLighting|feMerge|feSpecularLighting|filter|g|hatch|linearGradient|marker|mask|mesh|meshgradient|meshpatch|meshrow|pattern|radialGradient|switch|text|textPath)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.structure.svg.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.structure.svg.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.structure.svg.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.inline.svg.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(a|animate|discard|feBlend|feColorMatrix|feComposite|feConvolveMatrix|feDisplacementMap|feDistantLight|feDropShadow|feFlood|feFuncA|feFuncB|feFuncG|feFuncR|feGaussianBlur|feMergeNode|feMorphology|feOffset|fePointLight|feSpotLight|feTile|feTurbulence|hatchPath|mpath|set|solidcolor|stop|tspan)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.inline.svg.$2.html\"},{\"begin\":\"(?i)(<)(a|animate|discard|feBlend|feColorMatrix|feComposite|feConvolveMatrix|feDisplacementMap|feDistantLight|feDropShadow|feFlood|feFuncA|feFuncB|feFuncG|feFuncR|feGaussianBlur|feMergeNode|feMorphology|feOffset|fePointLight|feSpotLight|feTile|feTurbulence|hatchPath|mpath|set|solidcolor|stop|tspan)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.inline.svg.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.inline.svg.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.inline.svg.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.object.svg.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(circle|ellipse|feImage|foreignObject|image|line|path|polygon|polyline|rect|symbol|use|view)(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.object.svg.$2.html\"},{\"begin\":\"(?i)(<)(a|circle|ellipse|feImage|foreignObject|image|line|path|polygon|polyline|rect|symbol|use|view)(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.object.svg.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)(\\\\2)\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.object.svg.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.object.svg.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.other.svg.$2.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)((altGlyph|altGlyphDef|altGlyphItem|animateColor|animateTransform|cursor|font|font-face|font-face-format|font-face-name|font-face-src|font-face-uri|glyph|glyphRef|hkern|missing-glyph|tref|vkern))(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.other.svg.$2.html\"},{\"begin\":\"(?i)(<)((altGlyph|altGlyphDef|altGlyphItem|animateColor|animateTransform|cursor|font|font-face|font-face-format|font-face-name|font-face-src|font-face-uri|glyph|glyphRef|hkern|missing-glyph|tref|vkern))(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.other.svg.$2.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)((\\\\2))\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.other.svg.$2.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.other.svg.$2.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"captures\":{\"0\":{\"name\":\"meta.tag.other.invalid.void.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"match\":\"(?i)(<)(([:\\\\w]+))(?=\\\\s|/?>)(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(/>)\",\"name\":\"meta.element.other.invalid.html\"},{\"begin\":\"(?i)(<)((\\\\w[^>\\\\s]*))(?=\\\\s|/?>)(?:(([^\\\"'>]|\\\"[^\\\"]*\\\"|'[^']*')*)(>))?\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.other.invalid.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"patterns\":[{\"include\":\"#attribute\"}]},\"6\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(?i)(</)((\\\\2))\\\\s*(>)|(/>)|(?=</\\\\w+)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.other.invalid.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"},\"5\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.element.other.invalid.html\",\"patterns\":[{\"begin\":\"(?<!>)\\\\G\",\"end\":\"(?=/>)|>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.invalid.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#tags\"}]},{\"include\":\"#tags-invalid\"}]}}},\"tags-invalid\":{\"patterns\":[{\"begin\":\"(</?)((\\\\w[^>\\\\s]*))(?<!/)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.unrecognized-tag.html\"}},\"end\":\"((?: ?/)?>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.$2.html\",\"patterns\":[{\"include\":\"#attribute\"}]}]},\"tags-valid\":{\"patterns\":[{\"begin\":\"(^[\\\\t ]+)?(?=<(?i:style)\\\\b(?!-))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.embedded.leading.html\"}},\"end\":\"(?!\\\\G)([\\\\t ]*$\\\\n?)?\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.embedded.trailing.html\"}},\"patterns\":[{\"begin\":\"(?i)(<)(style)(?=\\\\s|/?>)\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.style.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"(?i)((<)/)(style)\\\\s*(>)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.style.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"source.css-ignored-vscode\"},\"3\":{\"name\":\"entity.name.tag.html\"},\"4\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.embedded.block.html\",\"patterns\":[{\"begin\":\"\\\\G\",\"captures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"(>)\",\"name\":\"meta.tag.metadata.style.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?!\\\\G)\",\"end\":\"(?=</(?i:style))\",\"name\":\"source.css\",\"patterns\":[{\"include\":\"source.css\"}]}]}]},{\"begin\":\"(^[\\\\t ]+)?(?=<(?i:script)\\\\b(?!-))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.embedded.leading.html\"}},\"end\":\"(?!\\\\G)([\\\\t ]*$\\\\n?)?\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.embedded.trailing.html\"}},\"patterns\":[{\"begin\":\"(<)((?i:script))\\\\b\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"(/)((?i:script))(>)\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.embedded.block.html\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=/)\",\"patterns\":[{\"begin\":\"(>)\",\"beginCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.start.html\"},\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"end\":\"((<))(?=/(?i:script))\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"source.js-ignored-vscode\"}},\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=</(?i:script))\",\"name\":\"source.js\",\"patterns\":[{\"begin\":\"(^[\\\\t ]+)?(?=//)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.whitespace.comment.leading.js\"}},\"end\":\"(?!\\\\G)\",\"patterns\":[{\"begin\":\"//\",\"beginCaptures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"(?=<\/script)|\\\\n\",\"name\":\"comment.line.double-slash.js\"}]},{\"begin\":\"/\\\\*\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.js\"}},\"end\":\"\\\\*/|(?=<\/script)\",\"name\":\"comment.block.js\"},{\"include\":\"source.js\"}]}]},{\"begin\":\"\\\\G\",\"end\":\"(?i:(?=>|type(?=[=\\\\s])(?!\\\\s*=\\\\s*(''|\\\"\\\"|([\\\"']?)(text/(javascript(1\\\\.[0-5])?|x-javascript|jscript|livescript|(x-)?ecmascript|babel)|application/((?:(x-)?jav|(x-)?ecm)ascript)|module)[\\\"'>\\\\s]))))\",\"name\":\"meta.tag.metadata.script.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i:(?=type\\\\s*=\\\\s*([\\\"']?)text/(x-handlebars|(x-(handlebars-)?|ng-)?template|html)[\\\"'>\\\\s]))\",\"end\":\"((<))(?=/(?i:script))\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"text.html.basic\"}},\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.script.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?!\\\\G)\",\"end\":\"(?=</(?i:script))\",\"name\":\"text.html.basic\",\"patterns\":[{\"include\":\"text.html.basic\"}]}]},{\"begin\":\"(?=(?i:type))\",\"end\":\"(<)(?=/(?i:script))\",\"endCaptures\":{\"0\":{\"name\":\"meta.tag.metadata.script.end.html\"},\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"}},\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.script.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?!\\\\G)\",\"end\":\"(?=</(?i:script))\",\"name\":\"source.unknown\"}]}]}]}]},{\"begin\":\"(?i)(<)(base|link|meta)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(noscript|title)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)(noscript|title)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(col|hr|input)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(address|article|aside|blockquote|body|button|caption|colgroup|datalist|dd|details|dialog|div|dl|dt|fieldset|figcaption|figure|footer|form|head|header|hgroup|html|h[1-6]|label|legend|li|main|map|menu|meter|nav|ol|optgroup|option|output|p|pre|progress|section|select|slot|summary|table|tbody|td|template|textarea|tfoot|th|thead|tr|ul)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)(address|article|aside|blockquote|body|button|caption|colgroup|datalist|dd|details|dialog|div|dl|dt|fieldset|figcaption|figure|footer|form|head|header|hgroup|html|h[1-6]|label|legend|li|main|map|menu|meter|nav|ol|optgroup|option|output|p|pre|progress|section|select|slot|summary|table|tbody|td|template|textarea|tfoot|th|thead|tr|ul)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(area|br|wbr)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(a|abbr|b|bdi|bdo|cite|code|data|del|dfn|em|i|ins|kbd|mark|q|rp|rt|ruby|s|samp|small|span|strong|sub|sup|time|u|var)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)(a|abbr|b|bdi|bdo|cite|code|data|del|dfn|em|i|ins|kbd|mark|q|rp|rt|ruby|s|samp|small|span|strong|sub|sup|time|u|var)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(embed|img|param|source|track)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)(audio|canvas|iframe|object|picture|video)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)(audio|canvas|iframe|object|picture|video)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((basefont|isindex))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.metadata.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((center|frameset|noembed|noframes))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)((center|frameset|noembed|noframes))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.structure.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((acronym|big|blink|font|strike|tt|xmp))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)((acronym|big|blink|font|strike|tt|xmp))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.inline.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((frame))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.void.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((applet))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)((applet))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.deprecated.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.object.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(<)((dir|keygen|listing|menuitem|plaintext|spacer))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.no-longer-supported.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.$2.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(?i)(</)((dir|keygen|listing|menuitem|plaintext|spacer))(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"},\"3\":{\"name\":\"invalid.illegal.no-longer-supported.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.$2.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"include\":\"#math\"},{\"include\":\"#svg\"},{\"begin\":\"(<)([A-Za-z][.0-9A-Z_a-z·À-ÖØ-öø-ͽͿ-῿‌‍‿⁀⁰-↏Ⰰ-⿯、-퟿豈-﷏ﷰ-�𐀀-\\\\x{EFFFF}]*-[-.0-9A-Z_a-z·À-ÖØ-öø-ͽͿ-῿‌‍‿⁀⁰-↏Ⰰ-⿯、-퟿豈-﷏ﷰ-�𐀀-\\\\x{EFFFF}]*)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.custom.start.html\",\"patterns\":[{\"include\":\"#attribute\"}]},{\"begin\":\"(</)([A-Za-z][.0-9A-Z_a-z·À-ÖØ-öø-ͽͿ-῿‌‍‿⁀⁰-↏Ⰰ-⿯、-퟿豈-﷏ﷰ-�𐀀-\\\\x{EFFFF}]*-[-.0-9A-Z_a-z·À-ÖØ-öø-ͽͿ-῿‌‍‿⁀⁰-↏Ⰰ-⿯、-퟿豈-﷏ﷰ-�𐀀-\\\\x{EFFFF}]*)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\">\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.custom.end.html\",\"patterns\":[{\"include\":\"#attribute\"}]}]},\"xml-processing\":{\"begin\":\"(<\\\\?)(xml)\",\"captures\":{\"1\":{\"name\":\"punctuation.definition.tag.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"(\\\\?>)\",\"name\":\"meta.tag.metadata.processing.xml.html\",\"patterns\":[{\"include\":\"#attribute\"}]}},\"scopeName\":\"text.html.basic\",\"embeddedLangs\":[\"javascript\",\"css\"]}"));
var html_default = [
	...javascript_default,
	...css_default,
	lang$6
];
//#endregion
//#region ../../node_modules/@shikijs/langs/dist/html-derivative.mjs
var lang$5 = Object.freeze(JSON.parse("{\"displayName\":\"HTML (Derivative)\",\"injections\":{\"R:text.html - (comment.block, text.html meta.embedded, meta.tag.*.*.html, meta.tag.*.*.*.html, meta.tag.*.*.*.*.html)\":{\"patterns\":[{\"match\":\"<\",\"name\":\"invalid.illegal.bad-angle-bracket.html\"}]}},\"name\":\"html-derivative\",\"patterns\":[{\"include\":\"text.html.basic#core-minus-invalid\"},{\"begin\":\"(</?)(\\\\w[^<>\\\\s]*)(?<!/)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"},\"2\":{\"name\":\"entity.name.tag.html\"}},\"end\":\"((?: ?/)?>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"meta.tag.other.unrecognized.html.derivative\",\"patterns\":[{\"include\":\"text.html.basic#attribute\"}]}],\"scopeName\":\"text.html.derivative\",\"embeddedLangs\":[\"html\"]}"));
var html_derivative_default = [...html_default, lang$5];
var markdown_vue_default = [Object.freeze(JSON.parse("{\"fileTypes\":[],\"injectTo\":[\"text.html.markdown\"],\"injectionSelector\":\"L:text.html.markdown\",\"name\":\"markdown-vue\",\"patterns\":[{\"include\":\"#vue-code-block\"}],\"repository\":{\"vue-code-block\":{\"begin\":\"(^|\\\\G)(\\\\s*)(`{3,}|~{3,})\\\\s*(?i:(vue)((\\\\s+|[,:?{])[^`~]*)?$)\",\"beginCaptures\":{\"3\":{\"name\":\"punctuation.definition.markdown\"},\"4\":{\"name\":\"fenced_code.block.language.markdown\"},\"5\":{\"name\":\"fenced_code.block.language.attributes.markdown\",\"patterns\":[]}},\"end\":\"(^|\\\\G)(\\\\2|\\\\s{0,3})(\\\\3)\\\\s*$\",\"endCaptures\":{\"3\":{\"name\":\"punctuation.definition.markdown\"}},\"name\":\"markup.fenced_code.block.markdown\",\"patterns\":[{\"include\":\"text.html.vue\"}]}},\"scopeName\":\"markdown.vue.codeblock\"}"))];
var vue_directives_default = [Object.freeze(JSON.parse("{\"fileTypes\":[],\"injectTo\":[\"source.vue\",\"text.html.markdown\",\"text.html.derivative\",\"text.pug\"],\"injectionSelector\":\"L:meta.tag -meta.attribute -meta.ng-binding -entity.name.tag.pug -attribute_value -source.tsx -source.js.jsx, L:meta.element -meta.attribute\",\"name\":\"vue-directives\",\"patterns\":[{\"include\":\"text.html.vue#vue-directives\"}],\"scopeName\":\"vue.directives\"}"))];
var vue_interpolations_default = [Object.freeze(JSON.parse("{\"fileTypes\":[],\"injectTo\":[\"source.vue\",\"text.html.markdown\",\"text.html.derivative\",\"text.pug\"],\"injectionSelector\":\"L:text.pug -comment -string.comment, L:text.html.derivative -comment.block, L:text.html.markdown -comment.block\",\"name\":\"vue-interpolations\",\"patterns\":[{\"include\":\"text.html.vue#vue-interpolations\"}],\"scopeName\":\"vue.interpolations\"}"))];
//#endregion
//#region ../../node_modules/@shikijs/langs/dist/vue-sfc-style-variable-injection.mjs
var lang$1 = Object.freeze(JSON.parse("{\"fileTypes\":[],\"injectTo\":[\"source.vue\"],\"injectionSelector\":\"L:source.css -comment, L:source.postcss -comment, L:source.sass -comment, L:source.stylus -comment\",\"name\":\"vue-sfc-style-variable-injection\",\"patterns\":[{\"include\":\"#vue-sfc-style-variable-injection\"}],\"repository\":{\"vue-sfc-style-variable-injection\":{\"begin\":\"\\\\b(v-bind)\\\\s*\\\\(\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.function\"}},\"end\":\"\\\\)\",\"name\":\"vue.sfc.style.variable.injection.v-bind\",\"patterns\":[{\"begin\":\"([\\\"'])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html\"}},\"end\":\"(\\\\1)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html\"}},\"name\":\"source.ts.embedded.html.vue\",\"patterns\":[{\"include\":\"source.js\"}]},{\"include\":\"source.js\"}]}},\"scopeName\":\"vue.sfc.style.variable.injection\",\"embeddedLangs\":[\"javascript\"]}"));
var vue_sfc_style_variable_injection_default = [...javascript_default, lang$1];
//#endregion
//#region ../../node_modules/@shikijs/langs/dist/vue.mjs
var lang = Object.freeze(JSON.parse("{\"displayName\":\"Vue\",\"name\":\"vue\",\"patterns\":[{\"include\":\"#vue-comments\"},{\"include\":\"#self-closing-tag\"},{\"begin\":\"(<)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"}},\"end\":\"(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"patterns\":[{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)md\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"text.html.markdown\",\"patterns\":[{\"include\":\"text.html.markdown\"}]}]},{\"begin\":\"(?!template(?![-0-:A-Za-z]))([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)html\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"contentName\":\"text.html.derivative\",\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"include\":\"#html-stuff\"}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)pug\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"text.pug\",\"patterns\":[{\"include\":\"text.pug\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)stylus\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.stylus\",\"patterns\":[{\"include\":\"source.stylus\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)postcss\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.postcss\",\"patterns\":[{\"include\":\"source.postcss\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)sass\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.sass\",\"patterns\":[{\"include\":\"source.sass\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)css\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.css\",\"patterns\":[{\"include\":\"source.css\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)scss\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.css.scss\",\"patterns\":[{\"include\":\"source.css.scss\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)less\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.css.less\",\"patterns\":[{\"include\":\"source.css.less\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)js\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.js\",\"patterns\":[{\"include\":\"source.js\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)ts\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)(?=[^\\\\n]*<\/script[>\\\\s])\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.ts\",\"patterns\":[{\"include\":\"source.ts\"}]},{\"begin\":\"(?<=>)\",\"name\":\"source.ts\",\"patterns\":[{\"include\":\"source.ts\"}],\"while\":\"^(?!\\\\s*<\/script[>\\\\s])\"}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)jsx\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.js.jsx\",\"patterns\":[{\"include\":\"source.js.jsx\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)tsx\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)(?=[^\\\\n]*<\/script[>\\\\s])\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.tsx\",\"patterns\":[{\"include\":\"source.tsx\"}]},{\"begin\":\"(?<=>)\",\"name\":\"source.tsx\",\"patterns\":[{\"include\":\"source.tsx\"}],\"while\":\"^(?!\\\\s*<\/script[>\\\\s])\"}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)coffee\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.coffee\",\"patterns\":[{\"include\":\"source.coffee\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)json\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.json\",\"patterns\":[{\"include\":\"source.json\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)jsonc\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.json.comments\",\"patterns\":[{\"include\":\"source.json.comments\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)json5\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.json5\",\"patterns\":[{\"include\":\"source.json5\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)yaml\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.yaml\",\"patterns\":[{\"include\":\"source.yaml\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)toml\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.toml\",\"patterns\":[{\"include\":\"source.toml\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)(g(?:ql|raphql))\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"source.graphql\",\"patterns\":[{\"include\":\"source.graphql\"}]}]},{\"begin\":\"([-0-:A-Za-z]+)\\\\b(?=[^>]*\\\\blang\\\\s*=\\\\s*([\\\"']?)vue\\\\b\\\\2)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"text.html.vue\",\"patterns\":[{\"include\":\"text.html.vue\"}]}]},{\"begin\":\"(template)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</template[>\\\\s])\",\"name\":\"text.html.derivative\",\"patterns\":[{\"include\":\"#html-stuff\"}]}]},{\"begin\":\"(script)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#multi-line-script-tag-stuff\"}]},{\"begin\":\"(style)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#multi-line-style-tag-stuff\"}]},{\"begin\":\"([-0-:A-Za-z]+)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.name.tag.$1.html.vue\"}},\"end\":\"(</)(\\\\1)\\\\s*(?=>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</)\",\"name\":\"text\"}]}]}],\"repository\":{\"capitalized-tag\":{\"begin\":\"(<)([A-Z][-0-:A-Za-z]*)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.html.vue\"}},\"end\":\"/?>\",\"endCaptures\":{\"0\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.tag.structure.$2.start.html.vue\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=/?>)\",\"patterns\":[{\"include\":\"#vue-directives\"},{\"include\":\"text.html.basic#attribute\"}]}]},\"html-stuff\":{\"patterns\":[{\"include\":\"#template-tag\"},{\"include\":\"#capitalized-tag\"},{\"include\":\"text.html.derivative\"},{\"include\":\"text.html.basic\"}]},\"multi-line-script-tag-stuff\":{\"begin\":\"\\\\G\",\"end\":\"(?=<\/script[>\\\\s])\",\"patterns\":[{\"begin\":\"\\\\G(?!\\\\blang\\\\s*=\\\\s*[\\\"']?(?:tsx??|jsx|coffee)\\\\b)\",\"end\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?(?:tsx??|jsx|coffee)\\\\b)|(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.tag-stuff\",\"patterns\":[{\"include\":\"#vue-directives\"},{\"include\":\"text.html.basic#attribute\"}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?ts\\\\b)\",\"end\":\"(?=<\/script[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)(?=[^\\\\n]*<\/script[>\\\\s])\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.ts\",\"patterns\":[{\"include\":\"source.ts\"}]},{\"begin\":\"(?<=>)\",\"name\":\"source.ts\",\"patterns\":[{\"include\":\"source.ts\"}],\"while\":\"^(?!\\\\s*<\/script[>\\\\s])\"}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?tsx\\\\b)\",\"end\":\"(?=<\/script[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)(?=[^\\\\n]*<\/script[>\\\\s])\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.tsx\",\"patterns\":[{\"include\":\"source.tsx\"}]},{\"begin\":\"(?<=>)\",\"name\":\"source.tsx\",\"patterns\":[{\"include\":\"source.tsx\"}],\"while\":\"^(?!\\\\s*<\/script[>\\\\s])\"}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?jsx\\\\b)\",\"end\":\"(?=<\/script[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.js.jsx\",\"patterns\":[{\"include\":\"source.js.jsx\"}]}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?coffee\\\\b)\",\"end\":\"(?=<\/script[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.coffee\",\"patterns\":[{\"include\":\"source.coffee\"}]}]},{\"begin\":\"(?<=>)\",\"end\":\"(?=<\/script[>\\\\s])\",\"name\":\"source.js\",\"patterns\":[{\"include\":\"source.js\"}]}]},\"multi-line-style-tag-stuff\":{\"begin\":\"\\\\G\",\"end\":\"(?=</style[>\\\\s])\",\"patterns\":[{\"begin\":\"\\\\G(?!\\\\blang\\\\s*=\\\\s*[\\\"']?(?:scss|stylus|less|postcss)\\\\b)\",\"end\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?(?:scss|stylus|less|postcss)\\\\b)|(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.tag-stuff\",\"patterns\":[{\"include\":\"#vue-directives\"},{\"include\":\"text.html.basic#attribute\"}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?scss\\\\b)\",\"end\":\"(?=</style[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</style[>\\\\s])\",\"name\":\"source.css.scss\",\"patterns\":[{\"include\":\"source.css.scss\"}]}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?stylus\\\\b)\",\"end\":\"(?=</style[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</style[>\\\\s])\",\"name\":\"source.stylus\",\"patterns\":[{\"include\":\"source.stylus\"}]}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?less\\\\b)\",\"end\":\"(?=</style[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</style[>\\\\s])\",\"name\":\"source.css.less\",\"patterns\":[{\"include\":\"source.css.less\"}]}]},{\"begin\":\"(?=\\\\blang\\\\s*=\\\\s*[\\\"']?postcss\\\\b)\",\"end\":\"(?=</style[>\\\\s])\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"begin\":\"(?<=>)\",\"end\":\"(?=</style[>\\\\s])\",\"name\":\"source.postcss\",\"patterns\":[{\"include\":\"source.postcss\"}]}]},{\"begin\":\"(?<=>)\",\"end\":\"(?=</style[>\\\\s])\",\"name\":\"source.css\",\"patterns\":[{\"include\":\"source.css\"}]}]},\"self-closing-tag\":{\"begin\":\"(<)([-0-:A-Za-z]+)(?=([^>]+/>))\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"end\":\"(/>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"self-closing-tag\",\"patterns\":[{\"include\":\"#tag-stuff\"}]},\"tag-stuff\":{\"begin\":\"\\\\G\",\"end\":\"(?=/>)|(>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.tag-stuff\",\"patterns\":[{\"include\":\"#vue-directives\"},{\"include\":\"text.html.basic#attribute\"}]},\"template-tag\":{\"patterns\":[{\"include\":\"#template-tag-1\"},{\"include\":\"#template-tag-2\"}]},\"template-tag-1\":{\"begin\":\"(<)(template)\\\\b(>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"},\"3\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"end\":\"(/?>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.template-tag.start\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=/>)|((</)(template)(?=[>\\\\s]))\",\"endCaptures\":{\"2\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"3\":{\"name\":\"entity.name.tag.$3.html.vue\"}},\"name\":\"meta.template-tag.end\",\"patterns\":[{\"include\":\"#html-stuff\"}]}]},\"template-tag-2\":{\"begin\":\"(<)(template)(?=\\\\s|/?>)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"2\":{\"name\":\"entity.name.tag.$2.html.vue\"}},\"end\":\"(/?>)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.tag.end.html.vue\"}},\"name\":\"meta.template-tag.start\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=/>)|((</)(template)(?=[>\\\\s]))\",\"endCaptures\":{\"2\":{\"name\":\"punctuation.definition.tag.begin.html.vue\"},\"3\":{\"name\":\"entity.name.tag.$3.html.vue\"}},\"name\":\"meta.template-tag.end\",\"patterns\":[{\"include\":\"#tag-stuff\"},{\"include\":\"#html-stuff\"}]}]},\"vue-comments\":{\"patterns\":[{\"include\":\"#vue-comments-key-value\"},{\"begin\":\"<!--\",\"captures\":{\"0\":{\"name\":\"punctuation.definition.comment.vue\"}},\"end\":\"-->\",\"name\":\"comment.block.vue\"}]},\"vue-comments-key-value\":{\"begin\":\"(<!--)\\\\s*(@)([$\\\\w]+)(?=\\\\s)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.vue\"},\"2\":{\"name\":\"punctuation.definition.block.tag.comment.vue\"},\"3\":{\"name\":\"storage.type.class.comment.vue\"}},\"end\":\"(-->)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.comment.vue\"}},\"name\":\"comment.block.vue\",\"patterns\":[{\"include\":\"source.json#value\"}]},\"vue-directives\":{\"patterns\":[{\"include\":\"#vue-directives-control\"},{\"include\":\"#vue-directives-generic-attr\"},{\"include\":\"#vue-directives-style-attr\"},{\"include\":\"#vue-directives-original\"}]},\"vue-directives-control\":{\"begin\":\"(?:(v-for)|(v-(?:if|else-if|else)))(?=[)/=>\\\\s])\",\"beginCaptures\":{\"1\":{\"name\":\"keyword.control.loop.vue\"},\"2\":{\"name\":\"keyword.control.conditional.vue\"}},\"end\":\"(?=\\\\s*[^=\\\\s])\",\"name\":\"meta.attribute.directive.control.vue\",\"patterns\":[{\"include\":\"#vue-directives-expression\"}]},\"vue-directives-expression\":{\"patterns\":[{\"begin\":\"(=)\\\\s*([\\\"'`])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.key-value.html.vue\"},\"2\":{\"name\":\"punctuation.definition.string.begin.html.vue\"}},\"end\":\"(\\\\2)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.html.vue\"}},\"patterns\":[{\"begin\":\"(?<=([\\\"'`]))\",\"end\":\"(?=\\\\1)\",\"name\":\"source.ts.embedded.html.vue\",\"patterns\":[{\"include\":\"source.ts#expression\"}]}]},{\"begin\":\"(=)\\\\s*(?=[^\\\"'`])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.key-value.html.vue\"}},\"end\":\"(?=([>\\\\s]|/>))\",\"patterns\":[{\"begin\":\"(?=[^\\\"'`])\",\"end\":\"(?=([>\\\\s]|/>))\",\"name\":\"source.ts.embedded.html.vue\",\"patterns\":[{\"include\":\"source.ts#expression\"}]}]}]},\"vue-directives-generic-attr\":{\"begin\":\"\\\\b(generic)\\\\s*(=)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.html.vue\"},\"2\":{\"name\":\"punctuation.separator.key-value.html.vue\"}},\"end\":\"(?<=[\\\"'])\",\"name\":\"meta.attribute.generic.vue\",\"patterns\":[{\"begin\":\"([\\\"'])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.html.vue\"}},\"end\":\"(\\\\1)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.html.vue\"}},\"name\":\"meta.type.parameters.vue\",\"patterns\":[{\"include\":\"source.ts#comment\"},{\"match\":\"(?<![$_[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out)(?![$_[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\",\"name\":\"storage.modifier.ts\"},{\"include\":\"source.ts#type\"},{\"include\":\"source.ts#punctuation-comma\"},{\"match\":\"(=)(?!>)\",\"name\":\"keyword.operator.assignment.ts\"}]}]},\"vue-directives-original\":{\"begin\":\"(?:(v-[-\\\\w]+)(:)?|([.:])|(@)|(#))(?:(\\\\[)([^]]*)(])|([-\\\\w]+))?\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.html.vue\"},\"2\":{\"name\":\"punctuation.separator.key-value.html.vue\"},\"3\":{\"name\":\"punctuation.attribute-shorthand.bind.html.vue\"},\"4\":{\"name\":\"punctuation.attribute-shorthand.event.html.vue\"},\"5\":{\"name\":\"punctuation.attribute-shorthand.slot.html.vue\"},\"6\":{\"name\":\"punctuation.separator.key-value.html.vue\"},\"7\":{\"name\":\"source.ts.embedded.html.vue\",\"patterns\":[{\"include\":\"source.ts#expression\"}]},\"8\":{\"name\":\"punctuation.separator.key-value.html.vue\"},\"9\":{\"name\":\"entity.other.attribute-name.html.vue\"}},\"end\":\"(?=\\\\s*[^=\\\\s])\",\"name\":\"meta.attribute.directive.vue\",\"patterns\":[{\"1\":{\"name\":\"punctuation.separator.key-value.html.vue\"},\"2\":{\"name\":\"entity.other.attribute-name.html.vue\"},\"match\":\"(\\\\.)([-\\\\w]*)\"},{\"include\":\"#vue-directives-expression\"}]},\"vue-directives-style-attr\":{\"begin\":\"\\\\b(style)\\\\s*(=)\",\"beginCaptures\":{\"1\":{\"name\":\"entity.other.attribute-name.html.vue\"},\"2\":{\"name\":\"punctuation.separator.key-value.html.vue\"}},\"end\":\"(?<=[\\\"'])\",\"name\":\"meta.attribute.style.vue\",\"patterns\":[{\"begin\":\"([\\\"'])\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.begin.html.vue\"}},\"end\":\"(\\\\1)\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.string.end.html.vue\"}},\"name\":\"source.css.embedded.html.vue\",\"patterns\":[{\"include\":\"source.css#comment-block\"},{\"include\":\"source.css#escapes\"},{\"include\":\"source.css#font-features\"},{\"match\":\"(?<![-\\\\w])--[-A-Z_a-z[^\\\\x00-\\\\x7F]](?:[-0-9A-Z_a-z[^\\\\x00-\\\\x7F]]|\\\\\\\\(?:\\\\h{1,6}|.))*\",\"name\":\"variable.css\"},{\"begin\":\"(?<![-A-Za-z])(?=[-A-Za-z])\",\"end\":\"$|(?![-A-Za-z])\",\"name\":\"meta.property-name.css\",\"patterns\":[{\"include\":\"source.css#property-names\"}]},{\"begin\":\"(:)\\\\s*\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.separator.key-value.css\"}},\"contentName\":\"meta.property-value.css\",\"end\":\"\\\\s*(;)|\\\\s*(?=[\\\"'])\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.terminator.rule.css\"}},\"patterns\":[{\"include\":\"source.css#comment-block\"},{\"include\":\"source.css#property-values\"}]},{\"match\":\";\",\"name\":\"punctuation.terminator.rule.css\"}]}]},\"vue-interpolations\":{\"patterns\":[{\"begin\":\"(\\\\{\\\\{)\",\"beginCaptures\":{\"1\":{\"name\":\"punctuation.definition.interpolation.begin.html.vue\"}},\"end\":\"(}})\",\"endCaptures\":{\"1\":{\"name\":\"punctuation.definition.interpolation.end.html.vue\"}},\"name\":\"expression.embedded.vue\",\"patterns\":[{\"begin\":\"\\\\G\",\"end\":\"(?=}})\",\"name\":\"source.ts.embedded.html.vue\",\"patterns\":[{\"include\":\"source.ts#expression\"}]}]}]}},\"scopeName\":\"text.html.vue\",\"embeddedLangs\":[\"css\",\"javascript\",\"typescript\",\"json\",\"html\",\"html-derivative\",\"markdown-vue\",\"vue-directives\",\"vue-interpolations\",\"vue-sfc-style-variable-injection\"],\"embeddedLangsLazy\":[\"markdown\",\"pug\",\"stylus\",\"sass\",\"scss\",\"less\",\"jsx\",\"tsx\",\"coffee\",\"jsonc\",\"json5\",\"yaml\",\"toml\",\"graphql\"]}"));
var vue_default = [
	...css_default,
	...javascript_default,
	...typescript_default,
	...json_default,
	...html_default,
	...html_derivative_default,
	...markdown_vue_default,
	...vue_directives_default,
	...vue_interpolations_default,
	...vue_sfc_style_variable_injection_default,
	lang
];
//#endregion
//#region ../../node_modules/@shikijs/themes/dist/min-dark.mjs
var min_dark_default = Object.freeze(JSON.parse("{\"colors\":{\"activityBar.background\":\"#1A1A1A\",\"activityBar.foreground\":\"#7D7D7D\",\"activityBarBadge.background\":\"#383838\",\"badge.background\":\"#383838\",\"badge.foreground\":\"#C1C1C1\",\"button.background\":\"#333\",\"debugIcon.breakpointCurrentStackframeForeground\":\"#79b8ff\",\"debugIcon.breakpointDisabledForeground\":\"#848484\",\"debugIcon.breakpointForeground\":\"#FF7A84\",\"debugIcon.breakpointStackframeForeground\":\"#79b8ff\",\"debugIcon.breakpointUnverifiedForeground\":\"#848484\",\"debugIcon.continueForeground\":\"#FF7A84\",\"debugIcon.disconnectForeground\":\"#FF7A84\",\"debugIcon.pauseForeground\":\"#FF7A84\",\"debugIcon.restartForeground\":\"#79b8ff\",\"debugIcon.startForeground\":\"#79b8ff\",\"debugIcon.stepBackForeground\":\"#FF7A84\",\"debugIcon.stepIntoForeground\":\"#FF7A84\",\"debugIcon.stepOutForeground\":\"#FF7A84\",\"debugIcon.stepOverForeground\":\"#FF7A84\",\"debugIcon.stopForeground\":\"#79b8ff\",\"diffEditor.insertedTextBackground\":\"#3a632a4b\",\"diffEditor.removedTextBackground\":\"#88063852\",\"editor.background\":\"#1f1f1f\",\"editor.lineHighlightBorder\":\"#303030\",\"editorGroupHeader.tabsBackground\":\"#1A1A1A\",\"editorGroupHeader.tabsBorder\":\"#1A1A1A\",\"editorIndentGuide.activeBackground\":\"#383838\",\"editorIndentGuide.background\":\"#2A2A2A\",\"editorLineNumber.foreground\":\"#727272\",\"editorRuler.foreground\":\"#2A2A2A\",\"editorSuggestWidget.background\":\"#1A1A1A\",\"focusBorder\":\"#444\",\"foreground\":\"#888888\",\"gitDecoration.ignoredResourceForeground\":\"#444444\",\"input.background\":\"#2A2A2A\",\"input.foreground\":\"#E0E0E0\",\"inputOption.activeBackground\":\"#3a3a3a\",\"list.activeSelectionBackground\":\"#212121\",\"list.activeSelectionForeground\":\"#F5F5F5\",\"list.focusBackground\":\"#292929\",\"list.highlightForeground\":\"#EAEAEA\",\"list.hoverBackground\":\"#262626\",\"list.hoverForeground\":\"#9E9E9E\",\"list.inactiveSelectionBackground\":\"#212121\",\"list.inactiveSelectionForeground\":\"#F5F5F5\",\"panelTitle.activeBorder\":\"#1f1f1f\",\"panelTitle.activeForeground\":\"#FAFAFA\",\"panelTitle.inactiveForeground\":\"#484848\",\"peekView.border\":\"#444\",\"peekViewEditor.background\":\"#242424\",\"pickerGroup.border\":\"#363636\",\"pickerGroup.foreground\":\"#EAEAEA\",\"progressBar.background\":\"#FAFAFA\",\"scrollbar.shadow\":\"#1f1f1f\",\"sideBar.background\":\"#1A1A1A\",\"sideBarSectionHeader.background\":\"#202020\",\"statusBar.background\":\"#1A1A1A\",\"statusBar.debuggingBackground\":\"#1A1A1A\",\"statusBar.foreground\":\"#7E7E7E\",\"statusBar.noFolderBackground\":\"#1A1A1A\",\"statusBarItem.prominentBackground\":\"#fafafa1a\",\"statusBarItem.remoteBackground\":\"#1a1a1a00\",\"statusBarItem.remoteForeground\":\"#7E7E7E\",\"symbolIcon.classForeground\":\"#FF9800\",\"symbolIcon.constructorForeground\":\"#b392f0\",\"symbolIcon.enumeratorForeground\":\"#FF9800\",\"symbolIcon.enumeratorMemberForeground\":\"#79b8ff\",\"symbolIcon.eventForeground\":\"#FF9800\",\"symbolIcon.fieldForeground\":\"#79b8ff\",\"symbolIcon.functionForeground\":\"#b392f0\",\"symbolIcon.interfaceForeground\":\"#79b8ff\",\"symbolIcon.methodForeground\":\"#b392f0\",\"symbolIcon.variableForeground\":\"#79b8ff\",\"tab.activeBorder\":\"#1e1e1e\",\"tab.activeForeground\":\"#FAFAFA\",\"tab.border\":\"#1A1A1A\",\"tab.inactiveBackground\":\"#1A1A1A\",\"tab.inactiveForeground\":\"#727272\",\"terminal.ansiBrightBlack\":\"#5c5c5c\",\"textLink.activeForeground\":\"#fafafa\",\"textLink.foreground\":\"#CCC\",\"titleBar.activeBackground\":\"#1A1A1A\",\"titleBar.border\":\"#00000000\"},\"displayName\":\"Min Dark\",\"name\":\"min-dark\",\"semanticHighlighting\":true,\"tokenColors\":[{\"settings\":{\"foreground\":\"#b392f0\"}},{\"scope\":[\"support.function\",\"keyword.operator.accessor\",\"meta.group.braces.round.function.arguments\",\"meta.template.expression\",\"markup.fenced_code meta.embedded.block\"],\"settings\":{\"foreground\":\"#b392f0\"}},{\"scope\":\"emphasis\",\"settings\":{\"fontStyle\":\"italic\"}},{\"scope\":[\"strong\",\"markup.heading.markdown\",\"markup.bold.markdown\"],\"settings\":{\"fontStyle\":\"bold\",\"foreground\":\"#FF7A84\"}},{\"scope\":[\"markup.italic.markdown\"],\"settings\":{\"fontStyle\":\"italic\"}},{\"scope\":\"meta.link.inline.markdown\",\"settings\":{\"fontStyle\":\"underline\",\"foreground\":\"#1976D2\"}},{\"scope\":[\"string\",\"markup.fenced_code\",\"markup.inline\"],\"settings\":{\"foreground\":\"#9db1c5\"}},{\"scope\":[\"comment\",\"string.quoted.docstring.multi\"],\"settings\":{\"foreground\":\"#6b737c\"}},{\"scope\":[\"constant.language\",\"variable.language.this\",\"variable.other.object\",\"variable.other.class\",\"variable.other.constant\",\"meta.property-name\",\"support\",\"string.other.link.title.markdown\"],\"settings\":{\"foreground\":\"#79b8ff\"}},{\"scope\":[\"constant.numeric\",\"constant.other.placeholder\",\"constant.character.format.placeholder\",\"meta.property-value\",\"keyword.other.unit\",\"keyword.other.template\",\"entity.name.tag.yaml\",\"entity.other.attribute-name\",\"support.type.property-name.json\"],\"settings\":{\"foreground\":\"#f8f8f8\"}},{\"scope\":[\"keyword\",\"storage.modifier\",\"storage.type\",\"storage.control.clojure\",\"entity.name.function.clojure\",\"support.function.node\",\"punctuation.separator.key-value\",\"punctuation.definition.template-expression\"],\"settings\":{\"foreground\":\"#f97583\"}},{\"scope\":\"variable.parameter.function\",\"settings\":{\"foreground\":\"#FF9800\"}},{\"scope\":[\"entity.name.type\",\"entity.other.inherited-class\",\"meta.function-call\",\"meta.instance.constructor\",\"entity.other.attribute-name\",\"entity.name.function\",\"constant.keyword.clojure\"],\"settings\":{\"foreground\":\"#b392f0\"}},{\"scope\":[\"entity.name.tag\",\"string.quoted\",\"string.regexp\",\"string.interpolated\",\"string.template\",\"string.unquoted.plain.out.yaml\",\"keyword.other.template\"],\"settings\":{\"foreground\":\"#ffab70\"}},{\"scope\":\"token.info-token\",\"settings\":{\"foreground\":\"#316bcd\"}},{\"scope\":\"token.warn-token\",\"settings\":{\"foreground\":\"#cd9731\"}},{\"scope\":\"token.error-token\",\"settings\":{\"foreground\":\"#cd3131\"}},{\"scope\":\"token.debug-token\",\"settings\":{\"foreground\":\"#800080\"}},{\"scope\":[\"punctuation.definition.arguments\",\"punctuation.definition.dict\",\"punctuation.separator\",\"meta.function-call.arguments\"],\"settings\":{\"foreground\":\"#bbbbbb\"}},{\"scope\":\"markup.underline.link\",\"settings\":{\"foreground\":\"#ffab70\"}},{\"scope\":[\"beginning.punctuation.definition.list.markdown\"],\"settings\":{\"foreground\":\"#FF7A84\"}},{\"scope\":\"punctuation.definition.metadata.markdown\",\"settings\":{\"foreground\":\"#ffab70\"}},{\"scope\":[\"punctuation.definition.string.begin.markdown\",\"punctuation.definition.string.end.markdown\"],\"settings\":{\"foreground\":\"#79b8ff\"}}],\"type\":\"dark\"}"));
//#endregion
//#region src/components/MarkdownViewer/ProsePre.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$34 = { class: "prose-pre" };
var _hoisted_2$18 = { class: "prose-pre-content" };
//#endregion
//#region src/components/MarkdownViewer/ProsePre.vue
var ProsePre_default = /* @__PURE__ */ defineComponent({
	__name: "ProsePre",
	props: { __node: {} },
	setup(__props) {
		const props = __props;
		async function copyCode() {
			if (props.__node) {
				const text = textContent(props.__node);
				await navigator.clipboard.writeText(text);
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$34, [createElementVNode("button", {
				type: "button",
				class: "copy-code-button",
				onClick: copyCode
			}, [..._cache[0] || (_cache[0] = [createElementVNode("div", { class: "image i-mdi-content-copy image-small" }, null, -1)])]), createElementVNode("div", _hoisted_2$18, [renderSlot(_ctx.$slots, "default")])]);
		};
	}
});
//#endregion
//#region src/components/MarkdownViewer/MarkdownViewer.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$33 = { class: "markdown-viewer" };
//#endregion
//#region src/components/MarkdownViewer/MarkdownViewer.vue
var MarkdownViewer_default = /* @__PURE__ */ defineComponent({
	__name: "MarkdownViewer",
	props: {
		source: { default: void 0 },
		sanitize: {
			type: Boolean,
			default: false
		},
		highlightCode: {
			type: Boolean,
			default: false
		},
		copyCodeButton: {
			type: Boolean,
			default: false
		},
		mermaid: {
			type: Boolean,
			default: false
		},
		streaming: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const value = computed(() => props.source ?? "");
		const plugins = computed(() => {
			const plugins = [];
			if (props.highlightCode) plugins.push(highlightPlugin({
				languages: [
					csharp_default,
					sql_default,
					typescript_default,
					vue_default
				],
				themes: {
					dark: min_dark_default,
					light: min_dark_default
				}
			}));
			if (props.mermaid) plugins.push(mermaidPlugin());
			if (props.sanitize) plugins.push(securityPlugin());
			return plugins;
		});
		const components = computed(() => {
			const components = {};
			if (props.highlightCode && props.copyCodeButton) components.ProsePre = ProsePre_default;
			if (props.mermaid) components.Mermaid = Mermaid;
			return components;
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$33, [(openBlock(), createBlock(Suspense, null, {
				default: withCtx(() => [createVNode(unref(Markdown), {
					value: value.value,
					streaming: __props.streaming,
					plugins: plugins.value,
					components: components.value
				}, null, 8, [
					"value",
					"streaming",
					"plugins",
					"components"
				])]),
				_: 1
			}))]);
		};
	}
});
//#endregion
//#region src/utils/dropdown.ts
/**
* Gets a value indicating whether there is an active dropdown.
* lookup-dropdown: Lookup
* select-dropdown: Select
* wj-dropdown-panel: Wijmo dropdown components
*/
var selectors = ".lookup-dropdown, .select-dropdown, .wj-dropdown-panel, .dropdown-menu";
function isDropdownActive() {
	return !!document.body.querySelector(selectors);
}
function isInDropdown(element) {
	const dropdowns = document.body.querySelectorAll(selectors);
	for (const dropdown of dropdowns) if (dropdown.contains(element)) return true;
	return false;
}
//#endregion
//#region src/components/Popover/popoverEventBus.ts
var hideAllPopoversEventBus = useEventBus("hide-all-popovers");
function hideAllPopovers() {
	hideAllPopoversEventBus.emit();
}
//#endregion
//#region src/components/Popover/Popover.vue?vue&type=script&setup=true&lang.ts
var viewportGutter = 10;
//#endregion
//#region src/components/Popover/Popover.vue
var Popover_default = /* @__PURE__ */ defineComponent({
	__name: "Popover",
	props: { preventHide: { type: Boolean } },
	emits: ["show", "hide"],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const popover = ref();
		const stopListeningToHideAllPopovers = hideAllPopoversEventBus.on(handleHideAllPopovers);
		onBeforeUnmount(() => {
			if (popover.value?.visible) emit("hide");
			stopListeningToHideAllPopovers();
		});
		onClickOutside(popover, (event) => {
			const currentPopover = popover.value;
			if (!currentPopover?.visible) return;
			currentPopover.selfClick = event.target instanceof Element && isInDropdown(event.target) || props.preventHide === true;
		}, { capture: true });
		function toggle(event, options = {}) {
			popover.value.toggle(event, options.positionTarget);
			if (options.hideOthers) hideAllPopoversEventBus.emit({
				instance: popover.value,
				target: options.positionTarget ?? event.currentTarget
			});
		}
		function show(event, options = {}) {
			popover.value.show(event, options.positionTarget);
		}
		function hide() {
			popover.value.hide();
		}
		function handleShow() {
			const container = popover.value.container;
			const content = container.querySelector(".p-popover-content");
			const targetRect = popover.value.target.getBoundingClientRect();
			const viewportTop = window.visualViewport?.offsetTop ?? 0;
			const viewportBottom = viewportTop + (window.visualViewport?.height ?? window.innerHeight);
			const availableHeight = Math.max(viewportBottom - targetRect.bottom, targetRect.top - viewportTop) - viewportGutter;
			const chromeHeight = container.offsetHeight - content.offsetHeight;
			content.style.maxHeight = `${Math.max(0, availableHeight - chromeHeight)}px`;
			container.removeAttribute("data-p-popover-flipped");
			container.classList.remove("p-popover-flipped");
			popover.value.alignOverlay();
			popover.value.selfClick = true;
			emit("show");
		}
		function handleHide() {
			emit("hide");
		}
		function handleHideAllPopovers(popoverToKeep) {
			const currentPopover = popover.value;
			if (!currentPopover?.visible) return;
			const popoverTarget = popoverToKeep?.target;
			const containsPopoverToKeep = popoverTarget != null && currentPopover.container?.contains(popoverTarget) === true;
			if (popoverToKeep?.instance !== currentPopover && !containsPopoverToKeep) hide();
		}
		__expose({
			popover,
			toggle,
			show,
			hide
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimePopover), {
				ref_key: "popover",
				ref: popover,
				onShow: handleShow,
				onHide: handleHide
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/PopoverWithTarget/PopoverWithTarget.vue
var PopoverWithTarget_default = /* @__PURE__ */ defineComponent({
	__name: "PopoverWithTarget",
	props: {
		"target": { default: null },
		"targetModifiers": {}
	},
	emits: ["update:target"],
	setup(__props) {
		const target = useModel(__props, "target");
		const popoverElement = useTemplateRef("popover");
		watch([popoverElement, target], ([popover, currentTarget]) => {
			if (popover) {
				if (currentTarget) popover.show({ currentTarget });
				else popover.hide();
			}
		}, { immediate: true });
		function handleHide() {
			target.value = null;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				ref: "popover",
				onHide: handleHide
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/VerticalLayout/VerticalLayout.ts?vue&type=script&src=true&lang.ts
var VerticalLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "VerticalLayout",
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		},
		verticalAlign: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		return { style: computed(() => ({
			[`--vertical-space`]: SpaceValues[props.space],
			[`--vertical-align`]: AlignValues[props.align],
			...props.verticalAlign && { justifyContent: VerticalAlignValues[props.verticalAlign] }
		})) };
	}
});
//#endregion
//#region src/components/VerticalLayout/VerticalLayout.vue
function _sfc_render$29(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "vertical-layout",
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default")], 4);
}
var VerticalLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(VerticalLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$29]]);
//#endregion
//#region src/components/AiSuggestionIndicator/AiSuggestionIndicator.vue
var AiSuggestionIndicator_default = /* @__PURE__ */ defineComponent({
	__name: "AiSuggestionIndicator",
	props: {
		suggestion: { default: void 0 },
		animated: {
			type: Boolean,
			default: true
		}
	},
	emits: ["apply", "cancel"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const popoverTarget = shallowRef(null);
		const popoverContent = shallowRef(null);
		const indicatorElement = shallowRef(null);
		let closeTimeout = null;
		let primePopoverEl = null;
		function cancelCloseTimeout() {
			if (closeTimeout) {
				clearTimeout(closeTimeout);
				closeTimeout = null;
			}
		}
		function isMouseOverElement(element) {
			return element?.matches(":hover") ?? false;
		}
		function scheduleClose() {
			cancelCloseTimeout();
			closeTimeout = setTimeout(() => {
				if (!isMouseOverElement(indicatorElement.value) && !isMouseOverElement(primePopoverEl)) popoverTarget.value = null;
			}, 200);
		}
		function handlePopoverMouseEnter() {
			cancelCloseTimeout();
		}
		function handlePopoverMouseLeave() {
			scheduleClose();
		}
		watch(popoverContent, (content) => {
			if (primePopoverEl) {
				primePopoverEl.removeEventListener("mouseenter", handlePopoverMouseEnter);
				primePopoverEl.removeEventListener("mouseleave", handlePopoverMouseLeave);
				primePopoverEl = null;
			}
			if (content) setTimeout(() => {
				primePopoverEl = content.$el?.closest(".p-popover");
				if (primePopoverEl) {
					primePopoverEl.addEventListener("mouseenter", handlePopoverMouseEnter);
					primePopoverEl.addEventListener("mouseleave", handlePopoverMouseLeave);
				}
			}, 0);
		});
		function handleIndicatorMouseEnter(event) {
			cancelCloseTimeout();
			if (popoverTarget.value) return;
			popoverTarget.value = event.currentTarget;
		}
		function handleIndicatorMouseLeave() {
			scheduleClose();
		}
		function handleCancel() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("cancel");
		}
		function handleApply() {
			cancelCloseTimeout();
			popoverTarget.value = null;
			emit("apply");
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [props.suggestion ? (openBlock(), createElementBlock("span", {
				key: 0,
				ref_key: "indicatorElement",
				ref: indicatorElement,
				class: normalizeClass(["ai-suggestion-indicator", { "is-animated": props.animated }]),
				onMouseenter: handleIndicatorMouseEnter,
				onMouseleave: handleIndicatorMouseLeave
			}, [createVNode(Image_default, {
				name: "ai",
				size: "extrasmall"
			})], 34)) : createCommentVNode("", true), props.suggestion ? (openBlock(), createBlock(PopoverWithTarget_default, {
				key: 1,
				target: popoverTarget.value,
				"onUpdate:target": _cache[0] || (_cache[0] = ($event) => popoverTarget.value = $event)
			}, {
				default: withCtx(() => [createVNode(VerticalLayout_default, {
					ref_key: "popoverContent",
					ref: popoverContent,
					space: "small",
					class: "ai-suggestion-popover"
				}, {
					default: withCtx(() => [
						createVNode(Text_default, null, {
							default: withCtx(() => [createTextVNode(toDisplayString(unref(translate)("AiSuggestion")), 1)]),
							_: 1
						}),
						props.suggestion?.text ? (openBlock(), createBlock(MarkdownViewer_default, {
							key: 0,
							class: "ai-suggestion-markdown",
							source: props.suggestion.text,
							sanitize: true
						}, null, 8, ["source"])) : createCommentVNode("", true),
						createVNode(HorizontalLayout_default, {
							align: "right",
							class: "neos-fill-parent-width"
						}, {
							default: withCtx(() => [createVNode(ButtonsLayout_default, null, {
								default: withCtx(() => [createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "check",
									animated: "",
									label: unref(translate)("Apply"),
									onClick: handleApply
								}, null, 8, ["label"]), createVNode(Button_default, {
									variant: "default",
									size: "small",
									icon: "reset",
									animated: "",
									onClick: handleCancel
								})]),
								_: 1
							})]),
							_: 1
						})
					]),
					_: 1
				}, 512)]),
				_: 1
			}, 8, ["target"])) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
//#region src/composables/useModal.ts
function useModal() {
	const isOpen = ref(false);
	function open() {
		isOpen.value = true;
	}
	function close() {
		isOpen.value = false;
	}
	return {
		isOpen,
		open,
		close
	};
}
//#endregion
//#region src/components/Modal/Modal.vue
var Modal_default = /* @__PURE__ */ defineComponent({
	inheritAttrs: false,
	__name: "Modal",
	props: {
		isOpen: { type: Boolean },
		dismissOnClickOutside: {
			type: Boolean,
			default: false
		},
		size: { default: "auto" },
		dismissible: {
			type: Boolean,
			default: false
		},
		position: { default: "center" },
		maximizable: {
			type: Boolean,
			default: true
		},
		focus: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:isOpen", "close"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const isDisplayed = computed({
			get: () => props.isOpen,
			set: (value) => {
				emit("update:isOpen", value);
				emit("close");
			}
		});
		const sizeClass = computed(() => props.size === "full" ? `modal-full-size` : void 0);
		const headerActionsStyle = computed(() => !props.dismissible && !props.maximizable ? "display: none" : void 0);
		const root = ref();
		useComponentAutomationProperties(root);
		watch(root, (r) => {
			if (!props.focus) r.onAfterEnter = () => void 0;
		});
		function onEscape() {
			if (props.dismissible) isDisplayed.value = false;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeDialog), mergeProps({
				ref_key: "root",
				ref: root,
				visible: isDisplayed.value,
				"onUpdate:visible": _cache[0] || (_cache[0] = ($event) => isDisplayed.value = $event)
			}, _ctx.$attrs, {
				modal: "",
				"dismissable-mask": __props.dismissOnClickOutside,
				closable: __props.dismissible,
				"close-on-escape": false,
				class: ["modal", sizeClass.value],
				position: __props.position,
				draggable: false,
				maximizable: __props.maximizable,
				pt: {
					header: { class: "neos-horizontal-content" },
					footer: { class: "neos-horizontal-content" },
					content: { class: "modal-body neos-vertical-content" },
					headerActions: { style: headerActionsStyle.value }
				},
				onKeydown: withKeys(onEscape, ["esc"])
			}), createSlots({
				default: withCtx(() => [renderSlot(_ctx.$slots, "body")]),
				_: 2
			}, [_ctx.$slots.header ? {
				name: "header",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
				key: "0"
			} : void 0, _ctx.$slots.footer ? {
				name: "footer",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
				key: "1"
			} : void 0]), 1040, [
				"visible",
				"dismissable-mask",
				"closable",
				"position",
				"class",
				"maximizable",
				"pt"
			]);
		};
	}
});
//#endregion
//#region src/components/InputDocumentationButton/InputDocumentationButton.ts?vue&type=script&src=true&lang.ts
var InputDocumentationButton_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDocumentationButton",
	components: {
		Button: Button_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		Text: Text_default
	},
	setup() {
		const { translate } = useGlobalResourceManager();
		const { isOpen, open, close } = useModal();
		return {
			translate,
			isOpen,
			open,
			close
		};
	}
});
//#endregion
//#region src/components/InputDocumentationButton/InputDocumentationButton.vue
function _sfc_render$28(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Image = resolveComponent("Image");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_Button, {
		variant: "link",
		icon: "info",
		size: "extrasmall",
		class: "input-documentation-button",
		tabindex: "-1",
		onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.open(), ["stop"]))
	}), createVNode(_component_Modal, {
		"is-open": _ctx.isOpen,
		"onUpdate:isOpen": _cache[1] || (_cache[1] = ($event) => _ctx.isOpen = $event),
		class: "input-documentation-modal",
		dismissible: true,
		maximizable: false,
		"dismiss-on-click-outside": true,
		onClose: _cache[2] || (_cache[2] = ($event) => _ctx.close())
	}, {
		header: withCtx(() => [createVNode(_component_HorizontalLayout, { "vertical-align": "center" }, {
			default: withCtx(() => [createVNode(_component_Image, {
				name: "info",
				size: "extralarge",
				class: "input-documentation-modal-icon"
			}), createVNode(_component_Text, {
				size: "extralarge",
				weight: "strong"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
				_: 3
			})]),
			_: 3
		})]),
		body: withCtx(() => [renderSlot(_ctx.$slots, "body", {}, void 0, true)]),
		_: 3
	}, 8, ["is-open"])], 64);
}
var InputDocumentationButton_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputDocumentationButton_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$28], ["__scopeId", "data-v-089db859"]]);
//#endregion
//#region src/components/InputLabel/InputLabel.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$32 = ["for"];
var _hoisted_2$17 = {
	key: 0,
	class: "input-label-required"
};
//#endregion
//#region src/components/InputLabel/InputLabel.vue
var InputLabel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputLabel",
	props: /*@__PURE__*/ mergeDefaults({
		size: {},
		weight: {},
		label: {},
		required: { type: Boolean },
		documentation: {},
		htmlFor: {},
		aiSuggestion: {}
	}, {
		...smallTextPropsDefaults,
		documentation: void 0,
		htmlFor: void 0,
		aiSuggestion: void 0
	}),
	emits: ["aiApply", "aiCancel"],
	setup(__props) {
		const { classes } = useText(__props);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				space: "extrasmall",
				"vertical-align": "center",
				wrap: false,
				class: "input-label"
			}, {
				default: withCtx(() => [
					createElementVNode("label", {
						for: __props.htmlFor,
						class: normalizeClass(unref(classes))
					}, [
						createTextVNode(toDisplayString(__props.label) + " ", 1),
						createVNode(AiSuggestionIndicator_default, {
							suggestion: __props.aiSuggestion,
							onApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
							onCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
						}, null, 8, ["suggestion"]),
						__props.required ? (openBlock(), createElementBlock("span", _hoisted_2$17, " *")) : createCommentVNode("", true)
					], 10, _hoisted_1$32),
					__props.documentation ? (openBlock(), createBlock(InputDocumentationButton_default, { key: 0 }, {
						header: withCtx(() => [createTextVNode(toDisplayString(__props.label), 1)]),
						body: withCtx(() => [createVNode(MarkdownViewer_default, {
							source: __props.documentation,
							sanitize: true
						}, null, 8, ["source"])]),
						_: 1
					})) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "default", {}, void 0, true)
				]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-cd57ec2c"]]);
//#endregion
//#region src/components/InputMessage/InputMessage.vue
var InputMessage_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputMessage",
	props: {
		text: {},
		severity: { default: void 0 },
		maxLines: { default: 1 },
		showIcon: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const textClass = computed(() => {
			switch (props.severity) {
				case "information": return "input-message-information";
				case "warning": return "input-message-warning";
				default: return "input-message-error";
			}
		});
		const iconName = computed(() => {
			switch (props.severity) {
				case "information": return "info";
				case "warning": return "warning";
				default: return "error";
			}
		});
		return (_ctx, _cache) => {
			return __props.showIcon ? (openBlock(), createBlock(HorizontalLayout_default, {
				key: 0,
				space: "extrasmall",
				"vertical-align": "top",
				wrap: false,
				class: "input-message-row"
			}, {
				default: withCtx(() => [createVNode(Image_default, {
					name: iconName.value,
					size: "small",
					class: normalizeClass(["input-message-icon", textClass.value])
				}, null, 8, ["name", "class"]), createVNode(Text_default, {
					size: "small",
					"max-lines": __props.maxLines,
					tooltip: __props.text,
					class: normalizeClass(["input-message", textClass.value])
				}, {
					default: withCtx(() => [createTextVNode(toDisplayString(__props.text), 1)]),
					_: 1
				}, 8, [
					"max-lines",
					"tooltip",
					"class"
				])]),
				_: 1
			})) : (openBlock(), createBlock(Text_default, {
				key: 1,
				size: "small",
				"max-lines": __props.maxLines,
				tooltip: __props.text,
				class: normalizeClass(["input-message", textClass.value])
			}, {
				default: withCtx(() => [createTextVNode(toDisplayString(__props.text), 1)]),
				_: 1
			}, 8, [
				"max-lines",
				"tooltip",
				"class"
			]));
		};
	}
}), [["__scopeId", "data-v-9bf078d6"]]);
//#endregion
//#region src/composables/useLocalizator.ts
function provideLocalizator(localizator) {
	provide("localizator", localizator);
	return localizator;
}
function useLocalizator() {
	const localizator = inject("localizator");
	if (!localizator) throw new Error("Localizator not provided");
	return localizator;
}
//#endregion
//#region src/composables/useSelectableItemProperties.ts
function useSelectableItemProperties(props) {
	const localizator = useLocalizator();
	function getItemKey(item) {
		if (props.keyProperty) return getPropertyByPath(item, props.keyProperty);
		return item;
	}
	function getItemLabel(item) {
		let label;
		if (props.displayProperty) label = getPropertyByPath(item, props.displayProperty);
		else label = item;
		if (label == null) return "";
		if (typeof label !== "object" || label instanceof Date) return String(label);
		return localizator.translate(label) ?? "";
	}
	function isSameItem(leftItem, rightItem) {
		return equals(leftItem, rightItem, props.keyProperty);
	}
	return {
		getItemKey,
		getItemLabel,
		isSameItem
	};
}
//#endregion
//#region src/utils/keyboard.ts
function isTypeaheadKey(event) {
	if (event.target instanceof HTMLInputElement) return false;
	if (event.key.length !== 1) return false;
	if (event.ctrlKey || event.altKey || event.metaKey) return false;
	return !event.isComposing;
}
//#endregion
//#region src/components/Spinner/Spinner.ts?vue&type=script&src=true&lang.ts
var Spinner_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Spinner",
	props: { size: {
		type: String,
		default: "medium"
	} },
	setup(props) {
		return { spinnerClasses: computed(() => [`spinner-${props.size}`]) };
	}
});
//#endregion
//#region src/components/Spinner/Spinner.vue
function _sfc_render$27(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", { class: normalizeClass(["spinner-container", _ctx.spinnerClasses]) }, [..._cache[0] || (_cache[0] = [createElementVNode("svg", {
		class: "spinner",
		fill: "none",
		viewBox: "0 0 24 24"
	}, [createElementVNode("circle", {
		cx: "12",
		cy: "12",
		r: "10",
		stroke: "currentColor",
		"stroke-width": "4",
		style: { "opacity": "0.25" }
	}), createElementVNode("path", {
		fill: "currentColor",
		d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
	})], -1)])], 2);
}
var Spinner_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Spinner_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$27], ["__scopeId", "data-v-8740c195"]]);
//#endregion
//#region src/composables/useSelectableListFilter.ts
function useSelectableListFilter(options) {
	const searchText = ref(null);
	const showSelected = ref(false);
	const displayedItems = computed(() => {
		const items = options.items();
		if (options.multiple() && options.searchable() && showSelected.value) {
			const selectedItems = options.selectedItems();
			return items.filter((item) => selectedItems.some((selectedItem) => options.isSameItem(selectedItem, item)));
		}
		if (!options.searchable()) return items;
		const normalizedSearch = searchText.value?.trim().toLocaleLowerCase();
		if (!normalizedSearch) return items;
		return items.filter((item) => options.getItemLabel(item).toLocaleLowerCase().includes(normalizedSearch));
	});
	watch([
		options.multiple,
		options.searchable,
		() => options.selectedItems().length
	], ([multiple, searchable, selectedCount]) => {
		if (!multiple || !searchable || selectedCount === 0) showSelected.value = false;
	});
	function handleSearch(setFocusedIndex) {
		showSelected.value = false;
		setFocusedIndex(0);
	}
	function toggleShowSelected(setFocusedIndex) {
		showSelected.value = !showSelected.value;
		setFocusedIndex(0);
	}
	return {
		displayedItems,
		searchText,
		showSelected,
		handleSearch,
		toggleShowSelected
	};
}
//#endregion
//#region src/components/SelectableItem/SelectableItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$31 = ["type", "checked"];
//#endregion
//#region src/components/SelectableItem/SelectableItem.vue
var SelectableItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableItem",
	props: {
		selected: { type: Boolean },
		focused: { type: Boolean },
		controlType: {}
	},
	emits: ["click", "checked"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		function handleClick(event) {
			if (event.target instanceof HTMLInputElement) return;
			emit("click", event);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				role: "option",
				class: "selectable-item",
				"aria-selected": __props.selected,
				"data-focused": __props.focused || void 0,
				onClick: handleClick
			}, {
				default: withCtx(() => [__props.controlType ? (openBlock(), createElementBlock("input", {
					key: 0,
					type: __props.controlType,
					checked: __props.selected,
					"aria-hidden": "true",
					tabindex: "-1",
					onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {}, ["prevent"])),
					onChange: _cache[1] || (_cache[1] = ($event) => emit("checked", $event))
				}, null, 40, _hoisted_1$31)) : createCommentVNode("", true), renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["aria-selected", "data-focused"]);
		};
	}
}), [["__scopeId", "data-v-b57dbc4f"]]);
//#endregion
//#region src/components/SelectableList/SelectableList.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$30 = [
	"id",
	"aria-busy",
	"aria-disabled",
	"aria-required",
	"data-focused",
	"aria-multiselectable",
	"aria-activedescendant",
	"tabindex"
];
//#endregion
//#region src/components/SelectableList/SelectableList.vue
var SelectableList_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableList",
	props: {
		items: {},
		selectedItems: {},
		getItemKey: { type: Function },
		isSameItem: { type: Function },
		listId: {},
		multiple: { type: Boolean },
		required: { type: Boolean },
		disabled: { type: Boolean },
		loading: { type: Boolean },
		tabIndex: {},
		focusSelectedOnFocus: { type: Boolean },
		clearFocusOnBlur: { type: Boolean },
		selectOnEnter: { type: Boolean },
		selectOnTab: { type: Boolean }
	},
	emits: [
		"mounted",
		"select",
		"escape"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const list = useTemplateRef("list");
		const focused = ref(false);
		const focusedIndex = ref(-1);
		const focusedItemId = computed(() => focusedIndex.value < 0 ? void 0 : getItemId(focusedIndex.value));
		watch(() => props.items.map(props.getItemKey), (itemKeys, previousItemKeys) => {
			if (itemKeys.length === 0) {
				focusedIndex.value = -1;
				return;
			}
			const previouslyFocusedKey = previousItemKeys?.[focusedIndex.value];
			const updatedIndex = previouslyFocusedKey === void 0 ? -1 : itemKeys.indexOf(previouslyFocusedKey);
			focusedIndex.value = updatedIndex >= 0 ? updatedIndex : Math.min(Math.max(focusedIndex.value, 0), itemKeys.length - 1);
		}, { flush: "sync" });
		onMounted(() => emit("mounted", list.value));
		function getItemId(index) {
			return `${props.listId}-option-${index}`;
		}
		function isSelected(item) {
			return props.selectedItems.some((selectedItem) => props.isSameItem(selectedItem, item));
		}
		function selectItem(item, index, originalEvent, source) {
			focusedIndex.value = index;
			emit("select", {
				item,
				index,
				source,
				originalEvent,
				checked: source === "checked" && originalEvent.target instanceof HTMLInputElement ? originalEvent.target.checked : !isSelected(item)
			});
		}
		function focusSelectedItem() {
			const selectedIndex = props.items.findIndex(isSelected);
			if (selectedIndex !== -1) {
				focusedIndex.value = selectedIndex;
				return;
			}
			if (props.items.length > 0) {
				focusedIndex.value = 0;
				return;
			}
			focusedIndex.value = -1;
		}
		function clearFocus() {
			focusedIndex.value = -1;
		}
		function setFocusedIndex(index) {
			focusedIndex.value = props.items.length === 0 ? -1 : Math.min(Math.max(index, 0), props.items.length - 1);
		}
		function handleKeydown(event) {
			const textInput = isTextInput(event);
			if (event.key === "Escape") {
				emit("escape", event);
				return;
			}
			const navigationOffset = getNavigationOffset(event.key);
			if (navigationOffset !== void 0) {
				event.preventDefault();
				setFocusedIndex(focusedIndex.value + navigationOffset);
				return;
			}
			const focusBoundary = getFocusBoundary(event.key, textInput);
			if (focusBoundary !== void 0) {
				event.preventDefault();
				setFocusedIndex(focusBoundary);
				return;
			}
			if (shouldSelectWithKeyboard(event, textInput) && hasFocusedItem()) {
				event.preventDefault();
				selectFocusedItem(event, "keyboard");
				return;
			}
			if (props.selectOnTab && event.key === "Tab" && hasFocusedItem()) selectFocusedItem(event, "tab");
		}
		function isTextInput(event) {
			return event.target instanceof HTMLInputElement && event.target.type === "text";
		}
		function getNavigationOffset(key) {
			if (key === "ArrowDown") return 1;
			if (key === "ArrowUp") return -1;
		}
		function getFocusBoundary(key, textInput) {
			if (textInput) return;
			if (key === "Home") return 0;
			if (key === "End") return props.items.length - 1;
		}
		function shouldSelectWithKeyboard(event, textInput) {
			if (event.key === " ") return !textInput;
			return props.selectOnEnter && event.key === "Enter";
		}
		function hasFocusedItem() {
			return focusedIndex.value >= 0 && focusedIndex.value < props.items.length;
		}
		function selectFocusedItem(event, source) {
			selectItem(props.items[focusedIndex.value], focusedIndex.value, event, source);
		}
		function focus() {
			if (props.disabled) return;
			list.value?.focus();
		}
		function handleListKeydown(event) {
			if (!props.disabled || event.key === "Escape") handleKeydown(event);
		}
		function handleFocus() {
			focused.value = true;
			if (props.focusSelectedOnFocus) focusSelectedItem();
		}
		function handleBlur() {
			focused.value = false;
			if (props.clearFocusOnBlur) clearFocus();
		}
		__expose({
			focusedItemId,
			focus,
			focusSelectedItem,
			clearFocus,
			setFocusedIndex
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: "selectable-list",
				onKeydown: handleListKeydown
			}, [
				renderSlot(_ctx.$slots, "header", {
					focusedItemId: focusedItemId.value,
					setFocusedIndex
				}, void 0, true),
				createElementVNode("div", {
					id: __props.listId,
					ref_key: "list",
					ref: list,
					class: "selectable-list-items",
					role: "listbox",
					"aria-busy": __props.loading || void 0,
					"aria-disabled": __props.disabled || void 0,
					"aria-required": __props.required || void 0,
					"data-focused": focused.value || void 0,
					"aria-multiselectable": __props.multiple || void 0,
					"aria-activedescendant": focusedItemId.value,
					tabindex: __props.disabled ? -1 : __props.tabIndex,
					onFocus: handleFocus,
					onBlur: handleBlur
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (item, index) => {
					return renderSlot(_ctx.$slots, "item", {
						item,
						itemId: getItemId(index),
						index,
						selected: isSelected(item),
						focused: focusedIndex.value === index,
						focus: () => !__props.disabled && (focusedIndex.value = index),
						select: (event, source) => !__props.disabled && selectItem(item, index, event, source)
					}, void 0, true, __props.getItemKey(item));
				}), 128))], 40, _hoisted_1$30),
				__props.items.length === 0 ? renderSlot(_ctx.$slots, "empty", {}, void 0, true, 0) : createCommentVNode("", true)
			], 32);
		};
	}
}), [["__scopeId", "data-v-5400cb12"]]);
//#endregion
//#region src/components/SelectableList/SelectableListHeader.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$29 = { class: "selectable-list-header-search-container neos-fill-parent-width" };
var _hoisted_2$16 = [
	"aria-busy",
	"aria-controls",
	"aria-activedescendant",
	"aria-label",
	"placeholder",
	"disabled",
	"tabindex",
	"autofocus"
];
var _hoisted_3$7 = {
	key: 0,
	class: "selectable-list-header-search-actions"
};
//#endregion
//#region src/components/SelectableList/SelectableListHeader.vue
var SelectableListHeader_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectableListHeader",
	props: /*@__PURE__*/ mergeModels({
		listId: {},
		disabled: {
			type: Boolean,
			default: false
		},
		loading: { type: Boolean },
		showSelected: { type: Boolean },
		selectedCount: {},
		autofocus: {
			type: Boolean,
			default: false
		},
		tabIndex: {},
		activeDescendant: {}
	}, {
		"modelValue": { default: null },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels(["toggleShowSelected"], ["update:modelValue"]),
	setup(__props, { expose: __expose, emit: __emit }) {
		const emit = __emit;
		const searchText = useModel(__props, "modelValue", {
			get: (value) => value,
			set: (value) => value || null
		});
		const { translate } = useGlobalResourceManager();
		const input = useTemplateRef("input");
		function focus() {
			input.value?.focus();
		}
		__expose({ focus });
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				"vertical-align": "center",
				wrap: false,
				class: "selectable-list-header"
			}, {
				default: withCtx(() => [createElementVNode("div", _hoisted_1$29, [withDirectives(createElementVNode("input", {
					ref_key: "input",
					ref: input,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchText.value = $event),
					role: "combobox",
					class: "selectable-list-header-search",
					autocomplete: "off",
					"aria-expanded": "true",
					"aria-autocomplete": "list",
					"aria-busy": __props.loading,
					"aria-controls": __props.listId,
					"aria-activedescendant": __props.activeDescendant,
					"aria-label": unref(translate)("Search"),
					placeholder: unref(translate)("Search"),
					disabled: __props.disabled,
					tabindex: __props.tabIndex,
					autofocus: __props.autofocus
				}, null, 8, _hoisted_2$16), [[vModelText, searchText.value]]), __props.loading || _ctx.$slots.actions ? (openBlock(), createElementBlock("div", _hoisted_3$7, [__props.loading ? (openBlock(), createBlock(Spinner_default, {
					key: 0,
					class: "selectable-list-header-search-spinner",
					size: "extrasmall"
				})) : createCommentVNode("", true), renderSlot(_ctx.$slots, "actions", {}, void 0, true)])) : createCommentVNode("", true)]), __props.selectedCount !== void 0 ? (openBlock(), createBlock(Button_default, {
					key: 0,
					variant: __props.showSelected ? "primary" : "default",
					disabled: __props.selectedCount === 0,
					"aria-label": unref(translate)(__props.showSelected ? "ShowAllValues" : "ShowSelectedValues", __props.selectedCount),
					size: "small",
					icon: "filterCheckOutline",
					label: __props.selectedCount,
					"aria-controls": __props.listId,
					"aria-pressed": __props.showSelected,
					class: "selectable-list-header-show-selected-button",
					onClick: _cache[1] || (_cache[1] = ($event) => emit("toggleShowSelected"))
				}, null, 8, [
					"variant",
					"disabled",
					"aria-label",
					"label",
					"aria-controls",
					"aria-pressed"
				])) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-d90caf4c"]]);
//#endregion
//#region src/components/Select/SelectDropdown.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$28 = {
	class: "select-dropdown-empty",
	role: "status",
	"aria-live": "polite"
};
var typeaheadResetDelay = 700;
//#endregion
//#region src/components/Select/SelectDropdown.vue
var SelectDropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "SelectDropdown",
	props: {
		listId: {},
		options: {},
		selectedOptions: {},
		getOptionKey: { type: Function },
		getOptionLabel: { type: Function },
		isSameOption: { type: Function },
		multiple: { type: Boolean },
		searchable: { type: Boolean },
		loading: { type: Boolean },
		required: { type: Boolean }
	},
	emits: [
		"show",
		"hide",
		"select"
	],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const popover = useTemplateRef("popover");
		const selectableList = useTemplateRef("selectableList");
		const searchInput = useTemplateRef("searchInput");
		const panelWidth = ref("");
		let target = null;
		let restoreFocusOnHide = false;
		let typeaheadText = "";
		let typeaheadResetTimeout;
		let typeaheadFocusedIndex;
		const { displayedItems: displayedOptions, searchText, showSelected, handleSearch, toggleShowSelected } = useSelectableListFilter({
			items: () => props.options,
			selectedItems: () => props.selectedOptions,
			multiple: () => props.multiple,
			searchable: () => props.searchable,
			getItemLabel: props.getOptionLabel,
			isSameItem: props.isSameOption
		});
		function setTarget(popoverTarget) {
			target = popoverTarget;
			panelWidth.value = `${popoverTarget.getBoundingClientRect().width}px`;
		}
		function toggle(popoverTarget) {
			setTarget(popoverTarget);
			popover.value?.toggle({ currentTarget: popoverTarget }, { hideOthers: true });
		}
		function show(popoverTarget) {
			setTarget(popoverTarget);
			popover.value?.show({ currentTarget: popoverTarget });
		}
		async function handleShow() {
			emit("show");
			await nextTick();
			if (typeaheadFocusedIndex === void 0) selectableList.value?.focusSelectedItem();
			else {
				selectableList.value?.setFocusedIndex(typeaheadFocusedIndex);
				typeaheadFocusedIndex = void 0;
			}
			(typeaheadText ? selectableList.value : searchInput.value ?? selectableList.value)?.focus();
		}
		function handleHide() {
			resetTypeahead();
			searchText.value = "";
			showSelected.value = false;
			selectableList.value?.clearFocus();
			emit("hide");
			if (restoreFocusOnHide) {
				target?.focus();
				restoreFocusOnHide = false;
			}
		}
		function hide(restoreFocus = false) {
			restoreFocusOnHide = restoreFocus;
			popover.value?.hide();
		}
		function handleEscape(event) {
			event.preventDefault();
			hide(true);
		}
		function typeahead(popoverTarget, key) {
			const focusedIndex = findTypeaheadMatch(key);
			if (focusedIndex === -1) return;
			typeaheadFocusedIndex = focusedIndex;
			show(popoverTarget);
			selectableList.value?.setFocusedIndex(focusedIndex);
			selectableList.value?.focus();
		}
		function handleTypeaheadKeydown(event) {
			if (!isTypeaheadKey(event)) return;
			event.preventDefault();
			const focusedIndex = findTypeaheadMatch(event.key);
			if (focusedIndex !== -1) selectableList.value?.setFocusedIndex(focusedIndex);
		}
		function findTypeaheadMatch(key) {
			typeaheadText += key;
			clearTimeout(typeaheadResetTimeout);
			typeaheadResetTimeout = setTimeout(resetTypeahead, typeaheadResetDelay);
			const normalizedText = typeaheadText.toLocaleLowerCase();
			return props.options.findIndex((option) => props.getOptionLabel(option).toLocaleLowerCase().startsWith(normalizedText));
		}
		function resetTypeahead() {
			clearTimeout(typeaheadResetTimeout);
			typeaheadResetTimeout = void 0;
			typeaheadText = "";
			typeaheadFocusedIndex = void 0;
		}
		onBeforeUnmount(resetTypeahead);
		__expose({
			toggle,
			show,
			hide,
			typeahead
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Popover_default, {
				ref_key: "popover",
				ref: popover,
				class: "select-dropdown",
				onShow: handleShow,
				onHide: handleHide
			}, {
				default: withCtx(() => [createVNode(SelectableList_default, {
					ref_key: "selectableList",
					ref: selectableList,
					items: unref(displayedOptions),
					"selected-items": __props.selectedOptions,
					"get-item-key": __props.getOptionKey,
					"is-same-item": __props.isSameOption,
					"list-id": __props.listId,
					multiple: __props.multiple,
					disabled: __props.loading && __props.options.length > 0,
					loading: __props.loading,
					required: __props.required,
					"tab-index": -1,
					"focus-selected-on-focus": false,
					"clear-focus-on-blur": false,
					"select-on-enter": true,
					"select-on-tab": true,
					class: "select-dropdown-list",
					style: normalizeStyle({ minWidth: panelWidth.value }),
					onSelect: _cache[1] || (_cache[1] = ($event) => emit("select", $event)),
					onEscape: handleEscape,
					onKeydown: handleTypeaheadKeydown
				}, {
					header: withCtx(({ focusedItemId, setFocusedIndex }) => [__props.searchable ? (openBlock(), createBlock(SelectableListHeader_default, {
						key: 0,
						ref_key: "searchInput",
						ref: searchInput,
						modelValue: unref(searchText),
						"onUpdate:modelValue": [_cache[0] || (_cache[0] = ($event) => isRef(searchText) ? searchText.value = $event : null), ($event) => unref(handleSearch)(setFocusedIndex)],
						"list-id": __props.listId,
						"active-descendant": focusedItemId,
						loading: __props.loading,
						"selected-count": __props.multiple ? __props.selectedOptions.length : void 0,
						"show-selected": unref(showSelected),
						onToggleShowSelected: ($event) => unref(toggleShowSelected)(setFocusedIndex)
					}, null, 8, [
						"modelValue",
						"list-id",
						"active-descendant",
						"loading",
						"selected-count",
						"show-selected",
						"onUpdate:modelValue",
						"onToggleShowSelected"
					])) : createCommentVNode("", true)]),
					item: withCtx(({ item, itemId, selected, focused, focus, select }) => [(openBlock(), createBlock(SelectableItem_default, {
						key: __props.getOptionKey(item),
						id: itemId,
						class: "select-option",
						selected,
						focused,
						"control-type": __props.multiple ? "checkbox" : void 0,
						"aria-label": __props.getOptionLabel(item),
						onMouseenter: focus,
						onClick: ($event) => select($event, "click"),
						onChecked: ($event) => select($event, "checked")
					}, {
						default: withCtx(() => [renderSlot(_ctx.$slots, "option", { option: item }, () => [createTextVNode(toDisplayString(__props.getOptionLabel(item)), 1)], true)]),
						_: 2
					}, 1032, [
						"id",
						"selected",
						"focused",
						"control-type",
						"aria-label",
						"onMouseenter",
						"onClick",
						"onChecked"
					]))]),
					empty: withCtx(() => [createElementVNode("span", _hoisted_1$28, toDisplayString(unref(translate)(__props.loading ? "Loading" : __props.options.length === 0 ? "NoValues" : "NoResultFound")), 1)]),
					_: 3
				}, 8, [
					"items",
					"selected-items",
					"get-item-key",
					"is-same-item",
					"list-id",
					"multiple",
					"disabled",
					"loading",
					"required",
					"style"
				])]),
				_: 3
			}, 512);
		};
	}
}), [["__scopeId", "data-v-1d72eff7"]]);
//#endregion
//#region src/components/Select/Select.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$27 = [
	"id",
	"aria-expanded",
	"aria-controls",
	"aria-disabled",
	"aria-busy",
	"aria-required",
	"data-focused",
	"tabindex"
];
var _hoisted_2$15 = { class: "select-values" };
var _hoisted_3$6 = {
	key: 0,
	class: "select-invalid-value"
};
var _hoisted_4$5 = {
	key: 2,
	class: "select-placeholder"
};
var _hoisted_5$5 = { class: "select-actions" };
var _hoisted_6$2 = ["aria-label"];
var _hoisted_7$2 = ["aria-label"];
//#endregion
//#region src/components/Select/Select.vue
var Select_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Select",
	props: {
		multiple: { type: Boolean },
		modelValue: {},
		id: {},
		values: {},
		required: { type: Boolean },
		disabled: { type: Boolean },
		keyProperty: {},
		displayProperty: {},
		searchable: { type: Boolean },
		loading: { type: Boolean },
		caret: { type: Boolean },
		invalidValue: {},
		placeholder: {},
		tabIndex: {}
	},
	emits: [
		"mounted",
		"hide",
		"show",
		"update:modelValue"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { getItemKey: getOptionKey, getItemLabel: getOptionLabel, isSameItem: isSameOption } = useSelectableItemProperties(props);
		const { translate } = useGlobalResourceManager();
		const trigger = useTemplateRef("trigger");
		const popover = useTemplateRef("popover");
		const open = ref(false);
		const { focused } = useFocus(trigger);
		const listboxId = computed(() => `${props.id}-listbox`);
		const triggerTabIndex = computed(() => props.disabled ? -1 : props.tabIndex ?? 0);
		const dataFocused = computed(() => open.value || focused.value || void 0);
		const selectedOptions = computed(() => {
			if (props.multiple) return Array.isArray(props.modelValue) ? props.modelValue : [];
			return props.modelValue == null ? [] : [props.modelValue];
		});
		const clearable = computed(() => !props.required && !props.disabled && selectedOptions.value.length > 0);
		onMounted(() => emit("mounted", trigger.value));
		function handleToggle() {
			if (!props.disabled) {
				trigger.value.focus();
				popover.value?.toggle(trigger.value);
			}
		}
		function handleKeydown(event) {
			if (props.disabled) return;
			if (clearable.value && (event.key === "Backspace" || event.key === "Delete")) {
				event.preventDefault();
				handleClear();
				return;
			}
			if (event.key === "Enter" || event.key === " " || event.key === "ArrowDown") {
				event.preventDefault();
				popover.value?.show(trigger.value);
				return;
			}
			if (isTypeaheadKey(event)) {
				event.preventDefault();
				popover.value?.typeahead(trigger.value, event.key);
			}
		}
		function handleClear() {
			trigger.value.focus();
			clear();
		}
		function handleDropdownShow() {
			open.value = true;
			emit("show");
		}
		function handleDropdownHide() {
			open.value = false;
			emit("hide");
		}
		function handleSelectOption(event) {
			if (props.multiple) {
				const modelValue = Array.isArray(props.modelValue) ? props.modelValue : [];
				emit("update:modelValue", event.checked ? [...modelValue, event.item] : modelValue.filter((selectedOption) => !isSameOption(selectedOption, event.item)));
				if (event.source === "tab") popover.value?.hide();
				return;
			}
			if (props.modelValue == null || !isSameOption(props.modelValue, event.item)) emit("update:modelValue", event.item);
			popover.value?.hide(true);
		}
		function removeOption(option) {
			if (!props.multiple) return;
			const updatedModelValue = selectedOptions.value.filter((selectedOption) => !isSameOption(selectedOption, option));
			if (updatedModelValue.length !== selectedOptions.value.length) emit("update:modelValue", updatedModelValue);
		}
		function clear() {
			emit("update:modelValue", props.multiple ? [] : null);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "trigger",
				ref: trigger,
				class: "select",
				id: __props.id,
				role: "combobox",
				"aria-haspopup": "listbox",
				"aria-expanded": open.value,
				"aria-controls": __props.disabled ? void 0 : listboxId.value,
				"aria-disabled": __props.disabled,
				"aria-busy": __props.loading,
				"aria-required": __props.required || void 0,
				"data-focused": dataFocused.value,
				tabindex: triggerTabIndex.value,
				onClick: handleToggle,
				onKeydown: handleKeydown
			}, [
				renderSlot(_ctx.$slots, "before", {}, void 0, true),
				createElementVNode("div", _hoisted_2$15, [__props.invalidValue != null ? (openBlock(), createElementBlock("span", _hoisted_3$6, toDisplayString(__props.invalidValue), 1)) : selectedOptions.value.length > 0 ? renderSlot(_ctx.$slots, "values", {
					getOptionKey: unref(getOptionKey),
					getOptionLabel: unref(getOptionLabel),
					removeOption
				}, void 0, true, 1) : __props.placeholder ? (openBlock(), createElementBlock("span", _hoisted_4$5, toDisplayString(__props.placeholder), 1)) : createCommentVNode("", true)]),
				createElementVNode("div", _hoisted_5$5, [
					__props.loading ? (openBlock(), createBlock(Spinner_default, {
						key: 0,
						class: "select-loading-spinner",
						size: "extrasmall"
					})) : createCommentVNode("", true),
					renderSlot(_ctx.$slots, "after", {}, void 0, true),
					clearable.value ? (openBlock(), createElementBlock("button", {
						key: 1,
						type: "button",
						class: "select-clear-button input-clear-button",
						"aria-label": unref(translate)("Clear"),
						tabindex: "-1",
						onClick: withModifiers(handleClear, ["stop"])
					}, [createVNode(Image_default, {
						name: "erase",
						size: "small"
					})], 8, _hoisted_6$2)) : createCommentVNode("", true),
					__props.caret && !__props.disabled ? (openBlock(), createElementBlock("button", {
						key: 2,
						type: "button",
						class: "select-caret-button",
						"aria-label": unref(translate)("Choose"),
						tabindex: "-1",
						onClick: withModifiers(handleToggle, ["stop"])
					}, [createVNode(Image_default, { name: "chevronDown" })], 8, _hoisted_7$2)) : createCommentVNode("", true)
				]),
				!__props.disabled ? (openBlock(), createBlock(SelectDropdown_default, {
					key: 0,
					ref_key: "popover",
					ref: popover,
					"list-id": listboxId.value,
					options: __props.values,
					"selected-options": selectedOptions.value,
					"get-option-key": unref(getOptionKey),
					"get-option-label": unref(getOptionLabel),
					"is-same-option": unref(isSameOption),
					multiple: __props.multiple,
					searchable: __props.searchable,
					loading: __props.loading,
					required: __props.required,
					onShow: handleDropdownShow,
					onHide: handleDropdownHide,
					onSelect: handleSelectOption
				}, {
					option: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", {
						option,
						getOptionLabel: unref(getOptionLabel)
					}, () => [createTextVNode(toDisplayString(unref(getOptionLabel)(option)), 1)], true)]),
					_: 3
				}, 8, [
					"list-id",
					"options",
					"selected-options",
					"get-option-key",
					"get-option-label",
					"is-same-option",
					"multiple",
					"searchable",
					"loading",
					"required"
				])) : createCommentVNode("", true)
			], 40, _hoisted_1$27);
		};
	}
}), [["__scopeId", "data-v-249c9c22"]]);
//#endregion
//#region src/components/Combobox/Combobox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$26 = { class: "combobox-value" };
//#endregion
//#region src/components/Combobox/Combobox.vue
var Combobox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Combobox",
	props: {
		...inputProps,
		modelValue: {
			type: null,
			default: null
		},
		invalidValue: {
			type: String,
			default: void 0
		},
		values: {
			type: Array,
			default: []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		caret: {
			type: Boolean,
			default: true
		}
	},
	emits: [
		...inputEmits,
		"update:invalidValue",
		"show",
		"hide"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const invalidValue = useInputInvalidValue(props, emit);
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const { disabledOrReadonly, keyProperty, displayProperty, getOptionValue } = useSelectProps(props);
		watch([() => props.modelValue, () => props.values.map(getOptionValue)], ([value, values]) => emitIfInvalid(value, values), { immediate: true });
		const selectedOption = computed({
			get() {
				return props.valueProperty ? findOption(props.modelValue) : props.modelValue;
			},
			set(value) {
				emit("update:modelValue", getOptionValue(value));
			}
		});
		function emitIfInvalid(value, values) {
			if (value == null) {
				invalidValue.value = null;
				return;
			}
			invalidValue.value = values.includes(value) ? null : String(value);
		}
		function findOption(value) {
			return props.values.find((option) => getOptionValue(option) === value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["combobox neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(Select_default, {
				id: unref(id),
				modelValue: selectedOption.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedOption.value = $event),
				values: __props.values,
				"key-property": unref(keyProperty),
				"display-property": unref(displayProperty),
				required: _ctx.required,
				disabled: unref(disabledOrReadonly),
				loading: __props.loading,
				caret: __props.caret,
				searchable: __props.searchable,
				"invalid-value": unref(invalidValue),
				placeholder: _ctx.placeholder,
				"tab-index": unref(tabIndex),
				"show-selection-control": false,
				class: "neos-input-content",
				onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
				onShow: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("show")),
				onHide: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("hide"))
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				values: withCtx(({ getOptionLabel }) => [createElementVNode("span", _hoisted_1$26, [renderSlot(_ctx.$slots, "value", { option: selectedOption.value }, () => [createTextVNode(toDisplayString(getOptionLabel(selectedOption.value)), 1)], true)])]),
				after: withCtx(() => [renderSlot(_ctx.$slots, "after", {}, void 0, true)]),
				option: withCtx(({ option, getOptionLabel }) => [renderSlot(_ctx.$slots, "option", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true)]),
				_: 3
			}, 8, [
				"id",
				"modelValue",
				"values",
				"key-property",
				"display-property",
				"required",
				"disabled",
				"loading",
				"caret",
				"searchable",
				"invalid-value",
				"placeholder",
				"tab-index"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-4d6d97fd"]]);
//#endregion
//#region src/components/BooleanCombobox/BooleanCombobox.vue
var BooleanCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "BooleanCombobox",
	props: {
		...inputProps,
		modelValue: {
			type: Boolean,
			default: void 0
		},
		trueDisplay: {
			type: String,
			default: "Yes"
		},
		falseDisplay: {
			type: String,
			default: "No"
		},
		nullDisplay: {
			type: String,
			default: "Undefined"
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		const values = [
			{
				caption: translate(props.trueDisplay),
				value: true
			},
			{
				caption: translate(props.falseDisplay),
				value: false
			},
			{
				caption: translate(props.nullDisplay),
				value: null
			}
		];
		function handleChange(value) {
			emit("update:modelValue", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(Combobox_default, {
				focused: unref(focused),
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => isRef(focused) ? focused.value = $event : null),
				"model-value": __props.modelValue,
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				readonly: _ctx.readonly,
				required: _ctx.required,
				"input-display-mode": _ctx.inputDisplayMode,
				"tab-stop": _ctx.tabStop,
				values,
				"value-property": "value",
				"display-property": "caption",
				"onUpdate:modelValue": handleChange
			}, null, 8, [
				"focused",
				"model-value",
				"label",
				"label-position",
				"readonly",
				"required",
				"input-display-mode",
				"tab-stop"
			]);
		};
	}
});
//#endregion
//#region src/components/Card/Card.ts?vue&type=script&src=true&lang.ts
var Card_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Card",
	components: { VerticalLayout: VerticalLayout_default },
	props: {
		space: {
			type: String,
			default: "small"
		},
		align: {
			type: String,
			default: "stretch"
		}
	},
	setup() {
		useComponentAutomationProperties();
	}
});
//#endregion
//#region src/components/Card/Card.vue
function _sfc_render$26(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		space: _ctx.space,
		align: _ctx.align,
		class: "card"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 8, ["space", "align"]);
}
var Card_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Card_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$26], ["__scopeId", "data-v-a6c80180"]]);
//#endregion
//#region src/components/Carousel/Carousel.vue
var Carousel_default = /* @__PURE__ */ defineComponent({
	__name: "Carousel",
	props: {
		source: {},
		pageSize: { default: 1 },
		scrollStep: { default: 1 },
		autoScrollInterval: { default: 0 },
		circular: { type: Boolean },
		navigationArrows: {
			type: Boolean,
			default: true
		},
		paginationIndicators: {
			type: Boolean,
			default: true
		}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(Carousel), {
				value: __props.source,
				"num-visible": __props.pageSize,
				"num-scroll": __props.scrollStep,
				"autoplay-interval": __props.autoScrollInterval,
				circular: __props.circular,
				"show-navigators": __props.navigationArrows,
				"show-indicators": __props.paginationIndicators
			}, {
				item: withCtx((slotProps) => [renderSlot(_ctx.$slots, "item", { context: slotProps.data })]),
				_: 3
			}, 8, [
				"value",
				"num-visible",
				"num-scroll",
				"autoplay-interval",
				"circular",
				"show-navigators",
				"show-indicators"
			]);
		};
	}
});
//#endregion
//#region src/components/Chart/Chart.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$25 = { class: "chart" };
var _hoisted_2$14 = { ref: "canvas" };
//#endregion
//#region src/components/Chart/Chart.vue
var Chart_default = /* @__PURE__ */ defineComponent({
	__name: "Chart",
	props: {
		type: {},
		data: {},
		options: { default: () => ({}) }
	},
	setup(__props) {
		const props = __props;
		const canvasElement = useTemplateRef("canvas");
		const chart = shallowRef();
		onMounted(() => {
			init();
		});
		onBeforeUnmount(() => {
			destroy();
		});
		watch([
			() => props.type,
			() => props.data,
			() => props.options
		], () => {
			init();
		});
		async function init() {
			const { Chart } = await import("chart.js/auto");
			Chart.register(annotationPlugin);
			destroy();
			chart.value = new Chart(canvasElement.value, {
				type: props.type,
				data: props.data,
				options: props.options
			});
		}
		function destroy() {
			if (chart.value) {
				chart.value.destroy();
				chart.value = void 0;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1$25, [createElementVNode("canvas", _hoisted_2$14, null, 512)]);
		};
	}
});
//#endregion
//#region src/components/Checkbox/Checkbox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$24 = { class: "checkbox-content neos-input-content" };
var _hoisted_2$13 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
//#endregion
//#region src/components/Checkbox/Checkbox.vue
var Checkbox_default = /* @__PURE__ */ defineComponent({
	__name: "Checkbox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		labelPosition: {
			type: String,
			default: "right"
		}
	}, {
		"modelValue": {
			type: Boolean,
			default: false
		},
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["neos-input checkbox", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				class: "checkbox-content-input-label",
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", _hoisted_1$24, [withDirectives(createElementVNode("input", {
				id: unref(id),
				ref: (el) => input.value = el,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => modelValue.value = $event),
				type: "checkbox",
				checked: modelValue.value,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex)
			}, null, 8, _hoisted_2$13), [[vModelCheckbox, modelValue.value]]), renderSlot(_ctx.$slots, "default")])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/Chip/Chip.ts?vue&type=script&src=true&lang.ts
var Chip_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Chip",
	components: { PrimeChip }
});
//#endregion
//#region src/components/Chip/Chip.vue
function _sfc_render$25(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_PrimeChip = resolveComponent("PrimeChip");
	return openBlock(), createBlock(_component_PrimeChip, null, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
		_: 3
	});
}
var Chip_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Chip_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$25]]);
//#endregion
//#region src/components/ContextMenuItem/ContextMenuItem.vue
var ContextMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenuItem",
	props: {
		item: {},
		props: {},
		hasSubmenu: {},
		size: {}
	},
	setup(__props) {
		const props = __props;
		const action = computed(() => props.props.action);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, mergeProps({
					"vertical-align": "center",
					wrap: false
				}, action.value), {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "context-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "context-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}, 16), __props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
					key: 0,
					name: "chevronRight",
					size: __props.size
				}, null, 8, ["size"])) : createCommentVNode("", true)]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/ContextMenu/ContextMenu.vue
var ContextMenu_default = /* @__PURE__ */ defineComponent({
	__name: "ContextMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const menu = ref();
		const pt = computed(() => ({ item: (options) => ({
			class: "context-menu-item",
			...options.context.item.attributes
		}) }));
		function toggle(event) {
			menu.value.toggle(event);
		}
		function show(event) {
			menu.value.show(event);
		}
		function hide() {
			menu.value.hide();
		}
		__expose({
			menu,
			toggle,
			show,
			hide
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeContextMenu), {
				ref_key: "menu",
				ref: menu,
				model: __props.items,
				popup: "",
				pt: pt.value
			}, {
				item: withCtx(({ item, props, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					props
				}, () => [createVNode(ContextMenuItem_default, {
					item,
					props,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"props",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 8, ["model", "pt"]);
		};
	}
});
//#endregion
//#region src/composables/useDatagridAddRow.ts
var AddRow = class extends Row {
	constructor(..._args) {
		super(..._args);
		this.isAddRow = true;
	}
};
/**
* Gets the functionalities of the add row of the data grid.
*/
function useDatagridAddRow(emit) {
	async function addRowAdding(grid) {
		if (grid.editableCollectionView) {
			grid.finishEditing();
			return !!await new Promise((resolve) => {
				emit("addRowAdding", resolve);
			});
		}
		return false;
	}
	async function addRowCommitting(grid) {
		if (grid.editableCollectionView && grid.editableCollectionView.currentAddItem) {
			const currentRow = grid.rows[grid.selection.row];
			if (currentRow) {
				grid.finishEditing();
				const cancelable = grid.editableCollectionView.currentAddItem !== currentRow.dataItem;
				const committed = await new Promise((resolve) => {
					emit("addRowCommitting", cancelable, resolve);
				});
				if (committed) addAddRow(grid);
				return committed;
			}
		}
		return false;
	}
	return {
		buildAddRow,
		addRowAdding,
		addRowCommitting
	};
}
/**
* Adds the add row.
*/
function addAddRow(grid) {
	if (!grid.rows.some((r) => r instanceof AddRow)) {
		grid.rows.push(new AddRow());
		return true;
	}
	return false;
}
/**
* Removes the add row.
*/
function removeAddRow(grid) {
	const index = grid.rows.findIndex((r) => r instanceof AddRow);
	if (index !== -1) {
		grid.rows.splice(index, 1);
		return true;
	}
	return false;
}
/**
* Builds the add row.
*/
function buildAddRow(grid, addRow = true) {
	let built = false;
	if (grid.editableCollectionView) {
		if (!addRow || grid.editableCollectionView.isAddingNew) built ||= removeAddRow(grid);
		if (addRow && !grid.editableCollectionView.isAddingNew) built ||= addAddRow(grid);
	}
	return built;
}
//#endregion
//#region src/composables/useDatagridCheckboxCell.ts
function isIndeterminateCheckboxCell(column, value) {
	return column.isExpressionCode && typeof value === "string" && value.startsWith("=");
}
function getCheckboxCellValue(value) {
	if (value === true || value === "true") return true;
	if (value === false || value === "false") return false;
}
function changeCheckboxCellValue(columns, hit, readOnly) {
	const col = hit.getColumn();
	const column = columns.get(col.name);
	const row = hit.getRow();
	if (!column || readOnly(col, row.dataItem)) return;
	const newValue = getNewCheckboxCellValue(column, row.dataItem[column.name]);
	if (newValue !== void 0) row.dataItem[column.name] = newValue;
}
function getNewCheckboxCellValue(column, value) {
	if (!column.isExpressionCode) return !value;
	if (value === "true") return "false";
	if (value === "false") return "true";
}
//#endregion
//#region src/composables/useDatagridDragDrop.ts
var dragScrollEdgeThreshold = 48;
var dragScrollStep = 24;
var undefinedHit$1 = {
	hit: void 0,
	row: void 0
};
var _dragRow;
var _dragRowElement;
var _dropRowElement;
function getRowIndex(row) {
	return row.grid.collectionView.sourceCollection.indexOf(row.dataItem);
}
function useDatagridDragDrop(props, grid) {
	const rowDragDrop = computed(() => !!props.rowDrop);
	function handleDragstart(event) {
		const { hit, row } = getHit(event);
		if (!row) {
			_dragRow = void 0;
			return;
		}
		_dragRow = row;
		_dragRowElement = getRowElement(hit);
		_dragRowElement.setAttribute("data-drag", "true");
		if (event.dataTransfer) {
			event.dataTransfer.effectAllowed = "move";
			event.dataTransfer.setDragImage(_dragRowElement, 0, 0);
		}
	}
	function handleDragover(event) {
		if (!_dragRow) return;
		updateAutoScroll(event);
		const { hit, row } = getHit(event);
		if (!row) {
			resetDropRow();
			return;
		}
		const rowIndex = getRowIndex(row);
		const dragRowIndex = getRowIndex(_dragRow);
		if (rowIndex === dragRowIndex) {
			resetDropRow();
			return;
		}
		if (hit.target.parentElement === _dropRowElement) {
			event.preventDefault();
			return;
		}
		if (!props.rowDragover || props.rowDragover({
			item: row.dataItem,
			newIndex: rowIndex
		})) {
			event.preventDefault();
			resetDropRow();
			_dropRowElement = getRowElement(hit);
			_dropRowElement.setAttribute("data-drop", rowIndex > dragRowIndex ? "bottom" : "top");
		}
	}
	function handleDrop(event) {
		if (!_dragRow || !props.rowDrop) return;
		const draggedRow = _dragRow;
		_dragRow = void 0;
		const { row } = getHit(event);
		if (!row) return;
		props.rowDrop({
			item: draggedRow.dataItem,
			newIndex: getRowIndex(row)
		});
	}
	function handleDragend() {
		resetDragRow();
		resetDropRow();
	}
	function getHit(event) {
		if (grid.value && event.target instanceof HTMLElement && event.target.closest(".row-drag-col")) {
			const hit = grid.value.hitTest(event);
			if (hit.cellType === CellType.Cell && hit.getColumn().name === "$$row-drag") {
				const row = hit.getRow();
				if (row.dataItem) return {
					hit,
					row
				};
			}
		}
		return undefinedHit$1;
	}
	function getRowElement(hit) {
		return hit.target.parentElement;
	}
	function updateAutoScroll(event) {
		const scrollRoot = getScrollRoot();
		if (!scrollRoot) return;
		const maxScrollTop = scrollRoot.scrollHeight - scrollRoot.clientHeight;
		if (maxScrollTop <= 0) return;
		const scrollRootRect = scrollRoot.getBoundingClientRect();
		if (event.clientY <= scrollRootRect.top + dragScrollEdgeThreshold) {
			scrollRoot.scrollTop = Math.max(0, scrollRoot.scrollTop - dragScrollStep);
			return;
		}
		if (event.clientY >= scrollRootRect.bottom - dragScrollEdgeThreshold) scrollRoot.scrollTop = Math.min(maxScrollTop, scrollRoot.scrollTop + dragScrollStep);
	}
	function getScrollRoot() {
		return grid.value?._root;
	}
	function resetDragRow() {
		_dragRow = void 0;
		if (_dragRowElement) {
			_dragRowElement.removeAttribute("data-drag");
			_dragRowElement = void 0;
		}
	}
	function resetDropRow() {
		if (_dropRowElement) {
			_dropRowElement.removeAttribute("data-drop");
			_dropRowElement = void 0;
		}
	}
	onScopeDispose(() => {
		resetDragRow();
		resetDropRow();
	});
	return {
		rowDragDrop,
		handleDragstart,
		handleDragover,
		handleDragend,
		handleDrop
	};
}
//#endregion
//#region src/utils/datagridUtils.ts
function isAddRow(row) {
	return row instanceof AddRow;
}
function isDetailRow(row) {
	return row instanceof DetailRow;
}
function isGroupRow(row) {
	return row instanceof GroupRow;
}
function isSingleColumnRow(row) {
	return isDetailRow(row) || isGroupRow(row);
}
function isSystemRow(row) {
	return isAddRow(row) || isSingleColumnRow(row);
}
function isEditingCell(grid, row, col) {
	if (!grid.editRange) return false;
	if (col === void 0) return grid.editRange.containsRow(row);
	return grid.editRange.contains(row, col);
}
function hitTestContainsColumn(hit, col) {
	if (hit.mergedRange) return hit.mergedRange.containsColumn(col);
	return hit.col === col;
}
function adjustColumnIndexForMergedRange(gridPanel, rowIndex, colIndex, backward) {
	const mergedRange = gridPanel.grid.getMergedRange(gridPanel, rowIndex, colIndex);
	if (mergedRange) return backward ? mergedRange.col : mergedRange.col2;
	return colIndex;
}
//#endregion
//#region src/composables/useDatagridMergeManager.ts
function useDatagridMergeManager(props, grid, systemColumnCount, columnsMap) {
	watch([grid, () => props.colspan], ([grid, colspan]) => {
		if (grid) {
			if (colspan) grid.mergeManager = new CustomMergeManager(colspan, systemColumnCount, columnsMap);
			else if (grid.mergeManager instanceof CustomMergeManager) grid.mergeManager = new MergeManager();
		}
	});
}
var CustomMergeManager = class extends MergeManager {
	constructor(colspan, systemColumnCount, columnsMap) {
		super();
		this.colspan = colspan;
		this.systemColumnCount = systemColumnCount;
		this.columnsMap = columnsMap;
	}
	getMergedRange(p, r, c) {
		if (p.cellType !== CellType.Cell) return null;
		if (c < this.systemColumnCount.value) return null;
		const column = p.columns[c];
		if (!column?.name) return null;
		const row = p.rows[r];
		if (!row || isSystemRow(row)) return null;
		const item = row?.dataItem;
		if (!item) return null;
		const colspan = this.getColspan(item, column);
		const range = colspan === -1 ? this.getFullRowRange(p, r) : this.getPartialRowRange(p, r, c, item, colspan);
		if (range.col === range.col2) return null;
		return range;
	}
	getFullRowRange(p, r) {
		return new CellRange(r, this.systemColumnCount.value, r, p.columns.length - 1);
	}
	getPartialRowRange(p, r, c, item, colspan) {
		let c1 = c;
		for (let i = c - 1; i >= this.systemColumnCount.value; i--) {
			const colspan = this.getColspan(item, p.columns[i]);
			if (i + colspan >= c) c1 = i;
		}
		return new CellRange(r, c1, r, c + colspan);
	}
	getColspan(item, column) {
		return this.colspan({
			item,
			column: this.columnsMap.value.get(column.name)
		});
	}
};
//#endregion
//#region src/composables/useDatagridRowActions.ts
var undefinedHit = {
	hit: void 0,
	row: void 0,
	item: void 0
};
function getHit(grid, event) {
	const hit = grid.hitTest(event);
	if (hit.cellType === CellType.Cell) {
		const row = hit.getRow();
		if (row?.dataItem && !isSystemRow(row)) return {
			hit,
			row,
			item: row.dataItem
		};
	}
	return undefinedHit;
}
function useDatagridRowActions(props, grid) {
	const rowActionsElement = shallowRef();
	const currentRow = shallowRef();
	const rowActionsItem = computed(() => currentRow.value?.item);
	watch(grid, (newGrid, oldGrid) => {
		if (oldGrid) {
			oldGrid.beginningEdit.removeHandler(handleBeginningEdit);
			oldGrid._root.removeEventListener("scroll", handleScroll);
			oldGrid._root.removeEventListener("mouseleave", handleMouseleave);
			oldGrid._root.removeEventListener("mousemove", handleMousemouse);
		}
		if (newGrid) {
			newGrid.beginningEdit.addHandler(handleBeginningEdit);
			newGrid._root.addEventListener("scroll", handleScroll);
			newGrid._root.addEventListener("mouseleave", handleMouseleave);
			newGrid._root.addEventListener("mousemove", handleMousemouse);
		}
	}, { immediate: true });
	async function handleMousemouse(event) {
		if (!grid.value || !rowActionsElement.value) return;
		if (currentRow.value && currentRow.value.target === event.target) return;
		const { hit, row, item } = getHit(grid.value, event);
		if (!hit || isEditingCell(grid.value, hit.row)) {
			resetCurrentRow();
			return;
		}
		if (isCurrentRow(item)) return;
		currentRow.value = {
			item,
			rowIndex: hit.row,
			target: event.target
		};
		rowActionsElement.value.removeAttribute("style");
		await nextTick();
		if (rowActionsElement.value.parentElement !== grid.value._root) grid.value._root.append(rowActionsElement.value);
		const cell = grid.value.cells.getCellElement(hit.row, hit.col);
		if (!cell) {
			resetCurrentRow();
			return;
		}
		updateCurrentRow(grid.value, rowActionsElement.value, row, cell);
	}
	function handleMouseleave() {
		if (!isDropdownActive()) resetCurrentRow();
	}
	function handleBeginningEdit() {
		resetCurrentRow();
	}
	function handleScroll() {
		resetCurrentRow();
	}
	function updateCurrentRow(grid, rowActionsElement, row, cell) {
		const height = row.height ?? grid.rows.defaultSize;
		const top = Number(cell.style.top.substring(0, cell.style.top.length - 2));
		rowActionsElement.style.display = "flex";
		rowActionsElement.style.height = `${height - 4}px`;
		rowActionsElement.style.top = `${grid.columnHeaders.rows.minSize + top + 2}px`;
		rowActionsElement.style.left = `${Math.min(grid.cells.hostElement.offsetWidth, grid._root.clientWidth + grid._root.scrollLeft) - 4}px`;
		rowActionsElement.style.width = "max-content";
		rowActionsElement.style.transform = "translateX(-100%)";
	}
	function resetCurrentRow() {
		currentRow.value = void 0;
		if (rowActionsElement.value) rowActionsElement.value.style.display = "none";
	}
	function isCurrentRow(item) {
		return currentRow.value?.item === item;
	}
	function isInRowActions(target) {
		return rowActionsElement.value?.contains(target) ?? false;
	}
	return {
		rowActionsItem,
		rowActionsElement,
		isInRowActions
	};
}
//#endregion
//#region src/composables/useDatagridRowDetail.ts
function useDatagridRowDetail(props) {
	const rowDetailComponent = ref();
	function isRowDetailVisible(row) {
		return rowDetailComponent.value?.control.isDetailVisible(row) ?? false;
	}
	function getRowDetailColumnIcon(row) {
		return isRowDetailVisible(row) ? "chevronDown" : "chevronRight";
	}
	function toggleRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (isRowDetailVisible(row)) rowDetailComponent.value.control.hideDetail(row);
		else rowDetailComponent.value.control.showDetail(row, props.rowDetailVisibilityMode === "single");
		return true;
	}
	function expandRowDetail(row) {
		if (!rowDetailComponent.value) return false;
		if (!isRowDetailVisible(row)) {
			rowDetailComponent.value.control.showDetail(row, false);
			return true;
		}
		return false;
	}
	function expandRowDetailsOnLoad(rows, currentRowIndex) {
		if (!props.rowDetailExpandedByDefault) return false;
		if (props.rowDetailVisibilityMode === "single") {
			const currentRow = rows[currentRowIndex];
			if (currentRow) return expandRowDetail(currentRow);
			return false;
		}
		for (const row of rows) if (!isSystemRow(row)) expandRowDetail(row);
		return true;
	}
	function expandRowDetailOnAdd(row) {
		if (!props.rowDetailExpandedByDefault) return false;
		return expandRowDetail(row);
	}
	return {
		rowDetailComponent,
		getRowDetailColumnIcon,
		toggleRowDetail,
		expandRowDetailsOnLoad,
		expandRowDetailOnAdd
	};
}
//#endregion
//#region src/composables/useDatagridValidation.ts
var validationTooltips = {
	error: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-error"
	}),
	warning: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-warning"
	}),
	information: new Tooltip({
		isContentHtml: false,
		showDelay: 50,
		cssClass: "datagrid-tooltip datagrid-tooltip-information"
	})
};
validationTooltips.error.popup.addHandler(popupHandler);
validationTooltips.warning.popup.addHandler(popupHandler);
validationTooltips.information.popup.addHandler(popupHandler);
function popupHandler(sender, args) {
	ZIndex$1.set("tooltip", args.tip);
	Control._POPUP_ZINDEX = Number(args.tip.style.zIndex);
	ZIndex$1.clear(args.tip);
}
function useDatagridValidation() {
	function setCellValidationMessage(cell, message) {
		if (message) {
			cell.classList.add(`${message.severity}-cell`);
			validationTooltips[message.severity].setTooltip(cell, message.text);
		} else for (const severity of validationMessageSeverities) {
			cell.classList.remove(`${severity}-cell`);
			validationTooltips[severity].setTooltip(cell, null);
		}
	}
	onUnmounted(() => {
		for (const tooltip of Object.values(validationTooltips)) tooltip.dispose();
	});
	return { setCellValidationMessage };
}
//#endregion
//#region src/exporting/utils.ts
function createTempCellElement(grid) {
	const element = document.createElement("div");
	element.style.visibility = "hidden";
	grid.cells.hostElement.append(element);
	element.dispose = () => {
		grid.cellFactory.disposeCell(element);
		element.remove();
	};
	return element;
}
function getDisplayTemplateText(grid, row, col) {
	const element = createTempCellElement(grid);
	grid.cellFactory.updateCell(grid.cells, row, col, element);
	const text = element.innerText;
	element.dispose();
	return text;
}
//#endregion
//#region src/utils/DatagridCollectionView.ts
var DatagridCollectionView = class {
	constructor() {
		this.sourceCollection = [];
		this.items = [];
		this.canFilter = true;
		this.canGroup = true;
		this.canSort = true;
		this.currentPosition = -1;
		this.isEditingItem = false;
		this.filter = () => true;
		this.groupDescriptions = new ObservableArray$1();
		this.groups = [];
		this.sortDescriptions = new ObservableArray$1();
		this.collectionChanged = new Event$1();
		this.currentChanged = new Event$1();
		this.currentChanging = new Event$1();
	}
	get isEmpty() {
		return this.sourceCollection.length === 0;
	}
	get canAddNew() {
		return true;
	}
	get canCancelEdit() {
		return true;
	}
	get canRemove() {
		return true;
	}
	get currentItem() {}
	get currentAddItem() {}
	get isAddingNew() {
		return false;
	}
	contains() {
		return true;
	}
	moveCurrentTo() {
		return true;
	}
	moveCurrentToFirst() {
		return true;
	}
	moveCurrentToLast() {
		return true;
	}
	moveCurrentToNext() {
		return true;
	}
	moveCurrentToPosition() {
		return true;
	}
	moveCurrentToPrevious() {
		return true;
	}
	refresh() {}
	beginUpdate() {}
	endUpdate() {}
	deferUpdate() {}
	addNew() {}
	commitNew() {}
	cancelNew() {}
	editItem() {}
	commitEdit() {}
	cancelEdit() {}
	remove() {}
	removeAt() {}
	implementsInterface(interfaceName) {
		return interfaceName === "INotifyCollectionChanged" || interfaceName === "ICollectionView" || interfaceName === "IEditableCollectionView";
	}
};
//#endregion
//#region src/utils/style.ts
/**
* Takes an abstracted single or multiple space value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiSpaceValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, SpaceValues);
}
/**
* Takes an abstracted single or multiple radius value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getMultiRadiusValue(abstractedValue) {
	return getPredefinedSizingValue(abstractedValue, CornerRadiusValues);
}
/**
* Converts Neos content align values to PrimeVue divider align values.
* - We use culturally invariant vocabulary (e.g. 'start' | 'end').
* - Whereas PrimeVue uses occidental vocabulary (e.g. 'left' | 'right').
*/
function convertInvariantTextAlignToOccidentalTextAlign(align) {
	switch (align) {
		case "center": return "center";
		case "end": return "right";
		default: return "left";
	}
}
function convertTextAlignToAlignItems(align, explicitDefaultValue) {
	switch (align) {
		case "center": return "center";
		case "end": return "flex-end";
		case "start": return explicitDefaultValue ? "flex-start" : "";
		default: return "";
	}
}
/**
* (PRIVATE)
* Takes an abstracted single or multiple sizing value(s) (1 or 4 space values separated by spaces) and transform it to CSS property value.
*
* @param abstractedValue - The abstracted multi-size value.
*/
function getPredefinedSizingValue(abstractedValue, allowedSpacingValues) {
	const spaceAbstractValues = abstractedValue.replaceAll("'", "").split(" ").map((r) => allowedSpacingValues[r]);
	if (spaceAbstractValues.length > 0 && spaceAbstractValues.filter((s) => s === void 0).length === 0) return spaceAbstractValues.join(" ");
	return "";
}
/**
* Returns the value if it is a supported color name/value,
* or the value of the CSS variable with that name (`var(--thatParamValue)`).
*/
function getColorValue(value) {
	return value !== "background" && CSS.supports("color", value) ? value : `var(--${value})`;
}
//#endregion
//#region src/exporting/csv.ts
async function exportToCsvFile(grid, columns, systemColumnCount) {
	const csv = await getClipString(grid, columns, new CellRange(0, systemColumnCount, grid.rows.length - 1, grid.columns.length - 1));
	saveAs(new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8" }), "export.csv");
}
/**
* The following code is coming from https://www.grapecity.com/forums/wijmo/subtotal-aggregated-column-identififcation.
* The original "getClipString" method uses raw values and not the displayed values.
**/
/* istanbul ignore next -- @preserve */
async function getClipString(grid, columns, rng) {
	const tempCellElement = createTempCellElement(grid);
	let text = `${getHeaderString(grid, rng, tempCellElement)}\n`;
	for (let r = rng.topRow; r <= rng.bottomRow; r++) {
		if (grid.rows[r] instanceof AddRow) continue;
		text += `${await getRowString(grid, columns, rng, r)}\n`;
	}
	tempCellElement.dispose();
	return text;
}
/* istanbul ignore next -- @preserve */
function getHeaderString(grid, rng, tempCellElement) {
	let text = "";
	const row = grid.columnHeaders.rows.length - 1;
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		if (!grid.columns[c].isVisible) continue;
		if (!firstCell) text += ",";
		firstCell = false;
		grid.cellFactory.updateCell(grid.columnHeaders, row, c, tempCellElement);
		text += tempCellElement.querySelector(".column-caption")?.innerText?.replaceAll(",", "");
	}
	return text;
}
/* istanbul ignore next -- @preserve */
async function getRowString(grid, columns, rng, r) {
	let text = "";
	let firstCell = true;
	for (let c = rng.leftCol; c <= rng.rightCol; c++) {
		const col = grid.columns[c];
		if (!col.isVisible) continue;
		if (firstCell) firstCell = false;
		else text += ",";
		const column = columns.get(col.name);
		if (column) {
			if (column.displayTemplate) text += escapeValue(getDisplayTemplateText(grid, r, c));
			else if (column.displayText) {
				const item = grid.rows[r].dataItem;
				const value = getPropertyByPath(item, column.name);
				text += escapeValue(await column.displayText(value, item));
			}
		}
	}
	return text;
}
function escapeValue(value) {
	return value.includes(",") || value.includes("\n") || value.includes("\"") ? `"${value.replaceAll("\"", "\"\"")}"` : value;
}
//#endregion
//#region src/exporting/xlsx.ts
async function exportToXlsxFile(grid, columns) {
	const { FlexGridXlsxConverter } = await import("@mescius/wijmo.grid.xlsx");
	FlexGridXlsxConverter.saveAsync(grid, {
		includeStyles: false,
		includeColumns(col) {
			if (grid.collectionView.groupDescriptions.length > 0) {
				if (col.name === "$$row-indicator") return true;
				if (grid.collectionView.groupDescriptions.some((d) => d instanceof PropertyGroupDescription$1 && d.propertyName === col.name)) return false;
			}
			return columns.get(col.name)?.visible === true;
		},
		formatItem(args) {
			if (args.panel === grid.columnHeaders) formatColumnHeader(args, columns);
			else if (args.panel === grid.cells) formatCell(args, grid, columns);
		}
	}, "export.xlsx");
}
function formatColumnHeader(args, columns) {
	const col = args.getColumn();
	if (col.name === "$$row-indicator") args.xlsxCell.value = void 0;
	else {
		const column = columns.get(col.name);
		if (column) updateCellAlignment(args.xlsxCell.style, column.align);
	}
}
function formatCell(args, grid, columns) {
	const item = args.getRow().dataItem;
	if (!item) {
		args.xlsxCell.value = void 0;
		return;
	}
	if (item instanceof CollectionViewGroup$1) formatGroupRowCell(args, grid, columns, item);
	else formatRowCell(args, grid, columns, item);
}
function formatRowCell(args, grid, columns, item) {
	const columnName = args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	args.xlsxCell.isDate = false;
	args.xlsxCell.isNumber = false;
	if (column.displayTemplate) args.xlsxCell.value = getDisplayTemplateText(grid, args.row, args.col);
	else if (column.displayTextSync) {
		const value = getPropertyByPath(item, columnName);
		args.xlsxCell.value = column.displayTextSync(value, item);
	}
	updateCellAlignment(args.xlsxCell.style, column.align);
}
function formatGroupRowCell(args, grid, columns, item) {
	const groupDescription = item.groupDescription;
	const isFirstColumn = grid.columns.firstVisibleIndex === args.col;
	const columnName = isFirstColumn ? groupDescription.propertyName : args.getColumn().name;
	const column = columns.get(columnName);
	if (!column) return;
	if (isFirstColumn && column.displayTextSync) args.xlsxCell.value = column.displayTextSync(item.name, item);
	updateCellAlignment(args.xlsxCell.style, isFirstColumn ? "start" : column.align);
}
function updateCellAlignment(style, align) {
	style.wordWrap = true;
	style.vAlign = 1;
	if (align === "end") style.hAlign = 3;
	else if (align === "center") style.hAlign = 2;
	else style.hAlign = 1;
}
//#endregion
//#region src/composables/useSpeech.ts
function useSpeech(props, culture, handleChange) {
	const speech = useSpeechRecognition({ lang: culture });
	/**
	* Indicates whether speech recognition is supported in the current browser and the speech button should be displayed.
	*/
	const displaySpeechButton = computed(() => props.speech && speech.isSupported.value);
	/**
	* Indicates whether the speech recognition is currently listening.
	*/
	const isListeningToSpeech = computed(() => speech.isListening.value);
	/**
	* Variant to apply to the speech button.
	*/
	const speechButtonVariant = computed(() => speech.isListening.value ? "ghost-primary" : "ghost");
	/**
	* The text that corresponds to the speech recognition result.
	*/
	const currentSpeech = ref(null);
	onMounted(() => {
		if (props.speech === "immediate") handleSpeechButtonClick();
	});
	watch([speech.result, speech.isFinal], ([result, isFinal]) => {
		currentSpeech.value = result;
		if (isFinal) {
			persistSpeech();
			speech.isListening.value = false;
		}
	});
	/**
	* Handles the click event of the speech button.
	* If speech recognition is already listening, it persists the current speech.
	*/
	function handleSpeechButtonClick() {
		if (speech.isListening.value) persistSpeech();
		speech.isListening.value = !speech.isListening.value;
	}
	function persistSpeech() {
		if (handleChange && currentSpeech.value !== null) handleChange(currentSpeech.value);
		currentSpeech.value = null;
	}
	return {
		currentSpeech,
		displaySpeechButton,
		handleSpeechButtonClick,
		isListeningToSpeech,
		speechButtonVariant
	};
}
/**
* Indicates whether the browser supports speech recognition.
* @returns true wen the browser supports speech recognition; otherwise false.
*/
function isSpeechSupported() {
	const w = window;
	return (w.SpeechRecognition ?? w.webkitSpeechRecognition) !== void 0;
}
//#endregion
//#region src/composables/useStringInput.ts
function useStringInput() {
	function normalizeWhiteSpaceInput(whiteSpaceHandling, inputText) {
		switch (whiteSpaceHandling) {
			case WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace:
			case WhiteSpaceHandling.noLeadingWhiteSpace: return inputText.trimStart();
			case WhiteSpaceHandling.noTrailingWhiteSpace: return inputText.trimEnd();
			case WhiteSpaceHandling.noWhiteSpace: return inputText.replaceAll(/\s/g, "");
		}
		return inputText;
	}
	function normalizeWhiteSpaceToEmit(whiteSpaceHandling, inputText) {
		if (whiteSpaceHandling === WhiteSpaceHandling.noLeadingAndTrailingWhiteSpace) return inputText.trim();
		return inputText;
	}
	return {
		normalizeWhiteSpaceInput,
		normalizeWhiteSpaceToEmit
	};
}
//#endregion
//#region src/utils/focus.ts
function isTouchDevice() {
	return navigator.maxTouchPoints > 0;
}
function focusExceptOnTouchDevice(element) {
	if (element && !isTouchDevice()) element.focus();
}
//#endregion
//#region src/components/Textbox/Textbox.ts?vue&type=script&src=true&lang.ts
var datagridMinRows = 1;
var datagridMaxRows = 10;
var Textbox_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Textbox",
	components: {
		Button: Button_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		Image: Image_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: 10
		},
		tooltip: {
			type: String,
			default: void 0
		},
		clear: {
			type: Boolean,
			default: false
		},
		speech: {
			type: [Boolean, String],
			default: false
		},
		characterCasing: {
			type: String,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		}
	},
	emits: [
		...inputEmits,
		"input",
		"listeningToSpeech",
		"keydown"
	],
	setup(props, { emit, slots }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const { currentSpeech, displaySpeechButton, handleSpeechButtonClick, isListeningToSpeech, speechButtonVariant } = useSpeech(props, useLocalizator().currentCulture, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const displayDefaultSlotContainer = computed(() => slots.default !== void 0 || props.clear || displaySpeechButton.value);
		const localValue = ref(props.modelValue ?? "");
		const isInputEmpty = ref(localValue.value.length === 0);
		watch(() => props.modelValue, (newVal) => {
			localValue.value = newVal ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		});
		watch(currentSpeech, (speech) => {
			if (speech != null) {
				localValue.value = speech;
				isInputEmpty.value = localValue.value.length === 0;
			}
		});
		const hasSuggestionPlaceholder = computed(() => isInputEmpty.value && props.aiSuggestion?.suggestedValue != null);
		const suggestionPlaceholderText = computed(() => String(props.aiSuggestion.suggestedValue));
		const placeholderText = computed(() => {
			if (hasSuggestionPlaceholder.value) return;
			return props.placeholder ?? (isListeningToSpeech.value ? translate("ListeningToSpeech") : void 0);
		});
		const text = computed(() => localValue.value);
		const textareaRows = ref();
		const { normalizeWhiteSpaceInput, normalizeWhiteSpaceToEmit } = useStringInput();
		watch(() => props.rows, () => {
			if (props.inputDisplayMode === "form" && props.multiLines) textareaRows.value = props.rows;
		});
		watch(isListeningToSpeech, (value) => emit("listeningToSpeech", value));
		onMounted(() => {
			if (props.multiLines) {
				if (props.inputDisplayMode === "datagrid") {
					if (props.modelValue) textareaRows.value = Math.min(Math.max(props.modelValue.split(`\n`).length, datagridMinRows), datagridMaxRows);
					else textareaRows.value = datagridMinRows;
				} else textareaRows.value = props.rows;
			}
		});
		function handleFocus(event) {
			event.target.select();
		}
		function handleBeforeAfterContentFocusin() {
			focusExceptOnTouchDevice(input.value);
		}
		function handleChange(event) {
			const element = event.target;
			emitNewValue(element.value);
		}
		function handleInput(event) {
			const element = event.target;
			isInputEmpty.value = !element.value;
			if (props.updateMode === "immediate") {
				localValue.value = element.value;
				isInputEmpty.value = localValue.value.length === 0;
				if (element.value != props.modelValue) emit("update:modelValue", element.value !== "" ? element.value : null);
				emit("input", event);
				return;
			}
			if (element.value) {
				let value = element.value;
				switch (props.characterCasing) {
					case CharacterCasing.upperCasing:
						value = element.value.toUpperCase();
						break;
					case CharacterCasing.lowerCasing: value = element.value.toLocaleLowerCase();
				}
				value = normalizeWhiteSpaceInput(props.whiteSpaceHandling, value);
				if (value !== element.value) {
					const { selectionStart, selectionEnd } = element;
					element.value = value;
					element.setSelectionRange(selectionStart, selectionEnd);
				}
			}
			localValue.value = element.value;
			emit("input", event);
		}
		function handleKeyDown(event) {
			if (hasSuggestionPlaceholder.value) {
				if (event.key === "Tab" && !event.shiftKey && !event.ctrlKey && !event.altKey) {
					event.preventDefault();
					event.stopPropagation();
					emit("aiApply");
					return;
				}
				if (event.key === "Escape") {
					event.preventDefault();
					event.stopPropagation();
					emit("aiCancel");
					return;
				}
			}
			if (props.inputDisplayMode === "datagrid" && props.multiLines) keyDown(event);
			emit("keydown", event);
		}
		function handleClearButtonClick() {
			emitNewValue(null);
			isInputEmpty.value = true;
			localValue.value = "";
		}
		function emitNewValue(value) {
			value = value !== "" ? value : null;
			const oldValue = props.modelValue;
			if (value) {
				switch (props.characterCasing) {
					case CharacterCasing.camelCasing:
						value = toCamelCase(value, true);
						break;
					case CharacterCasing.pascalCasing: value = toPascalCase(value);
				}
				value = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, value);
			}
			if (value != oldValue) emit("update:modelValue", value);
			if (value && (input.value instanceof HTMLInputElement || input.value instanceof HTMLTextAreaElement) && shouldResetInputValue(value, oldValue)) input.value.value = value;
			localValue.value = value ?? "";
			isInputEmpty.value = localValue.value.length === 0;
		}
		function keyDown(event) {
			switch (event.key) {
				case "Enter":
					if (event.altKey && !event.ctrlKey && !event.shiftKey) {
						const textarea = event.target;
						let cursorPos = textarea.selectionEnd;
						let value = textarea.value;
						value = `${value.substring(0, cursorPos)}\n${value.substring(cursorPos)}`;
						textarea.value = value;
						cursorPos += 1;
						textarea.setSelectionRange(cursorPos, cursorPos);
						if (cursorPos === value.length) textarea.scrollTop = textarea.scrollHeight;
						event.stopPropagation();
					}
					break;
				case "ArrowUp":
				case "ArrowDown": if (!event.altKey && !event.ctrlKey && !event.shiftKey) event.stopPropagation();
			}
		}
		function shouldResetInputValue(newValue, oldValue) {
			return props.inputDisplayMode === "form" && newValue === oldValue;
		}
		return {
			aiSuggestion: computed(() => props.aiSuggestion),
			classes,
			displayDefaultSlotContainer,
			displaySpeechButton,
			handleBeforeAfterContentFocusin,
			handleChange,
			handleClearButtonClick,
			handleFocus,
			handleInput,
			handleKeyDown,
			handleSpeechButtonClick,
			hasSuggestionPlaceholder,
			id,
			input,
			isLabelVisible,
			isMessageVisible,
			placeholderText,
			speechButtonVariant,
			suggestionPlaceholderText,
			tabIndex,
			text,
			textareaRows
		};
	}
});
//#endregion
//#region src/components/Textbox/Textbox.vue
var _hoisted_1$23 = ["title"];
var _hoisted_2$12 = {
	key: 1,
	class: "textbox-suggestion-placeholder"
};
var _hoisted_3$5 = { class: "textbox-suggestion-text" };
var _hoisted_4$4 = [
	"id",
	"value",
	"disabled",
	"rows",
	"maxlength",
	"readonly",
	"tabindex",
	"placeholder"
];
var _hoisted_5$4 = [
	"id",
	"value",
	"tabindex",
	"placeholder",
	"maxlength",
	"disabled",
	"readonly"
];
function _sfc_render$24(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["textbox neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", {
		class: "textbox-content neos-input-content",
		title: _ctx.tooltip ?? void 0
	}, [
		_ctx.$slots.before ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: "textbox-before-content",
			onFocusin: _cache[2] || (_cache[2] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [renderSlot(_ctx.$slots, "before", {}, void 0, true)], 32)) : createCommentVNode("", true),
		_ctx.hasSuggestionPlaceholder ? (openBlock(), createElementBlock("div", _hoisted_2$12, [createVNode(_component_Image, {
			class: "textbox-suggestion-icon",
			name: "ai"
		}), createElementVNode("span", _hoisted_3$5, toDisplayString(_ctx.suggestionPlaceholderText), 1)])) : createCommentVNode("", true),
		_ctx.multiLines ? (openBlock(), createElementBlock("textarea", {
			key: 2,
			id: _ctx.id,
			ref: "input",
			value: _ctx.text,
			disabled: _ctx.disabled,
			rows: _ctx.textareaRows,
			maxlength: _ctx.maxLength,
			readonly: _ctx.readonly,
			class: "textbox-textarea",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[3] || (_cache[3] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[4] || (_cache[4] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onKeydown: _cache[5] || (_cache[5] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}, "        ", 40, _hoisted_4$4)) : (openBlock(), createElementBlock("input", {
			key: 3,
			id: _ctx.id,
			ref: "input",
			type: "text",
			value: _ctx.text,
			class: "textbox-input",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholderText,
			maxlength: _ctx.maxLength,
			disabled: _ctx.disabled,
			readonly: _ctx.readonly,
			spellcheck: "false",
			autocomplete: "nope",
			onChange: _cache[6] || (_cache[6] = (...args) => _ctx.handleChange && _ctx.handleChange(...args)),
			onInput: _cache[7] || (_cache[7] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onFocus: _cache[8] || (_cache[8] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args)),
			onKeydown: _cache[9] || (_cache[9] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args))
		}, null, 40, _hoisted_5$4)),
		_ctx.displayDefaultSlotContainer ? (openBlock(), createElementBlock("div", {
			key: 4,
			class: "textbox-after-content",
			onFocusin: _cache[12] || (_cache[12] = (...args) => _ctx.handleBeforeAfterContentFocusin && _ctx.handleBeforeAfterContentFocusin(...args))
		}, [
			renderSlot(_ctx.$slots, "default", {}, void 0, true),
			_ctx.displaySpeechButton ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-speech-button",
				size: "small",
				variant: _ctx.speechButtonVariant,
				icon: "microphone",
				tabindex: "-1",
				onClick: _cache[10] || (_cache[10] = ($event) => _ctx.handleSpeechButtonClick())
			}, null, 8, ["variant"])) : createCommentVNode("", true),
			_ctx.clear ? withDirectives((openBlock(), createBlock(_component_Button, {
				key: 1,
				class: "input-clear-button",
				size: "small",
				variant: "ghost",
				icon: "erase",
				tabindex: "-1",
				onClick: _cache[11] || (_cache[11] = ($event) => _ctx.handleClearButtonClick())
			}, null, 512)), [[vShow, _ctx.modelValue]]) : createCommentVNode("", true)
		], 32)) : createCommentVNode("", true)
	], 8, _hoisted_1$23)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var Textbox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Textbox_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$24], ["__scopeId", "data-v-53a0603f"]]);
//#endregion
//#region src/components/DatagridColumnPicker/DatagridColumnPicker.ts?vue&type=script&src=true&lang.ts
var DatagridColumnPicker_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridColumnPicker",
	components: {
		Button: Button_default,
		Popover: Popover_default,
		Textbox: Textbox_default,
		VerticalLayout: VerticalLayout_default,
		WjListBox
	},
	props: {
		grid: {
			type: Object,
			required: true
		},
		columns: {
			type: Object,
			required: true
		}
	},
	emits: ["columnsChanged"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const popover = ref();
		const filter = ref();
		const pickerColumns = ref([]);
		watch(filter, () => pickerColumns.value = getColumns());
		function show(event) {
			pickerColumns.value = getColumns();
			popover.value.show(event);
		}
		function hide() {
			popover.value.hide();
		}
		function getColumns() {
			const cols = [];
			for (const column of props.grid.columns) {
				const col = column.name && props.columns.get(column.name);
				if (!col) continue;
				const caption = col.pickerCaption ?? col.caption;
				if (caption && col.movable !== false && (!filter.value || caption.toLowerCase().includes(filter.value.toLowerCase()))) cols.push({
					name: col.name,
					caption,
					visible: column.visible,
					visibleIndex: column.visibleIndex
				});
			}
			return cols.sort((a, b) => {
				if (a.visible && !b.visible) return -1;
				if (!a.visible && b.visible) return 1;
				if (a.visible && b.visible) return a.visibleIndex - b.visibleIndex;
				return a.caption.localeCompare(b.caption);
			});
		}
		function handleCheckedItemsChanged(listBox) {
			let changed = false;
			for (const column of props.grid.columns) if (pickerColumns.value.some((c) => c.name === column.name)) {
				const newVisible = listBox.checkedItems.some((c) => c.name === column.name);
				if (column.visible !== newVisible) {
					column.visible = newVisible;
					changed = true;
				}
			}
			if (changed) emit("columnsChanged", props.grid);
		}
		function handleFormatItem(listBox, args) {
			args.item.setAttribute("data-property", args.data.name);
		}
		return {
			translate,
			popover,
			pickerColumns,
			filter,
			show,
			hide,
			handleCheckedItemsChanged,
			handleFormatItem
		};
	}
});
//#endregion
//#region src/components/DatagridColumnPicker/DatagridColumnPicker.vue
function _sfc_render$23(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Textbox = resolveComponent("Textbox");
	const _component_WjListBox = resolveComponent("WjListBox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_Popover = resolveComponent("Popover");
	return openBlock(), createBlock(_component_Popover, {
		ref: "popover",
		class: "datagrid-column-picker"
	}, {
		default: withCtx(() => [createVNode(_component_VerticalLayout, { space: "small" }, {
			default: withCtx(() => [createVNode(_component_Textbox, {
				modelValue: _ctx.filter,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.filter = $event),
				placeholder: _ctx.translate("Search"),
				"update-mode": "immediate"
			}, null, 8, ["modelValue", "placeholder"]), createVNode(_component_WjListBox, {
				"items-source": _ctx.pickerColumns,
				"display-member-path": "caption",
				"checked-member-path": "visible",
				"checked-items-changed": _ctx.handleCheckedItemsChanged,
				"format-item": _ctx.handleFormatItem,
				class: "datagrid-column-picker-list-box"
			}, null, 8, [
				"items-source",
				"checked-items-changed",
				"format-item"
			])]),
			_: 1
		})]),
		_: 1
	}, 512);
}
//#endregion
//#region src/components/DatagridContextMenu/DatagridContextMenu.ts?vue&type=script&src=true&lang.ts
var DatagridContextMenu_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridContextMenu",
	components: {
		DatagridColumnPicker: /* @__PURE__ */ _plugin_vue_export_helper_default(DatagridColumnPicker_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$23], ["__scopeId", "data-v-7d1b0d37"]]),
		ContextMenu: ContextMenu_default
	},
	props: {
		grid: {
			type: Object,
			required: true
		},
		columns: {
			type: Object,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		systemColumnCount: {
			type: Number,
			required: true
		},
		groupable: {
			type: Boolean,
			required: true
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		}
	},
	emits: ["update:groupPanelVisible", "columnsChanged"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const contextMenu = ref();
		const columnPickerEl = ref();
		const contextMenuItems = ref([]);
		async function toggle(event) {
			const hit = hitTest(event);
			if (hit) {
				contextMenuItems.value = getMenuItems(hit);
				if (contextMenuItems.value.length > 0) {
					await nextTick();
					event.preventDefault();
					columnPickerEl.value.hide();
					contextMenu.value.show(event);
				}
			}
		}
		function hitTest(event) {
			const hit = props.grid.hitTest(event);
			return hit.cellType === CellType.ColumnHeader || hit.cellType === CellType.Cell ? hit : void 0;
		}
		function getMenuItems(hit) {
			if (hit.cellType === CellType.Cell) return getCellMenuItems(hit);
			return getColumnHeaderMenuItems(hit);
		}
		function getCellMenuItems(hit) {
			if (!props.getRowContextMenuItems) return [];
			const item = hit.getRow()?.dataItem;
			if (!item || item instanceof CollectionViewGroup$1) return [];
			return props.getRowContextMenuItems(item, () => contextMenu.value.hide());
		}
		function getColumnHeaderMenuItems(hit) {
			const column = hit.getColumn();
			const col = props.columns.get(column.name);
			const items = [];
			if (props.groupable) {
				if (col) items.push({
					label: translate("GroupByColumn"),
					icon: "addGroup",
					attributes: { "data-command": "GROUP_BY_COLUMN" },
					disabled: !col.groupable,
					command() {
						contextMenu.value.hide();
						hit.grid.collectionView.groupDescriptions.push(new PropertyGroupDescription$1(column.name));
						column.visible = false;
						emit("update:groupPanelVisible", true);
					}
				});
				items.push({
					label: props.groupPanelVisible ? translate("HideGroupPanel") : translate("ShowGroupPanel"),
					icon: "groupPanel",
					attributes: { "data-command": "TOGGLE_GROUP_PANEL" },
					command() {
						contextMenu.value.hide();
						emit("update:groupPanelVisible", !props.groupPanelVisible);
					}
				});
			}
			if (props.exportable) {
				if (items.length > 0) items.push({ separator: true });
				items.push({
					label: translate("ExportDisplayedDataToCsvFile"),
					icon: "csv",
					disabled: hit.grid.collectionView.groupDescriptions.length > 0,
					attributes: { "data-command": "EXPORT_TO_CSV" },
					command() {
						contextMenu.value.hide();
						exportToCsvFile(hit.grid, props.columns, props.systemColumnCount);
					}
				}, {
					label: translate("ExportDisplayedDataToXlsxFile"),
					icon: "excel",
					attributes: { "data-command": "EXPORT_TO_XLSX" },
					command() {
						contextMenu.value.hide();
						exportToXlsxFile(hit.grid, props.columns);
					}
				});
			}
			if (props.columnPicker) {
				if (items.length > 0) items.push({ separator: true });
				if (col) items.push({
					label: translate("HideColumn"),
					icon: "removeColumn",
					attributes: { "data-command": "HIDE_COLUMN" },
					command() {
						contextMenu.value.hide();
						hit.grid.finishEditing();
						column.visible = false;
						emitColumnsChanged(hit.grid);
					}
				});
				items.push({
					label: translate("ChooseColumns"),
					icon: "columnPicker",
					attributes: { "data-command": "SHOW_COLUMN_PICKER" },
					async command() {
						columnPickerEl.value.show({ currentTarget: props.grid._eCHdr });
					}
				});
			}
			return items;
		}
		function emitColumnsChanged(grid) {
			emit("columnsChanged", grid);
		}
		return {
			translate,
			contextMenu,
			contextMenuItems,
			columnPickerEl,
			toggle,
			emitColumnsChanged
		};
	}
});
//#endregion
//#region src/components/DatagridContextMenu/DatagridContextMenu.vue
function _sfc_render$22(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_ContextMenu = resolveComponent("ContextMenu");
	const _component_DatagridColumnPicker = resolveComponent("DatagridColumnPicker");
	return _ctx.contextMenuItems.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_ContextMenu, {
		ref: "contextMenu",
		items: _ctx.contextMenuItems,
		class: "datagrid-context-menu",
		size: "small"
	}, null, 8, ["items"]), createVNode(_component_DatagridColumnPicker, {
		ref: "columnPickerEl",
		grid: _ctx.grid,
		columns: _ctx.columns,
		onColumnsChanged: _ctx.emitColumnsChanged
	}, null, 8, [
		"grid",
		"columns",
		"onColumnsChanged"
	])], 64)) : createCommentVNode("", true);
}
var DatagridContextMenu_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridContextMenu_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$22]]);
//#endregion
//#region src/components/DatagridGroupPanel/DatagridGroupPanel.ts?vue&type=script&src=true&lang.ts
var DatagridGroupPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridGroupPanel",
	components: { WjGroupPanel },
	props: {
		grid: {
			type: Object,
			default: void 0
		},
		draggingColumn: {
			type: Object,
			default: void 0
		}
	},
	emits: ["sort"],
	setup(props, { emit }) {
		const root = ref();
		const { translate } = useGlobalResourceManager();
		watch([root, () => props.grid], () => {
			if (root.value && props.grid) {
				root.value.control.grid = props.grid;
				root.value.control._updateSort = function(event, marker) {
					const index = this._getElementIndex(marker);
					const groupDescription = this._gds[index];
					emit("sort", event, this._g.getColumn(groupDescription.propertyName));
				};
			}
		});
		function handleInitialization(panel) {
			panel.hostElement.addEventListener("drop", (e) => {
				if (props.draggingColumn && !props.draggingColumn.groupable) e.stopImmediatePropagation();
			}, true);
		}
		return {
			root,
			translate,
			handleInitialization
		};
	}
});
//#endregion
//#region src/components/DatagridGroupPanel/DatagridGroupPanel.vue
function _sfc_render$21(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_WjGroupPanel = resolveComponent("WjGroupPanel");
	return openBlock(), createBlock(_component_WjGroupPanel, {
		ref: "root",
		placeholder: _ctx.translate("GroupPanelPlaceholder"),
		initialized: _ctx.handleInitialization,
		class: "datagrid-group-panel"
	}, null, 8, ["placeholder", "initialized"]);
}
var DatagridGroupPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridGroupPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$21]]);
//#endregion
//#region src/components/LottieImage/LottieImage.vue
var LottieImage_default = /* @__PURE__ */ defineComponent({
	__name: "LottieImage",
	props: {
		name: {},
		dataPromise: {},
		loop: {
			type: [Boolean, Number],
			default: false
		}
	},
	setup(__props) {
		const props = __props;
		const images = useImages();
		const image = computed(() => images[props.name]);
		const root = ref();
		let animation = void 0;
		watch(root, async () => {
			if (!animation && root.value) {
				const value = root.value;
				animation = Lottie.loadAnimation({
					container: value,
					animationData: (await props.dataPromise()).default,
					loop: props.loop
				});
				intersectionObserver.observe(value);
			} else intersectionObserver.disconnect();
		});
		onBeforeUnmount(() => {
			animation?.destroy();
			intersectionObserver.disconnect();
		});
		const intersectionObserver = new IntersectionObserver((entries) => {
			if (entries[0].isIntersecting && animation) animation.play();
			else if (animation) animation.pause();
		});
		return (_ctx, _cache) => {
			return image.value ? (openBlock(), createBlock(Image_default, {
				key: 0,
				name: __props.name
			}, null, 8, ["name"])) : (openBlock(), createElementBlock("div", {
				key: 1,
				ref_key: "root",
				ref: root
			}, null, 512));
		};
	}
});
//#endregion
//#region src/components/DatagridNoDataOverlay/DatagridNoDataOverlay.ts?vue&type=script&src=true&lang.ts
var DatagridNoDataOverlay_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridNoDataOverlay",
	components: {
		Image: Image_default,
		LottieImage: LottieImage_default,
		Text: Text_default,
		VerticalLayout: VerticalLayout_default
	},
	props: { message: {
		type: String,
		default: void 0
	} },
	setup() {
		const { translate } = useGlobalResourceManager();
		return { translate };
	}
});
//#endregion
//#region src/components/DatagridNoDataOverlay/DatagridNoDataOverlay.vue
var _hoisted_1$22 = { class: "datagrid-no-data-overlay-action" };
function _sfc_render$20(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_LottieImage = resolveComponent("LottieImage");
	const _component_Text = resolveComponent("Text");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, { class: "datagrid-no-data-overlay" }, {
		default: withCtx(() => [createVNode(_component_VerticalLayout, {
			align: "center",
			space: "large"
		}, {
			default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, () => [
				createVNode(_component_LottieImage, {
					name: "datagridNoData",
					"data-promise": () => import("./DatagridNoData-BZZ9vgiO.js"),
					class: "datagrid-no-data-image"
				}),
				createVNode(_component_Text, { size: "large" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.message ?? _ctx.translate("NoDataFound")), 1)]),
					_: 1
				}),
				createElementVNode("div", _hoisted_1$22, [renderSlot(_ctx.$slots, "action", {}, void 0, true)])
			], true)]),
			_: 3
		})]),
		_: 3
	});
}
var DatagridNoDataOverlay_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridNoDataOverlay_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$20], ["__scopeId", "data-v-fd0b798e"]]);
//#endregion
//#region src/components/DatagridSummaryCell/DatagridSummaryCell.ts?vue&type=script&src=true&lang.ts
var DatagridSummaryCell_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "DatagridSummaryCell",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default
	},
	props: {
		types: {
			type: Object,
			required: true
		},
		type: {
			type: String,
			required: true
		},
		value: {
			type: Number,
			required: true
		},
		format: {
			type: String,
			default: void 0
		},
		align: {
			type: String,
			default: "left"
		},
		tag: {
			type: Boolean,
			default: true
		}
	},
	setup(props) {
		const currentType = computed(() => props.types[props.type]);
		return {
			typeTag: computed(() => props.tag ? currentType.value?.tag : void 0),
			typeCaption: computed(() => currentType.value?.caption ?? void 0),
			formattedValue: computed(() => props.format ? Globalize.format(props.value, props.format) : props.value)
		};
	}
});
//#endregion
//#region src/components/DatagridSummaryCell/DatagridSummaryCell.vue
var _hoisted_1$21 = {
	key: 0,
	class: "tag"
};
function _sfc_render$19(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		align: _ctx.align,
		space: "extrasmall",
		"vertical-align": "center",
		wrap: false,
		class: "datagrid-summary-cell neos-fill-parent-width",
		"data-type": _ctx.type,
		title: _ctx.typeCaption
	}, {
		default: withCtx(() => [_ctx.typeTag ? (openBlock(), createElementBlock("span", _hoisted_1$21, toDisplayString(_ctx.typeTag), 1)) : createCommentVNode("", true), createVNode(_component_Text, {
			size: "small",
			weight: "strong",
			class: "value"
		}, {
			default: withCtx(() => [createTextVNode(toDisplayString(_ctx.formattedValue), 1)]),
			_: 1
		})]),
		_: 1
	}, 8, [
		"align",
		"data-type",
		"title"
	]);
}
var DatagridSummaryCell_default = /*#__PURE__*/ _plugin_vue_export_helper_default(DatagridSummaryCell_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$19], ["__scopeId", "data-v-ea7512a0"]]);
//#endregion
//#region src/components/DotLoader/DotLoader.vue
var DotLoader_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "DotLoader",
	props: { size: { default: "medium" } },
	setup(__props) {
		const props = __props;
		const loaderClasses = computed(() => [`dot-loader-${props.size}`]);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["dot-loader", loaderClasses.value]) }, [..._cache[0] || (_cache[0] = [
				createElementVNode("div", { class: "dot-loader-dot-1" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-2" }, null, -1),
				createElementVNode("div", { class: "dot-loader-dot-3" }, null, -1)
			])], 2);
		};
	}
}), [["__scopeId", "data-v-85a86eeb"]]);
//#endregion
//#region src/components/LoadingOverlay/LoadingOverlay.ts?vue&type=script&src=true&lang.ts
var LoadingOverlay_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "LoadingOverlay",
	components: {
		DotLoader: DotLoader_default,
		HorizontalLayout: HorizontalLayout_default,
		Text: Text_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		message: {
			type: String,
			default: void 0
		},
		focusTrap: {
			type: Boolean,
			default: false
		}
	},
	setup(props) {
		const root = ref();
		let modalCount = 0;
		let returnFocusElement = null;
		const { activate, deactivate } = useFocusTrap(root, {
			allowOutsideClick: true,
			fallbackFocus: document.createElement("div"),
			setReturnFocus: () => {
				if (returnFocusElement) {
					const el = returnFocusElement;
					returnFocusElement = null;
					return el;
				}
				return false;
			}
		});
		watch(() => props.message, () => {
			if (props.focusTrap && props.message) {
				modalCount = document.querySelectorAll(".modal").length;
				returnFocusElement = document.activeElement;
			}
		});
		watch([() => props.focusTrap, root], ([focusTrap, el]) => {
			if (focusTrap && el) activate();
			else {
				if (document.querySelectorAll(".modal").length > modalCount) returnFocusElement = null;
				deactivate();
			}
		}, {
			immediate: true,
			flush: "post"
		});
		return { root };
	}
});
//#endregion
//#region src/components/LoadingOverlay/LoadingOverlay.vue
function _sfc_render$18(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DotLoader = resolveComponent("DotLoader");
	const _component_Text = resolveComponent("Text");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(Transition, { name: "loading-overlay" }, {
		default: withCtx(() => [_ctx.message ? (openBlock(), createBlock(_component_VerticalLayout, {
			key: 0,
			ref: "root",
			align: "center",
			class: "loading-overlay"
		}, {
			default: withCtx(() => [createVNode(_component_HorizontalLayout, {
				space: "extrasmall",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(_component_DotLoader), createVNode(_component_Text, { tabindex: "0" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(_ctx.message), 1)]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 512)) : createCommentVNode("", true)]),
		_: 1
	});
}
var LoadingOverlay_default = /*#__PURE__*/ _plugin_vue_export_helper_default(LoadingOverlay_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$18], ["__scopeId", "data-v-7bcfd36a"]]);
//#endregion
//#region src/components/Datagrid/Datagrid.ts?vue&type=script&src=true&lang.ts
var MAX_SORT_DESCRIPTIONS = 10;
/**
* Restore columns aggregate.
*/
function restoreColumnsAggregate(grid, columnsMap) {
	for (const column of grid.columns) {
		const col = columnsMap.get(column.name);
		if (col && col.groupSummaryType !== void 0 && grid.collectionView && !grid.collectionView.groupDescriptions.some((gd) => gd.propertyName === column.name)) column.aggregate = Aggregate$1.Sum;
		else column.aggregate = Aggregate$1.None;
	}
}
/**
* Restore group rows state.
*/
function restoreGroupRowsState(grid) {
	grid.restoringGroupRowsState = true;
	for (const row of grid.rows) if (isGroupRow(row)) {
		Object.defineProperty(row, "hasChildren", { value: true });
		row.isCollapsed = row.dataItem.isCollapsed;
	}
	grid.restoringGroupRowsState = false;
}
/**
* Gets the visible columns.
*/
function getVisibleColumns(grid) {
	return grid.columns.filter((c) => c.isVisible);
}
function isStarSizedColumn(width) {
	return typeof width === "string" && width.trim().endsWith("*");
}
function getAutoSizedColumnWidth(column, neosColumn) {
	const minInitialWidth = neosColumn.minInitialWidth;
	return minInitialWidth && minInitialWidth > column.renderWidth ? minInitialWidth : column.renderWidth;
}
function getAutoSizedLastColumnWidth(grid, column, neosColumn, totalWidth, firstRender) {
	const width = getAutoSizedColumnWidth(column, neosColumn);
	if (totalWidth + width <= grid._root.clientWidth) return firstRender ? "*" : grid._root.clientWidth - totalWidth;
	return width;
}
/**
* Autosizes the grid columns.
*/
function autoSizeGridColumns(grid, columnsMap, firstRender) {
	let totalWidth = 8;
	const columns = getVisibleColumns(grid);
	const hasStarSizedColumn = columns.some((column) => column.name && isStarSizedColumn(columnsMap.get(column.name)?.width));
	for (let index = 0; index < columns.length; index++) {
		const column = columns[index];
		const neosColumn = column.name && columnsMap.get(column.name);
		if (neosColumn && neosColumn.width == null) {
			grid.autoSizeColumn(column.index, false);
			let width;
			if (!hasStarSizedColumn && index === columns.length - 1) width = getAutoSizedLastColumnWidth(grid, column, neosColumn, totalWidth, firstRender);
			else width = getAutoSizedColumnWidth(column, neosColumn);
			if (typeof width !== "number" || width > column.renderWidth) column.width = width;
		}
		totalWidth += column.renderWidth;
	}
}
/**
* Autosizes the grid rows.
*/
function autoSizeGridRows(grid, autoRowHeight) {
	if (autoRowHeight) grid.autoRowHeights = true;
	return autoRowHeight;
}
/**
* Hides grouping columns.
*/
function hideGroupingColumns(grid) {
	for (const groupDescription of grid.collectionView.groupDescriptions) {
		const propertyName = groupDescription.propertyName;
		const column = grid.columns.getColumn(propertyName);
		if (column) column.visible = false;
	}
}
/**
* Converts the boolean to the visibility value.
*/
function convertBooleanToVisibility(visible) {
	return visible ? void 0 : "hidden";
}
/**
* Gets the selection mode by mouse event.
*/
function getSelectionModeByMouseEvent(event) {
	if (event.shiftKey && !event.ctrlKey) return "range";
	if (event.ctrlKey && !event.shiftKey) return "multi";
	if (event.button === 2) return "single-select-only";
	return "single";
}
function convertColumnWidth(width) {
	if (width == null || typeof width !== "string" || isStarSizedColumn(width)) return width;
	const parsedWidth = Number(width);
	return Number.isNaN(parsedWidth) ? width : parsedWidth;
}
function canNavigateWithArrowKey(event) {
	return !event.altKey && !isDropdownActive();
}
function handleKeyNavigation(event) {
	event.preventDefault();
	event.stopImmediatePropagation();
}
var Datagrid_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Datagrid",
	components: {
		DatagridContextMenu: DatagridContextMenu_default,
		DatagridGroupPanel: DatagridGroupPanel_default,
		DatagridNoDataOverlay: DatagridNoDataOverlay_default,
		DatagridSummaryCell: DatagridSummaryCell_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		InputDocumentationButton: InputDocumentationButton_default,
		LoadingOverlay: LoadingOverlay_default,
		MarkdownViewer: MarkdownViewer_default,
		VerticalLayout: VerticalLayout_default,
		WjFlexGrid,
		WjFlexGridCellTemplate,
		WjFlexGridColumn,
		WjFlexGridDetail
	},
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Array,
			required: true
		},
		getRowContextMenuItems: {
			type: Function,
			default: void 0
		},
		source: {
			type: Object,
			required: true
		},
		editable: {
			type: Boolean,
			default: false
		},
		addRow: {
			type: Boolean,
			default: false
		},
		groupable: {
			type: Boolean,
			default: false
		},
		selectionColumn: {
			type: Boolean,
			default: true
		},
		selectionColumnHeader: {
			type: Boolean,
			default: true
		},
		onSelectionColumnHeaderCheck: {
			type: Function,
			default: void 0
		},
		selectionBinding: {
			type: String,
			default: void 0
		},
		groupPanelVisible: {
			type: Boolean,
			default: void 0
		},
		noDataOverlay: {
			type: Boolean,
			default: true
		},
		rowHeight: {
			type: Number,
			default: 56
		},
		autoRowHeight: {
			type: Boolean,
			default: false
		},
		infiniteScrolling: {
			type: Boolean,
			default: false
		},
		enterKeyActsAsTab: {
			type: Boolean,
			default: false
		},
		summaries: {
			type: Object,
			default: void 0
		},
		booleanDisplayMode: {
			type: String,
			default: "checkbox"
		},
		resizeColumnsOnFirstLoad: {
			type: Boolean,
			default: false
		},
		resizeColumnsOnRefresh: {
			type: Boolean,
			default: false
		},
		exportable: {
			type: Boolean,
			default: true
		},
		columnPicker: {
			type: Boolean,
			default: true
		},
		summaryTag: {
			type: Boolean,
			default: true
		},
		rowDetailVisibilityMode: {
			type: String,
			default: "single"
		},
		rowDetailExpandedByDefault: {
			type: Boolean,
			default: false
		},
		rowDragover: {
			type: Function,
			default: void 0
		},
		rowDrop: {
			type: Function,
			default: void 0
		},
		colspan: {
			type: Function,
			default: void 0
		}
	},
	emits: [
		"update:groupPanelVisible",
		"rowClick",
		"rowDoubleClick",
		"rowSelect",
		"formatCell",
		"validateCell",
		"positionChanging",
		"addRowAdding",
		"addRowCommitting",
		"loadRows",
		"toggleGroup",
		"columnsChanged"
	],
	setup(props, { emit, slots }) {
		const { translate } = useGlobalResourceManager();
		const columnsMap = computed(() => new Map(props.columns.map((c) => [c.name, c])));
		const hasColumnHeaderContextMenu = computed(() => props.groupable || props.columnPicker || props.exportable);
		const headerSelectorValue = ref(false);
		const isGroupPanelVisible = useVModel(props, "groupPanelVisible", emit, { passive: true });
		/**
		* Grid.
		*/
		const _grid = shallowRef();
		/**
		* Gets the system column count.
		*/
		const systemColumnCount = computed(() => {
			let count = 0;
			if (rowDragDrop.value) count++;
			if (slots["row-detail"]) count++;
			if (slots["row-indicator"]) count++;
			if (props.selectionColumn) count++;
			return count;
		});
		/**
		* Value indicating whether the ready state of the grid.
		*/
		const readyState = ref();
		/**
		* Value indicating whether the grid is visible.
		*/
		const isVisible = computed(() => readyState.value === "visible");
		/**
		* Value indicating whether the grid is empty.
		*/
		const isEmpty = ref(false);
		/**
		* Value indicating whether the no data overlay is visible.
		*/
		const isNoDataOverlayVisible = ref(false);
		/**
		* Overlay message
		*/
		const loadingMessage = translate("LoadingData");
		const loadingOverlayMessage = computed(() => props.loading ? loadingMessage : void 0);
		/**
		* Value indicating whether the "stay in edit mode" is active.
		*/
		let stayInEditMode = false;
		/**
		* Last selected row index.
		*/
		let lastSelectedRowIndex = 0;
		/**
		* Value indicating whether the columns should be resized on next refresh.
		*/
		let resizeColumnsOnNextRefresh = props.resizeColumnsOnFirstLoad;
		/**
		* Value indicating whether the row details should be expanded on next refresh.
		*/
		let expandRowDetailsOnLoadOnNextRefresh = props.rowDetailExpandedByDefault;
		/**
		* Dragging column.
		*/
		const draggingColumn = ref();
		/**
		* Context menu instance.
		*/
		const contextMenu = ref();
		/**
		* Display column sort index.
		*/
		const displayColumnSortIndex = ref(false);
		const { setCellValidationMessage } = useDatagridValidation();
		const { buildAddRow, addRowAdding, addRowCommitting } = useDatagridAddRow(emit);
		const { rowDetailComponent, getRowDetailColumnIcon, toggleRowDetail, expandRowDetailsOnLoad, expandRowDetailOnAdd } = useDatagridRowDetail(props);
		const { rowDragDrop, handleDragstart, handleDragover, handleDragend, handleDrop } = useDatagridDragDrop(props, _grid);
		const { rowActionsItem, rowActionsElement, isInRowActions } = useDatagridRowActions(props, _grid);
		useDatagridMergeManager(props, _grid, systemColumnCount, columnsMap);
		watch(() => props.summaries, () => _grid.value && buildSummaryRow(_grid.value));
		watch(() => props.addRow, () => _grid.value && buildAddRow(_grid.value, props.addRow));
		watch(() => props.rowHeight, () => _grid.value && setRowHeight(_grid.value));
		function handleInitialization(grid) {
			_grid.value = grid;
			grid._cvCollectionChanged = handleCollectionChanged;
			grid.columnHeaders.rows.minSize = 40;
			grid.rows.onCollectionChanged = handleRowsCollectionChanged;
			const originalGetDesiredWidth = grid["_getDesiredWidth"];
			grid["_getDesiredWidth"] = function(p, r, c, e) {
				const width = originalGetDesiredWidth.call(this, p, r, c, e);
				e.innerHTML = "";
				return width;
			};
			setRowHeight(grid);
			setFrozenColumns(grid);
			grid._wantsInput = isDropdownActive;
			grid.select(-1, -1);
			buildSummaryRow(grid);
		}
		function setRowHeight(grid) {
			grid.rows.defaultSize = props.rowHeight;
			if (!slots["row-detail"]) {
				grid.rows.minSize = props.rowHeight;
				if (!props.autoRowHeight) grid.rows.maxSize = props.rowHeight;
			}
		}
		function setFrozenColumns(grid) {
			const frozenColumns = props.columns.filter((c) => c.frozen);
			if (frozenColumns.length > 0) grid.frozenColumns = frozenColumns.length + systemColumnCount.value;
			else grid.frozenColumns = 0;
		}
		function resetColumns() {
			if (_grid.value) {
				setFrozenColumns(_grid.value);
				autoSizeGridColumns(_grid.value, columnsMap.value, false);
			}
		}
		function refresh() {
			if (_grid.value) _grid.value.invalidate(false);
		}
		/**
		* Handles the collection changed to update the rows.
		*/
		function handleCollectionChanged(sender, args) {
			switch (args.action) {
				case NotifyCollectionChangedAction$1.Change:
					handleChangeCollectionChanged(this, args);
					break;
				case NotifyCollectionChangedAction$1.Add: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const newRow = new Row(args.item);
					this.rows.insert(args.index, newRow);
					expandRowDetailOnAdd(newRow);
					break;
				}
				case NotifyCollectionChangedAction$1.Remove: {
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					const index = this.rows.findIndex((r) => r.dataItem === args.item);
					if (index !== -1) this.rows.removeAt(index);
					break;
				}
				default:
					resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
					expandRowDetailsOnLoadOnNextRefresh ||= props.rowDetailExpandedByDefault;
					this._bindGrid(false);
			}
		}
		function handleSuggestionChange(grid, args, column) {
			if (!args.isSuggestionChange) return false;
			const rowIndex = args.index;
			const colIndex = column.index;
			if (grid.currentEditingCell?.col === column && grid.currentEditingCell.row === grid.rows[rowIndex]) return true;
			if (stayInEditMode && isEditingCell(grid, rowIndex, colIndex)) return true;
			if (rowIndex !== void 0 && rowIndex >= 0 && colIndex >= 0) grid.refreshRange(new CellRange(rowIndex, colIndex, rowIndex, colIndex));
			return true;
		}
		function handleChangeCollectionChanged(grid, args) {
			if (props.selectionBinding && args.col === props.selectionBinding) {
				grid.invalidate(false);
				return;
			}
			const column = grid.columns.find((c) => c.name === args.col);
			if (!column?.isVisible) return;
			resizeColumnsOnNextRefresh ||= props.resizeColumnsOnRefresh;
			if (handleSuggestionChange(grid, args, column)) return;
			if (grid.currentEditingCell) {
				if (grid.currentEditingCell.col === column && grid.currentEditingCell.row === grid.rows[args.index]) {
					grid.currentEditingCell.value = args.value;
					return;
				}
				grid.stayInEditModeWhileInvalidating = true;
			}
			grid.invalidate(false);
		}
		function handleLoadedRows(grid) {
			if (!_grid.value) handleInitialization(grid);
			if (grid.collectionView) {
				restoreColumnsAggregate(grid, columnsMap.value);
				restoreGroupRowsState(grid);
			}
		}
		/**
		* Handles the refreshing event.
		*/
		function handleRefreshing(grid) {
			if (!readyState.value && grid.hostElement.clientHeight > 0) {
				let deferVisible = false;
				isGroupPanelVisible.value ??= grid.collectionView.groupDescriptions.length > 0;
				isNoDataOverlayVisible.value = props.noDataOverlay && grid.hostElement.clientHeight >= 340;
				autoSizeGridColumns(grid, columnsMap.value, true);
				deferVisible ||= autoSizeGridRows(grid, props.autoRowHeight);
				hideGroupingColumns(grid);
				buildAddRow(grid, props.addRow);
				readyState.value = deferVisible ? "initialized" : "visible";
			} else if (readyState.value === "initialized") readyState.value = "visible";
			else if (resizeColumnsOnNextRefresh && grid.rows.some((r) => !isSystemRow(r))) {
				autoSizeGridColumns(grid, columnsMap.value, false);
				resizeColumnsOnNextRefresh = false;
			}
			loadRowsIfInfiniteScrollingAndNoScroll(grid);
			displayColumnSortIndex.value = grid.collectionView.sortDescriptions.length > 1;
		}
		/**
		* Handles the refreshed event.
		*/
		function handleRefreshed(grid) {
			if (isVisible.value && grid.collectionView instanceof DatagridCollectionView) {
				if (grid.collectionView.lastAddedItem) {
					if (grid.collectionView.lastAddedItem !== grid.collectionView.currentAddItem) selectLastAddedItem(grid, grid.collectionView.lastAddedItem);
					grid.collectionView.lastAddedItem = void 0;
				} else if (grid.collectionView.currentItem) selectCurrentItem(grid);
			}
		}
		/**
		* Selects the first editable cell of the row of the last added item.
		*/
		function selectLastAddedItem(grid, lastAddedItem) {
			const colIndex = getFirstEditableColIndex(grid, lastAddedItem);
			selectCell(grid, grid.rows.findIndex((r) => r.dataItem === lastAddedItem), colIndex);
		}
		/**
		* Selects the current item.
		*/
		function selectCurrentItem(grid) {
			let currentRowIndex = grid.selection.row;
			const currentRow = grid.rows[currentRowIndex];
			if (isDetailRow(currentRow)) currentRowIndex--;
			const rowIndex = grid.rows.findIndex((r) => r.dataItem === grid.collectionView.currentItem);
			if (rowIndex !== currentRowIndex) grid.select(rowIndex, grid.selection.col);
			if (expandRowDetailsOnLoadOnNextRefresh) {
				expandRowDetailsOnLoadOnNextRefresh = false;
				expandRowDetailsOnLoad(grid.rows, rowIndex);
			}
		}
		/**
		* Handles the rows collection changed event to refresh the grid.
		*/
		function handleRowsCollectionChanged() {
			this._dirty = true;
			isEmpty.value = this.length === 0;
			if (isVisible.value && !buildAddRow(this.grid, props.addRow)) this.grid.invalidate(true);
		}
		function handleItemsSourceChanged(grid) {
			if (grid.itemsSource) {
				grid.collectionView.collectionChanged.addHandler(updateHeaderSelectorValue);
				updateHeaderSelectorValue();
			}
		}
		/**
		* Updates the value of the header selector.
		*/
		function updateHeaderSelectorValue() {
			if (_grid.value && props.selectionBinding && _grid.value.collectionView && _grid.value.collectionView.items.length > 0) {
				let headerSelectorValueChecked = true;
				for (const item of _grid.value.collectionView.items) if (!item[props.selectionBinding]) {
					headerSelectorValueChecked = false;
					break;
				}
				headerSelectorValue.value = headerSelectorValueChecked;
			}
		}
		/**
		* Handles the mousedown event.
		*/
		async function handleMousedown(event) {
			if (!_grid.value) return;
			if (event.target instanceof HTMLElement && event.target.getAttribute("wj-part") === "root") {
				event.preventDefault();
				return;
			}
			stayInEditMode = false;
			const hit = _grid.value.hitTest(event);
			if (event.button === 0 && props.selectionColumn && props.selectionBinding !== void 0 && hit.col === systemColumnCount.value - 1) handleMousedownOnSelectionCell(event, hit, props.selectionBinding);
			else if (hit.cellType === CellType.Cell) await handleMousedownOnCell(_grid.value, event, hit);
		}
		async function handleMousedownOnSelectionCell(event, hit, selectionBinding) {
			if (props.selectionColumnHeader && props.onSelectionColumnHeaderCheck && hit.cellType === CellType.ColumnHeader) {
				event.preventDefault();
				const newValue = !headerSelectorValue.value;
				if (await props.onSelectionColumnHeaderCheck(newValue)) headerSelectorValue.value = newValue;
				return;
			}
			const row = hit.getRow();
			if (hit.cellType === CellType.Cell && row.dataItem) {
				event.preventDefault();
				emitRowSelect(row.dataItem, !row.dataItem[selectionBinding]);
			}
		}
		async function handleMousedownOnCell(grid, event, hit) {
			const row = hit.getRow();
			if (isGroupRow(row)) {
				event.stopImmediatePropagation();
				handleMousedownOnGroupRowCell(grid, event, hit, row);
				return;
			}
			if (row.dataItem !== grid.collectionView.currentItem) {
				event.stopImmediatePropagation();
				document.activeElement.blur();
				if (!await positionChanging(grid, hit.row)) return;
				selectCellAndRow();
			} else if (!hitTestContainsColumn(hit, grid.selection.col)) {
				event.stopImmediatePropagation();
				selectCellAndRow();
			} else selectRow(grid, hit.row, getSelectionModeByMouseEvent(event));
			if (event.target instanceof HTMLElement && event.target.classList.contains("checkbox-cell")) changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
			if (hit.getColumn().name == "$$row-detail") toggleRowDetail(row);
			else emit("rowClick", row.dataItem);
			function selectCellAndRow() {
				grid._mouseHdl._selDown = grid.selection;
				selectCell(grid, hit.row, hit.col, event.button === 0);
				selectRow(grid, hit.row, getSelectionModeByMouseEvent(event));
			}
		}
		function handleMousedownOnGroupRowCell(grid, event, hit, row) {
			grid._mouseHdl._selDown = grid.selection;
			if (event.target instanceof HTMLElement && event.target.closest(".wj-elem-collapse")) row.isCollapsed = !row.isCollapsed;
			grid.select(hit.row, hit.col);
		}
		/**
		* Gets a value indicating whether the hit is on the row indicator column header.
		*/
		function isRowIndicatorColumnHeader(hit) {
			return hit.col === 0 && (rowDragDrop.value || slots["row-detail"] || slots["row-indicator"]);
		}
		/**
		* Changes the position.
		*/
		function positionChanging(grid, rowIndex) {
			let row = grid.rows[rowIndex];
			if (isDetailRow(row)) {
				if (rowIndex === grid.selection.row + 1) return Promise.resolve(true);
				row = grid.rows[rowIndex - 1];
			} else if (rowIndex === grid.selection.row - 1 && isDetailRow(grid.rows[grid.selection.row])) return Promise.resolve(true);
			if (isAddRow(row)) return addRowAdding(grid);
			return new Promise((resolve) => {
				const index = grid.collectionView.sourceCollection.indexOf(row.dataItem);
				emit("positionChanging", index, (canceled) => {
					if (!_grid.value) {
						resolve(false);
						return;
					}
					grid.focus();
					if (!canceled || index === -1) resolve(true);
					else resolve(false);
				});
			});
		}
		/**
		* Handles the click event.
		*/
		function handleClick(event) {
			if (!_grid.value) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType === CellType.ColumnHeader) handleClickOnColumnHeader(event, hit);
		}
		function handleClickOnColumnHeader(event, hit) {
			if (event.button !== 0) return;
			if (isRowIndicatorColumnHeader(hit)) {
				if (hasColumnHeaderContextMenu.value) toggleContextMenu(event);
			} else if (event.target instanceof HTMLElement && event.target.closest("[data-column]")) sortColumn(event, hit.getColumn());
		}
		function sortColumn(event, column) {
			if (!_grid.value || !column.name || !column.allowSorting) return;
			const currentSort = _grid.value.collectionView.sortDescriptions.find((s) => s.property === column.name);
			const sorts = event.ctrlKey ? _grid.value.collectionView.sortDescriptions.filter((s) => s.property !== column.name) : [];
			if (currentSort) {
				if (currentSort.ascending) sorts.push(new SortDescription$1(column.name, false));
			} else if (sorts.length >= MAX_SORT_DESCRIPTIONS) return;
			else sorts.push(new SortDescription$1(column.name, true));
			_grid.value.collectionView.sortDescriptions.splice(0, _grid.value.collectionView.sortDescriptions.length, ...sorts);
		}
		function isSystemColumn(column) {
			return column.name?.startsWith("$$") || column.name === props.selectionBinding;
		}
		/**
		* Handles the double click event.
		*/
		function handleDoubleClick(event) {
			if (!_grid.value || isInRowActions(event.target)) return;
			const hit = _grid.value.hitTest(event);
			if (hit.cellType === CellType.Cell && !isSystemColumn(hit.getColumn())) {
				const row = hit.getRow();
				if (!isSystemRow(row)) emit("rowDoubleClick", event, row.dataItem);
			}
		}
		/**
		* Handles the keydown event.
		*/
		function handleKeydown(event) {
			if (!_grid.value || _grid.value.rows.length === 0) return;
			if (event.defaultPrevented) return;
			const hit = _grid.value.hitTest(event.target);
			if (hit.cellType === CellType.Cell) {
				if (event.ctrlKey && event.key === "s") _grid.value.finishEditing(false);
				if (event.target instanceof HTMLElement && event.target.querySelector(".checkbox-cell") && event.key === " ") changeCheckboxCellValue(columnsMap.value, hit, (col, item) => isReadOnlyColumn(col, item, true));
			}
			handleKeyboardNavigation(_grid.value, event);
		}
		/**
		* Handles the navigation by keyboard.
		*/
		async function handleKeyboardNavigation(grid, event) {
			switch (event.key) {
				case "ArrowUp":
					await handleArrowUp(grid, event);
					break;
				case "ArrowDown":
					await handleArrowDown(grid, event);
					break;
				case "Enter":
					if (props.enterKeyActsAsTab) await handleTabKeyNavigation(grid, event);
					else await handleEnterNavigation(grid, event);
					break;
				case "Tab": await handleTabKeyNavigation(grid, event);
			}
		}
		async function handleTabKeyNavigation(grid, event) {
			const currentEditDelegatesToComponent = grid.currentEditDelegatesToComponent;
			grid.finishEditing();
			if (currentEditDelegatesToComponent) await new Promise((resolve) => {
				setTimeout(resolve);
			});
			await handleTabNavigation(grid, event);
		}
		/**
		* Handles the arrow up navigation.
		*/
		async function handleArrowUp(grid, event) {
			if (canNavigateWithArrowKey(event)) {
				const rowIndex = findPreviousVisibleRowIndex(grid, grid.selection.row);
				if (rowIndex !== void 0) {
					handleKeyNavigation(event);
					if (await positionChanging(grid, rowIndex)) {
						selectCell(grid, rowIndex, grid.selection.col);
						selectRow(grid, rowIndex, event.shiftKey ? "range" : "single");
					}
				}
			}
		}
		/**
		* Handles the arrow down navigation.
		*/
		async function handleArrowDown(grid, event) {
			if (canNavigateWithArrowKey(event)) {
				const rowIndex = await findNextVisibleRowIndex(grid, grid.selection.row);
				if (rowIndex !== void 0) {
					handleKeyNavigation(event);
					if (await positionChanging(grid, rowIndex)) {
						selectCell(grid, rowIndex, grid.selection.col);
						selectRow(grid, rowIndex, event.shiftKey ? "range" : "single");
					}
				}
			}
		}
		/**
		* Handles the enter navigation.
		*/
		async function handleEnterNavigation(grid, event) {
			if (isDropdownActive()) return;
			const rowIndex = event.shiftKey ? findPreviousVisibleRowIndex(grid, grid.selection.row) : await findNextVisibleRowIndex(grid, grid.selection.row);
			if (rowIndex !== void 0) {
				handleKeyNavigation(event);
				if (await positionChanging(grid, rowIndex)) {
					selectCell(grid, rowIndex, event.shiftKey ? grid.selection.col : getNextColumnIndexOnEnterNavigation(grid));
					selectRow(grid, rowIndex);
				}
			}
		}
		/**
		* Handles the tab navigation.
		*/
		async function handleTabNavigation(grid, event, rowIndex = grid.selection.row, colIndex = grid.selection.col, columns = getVisibleColumns(grid), lastColumnIndex = columns.length - 1) {
			colIndex = adjustColumnIndexForMergedRange(grid.cells, rowIndex, colIndex, event.shiftKey);
			let changePosition = false;
			const singleColumnRow = isSingleColumnRow(grid.rows[rowIndex]);
			if (event.shiftKey) {
				if (colIndex > systemColumnCount.value && !singleColumnRow) colIndex--;
				else {
					const previousRow = findPreviousVisibleRowIndex(grid, rowIndex);
					if (previousRow === void 0) return;
					rowIndex = previousRow;
					colIndex = lastColumnIndex;
					changePosition = true;
				}
			} else if (colIndex < systemColumnCount.value && !singleColumnRow) colIndex = systemColumnCount.value;
			else if (colIndex < lastColumnIndex && !singleColumnRow) colIndex++;
			else {
				const nextRow = await findNextVisibleRowIndex(grid, rowIndex);
				if (nextRow === void 0) return;
				rowIndex = nextRow;
				colIndex = systemColumnCount.value;
				changePosition = true;
			}
			function select() {
				const column = columns[colIndex];
				const row = grid.rows[rowIndex];
				if (!column || !row) return;
				if (isCellTabbable(column, row.dataItem)) {
					handleKeyNavigation(event);
					selectCell(grid, rowIndex, colIndex);
				} else handleTabNavigation(grid, event, rowIndex, colIndex, columns, lastColumnIndex);
			}
			if (changePosition) {
				handleKeyNavigation(event);
				if (await positionChanging(grid, rowIndex)) {
					select();
					selectRow(grid, rowIndex);
				}
			} else select();
		}
		async function findNextVisibleRowIndex(grid, index) {
			for (let i = index + 1; i < grid.rows.length; i++) if (grid.rows[i].isVisible) return i;
			if (props.addRow && await addRowCommitting(grid)) return index + 1;
		}
		function findPreviousVisibleRowIndex(grid, index) {
			for (let i = index - 1; i > -1; i--) if (grid.rows[i].isVisible) return i;
		}
		/**
		* Gets the index of the next column on enter navigation.
		* If the grid is editable, has the add row and the current row is the last row,
		* The next column will the first editable column of the next row. If there is no editable column, it will be the first column.
		* Otherwise, it the current column.
		*/
		function getNextColumnIndexOnEnterNavigation(grid) {
			if (props.editable && props.addRow && grid.selection.row === grid.rows.length - 2) {
				const item = grid.rows[grid.selection.row + 1].dataItem;
				return getFirstEditableColIndex(grid, item);
			}
			return grid.selection.col;
		}
		function getFirstEditableColIndex(grid, item) {
			for (let index = systemColumnCount.value; index < grid.columns.length; index++) {
				const column = grid.columns[index];
				if (column.isVisible && !isReadOnlyColumn(column, item, true)) return index;
			}
			return systemColumnCount.value;
		}
		/**
		* Gets a value indicating whether the cell can be focused using the Tab key.
		*/
		function isCellTabbable(col, item) {
			const column = getDatagridColumn(col);
			if (props.editable && column.readOnly && column.readOnly(item)) return false;
			return !column.tabStop || column.tabStop(item);
		}
		async function selectCell(grid, rowIndex, colIndex, quickEditing = true) {
			grid.stayInEditModeWhileInvalidating = false;
			grid.select(rowIndex, colIndex);
			startEditing(grid, rowIndex, colIndex, quickEditing);
		}
		async function startEditing(grid, rowIndex, colIndex, quickEditing = true) {
			if (props.addRow) await addRowCommitting(grid);
			if (quickEditing) {
				const row = grid.rows[rowIndex];
				const col = grid.columns[colIndex];
				if (row && !isReadOnlyColumn(col, row.dataItem, false)) setTimeout(() => grid.startEditing(false), 50);
			}
		}
		function selectRow(grid, rowIndex, mode = "single") {
			if (!props.selectionBinding) return;
			if (!props.selectionColumn && mode !== "single") mode = "single";
			let row = grid.rows[rowIndex];
			if (isDetailRow(row)) row = grid.rows[rowIndex - 1];
			const selectedItem = row.dataItem;
			const selected = !selectedItem[props.selectionBinding];
			if (mode === "single-select-only" && selected) mode = "single";
			if (mode === "range") {
				for (const row of grid.rows) if (row.index >= lastSelectedRowIndex && row.index < rowIndex || row.index > rowIndex && row.index <= lastSelectedRowIndex) emitRowSelect(row.dataItem, selected);
			}
			lastSelectedRowIndex = rowIndex;
			emitRowSelect(selectedItem, selected || mode !== "multi");
			if (mode === "single") {
				for (const row of grid.rows) if (row.index !== rowIndex && row.dataItem) emitRowSelect(row.dataItem, false);
			}
		}
		/**
		* Emits an row-select event to update the selection state of the item.
		*/
		async function emitRowSelect(item, selected) {
			if (props.selectionBinding && selected !== item[props.selectionBinding]) emit("rowSelect", item, selected);
		}
		/**
		* Handles the beginning edit event.
		*/
		function handleBeginningEdit(grid, args) {
			const col = args.getColumn();
			const item = args.getRow().dataItem;
			args.cancel = isReadOnlyColumn(col, item, false);
		}
		function isReadOnlyColumn(col, item, ignoreSlot) {
			if (props.editable && item) {
				const column = getDatagridColumn(col);
				if (column && !isIndeterminateCheckboxCell(column, getCellValue(column.name, item)) && (ignoreSlot || slots[`${col.name}-edit`])) return column.readOnly !== void 0 && column.readOnly(item);
			}
			return true;
		}
		/**
		* Handles the cell edit ending event.
		*/
		async function handleCellEditEnding(grid, args) {
			args._rng.col2 = args._rng.col;
			if (grid.currentEditDelegatesToComponent) args.cancel = true;
			if (grid.stayInEditModeWhileInvalidating) {
				args.stayInEditMode = true;
				grid.stayInEditModeWhileInvalidating = false;
				return;
			}
			if (!args.cancel && grid.hostElement.contains(document.activeElement)) triggerChangeOnActiveInput();
			if (stayInEditMode) {
				args.stayInEditMode = true;
				return;
			}
			grid.currentEditingCell = void 0;
			grid.currentEditDelegatesToComponent = false;
		}
		function handleFormatItem(grid, args) {
			if (args.panel === grid.cells) {
				const item = args.getRow().dataItem;
				if (item instanceof CollectionViewGroup$1) formatGroupRow(args, item);
				else if (item) formatItemRow(grid, args, item);
				else formatAddRow(grid, args);
			}
		}
		/**
		* Formats an item row.
		*/
		function formatItemRow(grid, args, item) {
			if (args.col === grid.columns.firstVisibleIndex) {
				args.cell.style.paddingLeft = "";
				args.cell.style.paddingRight = "";
			}
			if (args.col === grid.columns.firstVisibleIndex && props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", item[props.selectionBinding] === true);
			const col = args.getColumn();
			const column = getDatagridColumn(args.getColumn());
			if (column) {
				args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
				const isReadOnly = isReadOnlyColumn(col, item, true);
				args.cell.classList.toggle("read-only", isReadOnly);
				args.cell.querySelector("input[type=\"checkbox\"]")?.toggleAttribute("disabled", isReadOnly);
				if (isEditingCell(grid, args.row, args.col)) args.cell.classList.toggle("wj-state-active", true);
				else emitFormatCell(column, item, args.cell, isReadOnly);
				emitValidateCell(args.cell, item, column);
			} else if (col.name === "$$row-drag") args.cell.setAttribute("draggable", "true");
			else if (col.name === "$$row-indicator") emitValidateCell(args.cell, item);
		}
		/**
		* Formats a group row.
		*/
		function formatGroupRow(args, item) {
			if (item.groupDescription instanceof PropertyGroupDescription$1 && args.cell.hasAttribute("aria-expanded")) {
				const column = columnsMap.value.get(item.groupDescription.propertyName);
				if (column) {
					if (props.selectionBinding && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
					emitFormatCell(column, item, args.cell, true);
				}
			}
		}
		/**
		* Formats an add row.
		*/
		function formatAddRow(grid, args) {
			if (args.col === grid.columns.firstVisibleIndex && args.cell.parentElement) args.cell.parentElement.classList.toggle("selected", false);
			const column = getDatagridColumn(args.getColumn());
			if (column) args.cell.style.alignItems = convertTextAlignToAlignItems(column.align, false);
			setCellValidationMessage(args.cell, void 0);
		}
		/**
		* Emits a formatCell event.
		*/
		function emitFormatCell(column, item, cell, readOnly) {
			emit("formatCell", column, item, cell, readOnly, props.autoRowHeight);
		}
		/**
		* Emits a validateCell event.
		*/
		function emitValidateCell(cell, item, column) {
			emit("validateCell", item, column, (message) => setCellValidationMessage(cell, message));
		}
		/**
		* Toggles whether the mounted edit component persists its value itself.
		*/
		function toggleDelegateEditToComponent(value) {
			if (!_grid.value) return;
			_grid.value.currentEditDelegatesToComponent = value;
		}
		/**
		* Toggles the "stay in edit mode".
		*/
		function toggleStayInEditMode(value) {
			if (!_grid.value) return;
			stayInEditMode = value;
			if (!_grid.value.editRange && !value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the datagrid read only state.
		*/
		function toggleReadOnly(value) {
			if (!_grid.value) return;
			_grid.value.isReadOnly = value;
			if (!value) startEditing(_grid.value, _grid.value.selection.row, _grid.value.selection.col);
		}
		/**
		* Toggles the context menu.
		*/
		function toggleContextMenu(event) {
			contextMenu.value.toggle(event);
		}
		/**
		* Override the wijmo cell persistence behaviour.
		* Loosing focus on the editable cell component replace the editable cell with the display cell.
		* Some component (eg: Lookup) can persist their value asynchronously, so the model update take place
		* when the component is already unmounted.
		* To ensure that the data is updated, this override will force the update to the wijmo cell instance.
		*/
		function getCellInstanceOverride(cell) {
			const currentValue = shallowRef(cell.value);
			const currentEditingCell = {
				...cell,
				get value() {
					return currentValue.value;
				},
				set value(newValue) {
					currentValue.value = newValue;
					cell.value = newValue;
				}
			};
			if (_grid.value) {
				_grid.value.currentEditingCell = currentEditingCell;
				_grid.value.currentEditDelegatesToComponent = false;
			}
			return currentEditingCell;
		}
		/**
		* Gets the current sort image name.
		*/
		function getCurrentSortImageName(column) {
			if (column.currentSort === null) return "swap";
			return column.currentSort === "+" ? "arrowUp" : "arrowDown";
		}
		useComponentAutomationProperties();
		onBeforeUnmount(() => {
			if (!_grid.value) return;
			_grid.value.finishEditing();
			_grid.value.collectionView?.collectionChanged.removeHandler(updateHeaderSelectorValue);
			_grid.value = void 0;
		});
		function loadRowsIfInfiniteScrollingAndNoScroll(grid) {
			if (props.infiniteScrolling && grid._root.scrollHeight <= grid._root.clientHeight) {
				const pageRowsCount = getPageRowsCount(grid);
				if (grid.rows.length < pageRowsCount) emit("loadRows", pageRowsCount);
			}
		}
		/**
		* Handles the mouse wheel event.
		*/
		async function handleWheel() {
			await commitAddRow();
		}
		/**
		* Handles the scroll position changed event.
		*/
		function handleScrollPositionChanged(grid) {
			if (props.infiniteScrolling && grid.viewRange.bottomRow >= grid.rows.length - 10) {
				let group;
				for (const row of grid.rows) {
					if (isGroupRow(row) && !row.isCollapsed) group = row.dataItem;
					if (row.index === grid.viewRange.bottomRow) break;
				}
				emit("loadRows", getPageRowsCount(grid), group);
			}
		}
		/**
		* Handles the group collapsed change event.
		*/
		function handleGroupCollapsedChanged(grid, args) {
			if (!grid.restoringGroupRowsState) {
				const row = args.getRow();
				emit("toggleGroup", row.dataItem, row.isCollapsed, getPageRowsCount(grid));
			}
		}
		/**
		* Handles the dragging column event.
		*/
		function handleDraggingColumn(grid, args) {
			draggingColumn.value = getDatagridColumn(args.getColumn());
		}
		/**
		* Handles the dragged column event.
		*/
		function handleDraggedColumn(grid) {
			emitColumnsChanged(grid);
		}
		/**
		* Handles the resizing column event.
		*/
		function handleResizingColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).setAttribute("data-resizing", "true");
			grid.columnHeaders.hostElement.setAttribute("data-resizing-column", "true");
		}
		/**
		* Handles the resized column event.
		*/
		function handleResizedColumn(grid, e) {
			grid.columnHeaders.getCellElement(0, e.col).removeAttribute("data-resizing");
			grid.columnHeaders.hostElement.removeAttribute("data-resizing-column");
			emitColumnsChanged(grid);
		}
		/**
		* Emits a columns changed event.
		*/
		function emitColumnsChanged(grid) {
			const columns = [];
			for (const col of grid.columns) {
				const column = getDatagridColumn(col);
				if (column && column.tag) columns.push({
					tag: column.tag,
					visible: col.visible,
					position: col.visible ? col.visibleIndex : 0,
					width: col.width?.toString()
				});
			}
			emit("columnsChanged", columns);
		}
		/**
		* Handles the got focus event.
		*/
		async function handleGotFocus(grid) {
			if (grid.selection.row === -1 && grid.rows.length > 0 && !(document.activeElement instanceof HTMLButtonElement)) {
				if (isAddRow(grid.rows[0])) await addRowAdding(grid);
				selectCell(grid, 0, systemColumnCount.value);
			}
		}
		/**
		* Handles the lost focus event.
		*/
		function handleLostFocus(grid) {
			commitAddRow(grid);
		}
		/**
		* Handles the copying event.
		*/
		async function handleCopying(grid, args) {
			const item = args.getRow().dataItem;
			const isGroupRow = item.groupDescription instanceof PropertyGroupDescription$1;
			const columnName = isGroupRow ? item.groupDescription.propertyName : args.getColumn().name;
			const column = columnsMap.value.get(columnName);
			if (column) {
				let text;
				if (!isGroupRow && column.displayTemplate) text = getDisplayTemplateText(grid, args.row, args.col);
				else if (column.displayText) {
					const value = isGroupRow ? item.name : getPropertyByPath(item, columnName);
					text = await column.displayText(value, item);
				}
				if (text != null) {
					args.cancel = true;
					await navigator.clipboard.writeText(text);
				}
			}
		}
		/**
		* Handles the pasting cell event.
		*/
		function handlePastingCell(grid, args) {
			args.cancel = isReadOnlyColumn(args.getColumn(), args.getRow().dataItem, true);
		}
		/**
		* Builds the summary row.
		*/
		function buildSummaryRow(grid) {
			if (props.summaries) {
				if (grid.columnFooters.rows.length === 0) {
					const row = new Row(props.summaries);
					grid.columnFooters.rows.push(row);
				} else grid.columnFooters.rows[0].dataItem = props.summaries;
				grid.invalidate(false);
			} else grid.columnFooters.rows.clear();
		}
		/**
		* Gets the page rows count.
		*/
		function getPageRowsCount(grid) {
			return Math.ceil(grid.hostElement.clientHeight / grid.rows.defaultSize) + 10;
		}
		function getCellValue(path, item) {
			return item ? getPropertyByPath(item, path) : void 0;
		}
		function getDatagridColumn(column) {
			return columnsMap.value.get(column.name);
		}
		async function commitAddRow(grid = _grid.value) {
			if (grid && props.addRow && !stayInEditMode) await addRowCommitting(grid);
		}
		return {
			columnsMap,
			contextMenu,
			convertBooleanToVisibility,
			convertColumnWidth,
			DataType: DataType$1,
			displayColumnSortIndex,
			draggingColumn,
			emitColumnsChanged,
			getCellInstanceOverride,
			getCellValue,
			getCheckboxCellValue,
			getCurrentSortImageName,
			getRowDetailColumnIcon,
			grid: _grid,
			handleBeginningEdit,
			handleCellEditEnding,
			handleClick,
			handleCopying,
			handleDoubleClick,
			handleDragend,
			handleDraggedColumn,
			handleDraggingColumn,
			handleDragover,
			handleDragstart,
			handleDrop,
			handleFormatItem,
			handleGotFocus,
			handleGroupCollapsedChanged,
			handleInitialization,
			handleItemsSourceChanged,
			handleKeydown,
			handleLoadedRows,
			handleLostFocus,
			handleMousedown,
			handlePastingCell,
			handleRefreshed,
			handleRefreshing,
			handleResizedColumn,
			handleResizingColumn,
			handleScrollPositionChanged,
			handleWheel,
			hasColumnHeaderContextMenu,
			headerSelectorValue,
			isEmpty,
			isGroupPanelVisible,
			isIndeterminateCheckboxCell,
			isNoDataOverlayVisible,
			isVisible,
			loadingOverlayMessage,
			refresh,
			resetColumns,
			rowActionsElement,
			rowActionsItem,
			rowDetailComponent,
			rowDragDrop,
			sortColumn,
			systemColumnCount,
			toggleContextMenu,
			toggleDelegateEditToComponent,
			toggleReadOnly,
			toggleStayInEditMode
		};
	}
});
//#endregion
//#region src/components/Datagrid/Datagrid.vue
var _hoisted_1$20 = {
	key: 0,
	class: "row-action"
};
var _hoisted_2$11 = {
	key: 1,
	class: "row-indicator"
};
var _hoisted_3$4 = ["checked"];
var _hoisted_4$3 = ["checked"];
var _hoisted_5$3 = ["data-sort"];
var _hoisted_6$1 = { key: 0 };
var _hoisted_7$1 = {
	key: 0,
	class: "switch-content"
};
var _hoisted_8 = ["checked"];
var _hoisted_9 = ["checked", ".indeterminate"];
var _hoisted_10 = {
	key: 1,
	ref: "rowActionsElement",
	class: "datagrid-row-actions"
};
function _sfc_render$17(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_DatagridGroupPanel = resolveComponent("DatagridGroupPanel");
	const _component_DatagridContextMenu = resolveComponent("DatagridContextMenu");
	const _component_DatagridNoDataOverlay = resolveComponent("DatagridNoDataOverlay");
	const _component_LoadingOverlay = resolveComponent("LoadingOverlay");
	const _component_Image = resolveComponent("Image");
	const _component_WjFlexGridCellTemplate = resolveComponent("WjFlexGridCellTemplate");
	const _component_WjFlexGridColumn = resolveComponent("WjFlexGridColumn");
	const _component_MarkdownViewer = resolveComponent("MarkdownViewer");
	const _component_InputDocumentationButton = resolveComponent("InputDocumentationButton");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_DatagridSummaryCell = resolveComponent("DatagridSummaryCell");
	const _component_WjFlexGridDetail = resolveComponent("WjFlexGridDetail");
	const _component_WjFlexGrid = resolveComponent("WjFlexGrid");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	return openBlock(), createBlock(_component_VerticalLayout, {
		class: "datagrid neos-fill-parent-height",
		style: normalizeStyle({ visibility: _ctx.convertBooleanToVisibility(_ctx.isVisible) }),
		"data-editable": _ctx.editable
	}, {
		default: withCtx(() => [_ctx.grid ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [_ctx.groupable ? withDirectives((openBlock(), createBlock(_component_DatagridGroupPanel, {
			key: 0,
			grid: _ctx.grid,
			"dragging-column": _ctx.draggingColumn,
			onSort: _ctx.sortColumn
		}, null, 8, [
			"grid",
			"dragging-column",
			"onSort"
		])), [[vShow, _ctx.isGroupPanelVisible]]) : createCommentVNode("", true), createVNode(_component_DatagridContextMenu, {
			ref: "contextMenu",
			"group-panel-visible": _ctx.isGroupPanelVisible,
			"onUpdate:groupPanelVisible": _cache[0] || (_cache[0] = ($event) => _ctx.isGroupPanelVisible = $event),
			grid: _ctx.grid,
			columns: _ctx.columnsMap,
			"get-row-context-menu-items": _ctx.getRowContextMenuItems,
			"system-column-count": _ctx.systemColumnCount,
			groupable: _ctx.groupable,
			exportable: _ctx.exportable,
			"column-picker": _ctx.columnPicker,
			onColumnsChanged: _ctx.emitColumnsChanged
		}, null, 8, [
			"group-panel-visible",
			"grid",
			"columns",
			"get-row-context-menu-items",
			"system-column-count",
			"groupable",
			"exportable",
			"column-picker",
			"onColumnsChanged"
		])], 64)) : createCommentVNode("", true), createVNode(_component_VerticalLayout, {
			class: "neos-fill-parent-height",
			space: "none"
		}, {
			default: withCtx(() => [
				_ctx.isNoDataOverlayVisible && _ctx.isEmpty && !_ctx.loading ? (openBlock(), createBlock(_component_DatagridNoDataOverlay, { key: 0 }, {
					action: withCtx(() => [renderSlot(_ctx.$slots, "no-data-action")]),
					default: withCtx(() => [renderSlot(_ctx.$slots, "no-data")]),
					_: 3
				})) : createCommentVNode("", true),
				createVNode(_component_LoadingOverlay, { message: _ctx.loadingOverlayMessage }, null, 8, ["message"]),
				createVNode(_component_WjFlexGrid, {
					"items-source": _ctx.source,
					"selection-mode": "Cell",
					"headers-visibility": "Column",
					"key-action-tab": "None",
					"sticky-headers": true,
					"validate-edits": false,
					"defer-resizing": true,
					"clone-frozen-cells": false,
					"virtualization-threshold": [0, 100],
					"preserve-outline-state": false,
					"group-header-format": "{value}",
					"allow-sorting": "None",
					"loaded-rows": _ctx.handleLoadedRows,
					refreshing: _ctx.handleRefreshing,
					refreshed: _ctx.handleRefreshed,
					"items-source-changed": _ctx.handleItemsSourceChanged,
					"beginning-edit": _ctx.handleBeginningEdit,
					"cell-edit-ending": _ctx.handleCellEditEnding,
					"format-item": _ctx.handleFormatItem,
					"scroll-position-changed": _ctx.handleScrollPositionChanged,
					"group-collapsed-changing": _ctx.handleGroupCollapsedChanged,
					"dragging-column": _ctx.handleDraggingColumn,
					"dragged-column": _ctx.handleDraggedColumn,
					"resizing-column": _ctx.handleResizingColumn,
					"resized-column": _ctx.handleResizedColumn,
					"got-focus": _ctx.handleGotFocus,
					"lost-focus": _ctx.handleLostFocus,
					copying: _ctx.handleCopying,
					"pasting-cell": _ctx.handlePastingCell,
					"data-add-row": _ctx.addRow,
					"data-row-drag-drop": _ctx.rowDragDrop,
					onMousedown: _ctx.handleMousedown,
					onClick: _ctx.handleClick,
					onDblclick: _ctx.handleDoubleClick,
					onKeydown: _ctx.handleKeydown,
					onContextmenu: _ctx.toggleContextMenu,
					onDragstart: _ctx.handleDragstart,
					onDragover: _ctx.handleDragover,
					onDragend: _ctx.handleDragend,
					onDrop: _ctx.handleDrop,
					onWheel: _ctx.handleWheel
				}, {
					default: withCtx(() => [
						_ctx.rowDragDrop ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 0,
							name: "$$row-drag",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-drag-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx(() => [createVNode(_component_Image, { name: "dragVertical" })]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 1,
							name: "$$row-detail",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-detail-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createVNode(_component_Image, {
									name: _ctx.getRowDetailColumnIcon(cell.row),
									size: "small"
								}, null, 8, ["name"])]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true),
						_ctx.$slots["row-indicator"] ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 2,
							name: "$$row-indicator",
							width: 28,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col row-indicator-col"
						}, {
							default: withCtx(() => [createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
								default: withCtx(() => [_ctx.hasColumnHeaderContextMenu && !_ctx.rowDragDrop && !_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_Image, {
									key: 0,
									name: "cog",
									size: "small"
								})) : createCommentVNode("", true)]),
								_: 1
							}), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [_ctx.$slots["row-action"] ? (openBlock(), createElementBlock("div", _hoisted_1$20, [renderSlot(_ctx.$slots, "row-action", { item: cell.row.dataItem })])) : createCommentVNode("", true), _ctx.$slots["row-indicator"] ? (openBlock(), createElementBlock("div", _hoisted_2$11, [renderSlot(_ctx.$slots, "row-indicator", { item: cell.item })])) : createCommentVNode("", true)]),
								_: 3
							})]),
							_: 3
						})) : createCommentVNode("", true),
						_ctx.selectionColumn && _ctx.selectionBinding ? (openBlock(), createBlock(_component_WjFlexGridColumn, {
							key: 3,
							width: 28,
							name: _ctx.selectionBinding,
							"allow-dragging": false,
							"allow-resizing": false,
							"allow-sorting": false,
							"is-read-only": true,
							"is-required": false,
							"css-class-all": "system-col selection-col"
						}, {
							default: withCtx(() => [_ctx.selectionColumnHeader ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
								key: 0,
								"cell-type": "ColumnHeader"
							}, {
								default: withCtx(() => [createElementVNode("input", {
									type: "checkbox",
									class: "header-selector",
									checked: _ctx.headerSelectorValue,
									tabindex: "-1",
									onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_3$4), _cache[5] || (_cache[5] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})) : createCommentVNode("", true), createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Cell" }, {
								default: withCtx((cell) => [createElementVNode("input", {
									type: "checkbox",
									class: "row-selector",
									checked: cell.item?.[_ctx.selectionBinding],
									tabindex: "-1",
									onClick: _cache[2] || (_cache[2] = withModifiers(() => {}, ["prevent"]))
								}, null, 8, _hoisted_4$3), _cache[6] || (_cache[6] = createElementVNode("span", { class: "checkbox-rounded" }, null, -1))]),
								_: 1
							})]),
							_: 1
						}, 8, ["name"])) : createCommentVNode("", true),
						(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.columns, (column, i) => {
							return openBlock(), createBlock(_component_WjFlexGridColumn, {
								key: column.name + i,
								name: column.name,
								binding: column.name,
								header: column.caption,
								visible: column.visible,
								"allow-sorting": column.sortable,
								"allow-dragging": column.movable,
								"data-type": column.dataType,
								"is-read-only": !_ctx.editable,
								"is-required": false,
								width: _ctx.convertColumnWidth(column.width),
								"min-width": column.minWidth,
								"max-width": column.maxWidth
							}, {
								default: withCtx(() => [
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnHeader" }, {
										default: withCtx((cell) => [createVNode(_component_HorizontalLayout, {
											space: "extrasmall",
											"vertical-align": "center",
											wrap: false,
											align: column.align,
											"data-column": column.name,
											"data-sortable": column.sortable,
											title: column.caption
										}, {
											default: withCtx(() => [
												createElementVNode("span", { class: normalizeClass(["column-caption", { "column-caption-not-loaded": column.notLoaded }]) }, toDisplayString(column.caption), 3),
												column.documentation ? (openBlock(), createBlock(_component_InputDocumentationButton, { key: 0 }, {
													header: withCtx(() => [createTextVNode(toDisplayString(column.caption), 1)]),
													body: withCtx(() => [createVNode(_component_MarkdownViewer, {
														source: column.documentation,
														sanitize: true
													}, null, 8, ["source"])]),
													_: 2
												}, 1024)) : createCommentVNode("", true),
												column.sortable ? (openBlock(), createElementBlock("div", {
													key: 1,
													class: "sort-info",
													"data-sort": cell.col.currentSort
												}, [createVNode(_component_Image, {
													name: _ctx.getCurrentSortImageName(cell.col),
													size: "small"
												}, null, 8, ["name"]), _ctx.displayColumnSortIndex && cell.col.currentSortIndex > -1 ? (openBlock(), createElementBlock("span", _hoisted_6$1, toDisplayString(cell.col.currentSortIndex + 1), 1)) : createCommentVNode("", true)], 8, _hoisted_5$3)) : createCommentVNode("", true)
											]),
											_: 2
										}, 1032, [
											"align",
											"data-column",
											"data-sortable",
											"title"
										])]),
										_: 2
									}, 1024),
									_ctx.$slots[`${column.name}-edit`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 0,
										"cell-type": "CellEdit"
									}, {
										default: withCtx((cell) => [renderSlot(_ctx.$slots, `${column.name}-edit`, {
											column,
											cell: _ctx.getCellInstanceOverride(cell),
											toggleDelegateEditToComponent: _ctx.toggleDelegateEditToComponent,
											toggleStayInEditMode: _ctx.toggleStayInEditMode,
											toggleReadOnly: _ctx.toggleReadOnly
										})]),
										_: 2
									}, 1024)) : column.dataType == _ctx.DataType.Boolean ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 1,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [_ctx.booleanDisplayMode === "switch" ? (openBlock(), createElementBlock("div", _hoisted_7$1, [createElementVNode("label", null, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											tabindex: "-1",
											onClick: _cache[3] || (_cache[3] = withModifiers(() => {}, ["prevent"]))
										}, null, 8, _hoisted_8), _cache[7] || (_cache[7] = createElementVNode("span", { class: "checkbox-cell" }, null, -1))])])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [createElementVNode("input", {
											type: "checkbox",
											checked: _ctx.getCheckboxCellValue(_ctx.getCellValue(column.name, cell.item)),
											".indeterminate": _ctx.isIndeterminateCheckboxCell(column, _ctx.getCellValue(column.name, cell.item)),
											class: "checkbox-cell",
											tabindex: "-1",
											onClick: _cache[4] || (_cache[4] = withModifiers(() => {}, ["prevent"]))
										}, null, 40, _hoisted_9), _cache[8] || (_cache[8] = createElementVNode("span", { class: "checkbox-cell-overlay" }, null, -1))], 64))]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									_ctx.$slots[`${column.name}-display`] ? (openBlock(), createBlock(_component_WjFlexGridCellTemplate, {
										key: 2,
										"cell-type": "Cell"
									}, {
										default: withCtx((cell) => [cell.item ? renderSlot(_ctx.$slots, `${column.name}-display`, {
											column,
											cell: {
												...cell,
												value: _ctx.getCellValue(column.name, cell.item)
											}
										}, void 0, void 0, 0) : createCommentVNode("", true)]),
										_: 2
									}, 1024)) : createCommentVNode("", true),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "Group" }, {
										default: withCtx((cell) => [column.groupSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.groupSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024),
									createVNode(_component_WjFlexGridCellTemplate, { "cell-type": "ColumnFooter" }, {
										default: withCtx((cell) => [column.totalSummaryType !== void 0 && cell.value != void 0 ? (openBlock(), createBlock(_component_DatagridSummaryCell, {
											key: 0,
											types: column.summaryTypes,
											type: column.totalSummaryType,
											value: cell.value,
											format: column.format,
											align: column.align,
											tag: _ctx.summaryTag,
											"data-column": column.name
										}, null, 8, [
											"types",
											"type",
											"value",
											"format",
											"align",
											"tag",
											"data-column"
										])) : createCommentVNode("", true)]),
										_: 2
									}, 1024)
								]),
								_: 2
							}, 1032, [
								"name",
								"binding",
								"header",
								"visible",
								"allow-sorting",
								"allow-dragging",
								"data-type",
								"is-read-only",
								"width",
								"min-width",
								"max-width"
							]);
						}), 128)),
						_ctx.$slots["row-detail"] ? (openBlock(), createBlock(_component_WjFlexGridDetail, {
							key: 4,
							ref: "rowDetailComponent"
						}, {
							default: withCtx((cell) => [renderSlot(_ctx.$slots, "row-detail", { item: cell.item })]),
							_: 3
						}, 512)) : createCommentVNode("", true)
					]),
					_: 3
				}, 8, [
					"items-source",
					"loaded-rows",
					"refreshing",
					"refreshed",
					"items-source-changed",
					"beginning-edit",
					"cell-edit-ending",
					"format-item",
					"scroll-position-changed",
					"group-collapsed-changing",
					"dragging-column",
					"dragged-column",
					"resizing-column",
					"resized-column",
					"got-focus",
					"lost-focus",
					"copying",
					"pasting-cell",
					"data-add-row",
					"data-row-drag-drop",
					"onMousedown",
					"onClick",
					"onDblclick",
					"onKeydown",
					"onContextmenu",
					"onDragstart",
					"onDragover",
					"onDragend",
					"onDrop",
					"onWheel"
				]),
				_ctx.$slots["row-actions"] ? (openBlock(), createElementBlock("div", _hoisted_10, [renderSlot(_ctx.$slots, "row-actions", { item: _ctx.rowActionsItem })], 512)) : createCommentVNode("", true),
				_ctx.$slots.footer ? (openBlock(), createBlock(_component_VerticalLayout, {
					key: 2,
					class: "datagrid-footer"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "footer")]),
					_: 3
				})) : createCommentVNode("", true)
			]),
			_: 3
		})]),
		_: 3
	}, 8, ["style", "data-editable"]);
}
var Datagrid_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Datagrid_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$17]]);
//#endregion
//#region src/components/Divider/Divider.vue
var Divider_default = /* @__PURE__ */ defineComponent({
	__name: "Divider",
	props: {
		contentAlign: { default: "center" },
		layout: { default: "horizontal" },
		type: { default: "solid" },
		color: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const align = computed(() => convertInvariantTextAlignToOccidentalTextAlign(props.contentAlign));
		const colorValue = computed(() => props.color ? getColorValue(props.color) : void 0);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeDivider), {
				align: align.value,
				layout: __props.layout,
				type: __props.type,
				class: "divider",
				style: normalizeStyle({ "--p-divider-border-color": colorValue.value })
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"align",
				"layout",
				"type",
				"style"
			]);
		};
	}
});
//#endregion
//#region src/components/DocumentationButton/DocumentationButton.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$19 = ["innerHTML"];
//#endregion
//#region src/components/DocumentationButton/DocumentationButton.vue
var DocumentationButton_default = /* @__PURE__ */ defineComponent({
	__name: "DocumentationButton",
	props: {
		text: {},
		title: {}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(InputDocumentationButton_default, null, {
				header: withCtx(() => [createTextVNode(toDisplayString(__props.title), 1)]),
				body: withCtx(() => [createElementVNode("div", { innerHTML: __props.text }, null, 8, _hoisted_1$19)]),
				_: 1
			});
		};
	}
});
//#endregion
//#region src/components/Dropdown/Dropdown.ts?vue&type=script&src=true&lang.ts
var Dropdown_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Dropdown",
	props: {
		active: {
			type: Boolean,
			default: void 0
		},
		element: {
			type: Object,
			default: void 0
		},
		limitWidthToAnchor: {
			type: String,
			default: "none"
		},
		offset: {
			type: Number,
			default: 0
		},
		customClass: {
			type: String,
			default: void 0
		}
	},
	emits: ["update:active"],
	setup(props, { emit }) {
		const internalActive = ref(false);
		const isActive = computed({
			get: () => props.active ?? internalActive.value,
			set: (value) => {
				internalActive.value = value;
				if (props.active !== void 0) emit("update:active", value);
			}
		});
		const toggler = ref();
		const anchor = computed(() => props.element ?? toggler.value);
		const content = ref();
		const style = shallowRef();
		onMounted(() => {
			window.addEventListener("resize", updateDropdownStyle);
			document.addEventListener("scroll", onScroll, {
				capture: true,
				passive: true
			});
		});
		onUnmounted(() => {
			window.removeEventListener("resize", updateDropdownStyle);
			document.removeEventListener("scroll", onScroll, { capture: true });
		});
		onClickOutside(content, () => isActive.value = false, { ignore: [anchor] });
		function updateDropdownStyle() {
			if (!isActive.value || !anchor.value || !content.value) return;
			const styleValue = {};
			const rectAnchor = anchor.value.getBoundingClientRect();
			const rectContent = content.value.getBoundingClientRect();
			if (rectContent.height + props.offset <= document.documentElement.clientHeight - rectAnchor.y - rectAnchor.height) styleValue.top = `${rectAnchor.y + rectAnchor.height + props.offset}px`;
			else styleValue.top = `${rectAnchor.y - props.offset - rectContent.height}px`;
			let contentWidth;
			switch (props.limitWidthToAnchor) {
				case "absolute":
					styleValue.width = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				case "min":
					styleValue.minWidth = `${rectAnchor.width}px`;
					contentWidth = rectContent.width;
					break;
				case "max":
					styleValue.maxWidth = `${rectAnchor.width}px`;
					contentWidth = rectAnchor.width;
					break;
				default:
					styleValue.width = "unset";
					contentWidth = rectContent.width;
			}
			const availableWidthRightToAnchorPosition = document.documentElement.clientWidth - rectAnchor.x;
			if (contentWidth <= availableWidthRightToAnchorPosition) styleValue.left = `${rectAnchor.x}px`;
			else {
				let left = rectAnchor.x + rectAnchor.width - contentWidth;
				if (left + contentWidth > document.documentElement.clientWidth) left = document.documentElement.clientWidth - contentWidth;
				styleValue.left = `${left}px`;
			}
			styleValue.zIndex = findHighestZIndex();
			style.value = styleValue;
		}
		function onScroll(e) {
			if (!isActive.value || !(e.target instanceof HTMLElement)) return;
			if (anchor.value?.contains(e.target) || content.value?.contains(e.target)) return;
			isActive.value = false;
		}
		function findHighestZIndex() {
			const divs = Array.from(document.getElementsByTagName("div"));
			let highest = 0;
			for (const div of divs) {
				const zindex = Number.parseInt(div.style.zIndex, 10);
				if (zindex > highest) highest = zindex;
			}
			return `${highest + 1}`;
		}
		return {
			isActive,
			toggler,
			anchor,
			content,
			style,
			updateDropdownStyle
		};
	}
});
//#endregion
//#region src/components/Dropdown/Dropdown.vue
function _sfc_render$16(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock(Fragment, null, [_ctx.$slots.toggler ? (openBlock(), createElementBlock("div", {
		key: 0,
		ref: "toggler",
		class: "dropdown-trigger",
		onClick: _cache[0] || (_cache[0] = ($event) => _ctx.isActive = !_ctx.isActive)
	}, [renderSlot(_ctx.$slots, "toggler", {}, void 0, true)], 512)) : createCommentVNode("", true), (openBlock(), createBlock(Teleport, { to: "body" }, [createVNode(Transition, { name: "dropdown-content" }, {
		default: withCtx(() => [_ctx.isActive ? (openBlock(), createElementBlock("div", {
			key: 0,
			ref: "content",
			class: normalizeClass(["dropdown-content", _ctx.customClass]),
			style: normalizeStyle(_ctx.style),
			onVnodeMounted: _cache[1] || (_cache[1] = (...args) => _ctx.updateDropdownStyle && _ctx.updateDropdownStyle(...args))
		}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 6)) : createCommentVNode("", true)]),
		_: 3
	})]))], 64);
}
var Dropdown_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Dropdown_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$16], ["__scopeId", "data-v-fe7ac470"]]);
//#endregion
//#region src/components/DropdownMenuItem/DropdownMenuItem.vue
var DropdownMenuItem_default = /* @__PURE__ */ defineComponent({
	__name: "DropdownMenuItem",
	props: {
		item: {},
		props: {},
		hasSubmenu: {},
		size: {}
	},
	setup(__props) {
		const props = __props;
		const slots = useSlots();
		const hasActions = computed(() => props.hasSubmenu || slots.default);
		const action = computed(() => props.props.action);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(HorizontalLayout_default, {
				align: "space-between",
				"vertical-align": "center"
			}, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, mergeProps({
					"vertical-align": "center",
					wrap: false
				}, action.value), {
					default: withCtx(() => [
						__props.item.icon === "empty" ? (openBlock(), createElementBlock("div", {
							key: 0,
							class: "dropdown-menu-item-image empty",
							style: normalizeStyle(`width: var(--image-${__props.size}-size); height: var(--image-${__props.size}-size);`)
						}, null, 4)) : __props.item.icon ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: __props.item.icon,
							size: __props.size,
							class: "dropdown-menu-item-image"
						}, null, 8, ["name", "size"])) : createCommentVNode("", true),
						createVNode(Text_default, { "max-lines": 1 }, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.label), 1)]),
							_: 1
						}),
						__props.item.badge ? (openBlock(), createBlock(Badge_default, {
							key: 2,
							value: __props.item.badge,
							severity: __props.item.badgeSeverity
						}, null, 8, ["value", "severity"])) : createCommentVNode("", true)
					]),
					_: 1
				}, 16), __props.item.sublabel || hasActions.value ? (openBlock(), createBlock(HorizontalLayout_default, {
					key: 0,
					space: "none",
					"vertical-align": "center"
				}, {
					default: withCtx(() => [
						__props.item.sublabel ? (openBlock(), createBlock(Text_default, {
							key: 0,
							size: "extrasmall",
							class: "dropdown-menu-item-sublabel"
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(__props.item.sublabel), 1)]),
							_: 1
						})) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "default"),
						__props.hasSubmenu ? (openBlock(), createBlock(Image_default, {
							key: 1,
							name: "chevronRight",
							size: __props.size
						}, null, 8, ["size"])) : createCommentVNode("", true)
					]),
					_: 3
				})) : createCommentVNode("", true)]),
				_: 3
			});
		};
	}
});
//#endregion
//#region src/components/DropdownMenu/DropdownMenu.vue
var DropdownMenu_default = /* @__PURE__ */ defineComponent({
	__name: "DropdownMenu",
	props: {
		items: {},
		size: { default: "medium" }
	},
	setup(__props, { expose: __expose }) {
		const menuElement = useTemplateRef("menu");
		const pt = computed(() => ({
			item: (options) => ({
				class: "dropdown-menu-item",
				...options.context.item.attributes
			}),
			transition: { onEnter: handleMenuEnter },
			menu: { transition: { onEnter: handleMenuEnter } }
		}));
		function toggle(event) {
			menuElement.value.toggle(event);
		}
		function hide() {
			menuElement.value.hide();
		}
		function handleBeforeShow() {
			menuElement.value.target = null;
		}
		function handleMenuEnter(el) {
			const { top, bottom } = el.getBoundingClientRect();
			if (top < 0) el.style.transform = `translateY(${Math.abs(top)}px)`;
			else if (bottom > window.innerHeight) el.style.transform = `translateY(${Math.abs(bottom - window.innerHeight)}px)`;
		}
		__expose({
			toggle,
			hide,
			handleMenuEnter
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeMenu), {
				ref: "menu",
				model: __props.items,
				popup: "",
				pt: pt.value,
				class: "dropdown-menu",
				onBeforeShow: handleBeforeShow
			}, {
				item: withCtx(({ item, props, hasSubmenu }) => [renderSlot(_ctx.$slots, "item", {
					item,
					props,
					hasSubmenu,
					size: __props.size
				}, () => [createVNode(DropdownMenuItem_default, {
					item,
					props,
					"has-submenu": hasSubmenu,
					size: __props.size
				}, null, 8, [
					"item",
					"props",
					"has-submenu",
					"size"
				])])]),
				_: 3
			}, 8, ["model", "pt"]);
		};
	}
});
//#endregion
//#region src/components/RadioGroup/RadioGroup.ts?vue&type=script&src=true&lang.ts
var RadioGroup_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "RadioGroup",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: [
				String,
				Number,
				Boolean,
				Date,
				Object
			],
			default: null
		},
		values: {
			type: Array,
			default: () => []
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		orientation: {
			type: String,
			default: "horizontal"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const localizator = useLocalizator();
		const { id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const containerComponent = computed(() => props.orientation === "horizontal" ? HorizontalLayout_default : VerticalLayout_default);
		function getValue(value) {
			if (value && props.valueProperty) return value[props.valueProperty];
			return value;
		}
		function getDisplayValue(value) {
			if (value && props.displayProperty) return localizator.translate(value[props.displayProperty]);
			return localizator.translate(value);
		}
		function getId(value) {
			const v = getDisplayValue(value);
			return `${id}_${v ?? "null"}`;
		}
		return {
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			containerComponent,
			getValue,
			getDisplayValue,
			getId
		};
	}
});
//#endregion
//#region src/components/RadioGroup/RadioGroup.vue
var _hoisted_1$18 = [
	"id",
	"name",
	"disabled",
	"checked",
	"tabindex",
	"onChange"
];
var _hoisted_2$10 = ["for"];
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["radio-group neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		class: "radio-group-label",
		label: _ctx.label,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createElementVNode("div", { class: normalizeClass(["neos-input-content", { "neos-input-disabled": _ctx.disabled }]) }, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.containerComponent), null, {
		default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.values, (value) => {
			return openBlock(), createBlock(_component_HorizontalLayout, {
				key: value,
				class: "radio-group-element"
			}, {
				default: withCtx(() => [createElementVNode("input", {
					id: _ctx.getId(value),
					type: "radio",
					name: _ctx.id,
					disabled: _ctx.disabled || _ctx.readonly,
					checked: _ctx.modelValue === _ctx.getValue(value),
					tabindex: _ctx.tabIndex,
					onChange: ($event) => _ctx.$emit("update:modelValue", _ctx.getValue(value))
				}, null, 40, _hoisted_1$18), createElementVNode("label", { for: _ctx.getId(value) }, toDisplayString(_ctx.getDisplayValue(value)), 9, _hoisted_2$10)]),
				_: 2
			}, 1024);
		}), 128))]),
		_: 1
	})), renderSlot(_ctx.$slots, "default", {}, void 0, true)], 2)]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var RadioGroup_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RadioGroup_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$15], ["__scopeId", "data-v-6ec3b2e8"]]);
//#endregion
//#region src/components/Switch/Switch.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$17 = { class: "switch-content neos-input-content" };
var _hoisted_2$9 = [
	"id",
	"checked",
	"disabled",
	"tabindex"
];
//#endregion
//#region src/components/Switch/Switch.vue
var Switch_default = /* @__PURE__ */ defineComponent({
	__name: "Switch",
	props: {
		...inputProps,
		modelValue: {
			type: Boolean,
			default: false
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		function handleChange(event) {
			emit("update:modelValue", event.target.checked);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["switch neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createElementVNode("div", _hoisted_1$17, [createElementVNode("label", null, [createElementVNode("input", {
				id: unref(id),
				ref: "input",
				type: "checkbox",
				checked: __props.modelValue,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex),
				onChange: handleChange
			}, null, 40, _hoisted_2$9), _cache[2] || (_cache[2] = createElementVNode("span", null, null, -1))]), renderSlot(_ctx.$slots, "default")])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/DynamicCheckbox/DynamicCheckbox.vue
var DynamicCheckbox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCheckbox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		trueLabel: {
			type: String,
			default: "Yes"
		},
		falseLabel: {
			type: String,
			default: "No"
		},
		nullLabel: {
			type: String,
			default: "Undefined"
		},
		displayMode: {
			type: String,
			default: "switch"
		}
	}, {
		"modelValue": {
			type: [Boolean, null],
			default: null
		},
		"modelModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue", "update:focused"]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const focused = useModel(__props, "focused");
		const { translate } = useGlobalResourceManager();
		const radioGroupValues = computed(() => {
			const values = [{
				value: true,
				label: translate(props.trueLabel)
			}, {
				value: false,
				label: translate(props.falseLabel)
			}];
			if (!props.required) values.push({
				value: null,
				label: translate(props.nullLabel)
			});
			return values;
		});
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return _ctx.required && __props.displayMode === "switch" ? (openBlock(), createBlock(Switch_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[1] || (_cache[1] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : _ctx.required && __props.displayMode === "checkbox" ? (openBlock(), createBlock(Checkbox_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[5] || (_cache[5] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "checkbox",
				onAiApply: _cache[6] || (_cache[6] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[9] || (_cache[9] = ($event) => focused.value = $event),
				class: "checkbox",
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				disabled: _ctx.disabled,
				readonly: _ctx.readonly,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				"tab-stop": _ctx.tabStop,
				values: radioGroupValues.value,
				"value-property": "value",
				"display-property": "label",
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[10] || (_cache[10] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"disabled",
				"readonly",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"tab-stop",
				"values",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
//#endregion
//#region src/components/SelectButton/SelectButton.vue
var SelectButton_default = /* @__PURE__ */ defineComponent({
	__name: "SelectButton",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object,
				null
			],
			default: null
		},
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const localizator = useLocalizator();
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const modelValue = useModel(__props, "modelValue");
		const optionLabel = computed(() => {
			if (!props.displayProperty) return;
			return (option) => {
				const displayPropertyValue = getPropertyByPath(option, props.displayProperty);
				if (displayPropertyValue == null) return "";
				if (typeof displayPropertyValue !== "object" || displayPropertyValue instanceof Date) return displayPropertyValue.toString();
				return localizator.translate(displayPropertyValue) ?? "";
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["select-button neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(PrimeSelectButton), {
				id: unref(id),
				ref: (el) => input.value = el,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => modelValue.value = $event),
				class: "neos-input-content",
				options: __props.values,
				"option-value": __props.valueProperty,
				"option-label": optionLabel.value,
				disabled: _ctx.disabled || _ctx.readonly,
				tabindex: unref(tabIndex),
				"allow-empty": !_ctx.required
			}, null, 8, [
				"id",
				"modelValue",
				"options",
				"option-value",
				"option-label",
				"disabled",
				"tabindex",
				"allow-empty"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/DynamicCombobox/DynamicCombobox.vue
var DynamicCombobox_default = /* @__PURE__ */ defineComponent({
	__name: "DynamicCombobox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		displayMode: {
			type: String,
			default: "list"
		}
	}, {
		"modelValue": {
			type: [
				String,
				Boolean,
				Number,
				Date,
				Object,
				null
			],
			default: null
		},
		"modelModifiers": {},
		"invalidValue": { default: void 0 },
		"invalidValueModifiers": {},
		"focused": {
			type: Boolean,
			default: void 0
		},
		"focusedModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], [
		"update:modelValue",
		"update:invalidValue",
		"update:focused"
	]),
	setup(__props) {
		const props = __props;
		const modelValue = useModel(__props, "modelValue");
		const invalidValue = useModel(__props, "invalidValue");
		const focused = useModel(__props, "focused");
		const radioGroupOrientation = computed(() => props.displayMode === "vertical-radio" ? "vertical" : void 0);
		return (_ctx, _cache) => {
			return __props.displayMode === "list" || _ctx.inputDisplayMode === "datagrid" ? (openBlock(), createBlock(Combobox_default, {
				key: 0,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => modelValue.value = $event),
				"invalid-value": invalidValue.value,
				"onUpdate:invalidValue": _cache[1] || (_cache[1] = ($event) => invalidValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
			}, createSlots({ _: 2 }, [_ctx.$slots.value ? {
				name: "value",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "value", { option })]),
				key: "0"
			} : void 0, _ctx.$slots.option ? {
				name: "option",
				fn: withCtx(({ option }) => [renderSlot(_ctx.$slots, "option", { option })]),
				key: "1"
			} : void 0]), 1032, [
				"modelValue",
				"invalid-value",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : __props.displayMode === "select-button" ? (openBlock(), createBlock(SelectButton_default, {
				key: 1,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[6] || (_cache[6] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[7] || (_cache[7] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[8] || (_cache[8] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"ai-suggestion"
			])) : (openBlock(), createBlock(RadioGroup_default, {
				key: 2,
				modelValue: modelValue.value,
				"onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => modelValue.value = $event),
				focused: focused.value,
				"onUpdate:focused": _cache[10] || (_cache[10] = ($event) => focused.value = $event),
				label: _ctx.label,
				"label-position": _ctx.labelPosition,
				required: _ctx.required,
				readonly: _ctx.readonly,
				disabled: _ctx.disabled,
				"message-text": _ctx.messageText,
				"message-severity": _ctx.messageSeverity,
				"message-position": _ctx.messagePosition,
				documentation: _ctx.documentation,
				placeholder: _ctx.placeholder,
				"tab-stop": _ctx.tabStop,
				"input-display-mode": _ctx.inputDisplayMode,
				values: __props.values,
				"value-property": __props.valueProperty,
				"display-property": __props.displayProperty,
				orientation: radioGroupOrientation.value,
				"ai-suggestion": _ctx.aiSuggestion,
				class: "combobox",
				onAiApply: _cache[11] || (_cache[11] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[12] || (_cache[12] = ($event) => _ctx.$emit("aiCancel"))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, [
				"modelValue",
				"focused",
				"label",
				"label-position",
				"required",
				"readonly",
				"disabled",
				"message-text",
				"message-severity",
				"message-position",
				"documentation",
				"placeholder",
				"tab-stop",
				"input-display-mode",
				"values",
				"value-property",
				"display-property",
				"orientation",
				"ai-suggestion"
			]));
		};
	}
});
//#endregion
//#region src/components/GridLayout/GridLayout.ts?vue&type=script&src=true&lang.ts
function convertStyleAbstraction(abstractValue) {
	const starRegex = /(?:^| )((\d*)\*)/g;
	let starMatch;
	do {
		starMatch = starRegex.exec(abstractValue);
		if (starMatch != null) {
			const valueToReplace = starMatch[1];
			let value = starMatch[2];
			if (value == null || value === "") value = "1";
			abstractValue = abstractValue.replace(valueToReplace, `minmax(0, ${value}fr)`);
		}
	} while (starMatch != null);
	abstractValue = abstractValue.replaceAll("fit", "max-content").replaceAll(/(\d)(\s|$)/g, "$1px$2");
	return abstractValue;
}
var GridLayout_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "GridLayout",
	props: {
		rows: {
			type: String,
			default: ""
		},
		rowsSmall: {
			type: String,
			default: ""
		},
		rowsMedium: {
			type: String,
			default: ""
		},
		rowsLarge: {
			type: String,
			default: ""
		},
		rowsExtralarge: {
			type: String,
			default: ""
		},
		columns: {
			type: String,
			default: ""
		},
		columnsSmall: {
			type: String,
			default: ""
		},
		columnsMedium: {
			type: String,
			default: ""
		},
		columnsLarge: {
			type: String,
			default: ""
		},
		columnsExtralarge: {
			type: String,
			default: ""
		},
		rowsAuto: {
			type: String,
			default: ""
		},
		rowsAutoSmall: {
			type: String,
			default: ""
		},
		rowsAutoMedium: {
			type: String,
			default: ""
		},
		rowsAutoLarge: {
			type: String,
			default: ""
		},
		rowsAutoExtralarge: {
			type: String,
			default: ""
		},
		gap: {
			type: String,
			default: ""
		},
		gapSmall: {
			type: String,
			default: ""
		},
		gapMedium: {
			type: String,
			default: ""
		},
		gapLarge: {
			type: String,
			default: ""
		},
		gapExtralarge: {
			type: String,
			default: ""
		}
	},
	setup(props) {
		const style = {
			"--grid-layout-rows": convertStyleAbstraction(props.rows),
			"--grid-layout-columns": convertStyleAbstraction(props.columns),
			"--grid-layout-rows-auto": convertStyleAbstraction(props.rowsAuto),
			"--grid-layout-gap": SpaceValues[props.gap] || ""
		};
		style["--grid-layout-rows-small"] = convertStyleAbstraction(props.rowsSmall);
		style["--grid-layout-rows-medium"] = convertStyleAbstraction(props.rowsMedium);
		style["--grid-layout-rows-large"] = convertStyleAbstraction(props.rowsLarge);
		style["--grid-layout-rows-extralarge"] = convertStyleAbstraction(props.rowsExtralarge);
		style["--grid-layout-columns-small"] = convertStyleAbstraction(props.columnsSmall);
		style["--grid-layout-columns-medium"] = convertStyleAbstraction(props.columnsMedium);
		style["--grid-layout-columns-large"] = convertStyleAbstraction(props.columnsLarge);
		style["--grid-layout-columns-extralarge"] = convertStyleAbstraction(props.columnsExtralarge);
		style["--grid-layout-rows-auto-small"] = convertStyleAbstraction(props.rowsAutoSmall);
		style["--grid-layout-rows-auto-medium"] = convertStyleAbstraction(props.rowsAutoMedium);
		style["--grid-layout-rows-auto-large"] = convertStyleAbstraction(props.rowsAutoLarge);
		style["--grid-layout-rows-auto-extralarge"] = convertStyleAbstraction(props.rowsAutoExtralarge);
		style["--grid-layout-gap-small"] = SpaceValues[props.gapSmall] || "";
		style["--grid-layout-gap-medium"] = SpaceValues[props.gapMedium] || "";
		style["--grid-layout-gap-large"] = SpaceValues[props.gapLarge] || "";
		style["--grid-layout-gap-extralarge"] = SpaceValues[props.gapExtralarge] || "";
		useComponentAutomationProperties();
		return { style };
	}
});
//#endregion
//#region src/components/GridLayout/GridLayout.vue
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "neos-grid-layout neos-fill-parent-width",
		style: normalizeStyle(_ctx.style)
	}, [renderSlot(_ctx.$slots, "default", {}, void 0, true)], 4);
}
var GridLayout_default = /*#__PURE__*/ _plugin_vue_export_helper_default(GridLayout_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$14], ["__scopeId", "data-v-c6a1e71e"]]);
//#endregion
//#region src/components/GroupBox/GroupBox.vue
var GroupBox_default = /* @__PURE__ */ defineComponent({
	__name: "GroupBox",
	props: /*@__PURE__*/ mergeModels({
		expandable: { type: Boolean },
		headerPadding: {},
		contentPadding: {}
	}, {
		"expanded": {
			type: Boolean,
			default: true
		},
		"expandedModifiers": {}
	}),
	emits: ["update:expanded"],
	setup(__props) {
		const props = __props;
		const expanded = useModel(__props, "expanded");
		useComponentAutomationProperties();
		const isCollapsed = computed({
			get: () => !expanded.value,
			set: (value) => expanded.value = !value
		});
		const passthroughProps = computed(() => {
			const contentStyles = ["--vertical-space: 0;"];
			if (props.contentPadding) contentStyles.push(` --p-panel-content-padding: ${SpaceValues[props.contentPadding]};`);
			return {
				header: {
					class: "neos-horizontal-content",
					style: props.headerPadding ? `--p-panel-header-padding: ${SpaceValues[props.headerPadding]};` : void 0
				},
				content: {
					class: "neos-vertical-content",
					style: contentStyles.join("")
				}
			};
		});
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimePanel), {
				collapsed: isCollapsed.value,
				"onUpdate:collapsed": _cache[0] || (_cache[0] = ($event) => isCollapsed.value = $event),
				class: "group-box",
				toggleable: __props.expandable,
				pt: passthroughProps.value
			}, createSlots({
				toggleicon: withCtx(({ collapsed }) => [createVNode(Image_default, {
					class: normalizeClass(["group-box-toggle-button-icon", { collapsed }]),
					name: "chevronUp"
				}, null, 8, ["class"])]),
				default: withCtx(() => [renderSlot(_ctx.$slots, "content")]),
				_: 2
			}, [_ctx.$slots.header ? {
				name: "header",
				fn: withCtx(() => [renderSlot(_ctx.$slots, "header")]),
				key: "0"
			} : void 0]), 1032, [
				"collapsed",
				"toggleable",
				"pt"
			]);
		};
	}
});
//#endregion
//#region src/components/Heading/Heading.vue
var Heading_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Heading",
	props: {
		level: { default: 1 },
		maxLines: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		useComponentAutomationProperties();
		const { classes, styles } = useTextMaxLines(props);
		const tag = computed(() => `h${props.level}`);
		return (_ctx, _cache) => {
			return openBlock(), createBlock(resolveDynamicComponent(tag.value), {
				class: normalizeClass(["heading", unref(classes)]),
				style: normalizeStyle(unref(styles))
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_: 3
			}, 8, ["class", "style"]);
		};
	}
}), [["__scopeId", "data-v-dce8b0d5"]]);
//#endregion
//#region src/components/HtmlViewer/HtmlViewer.ts?vue&type=script&src=true&lang.ts
var HtmlViewer_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "HtmlViewer",
	props: {
		html: {
			type: String,
			required: true
		},
		css: {
			type: String,
			default: void 0
		}
	},
	setup(props) {
		let styleElement;
		function _removeStyleElement() {
			if (styleElement) {
				styleElement.remove();
				styleElement = void 0;
			}
		}
		const purifiedHtml = computed(() => DOMPurify.sanitize(`<html><body>${props.html}</body></html>`));
		watch(() => props.css, (css) => {
			if (css) {
				styleElement = document.createElement("style");
				styleElement.innerHTML = css;
				document.head.append(styleElement);
			} else _removeStyleElement();
		}, { immediate: true });
		onUnmounted(() => _removeStyleElement());
		return { purifiedHtml };
	}
});
//#endregion
//#region src/components/HtmlViewer/HtmlViewer.vue
var _hoisted_1$16 = ["innerHTML"];
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", {
		class: "html-viewer",
		innerHTML: _ctx.purifiedHtml
	}, null, 8, _hoisted_1$16);
}
var HtmlViewer_default = /*#__PURE__*/ _plugin_vue_export_helper_default(HtmlViewer_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$13]]);
//#endregion
//#region src/components/InputColor/InputColor.vue
var InputColor_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputColor",
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		function handleInitialization(_inputColor) {
			input.value = _inputColor.inputElement;
		}
		function handleValueChanged(_inputColor) {
			const value = _inputColor.value || null;
			if (value !== props.modelValue) emit("update:modelValue", value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["input-color neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(WjInputColor), {
				id: unref(id),
				value: __props.modelValue,
				"is-required": false,
				"is-read-only": _ctx.readonly,
				"is-disabled": _ctx.disabled,
				placeholder: _ctx.placeholder,
				"tab-order": unref(tabIndex),
				"click-action": "Toggle",
				initialized: handleInitialization,
				"value-changed": handleValueChanged,
				class: "neos-input-content",
				"data-filled": !!__props.modelValue,
				autocomplete: "nope"
			}, null, 8, [
				"id",
				"value",
				"is-read-only",
				"is-disabled",
				"placeholder",
				"tab-order",
				"data-filled"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-f59680a3"]]);
//#endregion
//#region src/utils/datetime.ts
/**
* Parses and completes a date time value from the specified string value.
* @param value - The value to parse and complete.
* @param dateFormatStrings - The date time format strings.
* @returns A date time value, or null if the value can't be converted.
*/
function parseAndComplete(value, dateFormatStrings) {
	let date = null;
	if (value.includes("/") || !value.startsWith("-") && value.includes("-")) for (const formatString of dateFormatStrings) {
		const parsedDate = Globalize.parseDate(value, formatString);
		if (parsedDate && !Number.isNaN(parsedDate.getDate())) {
			date = parsedDate;
			break;
		}
	}
	else if (value === "0") date = /* @__PURE__ */ new Date();
	else if (value.startsWith("+") || value.startsWith("-")) date = parseRelativeDate(value);
	else {
		const format = getSimplifiedDateFormat(new Intl.DateTimeFormat(navigator.language).resolvedOptions());
		date = parseSimplifiedDate(value, format);
	}
	return date;
}
function parseRelativeDate(value) {
	const amount = Number.parseInt(value, 10);
	return Number.isNaN(amount) ? null : addDays(/* @__PURE__ */ new Date(), amount);
}
//#endregion
//#region src/composables/useInputDate.ts
var inputDateProps = {
	...inputProps,
	modelValue: {
		type: [Date, null],
		default: null
	},
	invalidValue: {
		type: String,
		default: void 0
	},
	minValue: {
		type: [Date, null],
		default: void 0
	},
	maxValue: {
		type: [Date, null],
		default: void 0
	},
	calendar: {
		type: Boolean,
		default: true
	}
};
var inputDateEmits = [
	...inputEmits,
	"update:invalidValue",
	"togglePopover"
];
function useInputDate(props, emit, formatStrings) {
	const root = ref();
	const focused = useVModel(props, "focused", emit);
	const { translate } = useGlobalResourceManager();
	const messageTextInternal = ref();
	const messageSeverityInternal = ref();
	const displayCalendar = computed(() => props.calendar && !props.disabled && !props.readonly);
	const propsInternal = reactiveComputed(() => ({
		...props,
		messageText: props.messageText ?? messageTextInternal.value,
		messageSeverity: props.messageSeverity ?? messageSeverityInternal.value
	}));
	watch(() => props.modelValue, () => checkMinMax());
	useComponentAutomationProperties(root);
	const calendarPopover = ref();
	const key = ref(0);
	const invalidValue = useInputInvalidValue(propsInternal, emit);
	const textboxValue = computed({
		get() {
			if (invalidValue.value) return invalidValue.value;
			return props.modelValue ? Globalize.format(props.modelValue, props.format) : null;
		},
		set(value) {
			if (!value) {
				emitNewValue(null);
				messageTextInternal.value = void 0;
				messageSeverityInternal.value = void 0;
				return;
			}
			const newValue = getDateFromText(value);
			if (newValue && !Number.isNaN(newValue.getDate())) {
				const oldValue = props.modelValue;
				emitNewValue(newValue);
				checkMinMax(newValue);
				if (shouldUpdateKey(newValue, oldValue)) key.value++;
			} else {
				invalidValue.value = value;
				messageTextInternal.value = translate("ValidationMessage_InvalidFieldValue_ShortText");
				messageSeverityInternal.value = "error";
			}
		}
	});
	const calendarValue = computed({
		get: () => props.modelValue,
		set: (date) => {
			if (date && props.modelValue) date = setTimeOfDay(date, props.modelValue);
			emitNewValue(date);
			calendarPopover.value.hide();
			focusInput();
		}
	});
	/**
	* Checks that the value is within the min/max range.
	* When it is not the case, displays an error message.
	* Accepts an explicit value so the successful-parse branch of textboxValue's
	* setter can re-evaluate immediately with newValue, instead of waiting for
	* props.modelValue to change - that prop may never change reference if the
	* corrected value equals what the parent already holds.
	*/
	function checkMinMax(value = props.modelValue) {
		if (value != null && props.minValue != null && value < props.minValue) {
			messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", Globalize.format(props.minValue, props.format));
			messageSeverityInternal.value = "error";
		} else if (value != null && props.maxValue != null && value > props.maxValue) {
			messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", Globalize.format(props.maxValue, props.format));
			messageSeverityInternal.value = "error";
		} else {
			messageTextInternal.value = void 0;
			messageSeverityInternal.value = void 0;
		}
	}
	function getDateFromText(value) {
		let date = Globalize.parseDate(value, props.format);
		date ??= parseAndComplete(value, formatStrings);
		return date;
	}
	function emitNewValue(value) {
		emit("update:modelValue", value);
		invalidValue.value = null;
	}
	function handlePopoverShow() {
		emit("togglePopover", true);
	}
	function handlePopoverHide() {
		emit("togglePopover", false);
	}
	function focusInput() {
		focusExceptOnTouchDevice(root.value.$el.querySelector("input"));
	}
	function shouldUpdateKey(newValue, oldValue) {
		return props.inputDisplayMode === "form" && oldValue && newValue.getTime() === oldValue.getTime();
	}
	return {
		root,
		focused,
		key,
		displayCalendar,
		calendarPopover,
		calendarValue,
		textboxValue,
		propsInternal,
		handlePopoverShow,
		handlePopoverHide
	};
}
//#endregion
//#region src/components/InputDate/InputDate.ts?vue&type=script&src=true&lang.ts
var formatStrings$1 = ["d", "yyyy-MM-dd"];
var InputDate_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDate",
	components: {
		Button: Button_default,
		Textbox: Textbox_default,
		Popover: Popover_default,
		PrimeDatePicker: PrimeDatePicker$1
	},
	props: {
		...inputDateProps,
		format: {
			type: String,
			default: "d"
		},
		calendar: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputDateEmits],
	setup(props, { emit }) {
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide } = useInputDate(props, emit, formatStrings$1);
		function handleOpenCalendarButton(event) {
			calendarPopover.value.toggle(event, { positionTarget: root.value.$el });
		}
		return {
			root,
			focused,
			key,
			displayCalendar,
			calendarPopover,
			calendarValue,
			textboxValue,
			propsInternal,
			handleOpenCalendarButton,
			handlePopoverShow,
			handlePopoverHide
		};
	}
});
//#endregion
//#region src/components/InputDate/InputDate.vue
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_PrimeDatePicker = resolveComponent("PrimeDatePicker");
	const _component_Popover = resolveComponent("Popover");
	const _component_Textbox = resolveComponent("Textbox");
	return openBlock(), createBlock(_component_Textbox, {
		key: _ctx.key,
		ref: "root",
		modelValue: _ctx.textboxValue,
		"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.textboxValue = $event),
		focused: _ctx.focused,
		"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => _ctx.focused = $event),
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		placeholder: _ctx.placeholder,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.propsInternal.messageText,
		"message-severity": _ctx.propsInternal.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"ai-suggestion": _ctx.aiSuggestion,
		class: "input-date",
		onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default"),
			_ctx.displayCalendar ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				focused: _ctx.focused,
				"onUpdate:focused": _cache[0] || (_cache[0] = ($event) => _ctx.focused = $event),
				class: "input-date-open-calendar-button",
				size: "small",
				variant: "ghost",
				icon: "calendar",
				tabindex: "-1",
				onClick: _ctx.handleOpenCalendarButton
			}, null, 8, ["focused", "onClick"])) : createCommentVNode("", true),
			renderSlot(_ctx.$slots, "after"),
			createVNode(_component_Popover, {
				ref: "calendarPopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.calendarValue,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.calendarValue = $event),
					inline: "",
					"min-date": _ctx.minValue,
					"max-date": _ctx.maxValue
				}, null, 8, [
					"modelValue",
					"min-date",
					"max-date"
				])]),
				_: 1
			}, 8, ["onShow", "onHide"])
		]),
		_: 3
	}, 8, [
		"modelValue",
		"focused",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"placeholder",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"ai-suggestion"
	]);
}
var InputDate_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputDate_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$12]]);
//#endregion
//#region src/components/InputDateTime/InputDateTime.ts?vue&type=script&src=true&lang.ts
var formatStrings = [
	"d",
	"g",
	"G",
	"s",
	"o",
	"u"
];
var InputDateTime_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputDateTime",
	components: {
		Button: Button_default,
		Textbox: Textbox_default,
		Popover: Popover_default,
		PrimeDatePicker: PrimeDatePicker$1
	},
	props: {
		...inputDateProps,
		format: {
			type: String,
			default: "g"
		},
		time: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputDateEmits],
	setup(props, { emit }) {
		const { root, focused, key, displayCalendar, calendarPopover, calendarValue, textboxValue, propsInternal, handlePopoverShow, handlePopoverHide } = useInputDate(props, emit, formatStrings);
		const displayTime = computed(() => props.time && !props.disabled && !props.readonly);
		useComponentAutomationProperties(root);
		const timePopover = ref();
		const invalidValue = useInputInvalidValue(propsInternal, emit);
		const timeValue = computed({
			get: () => props.modelValue,
			set: (date) => emitNewValue(date)
		});
		function emitNewValue(value) {
			emit("update:modelValue", value);
			invalidValue.value = null;
		}
		function handleOpenCalendarButton(event) {
			timePopover.value.hide();
			calendarPopover.value.toggle(event, { positionTarget: root.value.$el });
		}
		function handleOpenTimeButton(event) {
			calendarPopover.value.hide();
			timePopover.value.toggle(event, { positionTarget: root.value.$el });
		}
		return {
			root,
			focused,
			key,
			displayCalendar,
			displayTime,
			calendarPopover,
			timePopover,
			textboxValue,
			calendarValue,
			timeValue,
			propsInternal,
			handleOpenCalendarButton,
			handleOpenTimeButton,
			handlePopoverShow,
			handlePopoverHide
		};
	}
});
//#endregion
//#region src/components/InputDateTime/InputDateTime.vue
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_PrimeDatePicker = resolveComponent("PrimeDatePicker");
	const _component_Popover = resolveComponent("Popover");
	const _component_Textbox = resolveComponent("Textbox");
	return openBlock(), createBlock(_component_Textbox, {
		key: _ctx.key,
		ref: "root",
		modelValue: _ctx.textboxValue,
		"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => _ctx.textboxValue = $event),
		focused: _ctx.focused,
		"onUpdate:focused": _cache[3] || (_cache[3] = ($event) => _ctx.focused = $event),
		label: _ctx.label,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		placeholder: _ctx.placeholder,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.propsInternal.messageText,
		"message-severity": _ctx.propsInternal.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"ai-suggestion": _ctx.aiSuggestion,
		class: "input-date-time",
		onAiApply: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		before: withCtx(() => [renderSlot(_ctx.$slots, "before")]),
		default: withCtx(() => [
			renderSlot(_ctx.$slots, "default"),
			_ctx.displayTime ? (openBlock(), createBlock(_component_Button, {
				key: 0,
				class: "input-date-time-open-time-button",
				size: "small",
				variant: "ghost",
				icon: "clock",
				tabindex: "-1",
				onClick: _ctx.handleOpenTimeButton
			}, null, 8, ["onClick"])) : createCommentVNode("", true),
			_ctx.displayCalendar ? (openBlock(), createBlock(_component_Button, {
				key: 1,
				class: "input-date-time-open-calendar-button",
				size: "small",
				variant: "ghost",
				icon: "calendar",
				tabindex: "-1",
				onClick: _ctx.handleOpenCalendarButton
			}, null, 8, ["onClick"])) : createCommentVNode("", true),
			renderSlot(_ctx.$slots, "after"),
			createVNode(_component_Popover, {
				ref: "calendarPopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.calendarValue,
					"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.calendarValue = $event),
					inline: "",
					"min-date": _ctx.minValue,
					"max-date": _ctx.maxValue
				}, null, 8, [
					"modelValue",
					"min-date",
					"max-date"
				])]),
				_: 1
			}, 8, ["onShow", "onHide"]),
			createVNode(_component_Popover, {
				ref: "timePopover",
				onShow: _ctx.handlePopoverShow,
				onHide: _ctx.handlePopoverHide
			}, {
				default: withCtx(() => [createVNode(_component_PrimeDatePicker, {
					modelValue: _ctx.timeValue,
					"onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.timeValue = $event),
					inline: "",
					"time-only": ""
				}, null, 8, ["modelValue"])]),
				_: 1
			}, 8, ["onShow", "onHide"])
		]),
		_: 3
	}, 8, [
		"modelValue",
		"focused",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"placeholder",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"ai-suggestion"
	]);
}
var InputDateTime_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputDateTime_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$11]]);
//#endregion
//#region src/components/InputLocalizableString/InputLocalizableString.ts?vue&type=script&src=true&lang.ts
var images = {
	en: "flagGB",
	fr: "flagFR",
	es: "flagES",
	de: "flagDE",
	it: "flagIT"
};
function useInputLocalizableStringInput(props, currentValue, defaultLanguage, applicationCurrentLanguage, emitNewValue) {
	const { normalizeWhiteSpaceInput, normalizeWhiteSpaceToEmit } = useStringInput();
	const inputPlaceholder = computed(() => currentValue.value?.[defaultLanguage] ?? props.placeholder);
	const editedLanguage = ref(applicationCurrentLanguage);
	const inputValue = ref("");
	let hasPendingInput = false;
	watch(() => currentValue.value?.[editedLanguage.value], (currentLanguageValue) => inputValue.value = currentLanguageValue ?? "", { immediate: true });
	function commitInputValue(inputText) {
		if (!hasPendingInput) return;
		inputText = normalizeWhiteSpaceToEmit(props.whiteSpaceHandling, inputText);
		emitNewValue({
			...currentValue.value,
			[editedLanguage.value]: inputText
		});
		hasPendingInput = false;
	}
	function handleInputValueInput(event) {
		let inputText = event.target.value;
		inputText = normalizeWhiteSpaceInput(props.whiteSpaceHandling, inputText);
		inputValue.value = inputText;
		hasPendingInput = true;
	}
	function handleInputValueChange(event) {
		commitInputValue(event.target.value);
	}
	function handleInputValueFocusOut() {
		commitInputValue(inputValue.value);
	}
	return {
		editedLanguage,
		handleInputValueChange,
		handleInputValueInput,
		handleInputValueFocusOut,
		inputPlaceholder,
		inputValue
	};
}
function useInputLocalizableStringModal(currentValue, languages, emitToggleModal, emitNewValue) {
	const { isOpen: isModalOpen, open, close } = useModal();
	const modalDraft = ref({});
	function openModal() {
		modalDraft.value = { ...currentValue.value };
		open();
		emitToggleModal(true);
	}
	function closeModal() {
		close();
		emitToggleModal(false);
	}
	function commitModalDraft() {
		const oldValue = currentValue.value ?? {};
		if (languages.some((l) => modalDraft.value[l] !== oldValue[l])) emitNewValue(modalDraft.value);
		closeModal();
	}
	return {
		isModalOpen,
		modalDraft,
		openModal,
		closeModal,
		commitModalDraft
	};
}
function removeUndefinedValues(value) {
	const newValue = {};
	for (const language in value) if (value[language]) newValue[language] = value[language];
	return newValue;
}
var InputLocalizableString_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputLocalizableString",
	components: {
		Button: Button_default,
		Heading: Heading_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Modal: Modal_default,
		ButtonsLayout: ButtonsLayout_default,
		Text: Text_default,
		Textbox: Textbox_default,
		VerticalLayout: VerticalLayout_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: Object,
			default: void 0
		},
		maxLength: {
			type: Number,
			default: void 0
		},
		multiLines: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: void 0
		},
		whiteSpaceHandling: {
			type: String,
			default: void 0
		},
		smartTranslate: {
			type: Function,
			default: void 0
		}
	},
	emits: [...inputEmits, "toggleModal"],
	setup(props, { emit }) {
		const localizator = useLocalizator();
		const inputLabel = computed(() => props.inputDisplayMode === "form" ? props.label : void 0);
		const smartTranslateButtonDisabled = computed(() => {
			const definedValues = Object.values(modalDraft.value).filter(Boolean);
			return definedValues.length === 0 || definedValues.length === localizator.localizableStringLanguages.length;
		});
		const currentValue = toRef(props, "modelValue");
		const root = ref();
		const smartTranslateButtonLoading = ref(false);
		const hasMultipleLanguages = localizator.localizableStringLanguages.length > 1;
		const { editedLanguage, inputValue, inputPlaceholder, handleInputValueFocusOut, handleInputValueInput, handleInputValueChange } = useInputLocalizableStringInput(props, currentValue, localizator.localizableStringDefaultLanguage, localizator.localizableStringCurrentLanguage, emitNewValue);
		const aiSuggestion = computed(() => {
			const suggestion = props.aiSuggestion;
			if (!suggestion) return;
			const languageSuggestedValue = suggestion.suggestedValue?.[editedLanguage.value];
			return {
				text: suggestion.text,
				suggestedValue: languageSuggestedValue
			};
		});
		const { isModalOpen, modalDraft, openModal, closeModal, commitModalDraft } = useInputLocalizableStringModal(currentValue, localizator.localizableStringLanguages, emitToggleModal, emitNewValue);
		const { translate } = useGlobalResourceManager();
		const focused = useVModel(props, "focused", emit);
		useComponentAutomationProperties(root);
		const canDisplayButtonsInColumn = computed(() => inputHeight.value > (localizator.localizableStringLanguages.length + 1) * openModalButtonHeight.value);
		const buttons = ref();
		const input = ref();
		const openModalButton = ref();
		const { width: buttonsWidth } = useElementBounding(buttons);
		const { height: inputHeight } = useElementBounding(input);
		const { height: openModalButtonHeight } = useElementBounding(openModalButton);
		onMounted(() => {
			input.value = root.value?.$el.querySelector(".textbox-content.neos-input-content");
		});
		function emitNewValue(value) {
			value = removeUndefinedValues(value);
			emit("update:modelValue", Object.keys(value).length === 0 ? null : value);
		}
		function emitToggleModal(value) {
			emit("toggleModal", value);
		}
		async function handleSmartTranslateButtonClick() {
			smartTranslateButtonLoading.value = true;
			try {
				const value = removeUndefinedValues(modalDraft.value);
				modalDraft.value = await props.smartTranslate(value);
			} finally {
				smartTranslateButtonLoading.value = false;
			}
		}
		function isRequiredLanguage(language) {
			return language === localizator.localizableStringRequiredLanguage ? props.required : false;
		}
		return {
			aiSuggestion,
			buttons,
			buttonsWidth,
			canDisplayButtonsInColumn,
			closeModal,
			commitModalDraft,
			editedLanguage,
			focused,
			handleInputValueFocusOut,
			handleInputValueChange,
			handleInputValueInput,
			handleSmartTranslateButtonClick,
			hasMultipleLanguages,
			images,
			input,
			inputLabel,
			inputPlaceholder,
			inputValue,
			isModalOpen,
			isRequiredLanguage,
			languages: localizator.localizableStringLanguages,
			modalDraft,
			openModal,
			openModalButton,
			root,
			smartTranslateButtonDisabled,
			smartTranslateButtonLoading,
			translate
		};
	}
});
//#endregion
//#region src/components/InputLocalizableString/InputLocalizableString.vue
var _hoisted_1$15 = { class: "input-localizable-string-modal-label" };
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Heading = resolveComponent("Heading");
	const _component_Image = resolveComponent("Image");
	const _component_Textbox = resolveComponent("Textbox");
	const _component_VerticalLayout = resolveComponent("VerticalLayout");
	const _component_ButtonsLayout = resolveComponent("ButtonsLayout");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_Modal = resolveComponent("Modal");
	return openBlock(), createBlock(_component_Textbox, {
		ref: "root",
		focused: _ctx.focused,
		"onUpdate:focused": _cache[2] || (_cache[2] = ($event) => _ctx.focused = $event),
		"model-value": _ctx.inputValue,
		label: _ctx.inputLabel,
		"label-position": _ctx.labelPosition,
		disabled: _ctx.disabled,
		readonly: _ctx.readonly,
		required: _ctx.required,
		tooltip: _ctx.inputValue,
		"input-display-mode": _ctx.inputDisplayMode,
		"message-text": _ctx.messageText,
		"message-severity": _ctx.messageSeverity,
		"message-position": _ctx.messagePosition,
		documentation: _ctx.documentation,
		"tab-stop": _ctx.tabStop,
		"max-length": _ctx.maxLength,
		"multi-lines": _ctx.multiLines,
		rows: _ctx.rows,
		placeholder: _ctx.inputPlaceholder,
		"white-space-handling": _ctx.whiteSpaceHandling,
		"ai-suggestion": _ctx.aiSuggestion,
		class: normalizeClass(["input-localizable-string", { "input-localizable-string-textbox-multiline": _ctx.multiLines }]),
		style: normalizeStyle(`--input-localizable-string-textarea-right-padding: calc(${_ctx.buttonsWidth}px + 0.5rem)`),
		onInput: _ctx.handleInputValueInput,
		onChange: _ctx.handleInputValueChange,
		onFocusout: _ctx.handleInputValueFocusOut,
		onAiApply: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("aiCancel"))
	}, {
		default: withCtx(() => [_ctx.hasMultipleLanguages ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("div", {
			ref: "buttons",
			class: normalizeClass(["input-localizable-string-buttons", { "input-localizable-string-buttons-column": _ctx.multiLines && _ctx.canDisplayButtonsInColumn }])
		}, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language) => {
			return openBlock(), createBlock(_component_Button, {
				key: language,
				"data-lang": language,
				disabled: _ctx.disabled,
				icon: _ctx.images[language],
				tooltip: language,
				variant: _ctx.editedLanguage == language ? "ghost-primary" : "ghost",
				class: "input-localizable-string-button input-localizable-string-switch-language-button",
				size: "small",
				tabindex: "-1",
				onClick: ($event) => _ctx.editedLanguage = language
			}, null, 8, [
				"data-lang",
				"disabled",
				"icon",
				"tooltip",
				"variant",
				"onClick"
			]);
		}), 128)), createVNode(_component_Button, {
			ref: "openModalButton",
			disabled: _ctx.disabled,
			class: "input-localizable-string-button input-localizable-string-open-modal-button",
			icon: "translate",
			size: "small",
			tabindex: "-1",
			variant: "ghost",
			onClick: _ctx.openModal
		}, null, 8, ["disabled", "onClick"])], 2), createVNode(_component_Modal, {
			"is-open": _ctx.isModalOpen,
			"onUpdate:isOpen": _cache[0] || (_cache[0] = ($event) => _ctx.isModalOpen = $event),
			dismissible: false,
			maximizable: false,
			class: "input-localizable-string-modal",
			onClose: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("toggleModal", false))
		}, {
			header: withCtx(() => [createVNode(_component_Heading, { level: 3 }, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.label), 1)]),
				_: 1
			})]),
			body: withCtx(() => [createVNode(_component_VerticalLayout, { align: "space-between" }, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.languages, (language, i) => {
					return openBlock(), createElementBlock("div", { key: language }, [createElementVNode("div", _hoisted_1$15, [createElementVNode("span", null, toDisplayString(_ctx.translate("InputLocalizableString_TextboxLabel", language)), 1), createVNode(_component_Image, {
						name: _ctx.images[language],
						size: "extrasmall",
						style: { "margin-right": "0.5rem" }
					}, null, 8, ["name"])]), createVNode(_component_Textbox, {
						modelValue: _ctx.modalDraft[language],
						"onUpdate:modelValue": ($event) => _ctx.modalDraft[language] = $event,
						readonly: _ctx.readonly,
						required: _ctx.isRequiredLanguage(language),
						tooltip: _ctx.modalDraft[language],
						"max-length": _ctx.maxLength,
						"multi-lines": _ctx.multiLines,
						rows: _ctx.rows,
						"data-lang": language,
						focused: i === 0,
						"white-space-handling": _ctx.whiteSpaceHandling,
						class: "input-localizable-string-modal-textbox"
					}, null, 8, [
						"modelValue",
						"onUpdate:modelValue",
						"readonly",
						"required",
						"tooltip",
						"max-length",
						"multi-lines",
						"rows",
						"data-lang",
						"focused",
						"white-space-handling"
					])]);
				}), 128))]),
				_: 1
			})]),
			footer: withCtx(() => [createVNode(_component_HorizontalLayout, {
				align: "space-between",
				class: "neos-fill-parent-width"
			}, {
				default: withCtx(() => [_ctx.smartTranslate ? (openBlock(), createBlock(_component_Button, {
					key: 0,
					class: "input-localizable-string-modal-smart-translate-button",
					icon: "translate",
					label: _ctx.translate("Translate"),
					disabled: _ctx.smartTranslateButtonDisabled,
					loading: _ctx.smartTranslateButtonLoading,
					animated: "",
					onClick: _ctx.handleSmartTranslateButtonClick
				}, null, 8, [
					"label",
					"disabled",
					"loading",
					"onClick"
				])) : createCommentVNode("", true), createVNode(_component_ButtonsLayout, { class: "neos-fill-parent-width" }, {
					default: withCtx(() => [createVNode(_component_Button, {
						class: "input-localizable-string-modal-ok-button",
						variant: "primary",
						icon: "validate",
						label: _ctx.translate("Ok"),
						animated: "",
						onClick: _ctx.commitModalDraft
					}, null, 8, ["label", "onClick"]), createVNode(_component_Button, {
						class: "input-localizable-string-modal-close-button",
						icon: "close",
						label: _ctx.translate("Cancel"),
						animated: "",
						onClick: _ctx.closeModal
					}, null, 8, ["label", "onClick"])]),
					_: 1
				})]),
				_: 1
			})]),
			_: 1
		}, 8, ["is-open"])], 64)) : createCommentVNode("", true)]),
		_: 1
	}, 8, [
		"focused",
		"model-value",
		"label",
		"label-position",
		"disabled",
		"readonly",
		"required",
		"tooltip",
		"input-display-mode",
		"message-text",
		"message-severity",
		"message-position",
		"documentation",
		"tab-stop",
		"max-length",
		"multi-lines",
		"rows",
		"placeholder",
		"white-space-handling",
		"ai-suggestion",
		"class",
		"style",
		"onInput",
		"onChange",
		"onFocusout"
	]);
}
var InputLocalizableString_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputLocalizableString_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$10], ["__scopeId", "data-v-ae733fa4"]]);
//#endregion
//#region src/components/InputMask/InputMask.vue
var InputMask_default = /* @__PURE__ */ defineComponent({
	__name: "InputMask",
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		mask: {
			type: String,
			required: true
		},
		valueMode: {
			type: String,
			default: "raw"
		}
	},
	emits: [...inputEmits],
	setup(__props, { expose: __expose, emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const component = ref();
		const valueProperty = computed(() => props.valueMode === "formatted" ? "value" : "rawValue");
		watch([
			component,
			() => props.valueMode,
			() => props.modelValue,
			() => props.mask
		], ([componentValue]) => updateProps(componentValue?.control));
		function handleInitialization(inputMask) {
			input.value = inputMask.inputElement;
			updateProps(inputMask);
		}
		function handleChange() {
			if (props.updateMode === "default") emitNewValue();
		}
		function handleInput() {
			if (props.updateMode === "immediate") emitNewValue();
		}
		function updateProps(inputMask) {
			if (!inputMask) return;
			inputMask.mask = props.mask;
			inputMask[valueProperty.value] = props.modelValue ?? "";
		}
		function emitNewValue() {
			let value = component.value.control[valueProperty.value];
			const newValue = value !== "" ? value : null;
			if (newValue !== props.modelValue) emit("update:modelValue", newValue);
		}
		__expose({
			updateProps,
			handleChange,
			handleInput
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["input-mask neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(unref(WjInputMask), {
				id: unref(id),
				ref_key: "component",
				ref: component,
				"is-required": false,
				"is-read-only": _ctx.readonly,
				"is-disabled": _ctx.disabled,
				placeholder: _ctx.placeholder,
				"tab-order": unref(tabIndex),
				initialized: handleInitialization,
				class: "neos-input-content",
				autocomplete: "nope",
				onChange: handleChange,
				onInput: handleInput
			}, null, 8, [
				"id",
				"is-read-only",
				"is-disabled",
				"placeholder",
				"tab-order"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
});
//#endregion
//#region src/components/InputNumber/InputNumber.ts?vue&type=script&src=true&lang.ts
var InputNumber_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputNumber",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		WjInputNumber
	},
	props: {
		...inputProps,
		modelValue: {
			type: Number,
			default: null
		},
		format: {
			type: String,
			default: void 0
		},
		minValue: {
			type: Number,
			default: void 0
		},
		maxValue: {
			type: Number,
			default: void 0
		},
		alignment: {
			type: String,
			default: "right"
		},
		step: {
			type: Number,
			default: void 0
		},
		updateMode: {
			type: String,
			default: "default"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		let inputNumber;
		const { translate } = useGlobalResourceManager();
		const _messageTextInternal = ref();
		const _messageSeverityInternal = ref();
		const propsInternal = reactiveComputed(() => ({
			...props,
			messageText: props.messageText ?? _messageTextInternal.value,
			messageSeverity: props.messageSeverity ?? _messageSeverityInternal.value
		}));
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(propsInternal, emit);
		const displayValue = ref(props.modelValue);
		let lastImmediateEmit;
		watch(() => props.modelValue, (newValue) => {
			checkMinMax();
			if (props.updateMode === "immediate" && newValue === lastImmediateEmit) {
				lastImmediateEmit = void 0;
				return;
			}
			displayValue.value = newValue;
		});
		/**
		* Checks that the value is within the min/max range.
		* When it is not the case, displays an error message.
		*/
		function checkMinMax() {
			const hasValue = props.modelValue != null;
			if (hasValue && props.minValue != null && props.modelValue < props.minValue) {
				_messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", props.minValue);
				_messageSeverityInternal.value = "error";
			} else if (hasValue && props.maxValue != null && props.modelValue > props.maxValue) {
				_messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", props.maxValue);
				_messageSeverityInternal.value = "error";
			} else {
				_messageTextInternal.value = void 0;
				_messageSeverityInternal.value = void 0;
			}
		}
		function handleInitialization(_inputNumber) {
			input.value = _inputNumber.inputElement;
			inputNumber = _inputNumber;
			inputNumber.inputElement.id = id;
			inputNumber.inputElement.style.textAlign = props.alignment;
			if (props.updateMode === "immediate") inputNumber.inputElement.addEventListener("input", handleImmediateInput);
		}
		function handleValueChanged() {
			if (inputNumber.value === inputNumber._oldValue && inputNumber.text !== inputNumber._oldText) inputNumber._setText(inputNumber.text);
			let value = inputNumber.value;
			if (value != null && !Number.isFinite(value)) value = null;
			emit("update:modelValue", value);
		}
		/**
		* Wijmo only commits its value on blur/Enter (see handleValueChanged above); for live
		* filter validation the chip popup needs the value on each keystroke, so this mirrors
		* Textbox's 'immediate' mode by parsing the raw input text and emitting whenever it is
		* a finite number.
		*/
		function handleImmediateInput() {
			const text = inputNumber.inputElement.value;
			if (text === "") {
				lastImmediateEmit = null;
				emit("update:modelValue", null);
				return;
			}
			const parsed = Globalize.parseFloat(text, props.format);
			if (Number.isFinite(parsed)) {
				lastImmediateEmit = parsed;
				emit("update:modelValue", parsed);
			}
		}
		return {
			classes,
			displayValue,
			handleInitialization,
			handleValueChanged,
			id,
			isLabelVisible,
			isMessageVisible,
			propsInternal,
			tabIndex
		};
	}
});
//#endregion
//#region src/components/InputNumber/InputNumber.vue
var _hoisted_1$14 = {
	key: 0,
	class: "input-number-before-content"
};
var _hoisted_2$8 = {
	key: 1,
	class: "input-number-after-content"
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_WjInputNumber = resolveComponent("WjInputNumber");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-number neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_WjInputNumber, {
		value: _ctx.displayValue,
		"is-required": false,
		"is-disabled": _ctx.disabled,
		"is-read-only": _ctx.readonly,
		format: _ctx.format,
		placeholder: _ctx.placeholder,
		initialized: _ctx.handleInitialization,
		"tab-order": _ctx.tabIndex,
		step: _ctx.step,
		class: "input-number-content neos-input-content",
		autocomplete: "nope",
		onChange: _ctx.handleValueChanged
	}, {
		default: withCtx(() => [_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_1$14, [renderSlot(_ctx.$slots, "before", {}, void 0, true)])) : createCommentVNode("", true), _ctx.$slots.default ? (openBlock(), createElementBlock("div", _hoisted_2$8, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])) : createCommentVNode("", true)]),
		_: 3
	}, 8, [
		"value",
		"is-disabled",
		"is-read-only",
		"format",
		"placeholder",
		"initialized",
		"tab-order",
		"step",
		"onChange"
	])]), _ctx.isMessageVisible && _ctx.propsInternal.messageText ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.propsInternal.messageText,
		severity: _ctx.propsInternal.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputNumber_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputNumber_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$9], ["__scopeId", "data-v-0e49ce15"]]);
//#endregion
//#region src/components/InputNumberCalculable/getWijmoConfig.ts
var FormatTextStatus = /* @__PURE__ */ function(FormatTextStatus) {
	FormatTextStatus[FormatTextStatus["TXT"] = 0] = "TXT";
	FormatTextStatus[FormatTextStatus["RAW"] = 1] = "RAW";
	FormatTextStatus[FormatTextStatus["FORMULA"] = 2] = "FORMULA";
	FormatTextStatus[FormatTextStatus["EVALUATED"] = 3] = "EVALUATED";
	return FormatTextStatus;
}({});
var formatEvaluated = (textToSet) => {
	return {
		status: 3,
		res: {
			formattedText: String(textToSet),
			value: textToSet
		}
	};
};
var formatRaw = (textToSet) => {
	return {
		status: 1,
		res: {
			formattedText: textToSet,
			value: null
		}
	};
};
var formatMath = (text) => {
	return {
		status: 2,
		res: {
			formattedText: text,
			value: null
		}
	};
};
var formatEmpty = () => {
	return {
		status: 0,
		res: {
			formattedText: "",
			value: null
		}
	};
};
var isEmpty = (value) => {
	return !value;
};
function getWijmoConfig(format) {
	const formatInfo = Globalize._parseNumericFormat(format);
	const Keys = {
		Enter: "Enter",
		Escape: "Escape",
		Delete: "Delete",
		Back: "Backspace",
		Up: "ArrowUp",
		Down: "ArrowDown",
		DecimalSeparator: Globalize.getNumberDecimalSeparator(),
		StartFormula: "="
	};
	const _chrDecimalSeparator = Keys.DecimalSeparator;
	const _chrNeg = "-";
	const _chrPls = "+";
	const _chrPct = "%";
	const notEmpty = [
		_chrDecimalSeparator,
		formatInfo.curr || culture.Globalize.numberFormat.currency.symbol,
		_chrNeg,
		_chrPls,
		_chrPct
	].filter(Boolean).map((c) => `\\${c}`);
	const _rxSym = new RegExp(String.raw`^[%+\-() ${notEmpty}]*$`);
	const _rxNeg = /(^\s*-)|([^e][-+]|\()/;
	const _tblMath = /* @__PURE__ */ new Set([
		"+",
		"-",
		"*",
		"/",
		"=",
		"%",
		"^",
		"(",
		")"
	]);
	const isNumericOnly = (text) => {
		return text >= "0" && text <= "9";
	};
	const isNumeric = (text) => {
		if (text == _chrDecimalSeparator || isNumericOnly(text)) return true;
		return [
			_chrPls,
			_chrNeg,
			"(",
			")"
		].includes(text);
	};
	const _getInputRange = (text) => {
		let _minSet = false;
		let _min = 0;
		let _max = 0;
		for (let n = 0; n < text.length; n++) if (isNumeric(text[n])) {
			if (!_minSet) {
				_min = n;
				_minSet = true;
			}
			_max = n + 1;
		}
		return {
			min: _min,
			max: _max
		};
	};
	const _getClampRange = (selectionStart, currentText, nextText) => {
		const decimalPositionInitial = currentText.indexOf(_chrDecimalSeparator);
		const decimalPositionNextText = nextText.indexOf(_chrDecimalSeparator);
		if (selectionStart <= decimalPositionInitial && decimalPositionNextText !== -1 || decimalPositionInitial === -1 && decimalPositionNextText === -1) return selectionStart + nextText.length - currentText.length;
		if (decimalPositionInitial === -1 && decimalPositionNextText !== -1) return decimalPositionNextText;
		return selectionStart;
	};
	const getNextSelectionRange = (status, selectionStart, currentText, nextText) => {
		if (status !== 0) return null;
		if (!nextText) return {
			selectionStart: 0,
			selectionEnd: 0
		};
		const { min: _start, max: _end } = _getInputRange(nextText);
		const range = clamp(_getClampRange(selectionStart, currentText, nextText), _start, _end);
		return {
			selectionStart: range,
			selectionEnd: range
		};
	};
	const isSeparator = (caract) => {
		return [
			_chrDecimalSeparator,
			_chrPct,
			_chrPct,
			")"
		].includes(caract);
	};
	const isMathKey = (key) => {
		return _tblMath.has(key);
	};
	const addAutoFormat = (text) => {
		if (formatInfo.spec == "p" && text.length > 0 && !text.includes(_chrPct)) return text + _chrPct;
		return text;
	};
	const _getDefaultFormatByPrecision = (indexOfDec) => {
		return indexOfDec > -1 ? "n2" : "n0";
	};
	const parseText = (newText, format) => {
		const indexOfDec = newText.indexOf(Keys.DecimalSeparator);
		const formatWijmo = isEmpty(format) ? _getDefaultFormatByPrecision(indexOfDec) : format;
		return {
			indexOfDec,
			value: Globalize.parseFloat(newText, formatWijmo),
			formatWijmo
		};
	};
	const _isPercentageFormatWithPrecision = () => {
		return formatInfo.spec == "g" && formatInfo.prec != 0;
	};
	const _parseInitialText = (textToSet, format) => {
		if (typeof textToSet === "number") return Globalize.format(textToSet, isEmpty(format) ? "n2" : format);
		if (!textToSet) return "";
		if (_rxSym.test(textToSet)) return (_rxNeg.test(textToSet) ? "-0" : "0") + (textToSet.includes(Keys.DecimalSeparator) ? Keys.DecimalSeparator : "");
		return textToSet;
	};
	const formatText = (textToSet, format) => {
		const newText = _parseInitialText(textToSet, format);
		if (!newText) return {
			status: 0,
			res: {
				formattedText: "",
				value: null
			}
		};
		const { indexOfDec, value: newValue, formatWijmo } = parseText(newText, format);
		if (Number.isNaN(newValue)) return {
			status: 0,
			res: {
				formattedText: newText,
				value: null,
				isNaN: true
			}
		};
		if (indexOfDec > -1 && _isPercentageFormatWithPrecision()) return {
			status: 0,
			res: {
				formattedText: newText,
				value: newValue
			}
		};
		const precision = indexOfDec > -1 ? 2 : null;
		return {
			status: 0,
			res: {
				formattedText: Globalize.format(newValue, formatWijmo, false, false, precision ?? void 0),
				value: newValue
			}
		};
	};
	const preventLeadingNumber = (text, inputSelectionStart) => {
		if (!text) return false;
		const selectionStart = inputSelectionStart;
		const { max } = _getInputRange(text);
		if (selectionStart >= max) {
			const decimalPosition = text.indexOf(Keys.DecimalSeparator);
			if (decimalPosition !== -1 && selectionStart - decimalPosition > (formatInfo.prec ?? 2)) return true;
		}
		return false;
	};
	return {
		getNextSelectionRange,
		addAutoFormat,
		formatText,
		parseText,
		formatRaw,
		formatMath,
		formatEmpty,
		formatEvaluated,
		preventLeadingNumber,
		isNumericOnly,
		isSeparator,
		isMathKey,
		Keys,
		precisionNumber: formatInfo.prec
	};
}
//#endregion
//#region src/components/InputNumberCalculable/InputNumberCalculable.ts?vue&type=script&src=true&lang.ts
function evalMath(text) {
	try {
		if (!/^[0-9+\-*/(),.\s^%]*$/.test(text)) throw new Error("Invalid characters");
		const evalResult = new Function(`"use strict"; return (${text.replaceAll("^", "**")});`)();
		if (typeof evalResult !== "number" || Number.isNaN(evalResult) || !Number.isFinite(evalResult)) throw new TypeError("Invalid mathematical expression");
		return {
			err: null,
			res: +evalResult?.toFixed(5)
		};
	} catch (error) {
		return {
			err: error,
			res: null
		};
	}
}
var withCache = (fn) => {
	const cache = /* @__PURE__ */ new Map();
	return ((...args) => {
		const key = JSON.stringify(args);
		if (cache.has(key)) return cache.get(key);
		const result = fn(...args);
		cache.clear();
		cache.set(key, result);
		return result;
	});
};
var evalMathWithCache = withCache(evalMath);
var InputNumberCalculable_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputNumberCalculable",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		Image: Image_default
	},
	props: {
		...inputProps,
		modelValue: {
			type: Number,
			default: null
		},
		format: {
			type: String,
			default: void 0
		},
		minValue: {
			type: Number,
			default: void 0
		},
		maxValue: {
			type: Number,
			default: void 0
		},
		alignment: {
			type: String,
			default: "right"
		},
		step: {
			type: Number,
			default: void 0
		},
		tooltip: {
			type: String,
			default: void 0
		},
		enableMask: {
			type: Boolean,
			default: true
		},
		updateModelAfterEachEval: {
			type: Boolean,
			default: false
		},
		previewModePosition: {
			type: String,
			default: "hidden"
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const calculablePreview = ref(null);
		const inputMode = ref(FormatTextStatus.TXT);
		const _isFormulaError = ref(false);
		const _messageTextInternal = ref();
		const _messageSeverityInternal = ref();
		const propsInternal = reactiveComputed(() => ({
			...props,
			messageText: props.messageText ?? (_isFormulaError.value ? translate("ValidationMessage_InvalidFieldValue_ShortText") : _messageTextInternal.value),
			messageSeverity: props.messageSeverity ?? (_isFormulaError.value ? "error" : _messageSeverityInternal.value)
		}));
		const inputFxt = useInput(propsInternal, emit);
		let _value = null;
		let _oldText = "";
		const _wijmoConfig = getWijmoConfig(props.format ?? "");
		const _evalText = (text) => evalMathWithCache(text.replaceAll(",", "."));
		const _getStep = () => props.step;
		const _getFormat = () => props.format ?? "";
		const _setPreviewValue = (newValue) => {
			calculablePreview.value = newValue;
		};
		const _getValue = () => {
			if (inputMode.value === FormatTextStatus.RAW) return _wijmoConfig.parseText(_getText(), _getFormat()).value;
			if (inputMode.value === FormatTextStatus.FORMULA) {
				const evalResult = _evalText(_getText());
				if (evalResult.err) return null;
				return evalResult.res;
			}
			return _value;
		};
		const _showError = (err) => {
			_isFormulaError.value = !!err;
		};
		const _getInputElement = () => inputFxt.input.value;
		const _getText = () => _getInputElement()?.value;
		const selectAll = () => {
			_getInputElement().select();
		};
		const setSelectionRange = (t, i) => {
			_getInputElement().setSelectionRange(t, i ?? t);
		};
		const _isEditable = () => {
			return !props.readonly && !props.disabled;
		};
		const isCalcInput = () => inputMode.value == FormatTextStatus.FORMULA || inputMode.value === FormatTextStatus.EVALUATED;
		const _incrementModel = (e) => {
			_updateModelValue((_getValue() ?? 0) + e);
		};
		const _mathKeyBeforeCursor = (text) => {
			for (let i = 0; i < _getInputElement().selectionStart; i++) if (_wijmoConfig.isMathKey(text[i])) return true;
			return false;
		};
		const _setInternalState = (format) => {
			_oldText = format.res.formattedText;
			inputMode.value = format.status;
			_value = format.res.value;
			debounceFn(format.res.formattedText, format.status);
		};
		const _setInternalStateAndInput = (format) => {
			_setInternalState(format);
			_getInputElement().value = format.res.formattedText;
		};
		const _setText = (textToSet, truncate = false) => {
			_setInternalStateAndInput(truncate ? _wijmoConfig.formatEmpty() : _wijmoConfig.formatText(textToSet, _getFormat()));
		};
		const _setValue = (newValue) => {
			_showError(null);
			if (inputMode.value === FormatTextStatus.TXT && newValue === _getValue()) return;
			const nullableValue = asNumber(newValue, true);
			if (nullableValue == null) _setText("");
			else if (!Number.isNaN(nullableValue)) _setText(newValue);
		};
		const _updateModelValue = (newValue) => {
			_setValue(newValue);
			if (newValue != props.modelValue) emit("update:modelValue", newValue);
		};
		const _getTextOnInput = (currentText) => {
			if (isCalcInput()) return _wijmoConfig.formatMath(currentText);
			if (props.enableMask) return _wijmoConfig.formatText(_wijmoConfig.addAutoFormat(currentText), _getFormat());
			return _wijmoConfig.formatRaw(currentText);
		};
		const onInput = (e) => {
			const target = e.target;
			const currentText = target.value;
			const res = _getTextOnInput(currentText);
			const nextSelection = _wijmoConfig.getNextSelectionRange(res.status, target.selectionStart, currentText, res.res.formattedText);
			target.value = res.res.formattedText;
			if (props.enableMask && nextSelection) target.setSelectionRange(nextSelection.selectionStart, nextSelection.selectionEnd);
			_setInternalState(res);
		};
		const _getDefaultStep = () => {
			if (!_getStep()) return 1;
			return _getStep();
		};
		const onWheel = (e) => {
			if (!e.defaultPrevented && !e.ctrlKey && _isEditable()) {
				e.preventDefault();
				_incrementModel(_getDefaultStep() * clamp(-1 * (e.deltaY ?? -1), -1, 1));
				nextTick(() => {
					selectAll();
				});
			}
		};
		const onGotFocus = (event) => {
			event.target.select();
		};
		const onBlur = () => {
			if (!_isEditable()) return;
			if (inputMode.value === FormatTextStatus.TXT && _getText() === _oldText) return;
			if (inputMode.value === FormatTextStatus.FORMULA) {
				const evalResult = _evalText(_getText());
				_showError(evalResult.err);
				if (!evalResult.err) {
					_setValue(_getValue());
					_updateModelValue(_getValue());
				}
				return;
			}
			if (isCalcInput()) _setValue(_getValue());
			else _setText(_getText());
			_updateModelValue(_getValue());
		};
		const onIncrement = (sens) => {
			_incrementModel(_getStep() * (sens === "+" ? 1 : -1));
		};
		const _manageKeyDownEnterBackspace = (e) => {
			if (isCalcInput()) return;
			const inputElement = _getInputElement();
			if (!_getValue()) {
				_setText("", true);
				e.preventDefault();
				return;
			}
			const selectionStart = inputElement.selectionStart;
			const selectionEnd = inputElement.selectionEnd;
			if (selectionEnd - selectionStart >= 2) return;
			switch (e.key) {
				case _wijmoConfig.Keys.Back:
					if (_wijmoConfig.isSeparator(inputElement.value[selectionEnd - 1])) {
						setSelectionRange(selectionEnd - 1);
						e.preventDefault();
					}
					break;
				case _wijmoConfig.Keys.Delete: if (_wijmoConfig.isSeparator(inputElement.value[selectionStart])) {
					setSelectionRange(selectionStart + 1);
					e.preventDefault();
				}
			}
		};
		const _manageArrowKeys = (e) => {
			if (_getStep()) {
				e.preventDefault();
				_incrementModel(_getStep() * (e.key == _wijmoConfig.Keys.Up ? 1 : -1));
				selectAll();
			}
		};
		const _manageDecimalSeparatorProtection = (inputElement, e) => {
			if (_wijmoConfig.precisionNumber) {
				const decimalPosition = inputElement.value.indexOf(_wijmoConfig.Keys.DecimalSeparator);
				if (decimalPosition !== -1) {
					setSelectionRange(inputElement.selectionStart <= decimalPosition ? decimalPosition + 1 : decimalPosition);
					e.preventDefault();
				} else if (e.key !== _wijmoConfig.Keys.DecimalSeparator) {
					inputElement.value += _wijmoConfig.Keys.DecimalSeparator;
					setSelectionRange(inputElement.value.length);
					e.preventDefault();
				}
			} else e.preventDefault();
		};
		const _manageKeyPressForTxt = (e) => {
			const inputElement = _getInputElement();
			switch (e.key) {
				case ".":
				case _wijmoConfig.Keys.DecimalSeparator:
					_manageDecimalSeparatorProtection(inputElement, e);
					break;
				default: if (_wijmoConfig.isNumericOnly(e.key)) {
					if (_wijmoConfig.preventLeadingNumber(inputElement.value, inputElement.selectionStart)) e.preventDefault();
				} else e.preventDefault();
			}
		};
		const _manageKeyPressForMath = (e) => {
			const inputElement = _getInputElement();
			if (e.key === "(") {
				if (_mathKeyBeforeCursor(inputElement.value)) inputElement.value += "(";
				else inputElement.value = `(${inputElement.value})`;
				inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
				e.preventDefault();
			}
		};
		const _parseValueOnMathKeyPress = (e) => {
			const inputElement = _getInputElement();
			if (isCalcInput()) return true;
			if (_wijmoConfig.isMathKey(e.key)) {
				if (e.key !== "(" && isInputValueFullySelected(inputElement)) {
					_setInternalState(_wijmoConfig.formatMath(e.key));
					inputElement.value = e.key;
					setSelectionRange(inputElement.value.length);
					e.preventDefault();
					return true;
				}
				_setInternalState(_wijmoConfig.formatMath(""));
				const { value: parsedValue } = _wijmoConfig.parseText(inputElement.value, _getFormat());
				inputElement.value = Number.isNaN(parsedValue) ? "" : String(parsedValue);
				return true;
			}
			return !props.enableMask;
		};
		function isInputValueFullySelected(inputElement) {
			return inputElement.value.length > 0 && inputElement.selectionStart === 0 && inputElement.selectionEnd === inputElement.value.length;
		}
		const onKeyPress = (e) => {
			if (e.defaultPrevented || e.ctrlKey || e.metaKey) return;
			if (!_isEditable()) return;
			if (e.key === _wijmoConfig.Keys.Enter) return;
			if (e.key === _wijmoConfig.Keys.StartFormula) {
				e.preventDefault();
				_setInternalStateAndInput(_wijmoConfig.formatMath(""));
				return;
			}
			if (_parseValueOnMathKeyPress(e)) {
				_manageKeyPressForMath(e);
				return;
			}
			_manageKeyPressForTxt(e);
		};
		const _manageEnterFormula = (e) => {
			e.preventDefault();
			e.stopPropagation();
			const evalResult = _evalText(_getText());
			_showError(evalResult.err);
			if (evalResult.err) return;
			const res = evalResult.res;
			if (props.updateModelAfterEachEval || e.shiftKey) _updateModelValue(res);
			else _setInternalStateAndInput(_wijmoConfig.formatEvaluated(res));
			_setPreviewValue(null);
		};
		const _manageEnterKey = (e) => {
			switch (inputMode.value) {
				case FormatTextStatus.FORMULA:
					_manageEnterFormula(e);
					break;
				case FormatTextStatus.EVALUATED:
					_setText(_getValue());
					_updateModelValue(_getValue());
					selectAll();
					break;
				case FormatTextStatus.RAW:
				case FormatTextStatus.TXT:
					_updateModelValue(_getValue());
					selectAll();
			}
		};
		const _manageEscapeKey = () => {
			_setText(props.modelValue ?? null);
			selectAll();
		};
		const onKeyDown = (e) => {
			if (e.defaultPrevented) return;
			if (!_isEditable()) return;
			switch (e.key) {
				case _wijmoConfig.Keys.Delete:
				case _wijmoConfig.Keys.Back:
					_manageKeyDownEnterBackspace(e);
					break;
				case _wijmoConfig.Keys.Up:
				case _wijmoConfig.Keys.Down:
					_manageArrowKeys(e);
					break;
				case _wijmoConfig.Keys.Escape:
					_manageEscapeKey();
					break;
				case _wijmoConfig.Keys.Enter: _manageEnterKey(e);
			}
		};
		const onChange = () => {
			if (!props.updateModelAfterEachEval && isCalcInput()) return;
			_updateModelValue(_getValue());
		};
		const debounceFn = useDebounceFn((newValue, mode) => {
			if (props.previewModePosition === "hidden") return;
			if (!newValue || mode != FormatTextStatus.FORMULA) _setPreviewValue(null);
			else {
				const result = _evalText(newValue);
				_setPreviewValue(result.err ? "N/A" : String(result.res));
			}
		}, 300);
		onMounted(() => {
			_setValue(props.modelValue ?? null);
		});
		watch(() => props.modelValue, (newValue) => {
			_setValue(newValue ?? null);
		});
		/**
		* Checks that the value is within the min/max range.
		* When it is not the case, displays an error message.
		*/
		function checkMinMax() {
			const hasValue = props.modelValue != null;
			if (hasValue && props.minValue != null && props.modelValue < props.minValue) {
				_messageTextInternal.value = translate("ValidationMessage_MinFieldValue_ShortText", props.minValue);
				_messageSeverityInternal.value = "error";
			} else if (hasValue && props.maxValue != null && props.modelValue > props.maxValue) {
				_messageTextInternal.value = translate("ValidationMessage_MaxFieldValue_ShortText", props.maxValue);
				_messageSeverityInternal.value = "error";
			} else {
				_messageTextInternal.value = void 0;
				_messageSeverityInternal.value = void 0;
			}
		}
		watch(() => props.modelValue, () => checkMinMax());
		return {
			...inputFxt,
			handleKeyDown: onKeyDown,
			handleKeyPress: onKeyPress,
			handleFocus: onGotFocus,
			handleBlur: onBlur,
			handleWheel: onWheel,
			handleInput: onInput,
			handleValueChanged: onChange,
			handleStep: onIncrement,
			calculablePreview,
			inputMode,
			propsInternal
		};
	}
});
//#endregion
//#region src/components/InputNumberCalculable/InputNumberCalculable.vue
var _hoisted_1$13 = ["title"];
var _hoisted_2$7 = {
	key: 1,
	class: "input-number-before-content"
};
var _hoisted_3$3 = {
	key: 2,
	class: "input-number-after-content"
};
var _hoisted_4$2 = {
	key: 3,
	class: "calculable-preview"
};
var _hoisted_5$2 = [
	"id",
	"tabindex",
	"placeholder",
	"disabled",
	"readonly"
];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_Image = resolveComponent("Image");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", {
		class: normalizeClass(["input-number neos-input", _ctx.classes]),
		onWheel: _cache[8] || (_cache[8] = (...args) => _ctx.handleWheel && _ctx.handleWheel(...args))
	}, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for"
	])) : createCommentVNode("", true), createElementVNode("div", {
		class: normalizeClass(["input-number-content neos-input-content", {
			"calc-mode": _ctx.inputMode === 2 || _ctx.inputMode == 3,
			"preview-left": _ctx.previewModePosition === "left",
			"preview-top": _ctx.previewModePosition === "top"
		}]),
		title: _ctx.propsInternal.tooltip ?? void 0
	}, [
		!!_ctx.step ? (openBlock(), createElementBlock("button", {
			key: 0,
			class: "btn-step decrement",
			onClick: _cache[0] || (_cache[0] = ($event) => _ctx.handleStep("-"))
		}, "-")) : createCommentVNode("", true),
		_ctx.$slots.before ? (openBlock(), createElementBlock("div", _hoisted_2$7, [renderSlot(_ctx.$slots, "before", {}, void 0, true)])) : createCommentVNode("", true),
		_ctx.$slots.default ? (openBlock(), createElementBlock("div", _hoisted_3$3, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])) : createCommentVNode("", true),
		createVNode(_component_Image, {
			class: "image-calc",
			name: "excel",
			size: "small"
		}),
		_ctx.previewModePosition !== "hidden" ? (openBlock(), createElementBlock("div", _hoisted_4$2, toDisplayString(_ctx.calculablePreview), 1)) : createCommentVNode("", true),
		createElementVNode("input", {
			id: _ctx.id,
			ref: "input",
			type: "text",
			class: "input-number-input",
			tabindex: _ctx.tabIndex,
			placeholder: _ctx.placeholder,
			disabled: _ctx.disabled,
			readonly: _ctx.readonly,
			style: normalizeStyle({ textAlign: _ctx.alignment }),
			spellcheck: "false",
			autocomplete: "off",
			onBlurCapture: _cache[1] || (_cache[1] = (...args) => _ctx.handleBlur && _ctx.handleBlur(...args)),
			onChange: _cache[2] || (_cache[2] = (...args) => _ctx.handleValueChanged && _ctx.handleValueChanged(...args)),
			onInput: _cache[3] || (_cache[3] = (...args) => _ctx.handleInput && _ctx.handleInput(...args)),
			onKeydown: _cache[4] || (_cache[4] = (...args) => _ctx.handleKeyDown && _ctx.handleKeyDown(...args)),
			onKeypress: _cache[5] || (_cache[5] = (...args) => _ctx.handleKeyPress && _ctx.handleKeyPress(...args)),
			onFocus: _cache[6] || (_cache[6] = (...args) => _ctx.handleFocus && _ctx.handleFocus(...args))
		}, null, 44, _hoisted_5$2),
		!!_ctx.step ? (openBlock(), createElementBlock("button", {
			key: 4,
			class: "btn-step increment",
			onClick: _cache[7] || (_cache[7] = ($event) => _ctx.handleStep("+"))
		}, "+")) : createCommentVNode("", true)
	], 10, _hoisted_1$13)]), _ctx.propsInternal.messageText ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.propsInternal.messageText,
		severity: _ctx.propsInternal.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 34);
}
var InputNumberCalculable_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputNumberCalculable_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$8], ["__scopeId", "data-v-666c9d2d"]]);
//#endregion
//#region src/components/InputPassword/InputPassword.ts?vue&type=script&src=true&lang.ts
var InputPassword_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputPassword",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		PrimePassword
	},
	props: {
		...inputProps,
		modelValue: {
			type: String,
			default: null
		},
		updateMode: {
			type: String,
			default: "default"
		},
		revealable: {
			type: Boolean,
			default: true
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const passwordComponent = ref();
		watch(() => passwordComponent.value?.$refs.input, (i) => input.value = i, { immediate: true });
		const passThrough = computed(() => ({ pcInputText: { root: {
			readOnly: props.readonly,
			onChange(event) {
				if (props.updateMode === "default") {
					const target = event.target;
					emitNewValue(target.value);
				}
			},
			onInput(event) {
				if (props.updateMode === "immediate") {
					const target = event.target;
					emitNewValue(target.value);
				}
			}
		} } }));
		function emitNewValue(value) {
			const newValue = value !== "" ? value : null;
			if (newValue !== props.modelValue) emit("update:modelValue", newValue);
		}
		return {
			passwordComponent,
			id,
			classes,
			isLabelVisible,
			isMessageVisible,
			tabIndex,
			passThrough
		};
	}
});
//#endregion
//#region src/components/InputPassword/InputPassword.vue
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_PrimePassword = resolveComponent("PrimePassword");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-password neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_PrimePassword, {
		id: _ctx.id,
		ref: "passwordComponent",
		"model-value": _ctx.modelValue,
		feedback: false,
		disabled: _ctx.disabled,
		placeholder: _ctx.placeholder,
		"toggle-mask": _ctx.revealable,
		pt: _ctx.passThrough,
		tabindex: _ctx.tabIndex,
		class: "neos-input-content"
	}, null, 8, [
		"id",
		"model-value",
		"disabled",
		"placeholder",
		"toggle-mask",
		"pt",
		"tabindex"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputPassword_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputPassword_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$7]]);
//#endregion
//#region src/components/InputSliderDiscrete/InputSliderDiscrete.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$12 = ["id", "tabindex"];
var _hoisted_2$6 = ["disabled"];
var _hoisted_3$2 = ["tabindex", "disabled"];
var _hoisted_4$1 = ["tabindex", "disabled"];
var _hoisted_5$1 = { class: "slider-discrete-markers" };
var _hoisted_6 = ["disabled", "onClick"];
var _hoisted_7 = { class: "slider-discrete-marker-label" };
//#endregion
//#region src/components/InputSliderDiscrete/InputSliderDiscrete.vue
var InputSliderDiscrete_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "InputSliderDiscrete",
	props: {
		...inputProps,
		isRange: {
			type: Boolean,
			default: false
		},
		values: {
			type: Array,
			required: true
		},
		trackColor: {
			type: String,
			default: null
		},
		selectedTrackColor: {
			type: String,
			default: null
		},
		selectedThumbColor: {
			type: String,
			default: null
		},
		modelValue: {
			type: [Number, Array],
			default: null
		}
	},
	emits: [...inputEmits],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const _messageTextInternal = ref(void 0);
		const _messageSeverityInternal = ref(void 0);
		const propsInternal = reactiveComputed(() => ({
			...props,
			focused: props.isRange ? void 0 : props.focused,
			autofocus: props.isRange ? void 0 : props.autofocus,
			messageText: props.messageText ?? _messageTextInternal.value,
			messageSeverity: props.messageSeverity ?? _messageSeverityInternal.value
		}));
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(propsInternal, emit);
		function formatList(values) {
			return values.map(String).join(", ");
		}
		const valuesContractViolation = computed(() => {
			if (props.values.length === 0) return;
			const nonNumeric = props.values.filter((value) => typeof value !== "number");
			if (nonNumeric.length > 0) return {
				key: "InputSliderDiscrete_InvalidValuesNonNumeric",
				args: formatList(nonNumeric)
			};
			const nonFinite = props.values.filter((value) => !Number.isFinite(value));
			if (nonFinite.length > 0) return {
				key: "InputSliderDiscrete_InvalidValuesNonFinite",
				args: formatList(nonFinite)
			};
			const duplicates = props.values.filter((value, index, source) => source.indexOf(value) !== index);
			if (duplicates.length > 0) return {
				key: "InputSliderDiscrete_InvalidValuesDuplicate",
				args: formatList([...new Set(duplicates)])
			};
			for (let index = 1; index < props.values.length; index++) if (props.values[index - 1] >= props.values[index]) return {
				key: "InputSliderDiscrete_InvalidValuesNotStrictlyIncreasing",
				args: `${props.values[index - 1]} >= ${props.values[index]}`
			};
		});
		const safeValues = computed(() => valuesContractViolation.value == null ? props.values : []);
		const interactionsDisabled = computed(() => props.readonly || props.disabled || safeValues.value.length === 0);
		const labelFor = computed(() => interactionsDisabled.value ? void 0 : id);
		const containerRef = useTemplateRef("containerRef");
		const trackRef = useTemplateRef("trackRef");
		const startThumbRef = useTemplateRef("startThumbRef");
		const endThumbRef = useTemplateRef("endThumbRef");
		const activeThumb = ref("single");
		const isDragging = ref(false);
		const isRangeFocused = ref(false);
		watch(containerRef, () => {
			if (!props.isRange) {
				input.value = containerRef.value;
				return;
			}
			if (props.focused === true) focusSliderContainer();
		});
		function getPreferredFocusableElement() {
			if (!props.isRange) return containerRef.value;
			return (activeThumb.value === "end" ? endThumbRef.value : startThumbRef.value) ?? startThumbRef.value ?? endThumbRef.value ?? containerRef.value;
		}
		watchEffect(() => {
			input.value = getPreferredFocusableElement();
		});
		watch(() => props.focused, (value) => {
			if (!props.isRange || value === void 0 || interactionsDisabled.value) return;
			if (value) {
				focusSliderContainer();
				return;
			}
			const activeElement = document.activeElement;
			if (activeElement instanceof HTMLElement && containerRef.value?.contains(activeElement)) activeElement.blur();
		}, { immediate: true });
		const allowedValuesText = computed(() => safeValues.value.join(", "));
		const hasSingleShapeMismatch = computed(() => !props.isRange && props.modelValue != null && Array.isArray(props.modelValue));
		const hasRangeShapeMismatch = computed(() => {
			if (!props.isRange || props.modelValue == null) return false;
			return !Array.isArray(props.modelValue) || props.modelValue.length !== 2;
		});
		const hasModelValueShapeMismatch = computed(() => hasSingleShapeMismatch.value || hasRangeShapeMismatch.value);
		function rangeBoundToIndex(value) {
			if (typeof value !== "number" || !Number.isFinite(value)) return null;
			const index = safeValues.value.indexOf(value);
			return index !== -1 ? index : null;
		}
		const validationError = computed(() => {
			if (valuesContractViolation.value) return translate(valuesContractViolation.value.key, valuesContractViolation.value.args);
			if (safeValues.value.length === 0) return;
			if (hasModelValueShapeMismatch.value) return props.isRange ? translate("InputSliderDiscrete_InvalidRangeShape") : translate("InputSliderDiscrete_InvalidValueShape");
			if (!props.isRange) return getRangeModeValidationMessage();
			if (props.modelValue == null) return;
			const [start, end] = props.modelValue;
			const invalidValues = [start, end].filter((value) => rangeBoundToIndex(value) == null);
			if (invalidValues.length > 0) return translate("InputSliderDiscrete_InvalidRangeValue", invalidValues.map(String).join(", "), allowedValuesText.value);
			if (start > end) return translate("InputSliderDiscrete_InvalidRangeOrder", start, end, allowedValuesText.value);
		});
		watchEffect(() => {
			if (validationError.value) {
				_messageTextInternal.value = validationError.value;
				_messageSeverityInternal.value = "error";
				return;
			}
			_messageTextInternal.value = void 0;
			_messageSeverityInternal.value = void 0;
		});
		function getRangeModeValidationMessage() {
			if (props.modelValue == null) return;
			const singleValue = props.modelValue;
			if (!safeValues.value.includes(singleValue)) return translate("InputSliderDiscrete_InvalidValue", singleValue, allowedValuesText.value);
		}
		function clampIndex(index) {
			return Math.min(Math.max(index, 0), Math.max(0, safeValues.value.length - 1));
		}
		function indexToPercent(index) {
			if (safeValues.value.length <= 1) return 0;
			return clampIndex(index) / (safeValues.value.length - 1) * 100;
		}
		function valueToPercent(value) {
			if (safeValues.value.length <= 1) return 0;
			const min = safeValues.value[0];
			const span = safeValues.value[safeValues.value.length - 1] - min;
			if (span === 0) return 0;
			const ratio = (value - min) / span;
			return Math.min(Math.max(ratio, 0), 1) * 100;
		}
		const hasInvalidModelValue = computed(() => validationError.value != null);
		const hasNullSelection = computed(() => props.modelValue == null);
		const showSingleThumb = computed(() => !hasSingleShapeMismatch.value && !hasNullSelection.value);
		const singleIndex = computed(() => {
			if (safeValues.value.length === 0 || Array.isArray(props.modelValue) || props.modelValue == null) return null;
			const exact = safeValues.value.indexOf(props.modelValue);
			return exact !== -1 ? exact : null;
		});
		const rangeIndexes = computed(() => {
			const last = Math.max(0, safeValues.value.length - 1);
			if (!props.isRange || safeValues.value.length === 0) return [0, last];
			if (props.modelValue == null) return [null, null];
			if (!Array.isArray(props.modelValue) || props.modelValue.length !== 2) return [null, null];
			const [first, second] = props.modelValue;
			return [rangeBoundToIndex(first), rangeBoundToIndex(second)];
		});
		const startIndex = computed(() => rangeIndexes.value[0]);
		const endIndex = computed(() => rangeIndexes.value[1]);
		const hasStartThumb = computed(() => props.isRange && startIndex.value !== null);
		const hasEndThumb = computed(() => props.isRange && endIndex.value !== null);
		const hasRangeThumb = computed(() => props.isRange && (hasStartThumb.value || hasEndThumb.value));
		const containerTabIndex = computed(() => {
			if (interactionsDisabled.value) return -1;
			if (!props.isRange) return tabIndex.value ?? 0;
			return hasRangeThumb.value ? -1 : tabIndex.value ?? 0;
		});
		function getCurrentRangeIndexesForInteraction() {
			const last = Math.max(0, safeValues.value.length - 1);
			const [start, end] = rangeIndexes.value;
			if (start == null && end == null) return [0, last];
			if (start == null) return [end, end];
			if (end == null) return [start, start];
			return [start, end];
		}
		const fillStyle = computed(() => {
			if (hasInvalidModelValue.value) {
				if (!props.isRange && props.modelValue != null && !Array.isArray(props.modelValue)) return {
					left: "0%",
					width: `${valueToPercent(props.modelValue)}%`
				};
				return {
					left: "0%",
					width: "0%"
				};
			}
			const [from, to] = computeRangeIndexes();
			const left = indexToPercent(from);
			const right = indexToPercent(to);
			return {
				left: `${left}%`,
				width: `${Math.max(0, right - left)}%`
			};
		});
		const singleThumbStyle = computed(() => {
			if (!props.isRange && props.modelValue != null && !Array.isArray(props.modelValue) && singleIndex.value == null) return { left: `${valueToPercent(props.modelValue)}%` };
			return { left: `${indexToPercent(singleIndex.value ?? 0)}%` };
		});
		const startThumbStyle = computed(() => ({ left: `${indexToPercent(startIndex.value ?? 0)}%` }));
		const endThumbStyle = computed(() => ({ left: `${indexToPercent(endIndex.value ?? 0)}%` }));
		const startThumbTabIndex = computed(() => {
			if (!props.isRange || !props.tabStop || interactionsDisabled.value || !hasStartThumb.value) return -1;
			if (!hasEndThumb.value) return 0;
			return activeThumb.value === "end" ? -1 : 0;
		});
		const endThumbTabIndex = computed(() => {
			if (!props.isRange || !props.tabStop || interactionsDisabled.value || !hasEndThumb.value) return -1;
			if (!hasStartThumb.value) return 0;
			return activeThumb.value === "end" ? 0 : -1;
		});
		const sliderStyle = computed(() => ({
			"--slider-discrete-track-color": props.trackColor ? getColorValue(props.trackColor) : void 0,
			"--slider-discrete-selected-track-color": props.selectedTrackColor ? getColorValue(props.selectedTrackColor) : void 0,
			"--slider-discrete-selected-thumb-color": props.selectedThumbColor ? getColorValue(props.selectedThumbColor) : void 0
		}));
		function computeRangeIndexes() {
			return props.isRange ? [Math.min(startIndex.value ?? 0, endIndex.value ?? 0), Math.max(startIndex.value ?? 0, endIndex.value ?? 0)] : [0, singleIndex.value ?? 0];
		}
		function markerStyle(index) {
			return { left: `${indexToPercent(index)}%` };
		}
		function emitSingleAt(index) {
			if (safeValues.value.length === 0) return;
			emit("update:modelValue", safeValues.value[clampIndex(index)]);
		}
		function emitRangeAt(firstIndex, secondIndex) {
			if (safeValues.value.length === 0) return;
			const first = clampIndex(firstIndex);
			const second = clampIndex(secondIndex);
			const start = Math.min(first, second);
			const end = Math.max(first, second);
			emit("update:modelValue", [safeValues.value[start], safeValues.value[end]]);
		}
		function updateWithActiveThumb(index) {
			if (!props.isRange) {
				emitSingleAt(index);
				return;
			}
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			if (activeThumb.value === "end") emitRangeAt(currentStart, index);
			else emitRangeAt(index, currentEnd);
		}
		function indexFromClientX(clientX) {
			if (!trackRef.value || safeValues.value.length <= 1) return 0;
			const rect = trackRef.value.getBoundingClientRect();
			const ratio = (clientX - rect.left) / rect.width;
			return Math.round(Math.min(Math.max(ratio, 0), 1) * (safeValues.value.length - 1));
		}
		function onPointerMove(event) {
			if (!isDragging.value || interactionsDisabled.value) return;
			updateWithActiveThumb(indexFromClientX(event.clientX));
		}
		function stopDrag() {
			isDragging.value = false;
			globalThis.removeEventListener("pointermove", onPointerMove);
			globalThis.removeEventListener("pointerup", stopDrag);
			globalThis.removeEventListener("pointercancel", stopDrag);
		}
		function startDrag(thumb, event) {
			if (interactionsDisabled.value) return;
			activeThumb.value = thumb;
			isDragging.value = true;
			updateWithActiveThumb(indexFromClientX(event.clientX));
			globalThis.addEventListener("pointermove", onPointerMove);
			globalThis.addEventListener("pointerup", stopDrag);
			globalThis.addEventListener("pointercancel", stopDrag);
		}
		onBeforeUnmount(() => {
			stopDrag();
		});
		function selectValue(value) {
			if (interactionsDisabled.value) return;
			const index = safeValues.value.indexOf(value);
			if (index === -1) return;
			if (!props.isRange) {
				activeThumb.value = "single";
				emitSingleAt(index);
				return;
			}
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			const startGap = Math.abs(index - currentStart);
			if (Math.abs(index - currentEnd) < startGap) {
				activeThumb.value = "end";
				emitRangeAt(currentStart, index);
			} else {
				activeThumb.value = "start";
				emitRangeAt(index, currentEnd);
			}
		}
		function handleKeyDown(event) {
			if (interactionsDisabled.value) return;
			if (props.isRange && isCtrlKey(event) && isArrowKey(event)) {
				event.preventDefault();
				activeThumb.value = event.key === "ArrowLeft" ? "start" : "end";
				return;
			}
			if (!isArrowKey(event)) return;
			event.preventDefault();
			const delta = event.key === "ArrowRight" ? 1 : -1;
			if (!props.isRange) {
				activeThumb.value = "single";
				emitSingleAt((singleIndex.value ?? 0) + delta);
				return;
			}
			updateSliderValue(delta);
		}
		function isArrowKey(event) {
			return event.key === "ArrowLeft" || event.key === "ArrowRight";
		}
		function updateSliderValue(delta) {
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			if ((activeThumb.value === "end" ? "end" : "start") === "start") emitRangeAt(Math.min(currentEnd, currentStart + delta), currentEnd);
			else emitRangeAt(currentStart, Math.max(currentStart, currentEnd + delta));
		}
		function isCtrlKey(event) {
			const isNotOtherKey = !event.shiftKey && !event.altKey && !event.metaKey;
			return event.ctrlKey && isNotOtherKey;
		}
		function handleTrackPointerDown(event) {
			if (interactionsDisabled.value) return;
			event.preventDefault();
			if (!props.isRange) {
				startDrag("single", event);
				return;
			}
			const targetIndex = indexFromClientX(event.clientX);
			const [currentStart, currentEnd] = getCurrentRangeIndexesForInteraction();
			const startGap = Math.abs(targetIndex - currentStart);
			startDrag(Math.abs(targetIndex - currentEnd) < startGap ? "end" : "start", event);
		}
		function handleThumbPointerDown(thumb, event) {
			event.stopPropagation();
			event.preventDefault();
			startDrag(thumb, event);
		}
		function markerIsSelected(index) {
			if (hasInvalidModelValue.value) return false;
			if (props.isRange) {
				const start = startIndex.value;
				const end = endIndex.value;
				if (start == null || end == null) return false;
				return index >= Math.min(start, end) && index <= Math.max(start, end);
			}
			return singleIndex.value != null && index === singleIndex.value;
		}
		function focusSliderContainer() {
			if (interactionsDisabled.value) return;
			const focusableElement = getPreferredFocusableElement();
			if (focusableElement != null) focusableElement.focus();
		}
		function handleContainerFocusIn() {
			if (!props.isRange || isRangeFocused.value) return;
			isRangeFocused.value = true;
			if (props.focused !== true) emit("update:focused", true);
		}
		function handleContainerFocusOut(event) {
			if (!props.isRange || !isRangeFocused.value) return;
			const nextTarget = event.relatedTarget;
			if (nextTarget instanceof Node && containerRef.value?.contains(nextTarget)) return;
			isRangeFocused.value = false;
			if (props.focused !== false) emit("update:focused", false);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				class: normalizeClass(["input-slider-discrete neos-input", unref(classes)]),
				style: normalizeStyle(sliderStyle.value)
			}, [
				unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
					key: 0,
					label: _ctx.label,
					required: _ctx.required,
					documentation: _ctx.documentation,
					"html-for": labelFor.value,
					"ai-suggestion": _ctx.aiSuggestion,
					onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
					onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel")),
					onClick: focusSliderContainer
				}, null, 8, [
					"label",
					"required",
					"documentation",
					"html-for",
					"ai-suggestion"
				])) : createCommentVNode("", true),
				createElementVNode("div", {
					id: unref(id),
					ref_key: "containerRef",
					ref: containerRef,
					class: "slider-discrete-container",
					tabindex: containerTabIndex.value,
					onKeydown: handleKeyDown,
					onFocusin: handleContainerFocusIn,
					onFocusout: handleContainerFocusOut
				}, [createElementVNode("div", {
					ref_key: "trackRef",
					ref: trackRef,
					class: "slider-discrete-track",
					onPointerdown: handleTrackPointerDown
				}, [
					_cache[9] || (_cache[9] = createElementVNode("div", { class: "slider-discrete-base-line" }, null, -1)),
					createElementVNode("div", {
						class: "slider-discrete-fill",
						style: normalizeStyle(fillStyle.value)
					}, null, 4),
					!props.isRange ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [showSingleThumb.value ? (openBlock(), createElementBlock("button", {
						key: 0,
						type: "button",
						class: "slider-discrete-thumb",
						style: normalizeStyle(singleThumbStyle.value),
						tabindex: "-1",
						disabled: interactionsDisabled.value,
						onPointerdown: _cache[2] || (_cache[2] = ($event) => handleThumbPointerDown("single", $event))
					}, null, 44, _hoisted_2$6)) : createCommentVNode("", true)], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [startIndex.value !== null ? (openBlock(), createElementBlock("button", {
						key: 0,
						ref_key: "startThumbRef",
						ref: startThumbRef,
						type: "button",
						class: normalizeClass(["slider-discrete-thumb", { "slider-discrete-thumb-active": activeThumb.value === "start" }]),
						style: normalizeStyle(startThumbStyle.value),
						tabindex: startThumbTabIndex.value,
						disabled: interactionsDisabled.value,
						onFocus: _cache[3] || (_cache[3] = ($event) => activeThumb.value = "start"),
						onPointerdown: _cache[4] || (_cache[4] = ($event) => handleThumbPointerDown("start", $event))
					}, null, 46, _hoisted_3$2)) : createCommentVNode("", true), endIndex.value !== null ? (openBlock(), createElementBlock("button", {
						key: 1,
						ref_key: "endThumbRef",
						ref: endThumbRef,
						type: "button",
						class: normalizeClass(["slider-discrete-thumb", { "slider-discrete-thumb-active": activeThumb.value === "end" }]),
						style: normalizeStyle(endThumbStyle.value),
						tabindex: endThumbTabIndex.value,
						disabled: interactionsDisabled.value,
						onFocus: _cache[5] || (_cache[5] = ($event) => activeThumb.value = "end"),
						onPointerdown: _cache[6] || (_cache[6] = ($event) => handleThumbPointerDown("end", $event))
					}, null, 46, _hoisted_4$1)) : createCommentVNode("", true)], 64)),
					createElementVNode("div", _hoisted_5$1, [(openBlock(true), createElementBlock(Fragment, null, renderList(safeValues.value, (value, index) => {
						return openBlock(), createElementBlock("button", {
							key: `${index}-${value}`,
							type: "button",
							class: normalizeClass(["slider-discrete-marker", { "slider-discrete-marker-selected": markerIsSelected(index) }]),
							style: normalizeStyle(markerStyle(index)),
							tabindex: "-1",
							disabled: interactionsDisabled.value,
							onPointerdown: _cache[7] || (_cache[7] = withModifiers(() => {}, ["stop"])),
							onClick: withModifiers(($event) => selectValue(value), ["stop"])
						}, [_cache[8] || (_cache[8] = createElementVNode("span", { class: "slider-discrete-marker-line" }, null, -1)), createElementVNode("span", _hoisted_7, toDisplayString(value), 1)], 46, _hoisted_6);
					}), 128))])
				], 544)], 40, _hoisted_1$12),
				unref(isMessageVisible) && unref(propsInternal).messageText ? (openBlock(), createBlock(InputMessage_default, {
					key: 1,
					text: unref(propsInternal).messageText,
					severity: unref(propsInternal).messageSeverity
				}, null, 8, ["text", "severity"])) : createCommentVNode("", true)
			], 6);
		};
	}
}), [["__scopeId", "data-v-68e80ae9"]]);
//#endregion
//#region src/components/InputTime/InputTime.ts?vue&type=script&src=true&lang.ts
var InputTime_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "InputTime",
	components: {
		InputLabel: InputLabel_default,
		InputMessage: InputMessage_default,
		WjInputTime
	},
	props: {
		...inputProps,
		modelValue: {
			type: [Date],
			default: null
		},
		format: {
			type: String,
			default: void 0
		}
	},
	emits: [...inputEmits],
	setup(props, { emit }) {
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		let _inputTime;
		function handleInitialization(inputTime) {
			_inputTime = inputTime;
			input.value = inputTime.inputElement;
			inputTime.inputElement.id = id;
			inputTime.isDroppedDownChanged.addHandler(handleDropdownChanged);
		}
		function handleDropdownChanged(sender) {
			if (sender.isDroppedDown) ZIndex$1.set("input-time", sender.dropDown);
			else ZIndex$1.clear(sender.dropDown);
		}
		function handleValueChanged(inputTime) {
			emit("update:modelValue", inputTime.value);
		}
		onBeforeUnmount(() => {
			if (_inputTime) {
				ZIndex$1.clear(_inputTime.dropDown);
				_inputTime.isDroppedDownChanged.removeHandler(handleDropdownChanged);
				_inputTime = void 0;
			}
		});
		return {
			classes,
			handleInitialization,
			handleValueChanged,
			id,
			isLabelVisible,
			isMessageVisible,
			tabIndex
		};
	}
});
//#endregion
//#region src/components/InputTime/InputTime.vue
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_InputLabel = resolveComponent("InputLabel");
	const _component_WjInputTime = resolveComponent("WjInputTime");
	const _component_InputMessage = resolveComponent("InputMessage");
	return openBlock(), createElementBlock("div", { class: normalizeClass(["input-time neos-input", _ctx.classes]) }, [createElementVNode("div", null, [_ctx.isLabelVisible ? (openBlock(), createBlock(_component_InputLabel, {
		key: 0,
		label: _ctx.label,
		required: _ctx.required,
		documentation: _ctx.documentation,
		"html-for": _ctx.id,
		"ai-suggestion": _ctx.aiSuggestion,
		onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
		onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
	}, null, 8, [
		"label",
		"required",
		"documentation",
		"html-for",
		"ai-suggestion"
	])) : createCommentVNode("", true), createVNode(_component_WjInputTime, {
		value: _ctx.modelValue,
		"is-required": false,
		"is-read-only": _ctx.readonly,
		"is-disabled": _ctx.disabled,
		placeholder: _ctx.placeholder,
		format: _ctx.format,
		"tab-order": _ctx.tabIndex,
		initialized: _ctx.handleInitialization,
		"value-changed": _ctx.handleValueChanged,
		class: "neos-input-content",
		autocomplete: "nope"
	}, null, 8, [
		"value",
		"is-read-only",
		"is-disabled",
		"placeholder",
		"format",
		"tab-order",
		"initialized",
		"value-changed"
	])]), _ctx.isMessageVisible ? (openBlock(), createBlock(_component_InputMessage, {
		key: 0,
		text: _ctx.messageText,
		severity: _ctx.messageSeverity
	}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
}
var InputTime_default = /*#__PURE__*/ _plugin_vue_export_helper_default(InputTime_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$6]]);
//#endregion
//#region src/components/ListBox/ListBox.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$11 = {
	class: "list-box-empty",
	role: "status",
	"aria-live": "polite"
};
//#endregion
//#region src/components/ListBox/ListBox.vue
var ListBox_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ListBox",
	props: /*@__PURE__*/ mergeModels({
		...inputProps,
		values: {
			type: Array,
			default: () => []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		multiple: {
			type: Boolean,
			default: false
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		}
	}, {
		"modelValue": { default: () => [] },
		"modelModifiers": {}
	}),
	emits: /*@__PURE__*/ mergeModels([...inputEmits], ["update:modelValue"]),
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const modelValue = useModel(__props, "modelValue");
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const { getItemKey, getItemLabel, isSameItem } = useSelectableItemProperties(props);
		const { translate } = useGlobalResourceManager();
		const containerTabIndex = computed(() => tabIndex.value ?? 0);
		const { displayedItems: displayedValues, searchText, showSelected, handleSearch, toggleShowSelected } = useSelectableListFilter({
			items: () => props.values,
			selectedItems: () => modelValue.value,
			multiple: () => props.multiple,
			searchable: () => props.searchable,
			getItemLabel,
			isSameItem
		});
		function handleSelection(event) {
			if (props.readonly || props.disabled || props.loading) return;
			if (event.source === "click") {
				const mouseEvent = event.originalEvent;
				if (!props.multiple || !mouseEvent.ctrlKey) {
					modelValue.value = [event.item];
					return;
				}
			}
			if (props.multiple) {
				if (event.checked) modelValue.value = [...modelValue.value, event.item];
				else modelValue.value = modelValue.value.filter((item) => !isSameItem(item, event.item));
			} else modelValue.value = [event.item];
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["list-box neos-input", unref(classes)]) }, [
				unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
					key: 0,
					label: _ctx.label,
					required: _ctx.required,
					documentation: _ctx.documentation,
					"html-for": unref(id),
					"ai-suggestion": _ctx.aiSuggestion,
					onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
					onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
				}, null, 8, [
					"label",
					"required",
					"documentation",
					"html-for",
					"ai-suggestion"
				])) : createCommentVNode("", true),
				createVNode(SelectableList_default, {
					"list-id": unref(id),
					items: unref(displayedValues),
					"selected-items": modelValue.value,
					"get-item-key": unref(getItemKey),
					"is-same-item": unref(isSameItem),
					multiple: __props.multiple,
					disabled: _ctx.disabled || _ctx.readonly || __props.loading && __props.values.length > 0,
					loading: __props.loading,
					required: _ctx.required,
					"tab-index": containerTabIndex.value,
					"focus-selected-on-focus": "",
					"clear-focus-on-blur": "",
					"select-on-enter": false,
					"select-on-tab": false,
					"aria-label": _ctx.label,
					class: "list-box-container",
					onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
					onSelect: handleSelection
				}, {
					header: withCtx(({ focusedItemId, setFocusedIndex }) => [__props.searchable ? (openBlock(), createBlock(SelectableListHeader_default, {
						key: 0,
						modelValue: unref(searchText),
						"onUpdate:modelValue": [_cache[2] || (_cache[2] = ($event) => isRef(searchText) ? searchText.value = $event : null), ($event) => unref(handleSearch)(setFocusedIndex)],
						class: "list-box-search-header",
						"list-id": unref(id),
						"active-descendant": focusedItemId,
						disabled: _ctx.disabled,
						loading: __props.loading,
						"tab-index": unref(tabIndex),
						"selected-count": __props.multiple ? modelValue.value.length : void 0,
						"show-selected": unref(showSelected),
						"show-selected-button-class": "list-box-show-selected-button",
						onToggleShowSelected: ($event) => unref(toggleShowSelected)(setFocusedIndex)
					}, null, 8, [
						"modelValue",
						"list-id",
						"active-descendant",
						"disabled",
						"loading",
						"tab-index",
						"selected-count",
						"show-selected",
						"onUpdate:modelValue",
						"onToggleShowSelected"
					])) : createCommentVNode("", true)]),
					item: withCtx(({ item, itemId, selected, focused, select }) => [createVNode(SelectableItem_default, {
						id: itemId,
						"control-type": __props.multiple ? "checkbox" : "radio",
						selected,
						focused,
						class: "list-box-item",
						"aria-label": unref(getItemLabel)(item),
						onClick: ($event) => select($event, "click"),
						onChecked: ($event) => select($event, "checked")
					}, {
						default: withCtx(() => [createElementVNode("span", null, toDisplayString(unref(getItemLabel)(item)), 1)]),
						_: 2
					}, 1032, [
						"id",
						"control-type",
						"selected",
						"focused",
						"aria-label",
						"onClick",
						"onChecked"
					])]),
					empty: withCtx(() => [createElementVNode("span", _hoisted_1$11, toDisplayString(unref(translate)(__props.loading ? "Loading" : __props.values.length === 0 ? "NoValues" : "NoResultFound")), 1)]),
					_: 1
				}, 8, [
					"list-id",
					"items",
					"selected-items",
					"get-item-key",
					"is-same-item",
					"multiple",
					"disabled",
					"loading",
					"required",
					"tab-index",
					"aria-label"
				]),
				unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
					key: 1,
					text: _ctx.messageText,
					severity: _ctx.messageSeverity
				}, null, 8, ["text", "severity"])) : createCommentVNode("", true)
			], 2);
		};
	}
}), [["__scopeId", "data-v-94ed6d18"]]);
//#endregion
//#region src/composables/useParentElement.ts
function useParentElement() {
	const parentElement = ref(null);
	const vm = getCurrentInstance();
	onMounted(() => {
		parentElement.value = vm.proxy.$el.parentElement;
	});
	onUnmounted(() => {
		parentElement.value = null;
	});
	return parentElement;
}
//#endregion
//#region src/components/LoadDataOnScroll/LoadDataOnScroll.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$10 = {
	key: 0,
	class: "load-data-on-scroll-spinner"
};
//#endregion
//#region src/components/LoadDataOnScroll/LoadDataOnScroll.vue
var LoadDataOnScroll_default = /* @__PURE__ */ defineComponent({
	__name: "LoadDataOnScroll",
	props: {
		direction: { default: "vertical" },
		onLoad: {
			type: Function,
			default: void 0
		},
		hasMoreData: { type: Boolean },
		spinnerSize: { default: "extralarge" }
	},
	setup(__props) {
		const props = __props;
		const loading = ref(false);
		const enabled = computed(() => props.onLoad && props.hasMoreData && !loading.value);
		const parentElement = useParentElement();
		const containerElement = computed(() => {
			const childElement = parentElement.value?.firstElementChild;
			return childElement?.hasAttribute("data-virtual-repeat") ? childElement : parentElement.value;
		});
		watch([enabled, containerElement], async () => {
			while (enabled.value && containerElement.value && !hasScrollbar(containerElement.value, props.direction)) await load();
		});
		useEventListener(containerElement, "scroll", onScroll);
		async function onScroll(event) {
			if (enabled.value && isAtScrollEnd(event.target, props.direction)) await load();
		}
		function hasScrollbar(element, direction) {
			if (direction === "horizontal") return element.scrollWidth > element.clientWidth;
			return element.scrollHeight > element.clientHeight;
		}
		function isAtScrollEnd(element, direction) {
			if (direction === "horizontal") {
				const threshold = (element.scrollWidth - element.clientWidth) * .1;
				return element.scrollLeft + element.clientWidth >= element.scrollWidth - threshold;
			}
			const threshold = (element.scrollHeight - element.clientHeight) * .1;
			return element.scrollTop + element.clientHeight >= element.scrollHeight - threshold;
		}
		async function load() {
			loading.value = true;
			try {
				await props.onLoad();
			} finally {
				loading.value = false;
			}
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [renderSlot(_ctx.$slots, "default"), loading.value ? (openBlock(), createElementBlock("div", _hoisted_1$10, [createVNode(Spinner_default, { size: __props.spinnerSize }, null, 8, ["size"])])) : createCommentVNode("", true)], 64);
		};
	}
});
//#endregion
//#region src/components/Message/Message.ts?vue&type=script&src=true&lang.ts
var Message_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Message",
	components: {
		Button: Button_default,
		Image: Image_default,
		Text: Text_default,
		HorizontalLayout: HorizontalLayout_default
	},
	props: {
		visible: {
			type: Boolean,
			default: void 0
		},
		showIcon: {
			type: Boolean,
			default: true
		},
		severity: {
			type: String,
			default: "info"
		},
		closable: {
			type: Boolean,
			default: false
		}
	},
	emits: ["update:visible"],
	setup(props, { emit }) {
		const internalVisible = ref(true);
		const isVisible = computed({
			get() {
				return props.visible ?? internalVisible.value;
			},
			set(value) {
				if (props.visible !== void 0) {
					emit("update:visible", value);
					return;
				}
				internalVisible.value = value;
			}
		});
		const severityClass = computed(() => `message-${props.severity}`);
		function close() {
			isVisible.value = false;
		}
		useComponentAutomationProperties();
		return {
			isVisible,
			severityClass,
			close
		};
	}
});
//#endregion
//#region src/components/Message/Message.vue
var _hoisted_1$9 = { class: "message-content neos-vertical-content neos-fill-parent-width" };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Button = resolveComponent("Button");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(Transition, { name: "message" }, {
		default: withCtx(() => [_ctx.isVisible ? (openBlock(), createElementBlock("div", {
			key: 0,
			class: normalizeClass(["message", `message-${_ctx.severity}`])
		}, [createVNode(_component_HorizontalLayout, {
			class: "message-wrapper neos-fill-parent-width",
			wrap: false
		}, {
			default: withCtx(() => [
				_ctx.showIcon ? (openBlock(), createBlock(_component_Image, {
					key: 0,
					name: _ctx.severity,
					size: "large",
					class: "message-icon"
				}, null, 8, ["name"])) : createCommentVNode("", true),
				createElementVNode("div", _hoisted_1$9, [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				_ctx.closable ? (openBlock(), createBlock(_component_Button, {
					key: 1,
					class: "message-close-button",
					variant: "link",
					size: "small",
					onClick: _cache[0] || (_cache[0] = ($event) => _ctx.close())
				}, {
					default: withCtx(() => [createVNode(_component_Image, { name: "close" })]),
					_: 1
				})) : createCommentVNode("", true)
			]),
			_: 3
		})], 2)) : createCommentVNode("", true)]),
		_: 3
	});
}
var Message_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Message_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$5], ["__scopeId", "data-v-2238c6f5"]]);
//#endregion
//#region src/components/MultiSelect/MultiSelect.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$8 = { class: "multi-select-chips" };
var _hoisted_2$5 = ["aria-label", "onClick"];
var _hoisted_3$1 = {
	key: 0,
	class: "multi-select-limit"
};
//#endregion
//#region src/components/MultiSelect/MultiSelect.vue
var MultiSelect_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "MultiSelect",
	props: {
		...inputProps,
		modelValue: {
			type: Array,
			default: () => []
		},
		values: {
			type: Array,
			default: () => []
		},
		keyProperty: {
			type: String,
			default: void 0
		},
		valueProperty: {
			type: String,
			default: void 0
		},
		displayProperty: {
			type: String,
			default: void 0
		},
		searchable: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		caret: {
			type: Boolean,
			default: true
		},
		maxDisplayedChips: {
			type: Number,
			default: 1
		}
	},
	emits: [
		...inputEmits,
		"show",
		"hide"
	],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const { translate } = useGlobalResourceManager();
		const { input, id, classes, isLabelVisible, isMessageVisible, tabIndex } = useInput(props, emit);
		const { disabledOrReadonly, keyProperty, displayProperty, getOptionValue } = useSelectProps(props);
		const selectedOptions = computed({
			get() {
				if (props.valueProperty) {
					const selectedValues = new Set(props.modelValue);
					return props.values.filter((option) => selectedValues.has(getOptionValue(option)));
				}
				return props.modelValue;
			},
			set(options) {
				emit("update:modelValue", options.map(getOptionValue));
			}
		});
		const displayedSelectedOptions = computed(() => props.maxDisplayedChips && selectedOptions.value.length > props.maxDisplayedChips ? selectedOptions.value.slice(0, props.maxDisplayedChips) : selectedOptions.value);
		const limitValue = computed(() => selectedOptions.value.length - displayedSelectedOptions.value.length);
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", { class: normalizeClass(["multi-select neos-input", unref(classes)]) }, [createElementVNode("div", null, [unref(isLabelVisible) ? (openBlock(), createBlock(InputLabel_default, {
				key: 0,
				label: _ctx.label,
				required: _ctx.required,
				documentation: _ctx.documentation,
				"html-for": unref(id),
				"ai-suggestion": _ctx.aiSuggestion,
				onAiApply: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("aiApply")),
				onAiCancel: _cache[1] || (_cache[1] = ($event) => _ctx.$emit("aiCancel"))
			}, null, 8, [
				"label",
				"required",
				"documentation",
				"html-for",
				"ai-suggestion"
			])) : createCommentVNode("", true), createVNode(Select_default, {
				id: unref(id),
				modelValue: selectedOptions.value,
				"onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => selectedOptions.value = $event),
				multiple: "",
				values: __props.values,
				"key-property": unref(keyProperty),
				"display-property": unref(displayProperty),
				required: _ctx.required,
				disabled: unref(disabledOrReadonly),
				loading: __props.loading,
				caret: __props.caret,
				searchable: __props.searchable,
				"invalid-value": null,
				placeholder: _ctx.placeholder,
				"tab-index": unref(tabIndex),
				class: "neos-input-content",
				onMounted: _cache[3] || (_cache[3] = ($event) => input.value = $event),
				onShow: _cache[4] || (_cache[4] = ($event) => _ctx.$emit("show")),
				onHide: _cache[5] || (_cache[5] = ($event) => _ctx.$emit("hide"))
			}, {
				before: withCtx(() => [renderSlot(_ctx.$slots, "before", {}, void 0, true)]),
				values: withCtx(({ getOptionKey, getOptionLabel, removeOption }) => [createElementVNode("span", _hoisted_1$8, [(openBlock(true), createElementBlock(Fragment, null, renderList(displayedSelectedOptions.value, (option) => {
					return openBlock(), createElementBlock("span", {
						key: getOptionKey(option),
						class: "multi-select-chip"
					}, [renderSlot(_ctx.$slots, "chip", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true), !unref(disabledOrReadonly) ? (openBlock(), createElementBlock("button", {
						key: 0,
						type: "button",
						class: "multi-select-remove",
						"aria-label": `${unref(translate)("Remove")} ${getOptionLabel(option)}`,
						tabindex: "-1",
						onClick: withModifiers(($event) => removeOption(option), ["stop"])
					}, [createVNode(Image_default, {
						name: "erase",
						size: "extrasmall"
					})], 8, _hoisted_2$5)) : createCommentVNode("", true)]);
				}), 128))]), limitValue.value ? (openBlock(), createElementBlock("span", _hoisted_3$1, "+" + toDisplayString(limitValue.value), 1)) : createCommentVNode("", true)]),
				after: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
				option: withCtx(({ option, getOptionLabel }) => [renderSlot(_ctx.$slots, "option", { option }, () => [createTextVNode(toDisplayString(getOptionLabel(option)), 1)], true)]),
				_: 3
			}, 8, [
				"id",
				"modelValue",
				"values",
				"key-property",
				"display-property",
				"required",
				"disabled",
				"loading",
				"caret",
				"searchable",
				"placeholder",
				"tab-index"
			])]), unref(isMessageVisible) ? (openBlock(), createBlock(InputMessage_default, {
				key: 0,
				text: _ctx.messageText,
				severity: _ctx.messageSeverity
			}, null, 8, ["text", "severity"])) : createCommentVNode("", true)], 2);
		};
	}
}), [["__scopeId", "data-v-e2537815"]]);
//#endregion
//#region src/components/PaginationBar/PaginationBar.ts?vue&type=script&src=true&lang.ts
var PaginationBar_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "PaginationBar",
	components: {
		Button: Button_default,
		Combobox: Combobox_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		Text: Text_default
	},
	props: {
		pageNumber: {
			type: Number,
			required: true
		},
		canMoveToNextPage: {
			type: Boolean,
			required: true
		},
		recordsByPage: {
			type: Number,
			required: true
		},
		recordsByPageList: {
			type: Array,
			default: () => [
				5,
				10,
				20,
				50
			]
		},
		totalRecordCount: {
			type: Number,
			default: void 0
		}
	},
	emits: ["update:pageNumber", "update:recordsByPage"],
	setup(props, { emit }) {
		const { translate } = useGlobalResourceManager();
		const internalPageNumber = computed({
			get: () => props.pageNumber,
			set: (value) => emit("update:pageNumber", value)
		});
		const internalRecordsByPage = computed({
			get: () => props.recordsByPage,
			set: (value) => emit("update:recordsByPage", value)
		});
		const internalRecordsByPageList = computed(() => props.recordsByPageList.includes(internalRecordsByPage.value) ? props.recordsByPageList : [...props.recordsByPageList, internalRecordsByPage.value].sort((a, b) => a - b));
		const canMoveToPreviousPage = computed(() => internalPageNumber.value > 1);
		const totalRecordCountCaption = computed(() => {
			if (props.totalRecordCount === void 0) return;
			return `/ ${props.totalRecordCount} ${translate(props.totalRecordCount > 1 ? "Items" : "Item").toLowerCase()}`;
		});
		function moveToFirstPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value = 1;
		}
		function moveToPreviousPage() {
			if (canMoveToPreviousPage.value) internalPageNumber.value -= 1;
		}
		function moveToNextPage() {
			if (props.canMoveToNextPage) internalPageNumber.value += 1;
		}
		return {
			internalPageNumber,
			internalRecordsByPage,
			internalRecordsByPageList,
			canMoveToPreviousPage,
			moveToFirstPage,
			moveToPreviousPage,
			moveToNextPage,
			totalRecordCountCaption
		};
	}
});
//#endregion
//#region src/components/PaginationBar/PaginationBar.vue
var _hoisted_1$7 = { class: "pagination-page-number" };
var _hoisted_2$4 = {
	key: 0,
	class: "pagination-total-record-count"
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Button = resolveComponent("Button");
	const _component_Text = resolveComponent("Text");
	const _component_Combobox = resolveComponent("Combobox");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	return openBlock(), createBlock(_component_HorizontalLayout, {
		class: "pagination-bar",
		"vertical-align": "center"
	}, {
		default: withCtx(() => [
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-first",
				icon: "doubleChevronLeft",
				onClick: _ctx.moveToFirstPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToPreviousPage,
				class: "pagination-button-move-previous",
				icon: "chevronLeft",
				onClick: _ctx.moveToPreviousPage
			}, null, 8, ["disabled", "onClick"]),
			createElementVNode("div", _hoisted_1$7, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.internalPageNumber), 1)]),
				_: 1
			})]),
			createVNode(_component_Button, {
				variant: "link",
				disabled: !_ctx.canMoveToNextPage,
				class: "pagination-button-move-next",
				icon: "chevronRight",
				onClick: _ctx.moveToNextPage
			}, null, 8, ["disabled", "onClick"]),
			createVNode(_component_Combobox, {
				modelValue: _ctx.internalRecordsByPage,
				"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.internalRecordsByPage = $event),
				values: _ctx.internalRecordsByPageList,
				required: "",
				class: "pagination-records-by-page"
			}, null, 8, ["modelValue", "values"]),
			_ctx.totalRecordCountCaption ? (openBlock(), createElementBlock("div", _hoisted_2$4, [createVNode(_component_Text, null, {
				default: withCtx(() => [createTextVNode(toDisplayString(_ctx.totalRecordCountCaption), 1)]),
				_: 1
			})])) : createCommentVNode("", true)
		]),
		_: 1
	});
}
var PaginationBar_default = /*#__PURE__*/ _plugin_vue_export_helper_default(PaginationBar_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$4], ["__scopeId", "data-v-748292b0"]]);
//#endregion
//#region src/components/ProgressBar/ProgressBar.vue
var ProgressBar_default = /* @__PURE__ */ defineComponent({
	__name: "ProgressBar",
	props: {
		value: { default: void 0 },
		showValue: {
			type: Boolean,
			default: true
		},
		mode: { default: "determinate" }
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeProgressBar), {
				class: "progress-bar",
				value: __props.value,
				"show-value": __props.showValue,
				mode: __props.mode
			}, null, 8, [
				"value",
				"show-value",
				"mode"
			]);
		};
	}
});
//#endregion
//#region src/components/ProgressIndicator/ProgressIndicator.vue
var ProgressIndicator_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "ProgressIndicator",
	props: { text: {} },
	setup(__props) {
		const props = __props;
		const { translate } = useGlobalResourceManager();
		const displayText = computed(() => props.text ?? translate("Loading"));
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, {
				align: "center",
				class: "progress-indicator"
			}, {
				default: withCtx(() => [createVNode(DotLoader_default, { size: "extralarge" }), createVNode(Text_default, { size: "extralarge" }, {
					default: withCtx(() => [createTextVNode(toDisplayString(displayText.value), 1)]),
					_: 1
				})]),
				_: 1
			});
		};
	}
}), [["__scopeId", "data-v-90d9e393"]]);
//#endregion
//#region src/components/ResponsiveDatagridWrapper/ResponsiveDatagridWrapper.vue
var ResponsiveDatagridWrapper_default = /* @__PURE__ */ defineComponent({
	__name: "ResponsiveDatagridWrapper",
	props: {
		cardMode: {
			type: Boolean,
			default: void 0
		},
		cardModeScope: { default: "window" },
		cardModeBreakpoint: { default: BreakpointValues.medium }
	},
	setup(__props) {
		const props = __props;
		const containerElement = useTemplateRef("container");
		const datagridMode = useDatagridMode();
		function useDatagridMode() {
			if (props.cardMode !== void 0) return computed(() => !props.cardMode);
			const datagridMode = ref(false);
			const cardModeScopeWidth = props.cardModeScope === "container" ? useElementSize(containerElement).width : useWindowSize().width;
			const cardModeBreakpoint = computed(() => {
				if (typeof props.cardModeBreakpoint === "number") return props.cardModeBreakpoint;
				return BreakpointValues[props.cardModeBreakpoint];
			});
			watch(cardModeScopeWidth, () => {
				datagridMode.value = cardModeScopeWidth.value >= cardModeBreakpoint.value;
			}, { immediate: true });
			return datagridMode;
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { ref: "container" }, {
				default: withCtx(() => [unref(datagridMode) ? renderSlot(_ctx.$slots, "datagrid", {}, void 0, void 0, 0) : renderSlot(_ctx.$slots, "data-cards", {}, void 0, void 0, 1)]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
//#region src/components/Splitter/Splitter.ts?vue&type=script&src=true&lang.ts
var splitterResizedEventName$1 = "neos-splitter:resized";
var Splitter_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Splitter",
	components: { Splitpanes },
	props: {
		horizontal: {
			type: Boolean,
			default: false
		},
		barColor: {
			type: String,
			default: ""
		},
		barHoverColor: {
			type: String,
			default: ""
		},
		barCornerRadius: {
			type: String,
			validator: (value) => multiSpaceValueValidatorExpression.test(value),
			default: "none"
		}
	},
	setup(props) {
		const splitpanesElement = ref(null);
		const style = computed(() => {
			const ret = { "--splitter-bar-corner-radius": getMultiSpaceValue(props.barCornerRadius) };
			if (props.barColor) ret["--splitter-bar-color"] = `var(--${props.barColor})`;
			if (props.barHoverColor) ret["--splitter-bar-hover-color"] = `var(--${props.barHoverColor})`;
			return ret;
		});
		function handleResized(args) {
			(splitpanesElement.value?.$el)?.dispatchEvent(new CustomEvent(splitterResizedEventName$1, { detail: args }));
		}
		useComponentAutomationProperties();
		return {
			style,
			handleResized,
			splitpanesElement
		};
	}
});
//#endregion
//#region src/components/Splitter/Splitter.vue
var _hoisted_1$6 = { class: "neos-vertical-content splitter" };
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Splitpanes = resolveComponent("Splitpanes");
	return openBlock(), createElementBlock("div", _hoisted_1$6, [createVNode(_component_Splitpanes, {
		ref: "splitpanesElement",
		class: "splitter",
		style: normalizeStyle(_ctx.style),
		horizontal: _ctx.horizontal,
		onResized: _ctx.handleResized
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "default", {}, void 0, true)]),
		_: 3
	}, 8, [
		"style",
		"horizontal",
		"onResized"
	])]);
}
var Splitter_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Splitter_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$3], ["__scopeId", "data-v-3673092d"]]);
//#endregion
//#region src/components/Splitter/Splitter.ts
var splitterResizedEventName = "neos-splitter:resized";
defineComponent({
	name: "Splitter",
	components: { Splitpanes },
	props: {
		horizontal: {
			type: Boolean,
			default: false
		},
		barColor: {
			type: String,
			default: ""
		},
		barHoverColor: {
			type: String,
			default: ""
		},
		barCornerRadius: {
			type: String,
			validator: (value) => multiSpaceValueValidatorExpression.test(value),
			default: "none"
		}
	},
	setup(props) {
		const splitpanesElement = ref(null);
		const style = computed(() => {
			const ret = { "--splitter-bar-corner-radius": getMultiSpaceValue(props.barCornerRadius) };
			if (props.barColor) ret["--splitter-bar-color"] = `var(--${props.barColor})`;
			if (props.barHoverColor) ret["--splitter-bar-hover-color"] = `var(--${props.barHoverColor})`;
			return ret;
		});
		function handleResized(args) {
			(splitpanesElement.value?.$el)?.dispatchEvent(new CustomEvent(splitterResizedEventName, { detail: args }));
		}
		useComponentAutomationProperties();
		return {
			style,
			handleResized,
			splitpanesElement
		};
	}
});
//#endregion
//#region src/components/SplitterPanel/SplitterPanel.ts?vue&type=script&src=true&lang.ts
function getClosestSplitterElement(paneElement) {
	return (paneElement?.$el)?.closest(".splitpanes") ?? null;
}
function getSplitterPaneIndex(paneElement, splitterElement) {
	const pane = paneElement?.$el;
	if (pane == null || splitterElement == null) return null;
	const paneIndex = Array.from(splitterElement.children).filter((element) => element instanceof HTMLElement && element.classList.contains("splitpanes__pane")).findIndex((element) => element.isSameNode(pane));
	return paneIndex === -1 ? null : paneIndex;
}
function emitResizedPaneSize(emit, paneElement, splitterElement, panes) {
	const paneIndex = getSplitterPaneIndex(paneElement, splitterElement);
	if (paneIndex == null) return;
	emit("update:size", panes[paneIndex]?.size);
}
var SplitterPanel_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "SplitterPanel",
	components: { Pane },
	emits: ["update:size"],
	props: {
		size: {
			type: [Number, String],
			default: void 0
		},
		minSize: {
			type: [Number, String],
			default: 0
		},
		maxSize: {
			type: [Number, String],
			default: 100
		}
	},
	setup(_, { emit }) {
		const paneElement = ref(null);
		let splitterElement = null;
		const handleSplitterResized = (event) => {
			const resizedEvent = event;
			emitResizedPaneSize(emit, paneElement.value, splitterElement, resizedEvent.detail.panes);
		};
		onMounted(() => {
			splitterElement = getClosestSplitterElement(paneElement.value);
			splitterElement?.addEventListener(splitterResizedEventName, handleSplitterResized);
		});
		onUnmounted(() => {
			splitterElement?.removeEventListener(splitterResizedEventName, handleSplitterResized);
		});
		return { paneElement };
	}
});
//#endregion
//#region src/components/SplitterPanel/SplitterPanel.vue
var _hoisted_1$5 = { class: "splitter-panel-content neos-vertical-content" };
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Pane = resolveComponent("Pane");
	return openBlock(), createBlock(_component_Pane, {
		ref: "paneElement",
		class: "splitter-panel",
		"min-size": _ctx.minSize,
		"max-size": _ctx.maxSize,
		size: _ctx.size
	}, {
		default: withCtx(() => [createElementVNode("div", _hoisted_1$5, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
		_: 3
	}, 8, [
		"min-size",
		"max-size",
		"size"
	]);
}
var SplitterPanel_default = /*#__PURE__*/ _plugin_vue_export_helper_default(SplitterPanel_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$2], ["__scopeId", "data-v-bd033c55"]]);
//#endregion
//#region src/components/Tabs/Tabs.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$4 = [
	"data-tab-index",
	"label",
	"onClick"
];
var _hoisted_2$3 = { class: "tab-details neos-fill-parent-height" };
var tabManagerKey = "tabManager";
//#endregion
//#region src/components/Tabs/Tabs.vue
var Tabs_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "Tabs",
	props: {
		"selectedIndex": {
			required: false,
			default: -1
		},
		"selectedIndexModifiers": {}
	},
	emits: ["update:selectedIndex"],
	setup(__props) {
		const selectedIndex = useModel(__props, "selectedIndex");
		const tabs = ref([]);
		function registerTab(caption, visible, icon) {
			const tab = reactive({
				caption,
				visible,
				icon,
				get index() {
					return tabs.value.indexOf(tab);
				},
				get active() {
					return selectedIndex.value === this.index;
				}
			});
			tabs.value.push(tab);
			if (selectedIndex.value === -1 && visible.value) selectedIndex.value = tab.index;
			return tab;
		}
		function selectNextVisibleTab(fromIndex) {
			for (let i = fromIndex; i < tabs.value.length; i++) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			for (let i = fromIndex - 1; i >= 0; i--) if (tabs.value[i].visible) {
				selectedIndex.value = i;
				return;
			}
			selectedIndex.value = -1;
		}
		function unregisterTab(tab) {
			const index = tab.index;
			const wasSelected = selectedIndex.value === index;
			tabs.value.splice(index, 1);
			if (wasSelected) selectNextVisibleTab(index);
			else if (selectedIndex.value > index) selectedIndex.value--;
		}
		function onTabVisibilityChanged(tab) {
			const index = tab.index;
			if (selectedIndex.value === -1 && tab.visible) selectedIndex.value = index;
			else if (index === selectedIndex.value && !tab.visible) selectNextVisibleTab(index + 1);
		}
		function handleTabClick(index) {
			selectedIndex.value = index;
		}
		provide(tabManagerKey, {
			registerTab,
			unregisterTab,
			onTabVisibilityChanged
		});
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(VerticalLayout_default, { class: "tabs-container neos-fill-parent-height" }, {
				default: withCtx(() => [createVNode(HorizontalLayout_default, {
					class: "tabs-headers-container",
					space: "none",
					wrap: false
				}, {
					default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(tabs.value, (tab, index) => {
						return openBlock(), createElementBlock(Fragment, { key: index }, [tab.visible ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: normalizeClass(["tab", { "tab-active": tab.active }]),
							"data-tab-index": index,
							label: tab.caption,
							onClick: ($event) => handleTabClick(index)
						}, [createVNode(Image_default, { name: tab.icon }, null, 8, ["name"]), createVNode(Text_default, {
							class: "tab-text",
							style: normalizeStyle(`--tab-text: '${tab.caption}'`)
						}, {
							default: withCtx(() => [createTextVNode(toDisplayString(tab.caption), 1)]),
							_: 2
						}, 1032, ["style"])], 10, _hoisted_1$4)) : createCommentVNode("", true)], 64);
					}), 128))]),
					_: 1
				}), createElementVNode("div", _hoisted_2$3, [renderSlot(_ctx.$slots, "default", {}, void 0, true)])]),
				_: 3
			});
		};
	}
}), [["__scopeId", "data-v-2b898449"]]);
//#endregion
//#region src/components/TabItem/TabItem.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$3 = ["data-tab-index"];
//#endregion
//#region src/components/TabItem/TabItem.vue
var TabItem_default = /*#__PURE__*/ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
	__name: "TabItem",
	props: {
		caption: { default: "" },
		visible: {
			type: [
				Boolean,
				Object,
				null
			],
			default: void 0
		},
		icon: { default: void 0 }
	},
	setup(__props) {
		const props = __props;
		const tabManager = inject(tabManagerKey);
		const visible = computed(() => {
			if (props.visible === void 0) return true;
			if (typeof props.visible === "boolean") return props.visible;
			return props.visible != null;
		});
		const root = ref();
		const tab = shallowRef(null);
		const isSlotMounted = ref(false);
		useComponentAutomationProperties(root);
		useIntersectionObserver(root, ([{ isIntersecting }], o) => {
			if (isIntersecting) {
				isSlotMounted.value = true;
				o.disconnect();
			}
		});
		onMounted(() => {
			tab.value = tabManager.registerTab(toRef(props, "caption"), visible, toRef(props, "icon"));
			isSlotMounted.value = tab.value.active;
		});
		watch(() => props.visible, () => tabManager.onTabVisibilityChanged(tab.value));
		onUnmounted(() => {
			tabManager.unregisterTab(tab.value);
		});
		return (_ctx, _cache) => {
			return tab.value && (tab.value.active || isSlotMounted.value) ? withDirectives((openBlock(), createElementBlock("div", {
				key: 0,
				ref_key: "root",
				ref: root,
				"data-tab-index": tab.value?.index,
				class: "tab-item neos-vertical-content"
			}, [isSlotMounted.value ? renderSlot(_ctx.$slots, "default", {}, void 0, true, 0) : (openBlock(), createBlock(ProgressIndicator_default, { key: 1 }))], 8, _hoisted_1$3)), [[vShow, tab.value?.active]]) : createCommentVNode("", true);
		};
	}
}), [["__scopeId", "data-v-075b08b1"]]);
//#endregion
//#region src/components/Timeline/Timeline.vue
var Timeline_default = /* @__PURE__ */ defineComponent({
	__name: "Timeline",
	props: {
		source: { default: () => [] },
		orientation: { default: "vertical" },
		align: { default: "left" }
	},
	setup(__props) {
		useComponentAutomationProperties();
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(PrimeTimeline), {
				value: __props.source,
				layout: __props.orientation,
				align: __props.align
			}, createSlots({ _: 2 }, [
				_ctx.$slots.content ? {
					name: "content",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "content", { context: item })]),
					key: "0"
				} : void 0,
				_ctx.$slots.marker ? {
					name: "marker",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "marker", { context: item })]),
					key: "1"
				} : void 0,
				_ctx.$slots.opposite ? {
					name: "opposite",
					fn: withCtx(({ item }) => [renderSlot(_ctx.$slots, "opposite", { context: item })]),
					key: "2"
				} : void 0
			]), 1032, [
				"value",
				"layout",
				"align"
			]);
		};
	}
});
//#endregion
//#region src/components/Toast/Toast.ts?vue&type=script&src=true&lang.ts
var Toast_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "Toast",
	components: {
		Button: Button_default,
		Divider: Divider_default,
		HorizontalLayout: HorizontalLayout_default,
		Image: Image_default,
		PrimeToast
	},
	props: {
		position: {
			type: String,
			default: "bottom-right"
		},
		group: {
			type: String,
			default: void 0
		}
	},
	setup() {
		const buttonContainerSpace = useButtonContainerSpace(useThemeManager(false));
		const pt = computed(() => ({
			message: (options) => ({
				onMouseover: () => {
					const message = options.props.message;
					clearInterval(message.intervalId);
				},
				onMouseleave: () => {
					options.props.message.start?.();
				}
			}),
			closeButton: { class: "neos-close-button button-extrasmall" }
		}));
		function getImageName(severity) {
			switch (severity) {
				case "info": return "info";
				case "error": return "danger";
				case "warn": return "warning";
				case "success": return "positive";
			}
		}
		/* istanbul ignore next -- @preserve */
		function getBackgroundColorValue(severity) {
			switch (severity) {
				case "info": return "var(--toast-info-icon)";
				case "warn": return "var(--toast-warning-icon)";
				case "error": return "var(--toast-danger-icon)";
				case "success": return "var(--toast-positive-icon)";
			}
		}
		function getButtonClass(index, severity) {
			const mainClass = index === 0 ? `toast-primary-button` : `toast-secondary-button`;
			switch (severity) {
				case "error": return `${mainClass}-danger`;
				case "info": return `${mainClass}-info`;
				case "success": return `${mainClass}-positive`;
				case "warn": return `${mainClass}-warning`;
			}
		}
		return {
			buttonContainerSpace,
			getBackgroundColorValue,
			getButtonClasses: getButtonClass,
			getImageName,
			pt
		};
	}
});
//#endregion
//#region src/components/Toast/Toast.vue
var _hoisted_1$2 = { class: "p-toast-content" };
var _hoisted_2$2 = { class: "p-toast-header" };
var _hoisted_3 = { class: "p-toast-summary" };
var _hoisted_4 = { class: "p-toast-detail" };
var _hoisted_5 = { class: "toast-buttons" };
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_Image = resolveComponent("Image");
	const _component_Divider = resolveComponent("Divider");
	const _component_Button = resolveComponent("Button");
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_PrimeToast = resolveComponent("PrimeToast");
	return openBlock(), createBlock(_component_PrimeToast, {
		position: _ctx.position,
		group: _ctx.group,
		pt: _ctx.pt
	}, {
		message: withCtx((slotProps) => [createElementVNode("div", _hoisted_1$2, [
			createElementVNode("div", _hoisted_2$2, [createVNode(_component_Image, {
				class: "p-toast-message-icon",
				style: normalizeStyle({ backgroundColor: _ctx.getBackgroundColorValue(slotProps.message.severity) }),
				name: _ctx.getImageName(slotProps.message.severity)
			}, null, 8, ["style", "name"]), createElementVNode("span", _hoisted_3, toDisplayString(slotProps.message.summary), 1)]),
			createElementVNode("div", _hoisted_4, [renderSlot(_ctx.$slots, "message", { message: slotProps.message }, () => [createTextVNode(toDisplayString(slotProps.message.detail), 1)], true)]),
			slotProps.message.buttons.length > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createVNode(_component_Divider, { class: "toast-divider" }), createElementVNode("div", _hoisted_5, [createVNode(_component_HorizontalLayout, {
				wrap: false,
				align: "right",
				space: _ctx.buttonContainerSpace
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(slotProps.message.buttons, (button, index) => {
					return openBlock(), createBlock(_component_Button, {
						key: index,
						class: normalizeClass(["toast-button", _ctx.getButtonClasses(index, slotProps.message.severity)]),
						icon: button.icon,
						label: button.text,
						animated: "",
						onClick: button.action
					}, null, 8, [
						"class",
						"icon",
						"label",
						"onClick"
					]);
				}), 128))]),
				_: 2
			}, 1032, ["space"])])], 64)) : createCommentVNode("", true),
			slotProps.message.progressBarValue ? (openBlock(), createElementBlock("div", {
				key: 1,
				class: "p-toast-progress-bar",
				style: normalizeStyle({ backgroundColor: _ctx.getBackgroundColorValue(slotProps.message.severity) })
			}, [createElementVNode("div", {
				class: "p-toast-progress-bar-value",
				style: normalizeStyle({ width: slotProps.message.progressBarValue + "%" })
			}, null, 4)], 4)) : createCommentVNode("", true)
		])]),
		_: 3
	}, 8, [
		"position",
		"group",
		"pt"
	]);
}
var Toast_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Toast_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render$1], ["__scopeId", "data-v-24ce5cf2"]]);
//#endregion
//#region src/components/TreeView/TreeViewConfig.ts
var TreeViewConfigKey = Symbol("TreeViewConfig");
function useTreeViewConfig() {
	const config = inject(TreeViewConfigKey);
	if (!config) throw new Error("Tree view configuration not provided.");
	return config;
}
//#endregion
//#region src/components/TreeViewNode/TreeViewNode.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1$1 = ["draggable"];
var _hoisted_2$1 = {
	key: 0,
	class: "tree-view-child-nodes"
};
//#endregion
//#region src/components/TreeView/TreeView.ts?vue&type=script&src=true&lang.ts
var TreeView_ts_vue_type_script_src_true_lang_default = defineComponent({
	name: "TreeView",
	components: {
		HorizontalLayout: HorizontalLayout_default,
		TreeViewNode: /* @__PURE__ */ _plugin_vue_export_helper_default(/* @__PURE__ */ defineComponent({
			__name: "TreeViewNode",
			props: {
				level: {},
				node: {},
				nodeClick: {},
				nodeCollapse: {},
				nodeDragover: {},
				nodeDragstart: {},
				nodeDrop: {},
				nodeExpand: {},
				parentNode: { default: void 0 }
			},
			setup(__props) {
				const props = __props;
				const config = useTreeViewConfig();
				const caption = computed(() => getPropertyByPath(props.node, config.captionProperty));
				const childNodesLineStyle = computed(() => ({ left: `${padding.value + 5}px` }));
				const children = computed(() => getPropertyByPath(props.node, config.childrenProperty));
				const dropInstruction = computed(() => config.currentDragContext.value?.dropNode === props.node ? config.currentDragContext.value.instruction : void 0);
				const expanded = computed(() => getPropertyByPath(props.node, config.expandedProperty));
				const draggable = computed(() => getPropertyByPath(props.node, config.draggableProperty));
				const dropIndicatorStyle = computed(() => ({
					left: `${6 * (props.level + 1)}px`,
					top: dropInstruction.value === "before" ? "-1px" : void 0,
					bottom: dropInstruction.value === "after" ? "-1px" : void 0
				}));
				const hasBeenExpanded = ref(expanded.value);
				const icon = computed(() => getPropertyByPath(props.node, config.iconProperty));
				const nodeClass = computed(() => ({
					"tree-view-node-selected": getPropertyByPath(props.node, config.selectedProperty),
					"tree-view-node-drag": config.currentDragContext.value?.draggedNode === props.node,
					"tree-view-node-drop": dropInstruction.value === "make-child",
					"tree-view-node-drop-parent-hint": dropInstruction.value === void 0 && config.currentDragContext.value?.newParentNode === props.node
				}));
				const nodeStyle = computed(() => ({ paddingLeft: `${padding.value}px` }));
				const padding = computed(() => 16 * props.level + (!getPropertyByPath(props.node, config.childrenProperty) ? 18 : 0));
				const showDropIndicator = computed(() => dropInstruction.value === "before" || dropInstruction.value === "after");
				const loading = computed(() => getPropertyByPath(props.node, config.loadingProperty));
				const toggleIcon = computed(() => {
					return getPropertyByPath(props.node, config.expandedProperty) ? "chevronDown" : "chevronRight";
				});
				const visible = computed(() => getPropertyByPath(props.node, config.visibleProperty) !== false);
				watch(expanded, (value) => {
					if (value) hasBeenExpanded.value = true;
				});
				function handleDragend() {
					config.currentDragContext.value = void 0;
				}
				function handleDragover(event) {
					props.nodeDragover(event, props.node, props.parentNode);
				}
				function handleDrop() {
					props.nodeDrop(props.node);
				}
				function handleToggle() {
					if (getPropertyByPath(props.node, config.expandedProperty)) props.nodeCollapse(props.node);
					else props.nodeExpand(props.node);
				}
				return (_ctx, _cache) => {
					const _component_TreeViewNode = resolveComponent("TreeViewNode", true);
					return visible.value ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [createElementVNode("button", {
						class: normalizeClass(["tree-view-node neos-horizontal-content", nodeClass.value]),
						draggable: draggable.value,
						style: normalizeStyle(nodeStyle.value),
						onClick: _cache[1] || (_cache[1] = ($event) => __props.nodeClick(__props.node)),
						onDragstart: _cache[2] || (_cache[2] = ($event) => __props.nodeDragstart(__props.node, __props.parentNode)),
						onDragover: handleDragover,
						onDragend: handleDragend,
						onDrop: handleDrop
					}, [
						children.value ? (openBlock(), createElementBlock("button", {
							key: 0,
							class: "tree-view-node-toggle-button",
							onClick: _cache[0] || (_cache[0] = withModifiers(($event) => handleToggle(), ["stop"]))
						}, [loading.value ? (openBlock(), createBlock(Spinner_default, {
							key: 0,
							size: "extrasmall"
						})) : (openBlock(), createBlock(Image_default, {
							key: 1,
							name: toggleIcon.value,
							size: "extrasmall"
						}, null, 8, ["name"]))])) : createCommentVNode("", true),
						renderSlot(_ctx.$slots, "node", { context: __props.node }, () => [createVNode(HorizontalLayout_default, null, {
							default: withCtx(() => [createVNode(Image_default, {
								name: icon.value,
								class: "tree-view-node-icon"
							}, null, 8, ["name"]), createVNode(Text_default, { class: "tree-view-node-caption" }, {
								default: withCtx(() => [createTextVNode(toDisplayString(caption.value), 1)]),
								_: 1
							})]),
							_: 1
						})], true),
						showDropIndicator.value ? (openBlock(), createElementBlock("div", {
							key: 1,
							class: "tree-view-node-drop-indicator",
							style: normalizeStyle(dropIndicatorStyle.value)
						}, null, 4)) : createCommentVNode("", true)
					], 46, _hoisted_1$1), children.value && hasBeenExpanded.value ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$1, [createElementVNode("div", {
						class: "tree-view-child-nodes-line",
						style: normalizeStyle(childNodesLineStyle.value)
					}, null, 4), (openBlock(true), createElementBlock(Fragment, null, renderList(children.value, (childNode) => {
						return openBlock(), createBlock(_component_TreeViewNode, {
							level: __props.level + 1,
							node: childNode,
							"parent-node": __props.node,
							"node-expand": __props.nodeExpand,
							"node-collapse": __props.nodeCollapse,
							"node-click": __props.nodeClick,
							"node-dragstart": __props.nodeDragstart,
							"node-dragover": __props.nodeDragover,
							"node-drop": __props.nodeDrop
						}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
							name: "node",
							fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
							key: "0"
						} : void 0]), 1032, [
							"level",
							"node",
							"parent-node",
							"node-expand",
							"node-collapse",
							"node-click",
							"node-dragstart",
							"node-dragover",
							"node-drop"
						]);
					}), 256))], 512)), [[vShow, expanded.value]]) : createCommentVNode("", true)], 64)) : createCommentVNode("", true);
				};
			}
		}), [["__scopeId", "data-v-ee231c4f"]])
	},
	props: {
		source: {
			type: Array,
			default: () => []
		},
		captionProperty: {
			type: String,
			default: ""
		},
		iconProperty: {
			type: String,
			default: ""
		},
		childrenProperty: {
			type: String,
			default: ""
		},
		loadingProperty: {
			type: String,
			default: "$loading"
		},
		loadedProperty: {
			type: String,
			default: "$loaded"
		},
		selectedProperty: {
			type: String,
			default: "$selected"
		},
		expandedProperty: {
			type: String,
			default: "$expanded"
		},
		visibleProperty: {
			type: String,
			default: "$visible"
		},
		draggableProperty: {
			type: String,
			default: "$draggable"
		},
		nodeColor: {
			type: String,
			default: void 0
		},
		nodeBackground: {
			type: String,
			default: void 0
		},
		nodeHoverColor: {
			type: String,
			default: void 0
		},
		nodeHoverBackground: {
			type: String,
			default: void 0
		},
		activeNodeColor: {
			type: String,
			default: void 0
		},
		activeNodeHoverColor: {
			type: String,
			default: void 0
		},
		activeNodeBackground: {
			type: String,
			default: void 0
		},
		activeNodeHoverBackground: {
			type: String,
			default: void 0
		},
		nodeLoad: {
			type: Function,
			default: void 0
		},
		nodeExpand: {
			type: Function,
			default: void 0
		},
		nodeCollapse: {
			type: Function,
			default: void 0
		},
		nodeClick: {
			type: Function,
			default: void 0
		},
		nodeDragover: {
			type: Function,
			default: void 0
		},
		nodeDrop: {
			type: Function,
			default: void 0
		}
	},
	setup(props) {
		useComponentAutomationProperties();
		const currentDragContext = ref();
		provide(TreeViewConfigKey, {
			captionProperty: props.captionProperty,
			iconProperty: props.iconProperty,
			childrenProperty: props.childrenProperty,
			loadingProperty: props.loadingProperty,
			loadedProperty: props.loadedProperty,
			selectedProperty: props.selectedProperty,
			expandedProperty: props.expandedProperty,
			visibleProperty: props.visibleProperty,
			draggableProperty: props.draggableProperty,
			currentDragContext
		});
		const setStyleValue = (styleObj, key, value) => {
			if (value) styleObj[`--${key}`] = `var(--${value})`;
		};
		const style = computed(() => {
			const styleValue = {};
			setStyleValue(styleValue, "vertical-space", "0");
			setStyleValue(styleValue, "tree-view-node-foreground", props.nodeColor);
			setStyleValue(styleValue, "tree-view-node-background", props.nodeBackground);
			setStyleValue(styleValue, "tree-view-node-hover-foreground", props.nodeHoverColor);
			setStyleValue(styleValue, "tree-view-node-hover-background", props.nodeHoverBackground);
			setStyleValue(styleValue, "tree-view-node-active-foreground", props.activeNodeColor);
			setStyleValue(styleValue, "tree-view-node-active-background", props.activeNodeBackground);
			setStyleValue(styleValue, "tree-view-node-active-hover-foreground", props.activeNodeHoverColor);
			setStyleValue(styleValue, "tree-view-node-active-hover-background", props.activeNodeHoverBackground);
			return styleValue;
		});
		async function handleNodeExpand(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			if (!getPropertyByPath(node, props.loadedProperty)) {
				if (props.nodeLoad) try {
					setPropertyByPath(node, props.loadingProperty, true);
					await props.nodeLoad(node);
				} finally {
					setPropertyByPath(node, props.loadingProperty, false);
				}
				setPropertyByPath(node, props.loadedProperty, true);
			}
			expandNode(node);
		}
		function handleNodeCollapse(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			collapseNode(node);
		}
		function handleNodeClick(node) {
			unselectAllNodes(props.source);
			setPropertyByPath(node, props.selectedProperty, true);
			props.nodeClick?.(node);
		}
		function handleNodeDragstart(node, parentNode) {
			currentDragContext.value = {
				draggedNode: node,
				parentNode,
				expandedBeforeDrag: !!node[props.expandedProperty]
			};
			if (currentDragContext.value.expandedBeforeDrag) collapseNode(node);
		}
		function handleNodeDragover(event, node, parentNode) {
			if (!currentDragContext.value || node === currentDragContext.value.draggedNode) return;
			const newInstruction = getDropInstruction(event);
			if (currentDragContext.value.dropNode === node && currentDragContext.value.instruction === newInstruction) {
				event.preventDefault();
				return;
			}
			currentDragContext.value.instruction = newInstruction;
			if (currentDragContext.value.instruction === "make-child") {
				currentDragContext.value.newIndex = getChildren(node)?.length ?? 0;
				currentDragContext.value.newParentNode = node;
			} else {
				currentDragContext.value.newParentNode = parentNode;
				currentDragContext.value.newIndex = getDropNewIndex(currentDragContext.value, node);
			}
			if (!props.nodeDragover || props.nodeDragover(currentDragContext.value)) {
				currentDragContext.value.dropNode = node;
				event.preventDefault();
			}
		}
		function handleNodeDrop() {
			if (!currentDragContext.value || !props.nodeDrop) {
				currentDragContext.value = void 0;
				return;
			}
			props.nodeDrop(currentDragContext.value);
			if (currentDragContext.value.newParentNode && !currentDragContext.value.newParentNode[props.expandedProperty]) expandNode(currentDragContext.value.newParentNode);
			if (currentDragContext.value.expandedBeforeDrag) expandNode(currentDragContext.value.draggedNode);
		}
		function collapseNode(node) {
			setPropertyByPath(node, props.expandedProperty, false);
			props.nodeCollapse?.(node);
		}
		function expandNode(node) {
			setPropertyByPath(node, props.expandedProperty, true);
			props.nodeExpand?.(node);
		}
		function getDropInstruction(event) {
			const borderBox = event.currentTarget.getBoundingClientRect();
			const quarterOfHeight = borderBox.height / 4;
			if (event.clientY <= borderBox.top + quarterOfHeight) return "before";
			if (event.clientY >= borderBox.bottom - quarterOfHeight) return "after";
			return "make-child";
		}
		function getDropNewIndex(dragContext, node) {
			const list = dragContext.newParentNode ? getChildren(dragContext.newParentNode) : props.source;
			let newIndex = list.indexOf(node);
			if (dragContext.newParentNode === dragContext.parentNode) {
				const oldIndex = list.indexOf(dragContext.draggedNode);
				if (oldIndex !== -1 && oldIndex < newIndex) newIndex--;
			}
			if (dragContext.instruction === "after") newIndex++;
			return newIndex;
		}
		function getChildren(node) {
			return getPropertyByPath(node, props.childrenProperty);
		}
		function unselectAllNodes(nodes) {
			for (const node of nodes) {
				if (getPropertyByPath(node, props.selectedProperty)) setPropertyByPath(node, props.selectedProperty, false);
				const children = getChildren(node);
				if (children) unselectAllNodes(children);
			}
		}
		return {
			style,
			handleNodeExpand,
			handleNodeCollapse,
			handleNodeClick,
			handleNodeDragstart,
			handleNodeDragover,
			handleNodeDrop
		};
	}
});
//#endregion
//#region src/components/TreeView/TreeView.vue
var _hoisted_1 = { class: "neos-fill-parent-height" };
var _hoisted_2 = { class: "tree-view-nodes" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	const _component_HorizontalLayout = resolveComponent("HorizontalLayout");
	const _component_TreeViewNode = resolveComponent("TreeViewNode");
	return openBlock(), createElementBlock("div", {
		class: "neos-vertical-content tree-view",
		style: normalizeStyle(_ctx.style)
	}, [_ctx.$slots.header ? (openBlock(), createBlock(_component_HorizontalLayout, {
		key: 0,
		space: "extrasmall",
		class: "tree-view-header"
	}, {
		default: withCtx(() => [renderSlot(_ctx.$slots, "header", {}, void 0, true)]),
		_: 3
	})) : createCommentVNode("", true), createElementVNode("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.source, (node, __, ___, _cached) => {
		const _memo = [node, _ctx.$slots.node];
		if (_cached && _cached.el && isMemoSame(_cached, _memo)) return _cached;
		const _item = (openBlock(), createBlock(_component_TreeViewNode, {
			level: 0,
			node,
			"node-expand": _ctx.handleNodeExpand,
			"node-collapse": _ctx.handleNodeCollapse,
			"node-click": _ctx.handleNodeClick,
			"node-dragstart": _ctx.handleNodeDragstart,
			"node-dragover": _ctx.handleNodeDragover,
			"node-drop": _ctx.handleNodeDrop
		}, createSlots({ _: 2 }, [_ctx.$slots.node ? {
			name: "node",
			fn: withCtx(({ context }) => [renderSlot(_ctx.$slots, "node", { context }, void 0, true)]),
			key: "0"
		} : void 0]), 1032, [
			"node",
			"node-expand",
			"node-collapse",
			"node-click",
			"node-dragstart",
			"node-dragover",
			"node-drop"
		]));
		_item.memo = _memo;
		return _item;
	}, _cache, 0), 256))])])], 4);
}
var TreeView_default = /*#__PURE__*/ _plugin_vue_export_helper_default(TreeView_ts_vue_type_script_src_true_lang_default, [["render", _sfc_render], ["__scopeId", "data-v-d10fe5cb"]]);
//#endregion
//#region src/components/VirtualRepeat/itemSpacing.ts
/**
* Computes the spacing style applied to the wrapper around a virtual repeat
* item, so items are spaced like a non-virtual layout's flexbox `gap`.
*
* The padding must sit on a wrapper INSIDE the virtua item, never on the item
* element itself: virtua measures each item through `ResizeObserver.contentRect`
* (the content-box, which excludes the element's own padding). Padding on an
* inner wrapper is part of the item's content-box and is therefore counted into
* the item offsets, producing real spacing; padding on the item element would
* be ignored and the items would stay glued together.
*
* Returns `undefined` (no wrapper needed) for the last item — matching `gap`,
* which adds no trailing space — and when `space` is `none`.
*/
function getItemSpacingStyle(index, count, space, horizontal) {
	if (space === "none" || index >= count - 1) return;
	return { [horizontal ? "paddingInlineEnd" : "paddingBlockEnd"]: SpaceValues[space] };
}
//#endregion
//#region src/components/VirtualRepeat/VirtualRepeat.vue
var VirtualRepeat_default = defineComponent({
	name: "VirtualRepeat",
	inheritAttrs: false,
	props: {
		data: {
			type: Array,
			required: true
		},
		horizontal: {
			type: Boolean,
			default: false
		},
		space: {
			type: String,
			default: "none"
		}
	},
	setup(props, { slots, attrs, expose }) {
		const inner = ref();
		expose({
			scrollToIndex(index, opts) {
				inner.value.scrollToIndex(index, opts);
			},
			scrollTo(offset) {
				inner.value.scrollTo(offset);
			},
			scrollBy(offset) {
				inner.value.scrollBy(offset);
			}
		});
		function getSharedKey(content) {
			const keys = content.map((node) => node.key).filter((key) => key != null);
			return keys.length > 0 && keys.every((key) => key === keys[0]) ? keys[0] : void 0;
		}
		function renderItem(item, index) {
			const content = slots.default({
				item,
				index
			});
			if (props.space === "none") return content;
			const style = getItemSpacingStyle(index, props.data.length, props.space, props.horizontal);
			return h("div", {
				key: getSharedKey(content),
				style
			}, content);
		}
		return () => h(VList, {
			...attrs,
			ref: inner,
			data: props.data,
			horizontal: props.horizontal
		}, { default: ({ item, index }) => renderItem(item, index) });
	}
});
//#endregion
//#region src/composables/usePressEvents.ts
var LONG_PRESS_DELAY = 500;
function usePressEvents(handlers) {
	let pressTimer = null;
	let longPressTriggered = false;
	function onPressStart() {
		longPressTriggered = false;
		pressTimer = setTimeout(() => {
			longPressTriggered = true;
			handlers.onLongPress?.();
		}, LONG_PRESS_DELAY);
	}
	function onPressEnd() {
		clearPressTimer();
		if (longPressTriggered) return;
		handlers.onPress?.();
	}
	function onPressCancel() {
		clearPressTimer();
		longPressTriggered = false;
	}
	function clearPressTimer() {
		if (pressTimer) {
			clearTimeout(pressTimer);
			pressTimer = null;
		}
	}
	onScopeDispose(clearPressTimer);
	return {
		onPressStart,
		onPressEnd,
		onPressCancel
	};
}
//#endregion
//#region src/composables/usePreventPopoverHide.ts
function usePreventPopoverHide() {
	const preventPopoverHide = shallowRef(false);
	function setPreventPopoverHide(value) {
		preventPopoverHide.value = value;
	}
	return {
		preventPopoverHide,
		setPreventPopoverHide
	};
}
//#endregion
//#region src/composables/useToast.ts
function useToast() {
	const toast = useToast$1();
	function add(definition) {
		const message = ref({
			buttons: definition.buttons,
			closable: definition.dismissible,
			detail: definition.text,
			group: definition.group,
			severity: definition.severity,
			summary: definition.title
		});
		if (definition.duration) {
			let currentStep = 0;
			const interval = 50;
			const totalSteps = definition.duration / interval;
			function start() {
				message.value.intervalId = window.setInterval(() => {
					currentStep++;
					message.value.progressBarValue = currentStep / totalSteps * 100;
					if (currentStep >= totalSteps) {
						clearInterval(message.value.intervalId);
						toast.remove(message.value);
					}
				}, interval);
			}
			message.value.start = start;
			start();
		}
		toast.add(message.value);
		return message.value;
	}
	function remove(instance) {
		toast.remove(instance);
	}
	return {
		add,
		remove
	};
}
//#endregion
//#region src/directives/automation.ts
/**
* v-neos-automation directive.
* Used to set node specific automation properties.
*/
var NeosAutomation = { beforeMount(el, binding) {
	if (binding.value) el.dataset[AutomationDirectivePropertyValues[binding.arg]] = binding.value;
} };
//#endregion
//#region src/directives/grid.ts
/**
* If the grid directive is used on a grid layout node, it set associated responsive CSS variable value (see global.css).
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateCellStyle(el, binding) {
	const property = binding.arg;
	const variable = `--grid-${property.startsWith("colspan") ? "column" : "row"}-span${/^[a-z]+(?<responsivePart>-[a-z]*)$/.exec(property)?.groups?.responsivePart ?? ""}`;
	const value = binding.value;
	el.style.setProperty(variable, value);
}
/**
* v-neos-grid directive.
* Used to set columns and rows span on grid layout nodes.
*/
var neosGrid = (el, binding) => updateCellStyle(el, binding);
//#endregion
//#region src/directives/layout.ts
/**
* Fix for elements overflowing outside horizontal and vertical layouts.
* Disabled by default to avoid breaking changes in existing UIs.
* Will be enabled by default in a future major release.
* At some point, this option should be removed and the fix should be always applied.
*/
var layoutOverflowFixOption = false;
/**
* Sets the value indicating whether the fix for elements overflowing outside horizontal and vertical layouts is enabled.
* @param value - Value.
*/
function setLayoutOverflowFixOption(value) {
	layoutOverflowFixOption = value;
}
var sizeValueRegex = /^(?:auto|(?<value>\d+))$/;
var sizeLimitValueRegex = /^(?<value>\d+)$/;
function setSizePropertiesAndClasses(el, property, value) {
	if (value === "fill") {
		if (layoutOverflowFixOption) el.classList.add(`neos-overflow-parent-${property}`);
		el.classList.add(`neos-fill-parent-${property}`);
		el.classList.remove(`neos-fixed-${property}`);
		el.style.setProperty(property, null);
		return;
	}
	const match = sizeValueRegex.exec(value.toString());
	if (match !== null && match.groups) {
		let propertyValue;
		el.classList.remove(`neos-fill-parent-${property}`);
		if (match.groups.value) {
			if (layoutOverflowFixOption) el.classList.add(`neos-overflow-parent-${property}`);
			el.classList.add(`neos-fixed-${property}`);
			propertyValue = `${match.groups.value}px`;
		} else {
			el.classList.remove(`neos-overflow-parent-${property}`);
			propertyValue = "auto";
		}
		el.style.setProperty(property, propertyValue);
	}
}
function setMinMaxSizeProperties(el, property, value) {
	const match = sizeLimitValueRegex.exec(value.toString());
	if (match !== null && match.groups) el.style.setProperty(property, `${match.groups.value}px`);
	else el.style.removeProperty(property);
}
function setSpaceProperties(el, property, value) {
	const values = getMultiSpaceValue(value);
	if (values.length > 0) el.style.setProperty(property, values);
	else el.style.removeProperty(property);
}
function setAlignementClass(el, property, value) {
	const validValues = property === LayoutDirectiveProperty.alignSelfHorizontal ? [
		"left",
		"right",
		"center",
		"stretch"
	] : [
		"top",
		"bottom",
		"center",
		"stretch"
	];
	if (validValues.includes(value)) {
		el.classList.add(`neos-${property}-${value}`);
		validValues.filter((v) => v !== value).forEach((v) => el.classList.remove(`neos-${property}-${v}`));
	}
}
function setVisibilityStyle(el, value) {
	el.style.setProperty("visibility", value === "hidden" ? "hidden" : "");
	el.style.setProperty("display", value === "collapsed" ? "none" : "");
}
function updateElementStylesAndClasses(el, property, value) {
	if (isSizeProperty(property)) setSizePropertiesAndClasses(el, property, value);
	else if (isMinMaxSizeProperty(property)) setMinMaxSizeProperties(el, property, value);
	else if (isSpaceProperty(property)) {
		if (property === LayoutDirectiveProperty.margin && el.classList.contains("button-animated")) value = value.toString().replaceAll("none", "extrasmall");
		setSpaceProperties(el, property, value.toString());
	} else if (isAlignementProperty(property)) setAlignementClass(el, property, value.toString());
	else if (property === LayoutDirectiveProperty.visibility) setVisibilityStyle(el, value.toString());
}
function isSizeProperty(property) {
	return property === LayoutDirectiveProperty.height || property === LayoutDirectiveProperty.width;
}
function isMinMaxSizeProperty(property) {
	return property === LayoutDirectiveProperty.minWidth || property === LayoutDirectiveProperty.maxWidth || property === LayoutDirectiveProperty.minHeight || property === LayoutDirectiveProperty.maxHeight;
}
function isSpaceProperty(property) {
	return property === LayoutDirectiveProperty.padding || property === LayoutDirectiveProperty.margin;
}
function isAlignementProperty(property) {
	return property === LayoutDirectiveProperty.alignSelfHorizontal || property === LayoutDirectiveProperty.alignSelfVertical;
}
function updateLayoutStyle(el, binding) {
	updateElementStylesAndClasses(el, binding.arg, binding.value);
}
/**
* v-neos-layout directive.
* Used to apply specific styles on nodes.
*/
var neosLayout = (el, binding) => {
	if (!isAlignementProperty(binding.arg) && (el.classList.contains("action-button") || el.classList.contains("menu-button"))) {
		for (const child of el.children) updateLayoutStyle(child, binding);
		return;
	}
	updateLayoutStyle(el, binding);
};
//#endregion
//#region src/directives/style.ts
/**
* If the style directive is used node, it set associated CSS property value.
*
* REMARK: Deals with with some properties separately from the default case when there isn't
* a simple one-to-one mapping between our abstraction and the name of the CSS property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateNodeStyle(el, binding) {
	const property = binding.arg;
	switch (property) {
		case "border-color":
			if (isBindingValueDefined(binding.value)) {
				el.style.setProperty("border", `1px solid`);
				el.style.setProperty("border-color", getColorValue(binding.value));
			} else {
				el.style.removeProperty("border");
				el.style.removeProperty("border-color");
			}
			break;
		case "corner-radius": {
			const cssProperty = el.classList.contains("button-animated") ? "--p-button-border-radius" : "border-radius";
			if (isBindingValueDefined(binding.value)) setMultiRadiusValue(el, cssProperty, binding.value);
			else el.style.removeProperty(cssProperty);
			break;
		}
		default: {
			const cssProperty = StyleDirectivePropertyValues[property];
			updateSimplyMappedNodeStyle(el, cssProperty, binding);
			break;
		}
	}
}
/**
* If the style directive is used node, it set associated CSS property value.
*
* REMARK: Deals only with the case when there is a simple one-to-one mapping between our abstraction and the name of the CSS property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateSimplyMappedNodeStyle(el, cssProperty, binding) {
	const property = binding.arg;
	switch (property) {
		case "hover-color":
		case "hover-background":
		case "hover-border-color":
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, getColorValue(binding.value));
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		case "hover-font-style":
		case "hover-text-decoration":
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, binding.value);
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		case "hover-font-weight": {
			const weight = WeightValues[binding.value];
			if (isBindingValueDefined(binding.value)) {
				el.setAttribute(`data-neos-${property}`, "");
				el.style.setProperty(cssProperty, weight);
			} else {
				el.removeAttribute(`data-neos-${property}`);
				el.style.removeProperty(cssProperty);
			}
			break;
		}
		case "shadow-color":
			if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, `0 0 0.5rem 0.25rem ${getColorValue(binding.value)}`);
			else el.style.removeProperty(cssProperty);
			break;
		case "font-style":
		case "overflow-wrap":
		case "text-align":
		case "text-decoration":
			if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, binding.value);
			else el.style.removeProperty(cssProperty);
			break;
		case "font-weight": {
			const weight = WeightValues[binding.value];
			if (weight != null) el.style.setProperty(cssProperty, weight);
			else el.style.removeProperty(cssProperty);
			break;
		}
		default: if (isBindingValueDefined(binding.value)) el.style.setProperty(cssProperty, getColorValue(binding.value));
		else el.style.removeProperty(cssProperty);
	}
}
function isBindingValueDefined(x) {
	return x != null && x.length > 0;
}
/**
* Sets the HTML node style property with cssPropertyValue if it is a correct multi space attribute value
* (ex: "full", "small medium small large")
*
* @param el - The HTML node.
* @param cssProperty - The CSS property key.
* @param input - The multi space attribute value.
*/
function setMultiRadiusValue(el, cssProperty, input) {
	const values = getMultiRadiusValue(input);
	if (values.length > 0) el.style.setProperty(cssProperty, values);
}
/**
* v-neos-style directive.
* Used to set node specific style.
*/
var neosStyle = (el, binding) => {
	if (el.classList.contains("neos-input")) {
		const nodes = el.querySelectorAll(".neos-input-content, textarea");
		for (const node of nodes) updateNodeStyle(node, binding);
		return;
	}
	if (el.classList.contains("action-button") || el.classList.contains("menu-button")) {
		for (const child of el.children) updateNodeStyle(child, binding);
		return;
	}
	updateNodeStyle(el, binding);
};
//#endregion
//#region src/directives/tooltip.ts
/**
* If the tooltip directive is used node, we set the associated tooltip property.
*
* @param el - The HTML node.
* @param binding - The Directive binding object.
*/
function updateNodeTooltip(el, binding) {
	if (binding.value != null) el.setAttribute("title", binding.value);
	else el.removeAttribute("title");
}
/**
* v-neos-tooltip directive.
* Used to set node specific tooltip.
*/
var neosTooltip = (el, binding) => {
	updateNodeTooltip(el, binding);
};
//#endregion
//#region src/utils/DatagridCollectionChangedEventArgs.ts
var DatagridCollectionChangedEventArgs = class extends NotifyCollectionChangedEventArgs {
	constructor(action, item, index, col, value, isSuggestionChange) {
		super(action, item, index);
		this.col = col;
		this.value = value;
		this.isSuggestionChange = isSuggestionChange;
	}
};
//#endregion
//#region src/utils/plugin.ts
var wijmoCultures = /* #__PURE__ */ Object.assign({
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.de.js": () => import("./wijmo.culture.de-eWShkwPm.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-CA.js": () => import("./wijmo.culture.en-CA-BK73lUtk.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en-GB.js": () => import("./wijmo.culture.en-GB-BONrbitz.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.en.js": () => import("./wijmo.culture.en-D6uwKN7_.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.es.js": () => import("./wijmo.culture.es-BgiedFR-.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr-CA.js": () => import("./wijmo.culture.fr-CA-CQ56kGh0.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.fr.js": () => import("./wijmo.culture.fr-aVS9-5iI.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.it.js": () => import("./wijmo.culture.it-Ba2m6T5C.js"),
	"../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.pt.js": () => import("./wijmo.culture.pt-DbZzyuWA.js")
});
var primeVueLocales = /* #__PURE__ */ Object.assign({
	"./locales/de.json": () => import("./de-CIDpsMuq.js"),
	"./locales/en-GB.json": () => import("./en-GB-c5G2l9-V.js"),
	"./locales/en.json": () => import("./en-Bbva_3wA.js"),
	"./locales/es.json": () => import("./es-DVxT5f1y.js"),
	"./locales/fr.json": () => import("./fr-BpzvF-eG.js"),
	"./locales/it.json": () => import("./it-BepJev15.js"),
	"./locales/pt.json": () => import("./pt-Ci36_Cph.js")
});
var plugin = { async install(app) {
	app.config.globalProperties.$neos = {};
	app.use(PrimeVue);
	app.use(ToastService);
	app.directive("tooltip", Tooltip$1);
} };
var wijmoConfigured = false;
function configureWijmo(key) {
	if (wijmoConfigured) return;
	setLicenseKey(key);
	overrideDatagridCellTemplate();
	overrideDatagridRowDetailTemplate();
	wijmoConfigured = true;
}
function useUILocale(localizator) {
	const primevue = usePrimeVue();
	async function updateUILocale() {
		await Promise.all([importWijmoLocale(localizator), updatePrimeVueLocale(localizator, primevue)]);
	}
	return { updateUILocale };
}
async function importWijmoLocale(localizator) {
	await importLocale(localizator, wijmoCultures, (lang) => `../../../../node_modules/@mescius/wijmo.cultures/wijmo.culture.${lang}.js`);
	culture.Globalize.calendar.twoDigitYearMax = twoDigitYearMax;
}
async function updatePrimeVueLocale(localizator, primevue) {
	const locale = (await importPrimeVueLocale(localizator))?.default;
	if (locale) primevue.config.locale = locale?.[Object.keys(locale)[0]];
}
function importPrimeVueLocale(localizator) {
	return importLocale(localizator, primeVueLocales, (lang) => `./locales/${lang}.json`);
}
async function importLocale(localizator, obj, getPath) {
	let fn = obj[getPath(localizator.currentCulture)];
	fn ??= obj[getPath(ResourceManager.getTwoLetterLanguage(localizator.currentCulture))];
	fn ??= obj[getPath(localizator.currentLanguage)];
	fn ??= obj[getPath(localizator.defaultLanguage)];
	return fn?.();
}
/**
* The Wijmo template overrides below rely on private integration points and browser layout
* primitives such as `ResizeObserver`, `requestAnimationFrame`, and live DOM measurements.
* Those interactions are not reproduced reliably in our unit test environment, so this block
* is documented and covered through manual verification instead of automated unit tests.
*/
/**
* Overrides the datagrid cell template definition to propagate the application context
* and the objects provided by the parent components.
*
* The following code comes from the Wijmo source code.
*
* The `$forceUpdate` method has been modified to update the component instead of remounting it.
*/
/* istanbul ignore next -- @preserve */
function overrideDatagridCellTemplate() {
	class V3CellTemplateCmp {
		constructor(props) {
			this.props = props;
			this._host = document.createElement("div");
		}
		$mount() {
			const { parent, ...props } = this.props;
			const vnode = h({
				parent,
				render: () => h("div", props, this.slotFn?.(this.context)),
				setup: () => propagateComponentContext(parent)
			});
			this.$el.innerHTML = "";
			render(vnode, this.$el);
		}
		get $el() {
			return this._host;
		}
		$destroy() {
			render(null, this.$el);
			this._host = null;
		}
		$forceUpdate() {
			if (this._host) {
				const element = this._host.firstChild;
				if (element && element.__vueParentComponent) element.__vueParentComponent.update();
			}
		}
	}
	WjFlexGridCellTemplateDefinition.methods._instantiateTemplate = function(parent, dataContext) {
		const ret = new V3CellTemplateCmp({ parent: this });
		ret.context = dataContext;
		ret.slotFn = this.$slots.default;
		ret.$mount();
		if (parent) parent.append(ret.$el);
		return ret;
	};
}
/**
* Overrides the datagrid detail template definition to propagate the application context
* and the objects provided by the parent components.
*
* This wraps Wijmo's original detail provider creation, replaces the detail cell factory
* to keep row detail height in sync with dynamic content by observing the rendered detail element.
*/
/* istanbul ignore next -- @preserve */
function overrideDatagridRowDetailTemplate() {
	const original = WjFlexGridDetail._wjBehCl.prototype._createControl;
	WjFlexGridDetail._wjBehCl.prototype._createControl = function() {
		const ctrl = original.call(this);
		ctrl.createDetailCell = (row) => {
			const parent = this.parent.component;
			const slotFn = this.component.$slots.default;
			const context = {
				row,
				item: row.dataItem,
				provider: this.control
			};
			const vnode = h({
				parent: this.component,
				render: () => h("div", slotFn?.(context)),
				setup: () => propagateComponentContext(parent)
			});
			const detail = document.createElement("div");
			render(vnode, detail);
			const content = vnode.el;
			const cleanup = watchDynamicDetailHeight(ctrl, row, detail, content ?? detail);
			this._openedComponents.push({
				$el: detail,
				$destroy() {
					cleanup();
					render(null, detail);
				}
			});
			return detail;
		};
		return ctrl;
	};
}
/**
* Observes the rendered detail content and keeps at most one pending height refresh.
*
* The first refresh request is issued immediately, but it only runs once the detail
* element is attached to the DOM. Later content resizes are coalesced through the same path.
*/
/* istanbul ignore next -- @preserve */
function watchDynamicDetailHeight(detailProvider, row, detail, content) {
	detail._neosResizeObserver = new ResizeObserver(() => {
		scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	});
	detail._neosResizeObserver.observe(content);
	scheduleDetailHeightRefresh(detailProvider, row, detail, content);
	return () => {
		const refreshFrame = detail._neosRefreshFrame;
		if (refreshFrame) {
			cancelAnimationFrame(refreshFrame);
			detail._neosRefreshFrame = void 0;
		}
		detail._neosResizeObserver?.disconnect();
		detail._neosResizeObserver = void 0;
	};
}
/**
* Recomputes the detail row height on the next animation frame after Vue and Wijmo have
* both had a chance to flush their DOM updates.
*
* The extra retries cover cases where the detail is mounted before layout produces a
* measurable height, such as deferred child rendering.
*/
/* istanbul ignore next -- @preserve */
function scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount = 0) {
	if (detail._neosRefreshFrame || !detail.isConnected) return;
	detail._neosRefreshFrame = requestAnimationFrame(() => {
		detail._neosRefreshFrame = void 0;
		if (!detail.isConnected) return;
		const detailRow = detailProvider.getDetailRow(row);
		if (!detailRow || detailRow.detail !== detail) return;
		Control.refreshAll(detail);
		const grid = detailProvider.grid;
		const measuredHeight = Math.max(content.scrollHeight, content.getBoundingClientRect().height);
		detailRow.height = measuredHeight + grid._cellPadVert * 2;
		if (measuredHeight === 0 && retryCount < 2) scheduleDetailHeightRefresh(detailProvider, row, detail, content, retryCount + 1);
	});
}
/**
* It is through the following code that the context is propagated.
*/
/* istanbul ignore next -- @preserve */
function propagateComponentContext(parent) {
	const currentInstance = getCurrentInstance();
	const parentInstance = parent;
	currentInstance.appContext = parentInstance.$.appContext;
	currentInstance.provides = parentInstance.$.provides;
}
//#endregion
export { Aggregate, AiSuggestionIndicator_default as AiSuggestionIndicator, AlignValues, AutomationDirectivePropertyValues, Avatar_default as Avatar, Badge_default as Badge, BooleanCombobox_default as BooleanCombobox, BreakpointValues, Button_default as Button, ButtonsLayout_default as ButtonsLayout, Card_default as Card, Carousel_default as Carousel, Chart_default as Chart, Checkbox_default as Checkbox, Chip_default as Chip, CollectionViewGroup, Combobox_default as Combobox, ContextMenu_default as ContextMenu, CornerRadiusValues, DataType, Datagrid_default as Datagrid, DatagridCollectionChangedEventArgs, DatagridCollectionView, DatagridInstance, DatagridNoDataOverlay_default as DatagridNoDataOverlay, Divider_default as Divider, DocumentationButton_default as DocumentationButton, Dropdown_default as Dropdown, DropdownMenu_default as DropdownMenu, DropdownMenuItem_default as DropdownMenuItem, DynamicCheckbox_default as DynamicCheckbox, DynamicCombobox_default as DynamicCombobox, GridLayout_default as GridLayout, GroupBox_default as GroupBox, GroupDescription, Heading_default as Heading, HorizontalLayout_default as HorizontalLayout, HtmlViewer_default as HtmlViewer, Image_default as Image, InputColor_default as InputColor, InputDate_default as InputDate, InputDateTime_default as InputDateTime, InputLabel_default as InputLabel, InputLocalizableString_default as InputLocalizableString, InputMask_default as InputMask, InputMessage_default as InputMessage, InputNumber_default as InputNumber, InputNumberCalculable_default as InputNumberCalculable, InputPassword_default as InputPassword, InputSliderDiscrete_default as InputSliderDiscrete, InputTime_default as InputTime, LayoutDirectiveProperty, ListBox_default as ListBox, LoadDataOnScroll_default as LoadDataOnScroll, LoadingOverlay_default as LoadingOverlay, LottieImage_default as LottieImage, MarkdownViewer_default as MarkdownViewer, Message_default as Message, Modal_default as Modal, MultiSelect_default as MultiSelect, NeosAutomation, neosGrid as NeosGrid, neosLayout as NeosLayout, neosStyle as NeosStyle, neosTooltip as NeosTooltip, NotifyCollectionChangedAction, ObservableArray, PaginationBar_default as PaginationBar, Popover_default as Popover, PopoverWithTarget_default as PopoverWithTarget, PrimeDatePicker, ProgressBar_default as ProgressBar, ProgressIndicator_default as ProgressIndicator, PropertyGroupDescription, RadioGroup_default as RadioGroup, ResponsiveDatagridWrapper_default as ResponsiveDatagridWrapper, SelectableListHeader_default as SelectableListHeader, SortDescription, SpaceValues, Spinner_default as Spinner, Splitter_default as Splitter, SplitterPanel_default as SplitterPanel, StyleDirectivePropertyValues, Switch_default as Switch, TabItem_default as TabItem, Tabs_default as Tabs, Text_default as Text, Textbox_default as Textbox, Timeline_default as Timeline, Toast_default as Toast, TreeView_default as TreeView, VerticalAlignValues, VerticalLayout_default as VerticalLayout, VirtualRepeat_default as VirtualRepeat, WeightValues, ZIndex, configureWijmo, convertTextAlignToAlignItems, focusExceptOnTouchDevice, focusableElementEmits, focusableElementProps, hideAllPopovers, importLocale, inputEmits, inputProps, isAutomationMode, isDropdownActive, isInDropdown, isSpeechSupported, isTouchDevice, multiSpaceValueValidatorExpression, plugin, provideGlobalResourceManager, provideImages, provideLocalizator, provideThemeManager, setAutomationMode, setLayoutOverflowFixOption, smallTextPropsDefaults, textPropsDefaults, triggerChangeOnActiveInput, useButtonContainerSpace, useComponentAutomationProperties, useFocusableElement, useGlobalResourceManager, useImages, useInput, useLocalizator, useModal, usePressEvents, usePreventPopoverHide, useSpeech, useText, useThemeManager, useToast, useUILocale, validationMessageSeverities };

//# sourceMappingURL=design-system.js.map